var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/generated/runtime.ts
var BASE_PATH = "https://app-qa.apacta.com".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : () => __async(this, null, function* () {
        return accessToken;
      });
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var _BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.fetchApi = (url, init) => __async(this, null, function* () {
      let fetchParams = { url, init };
      for (const middleware of this.middleware) {
        if (middleware.pre) {
          fetchParams = (yield middleware.pre(__spreadValues({
            fetch: this.fetchApi
          }, fetchParams))) || fetchParams;
        }
      }
      let response = void 0;
      try {
        response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
      } catch (e) {
        for (const middleware of this.middleware) {
          if (middleware.onError) {
            response = (yield middleware.onError({
              fetch: this.fetchApi,
              url: fetchParams.url,
              init: fetchParams.init,
              error: e,
              response: response ? response.clone() : void 0
            })) || response;
          }
        }
        if (response === void 0) {
          if (e instanceof Error) {
            throw new FetchError(e, "The request failed and the interceptors did not return an alternative response");
          } else {
            throw e;
          }
        }
      }
      for (const middleware of this.middleware) {
        if (middleware.post) {
          response = (yield middleware.post({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            response: response.clone()
          })) || response;
        }
      }
      return response;
    });
    this.middleware = configuration.middleware;
  }
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  request(context, initOverrides) {
    return __async(this, null, function* () {
      const { url, init } = yield this.createFetchParams(context, initOverrides);
      const response = yield this.fetchApi(url, init);
      if (response && (response.status >= 200 && response.status < 300)) {
        return response;
      }
      throw new ResponseError(response, "Response returned an error code");
    });
  }
  createFetchParams(context, initOverrides) {
    return __async(this, null, function* () {
      let url = this.configuration.basePath + context.path;
      if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
        url += "?" + this.configuration.queryParamsStringify(context.query);
      }
      const headers = Object.assign({}, this.configuration.headers, context.headers);
      Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
      const initOverrideFn = typeof initOverrides === "function" ? initOverrides : () => __async(this, null, function* () {
        return initOverrides;
      });
      const initParams = {
        method: context.method,
        headers,
        body: context.body,
        credentials: this.configuration.credentials
      };
      const overriddenInit = __spreadValues(__spreadValues({}, initParams), yield initOverrideFn({
        init: initParams,
        context
      }));
      const init = __spreadProps(__spreadValues({}, overriddenInit), {
        body: isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
      });
      return { url, init };
    });
  }
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
_BaseAPI.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
var BaseAPI = _BaseAPI;
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
    this.name = "ResponseError";
  }
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
    this.name = "FetchError";
  }
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
};
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => __spreadProps(__spreadValues({}, acc), { [key]: fn(data[key]) }),
    {}
  );
}
function canConsumeForm(consumes) {
  for (const consume of consumes) {
    if ("multipart/form-data" === consume.contentType) {
      return true;
    }
  }
  return false;
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  value() {
    return __async(this, null, function* () {
      return this.transformer(yield this.raw.json());
    });
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return void 0;
    });
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.blob();
    });
  }
};
var TextApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  value() {
    return __async(this, null, function* () {
      return yield this.raw.text();
    });
  }
};

// src/local-date.ts
var LOCAL_DATE_STRING_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
function fromLocalDateString(date) {
  if (date === void 0) {
    return void 0;
  }
  if (typeof date !== "string") {
    throw new Error("LocalDate: Date string (YYYY-MM-DD) is required.");
  }
  const match = date.match(LOCAL_DATE_STRING_REGEX);
  if (!match) {
    throw new Error("LocalDate: Date string (YYYY-MM-DD) is required.");
  }
  return new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10));
}
function toLocalDateString(date) {
  if (!date) return;
  let d = date;
  const offset = d.getTimezoneOffset();
  d = new Date(d.getTime() - offset * 60 * 1e3);
  return d.toISOString().split("T")[0];
}

// src/generated/models/AbsenceType.ts
function instanceOfAbsenceType(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function AbsenceTypeFromJSON(json) {
  return AbsenceTypeFromJSONTyped(json, false);
}
function AbsenceTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": json["company_id"],
    "name": json["name"],
    "salaryId": !exists(json, "salary_id") ? void 0 : json["salary_id"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function AbsenceTypeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "salary_id": value.salaryId
  };
}

// src/generated/models/Absence.ts
function instanceOfAbsence(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "absenceTypeId" in value;
  return isInstance;
}
function AbsenceFromJSON(json) {
  return AbsenceFromJSONTyped(json, false);
}
function AbsenceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": json["company_id"],
    "userId": json["user_id"],
    "absenceTypeId": json["absence_type_id"],
    "taskId": !exists(json, "task_id") ? void 0 : json["task_id"],
    "isFullDay": !exists(json, "is_full_day") ? void 0 : json["is_full_day"],
    "includeWeekend": !exists(json, "include_weekend") ? void 0 : json["include_weekend"],
    "date": !exists(json, "date") ? void 0 : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "futureAbsenceCardsInSequence": !exists(json, "futureAbsenceCardsInSequence") ? void 0 : json["futureAbsenceCardsInSequence"],
    "previousAbsenceCardsInSequence": !exists(json, "previousAbsenceCardsInSequence") ? void 0 : json["previousAbsenceCardsInSequence"],
    "absenceType": !exists(json, "absence_type") ? void 0 : AbsenceTypeFromJSON(json["absence_type"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function AbsenceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "user_id": value.userId,
    "absence_type_id": value.absenceTypeId,
    "task_id": value.taskId,
    "is_full_day": value.isFullDay,
    "include_weekend": value.includeWeekend,
    "date": value.date === void 0 ? void 0 : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "duration": value.duration,
    "futureAbsenceCardsInSequence": value.futureAbsenceCardsInSequence,
    "previousAbsenceCardsInSequence": value.previousAbsenceCardsInSequence,
    "absence_type": AbsenceTypeToJSON(value.absenceType)
  };
}

// src/generated/models/AbsenceCreateOrUpdateDTO.ts
function instanceOfAbsenceCreateOrUpdateDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "absenceTypeId" in value;
  isInstance = isInstance && "startDate" in value;
  return isInstance;
}
function AbsenceCreateOrUpdateDTOFromJSON(json) {
  return AbsenceCreateOrUpdateDTOFromJSONTyped(json, false);
}
function AbsenceCreateOrUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "userId": json["user_id"],
    "absenceTypeId": json["absence_type_id"],
    "startDate": new Date(json["start_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "includeWeekend": !exists(json, "include_weekend") ? void 0 : json["include_weekend"],
    "isFullDay": !exists(json, "is_full_day") ? void 0 : json["is_full_day"]
  };
}
function AbsenceCreateOrUpdateDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "absence_type_id": value.absenceTypeId,
    "start_date": value.startDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "duration": value.duration,
    "include_weekend": value.includeWeekend,
    "is_full_day": value.isFullDay
  };
}

// src/generated/models/ActionLogMetadata.ts
function instanceOfActionLogMetadata(value) {
  let isInstance = true;
  return isInstance;
}
function ActionLogMetadataFromJSON(json) {
  return ActionLogMetadataFromJSONTyped(json, false);
}
function ActionLogMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "emailId": !exists(json, "email_id") ? void 0 : json["email_id"],
    "recipientEmail": !exists(json, "recipient_email") ? void 0 : json["recipient_email"],
    "recipientName": !exists(json, "recipient_name") ? void 0 : json["recipient_name"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "source": !exists(json, "source") ? void 0 : json["source"],
    "sourceId": !exists(json, "source_id") ? void 0 : json["source_id"]
  };
}
function ActionLogMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email_id": value.emailId,
    "recipient_email": value.recipientEmail,
    "recipient_name": value.recipientName,
    "contact_id": value.contactId,
    "source": value.source,
    "source_id": value.sourceId
  };
}

// src/generated/models/EditUserRequestCustomIntegrationSettingsInner.ts
function instanceOfEditUserRequestCustomIntegrationSettingsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function EditUserRequestCustomIntegrationSettingsInnerFromJSON(json) {
  return EditUserRequestCustomIntegrationSettingsInnerFromJSONTyped(json, false);
}
function EditUserRequestCustomIntegrationSettingsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "value": json["value"]
  };
}
function EditUserRequestCustomIntegrationSettingsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "value": value.value
  };
}

// src/generated/models/IntegrationSettingUsersInnerJoinData.ts
function instanceOfIntegrationSettingUsersInnerJoinData(value) {
  let isInstance = true;
  return isInstance;
}
function IntegrationSettingUsersInnerJoinDataFromJSON(json) {
  return IntegrationSettingUsersInnerJoinDataFromJSONTyped(json, false);
}
function IntegrationSettingUsersInnerJoinDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "integrationSettingId": !exists(json, "integration_setting_id") ? void 0 : json["integration_setting_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "value": !exists(json, "value") ? void 0 : json["value"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IntegrationSettingUsersInnerJoinDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "user_id": value.userId,
    "integration_setting_id": value.integrationSettingId,
    "value": value.value
  };
}

// src/generated/models/IntegrationSettingUsersInner.ts
function instanceOfIntegrationSettingUsersInner(value) {
  let isInstance = true;
  return isInstance;
}
function IntegrationSettingUsersInnerFromJSON(json) {
  return IntegrationSettingUsersInnerFromJSONTyped(json, false);
}
function IntegrationSettingUsersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "joinData": !exists(json, "_joinData") ? void 0 : IntegrationSettingUsersInnerJoinDataFromJSON(json["_joinData"])
  };
}
function IntegrationSettingUsersInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "_joinData": IntegrationSettingUsersInnerJoinDataToJSON(value.joinData)
  };
}

// src/generated/models/IntegrationSetting.ts
function instanceOfIntegrationSetting(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function IntegrationSettingFromJSON(json) {
  return IntegrationSettingFromJSONTyped(json, false);
}
function IntegrationSettingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "integrationId": !exists(json, "integration_id") ? void 0 : json["integration_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "authUriJson": !exists(json, "auth_uri_json") ? void 0 : json["auth_uri_json"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "defaultValue": !exists(json, "default_value") ? void 0 : json["default_value"],
    "isUserSetting": !exists(json, "is_user_setting") ? void 0 : json["is_user_setting"],
    "isCompanySetting": !exists(json, "is_company_setting") ? void 0 : json["is_company_setting"],
    "isCustom": !exists(json, "is_custom") ? void 0 : json["is_custom"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "users": !exists(json, "users") ? void 0 : json["users"].map(IntegrationSettingUsersInnerFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IntegrationSettingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "integration_id": value.integrationId,
    "name": value.name,
    "description": value.description,
    "auth_uri_json": value.authUriJson,
    "identifier": value.identifier,
    "default_value": value.defaultValue,
    "is_user_setting": value.isUserSetting,
    "is_company_setting": value.isCompanySetting,
    "is_custom": value.isCustom,
    "placement": value.placement,
    "users": value.users === void 0 ? void 0 : value.users.map(IntegrationSettingUsersInnerToJSON)
  };
}

// src/generated/models/Integration.ts
function instanceOfIntegration(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function IntegrationFromJSON(json) {
  return IntegrationFromJSONTyped(json, false);
}
function IntegrationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "integrationTypeId": !exists(json, "integration_type_id") ? void 0 : json["integration_type_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "integrationSettings": !exists(json, "integration_settings") ? void 0 : json["integration_settings"].map(IntegrationSettingFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IntegrationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "name": value.name,
    "description": value.description,
    "identifier": value.identifier,
    "integration_settings": value.integrationSettings === void 0 ? void 0 : value.integrationSettings.map(IntegrationSettingToJSON)
  };
}

// src/generated/models/IntegrationType.ts
function instanceOfIntegrationType(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function IntegrationTypeFromJSON(json) {
  return IntegrationTypeFromJSONTyped(json, false);
}
function IntegrationTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "uniqueIntegration": !exists(json, "unique_integration") ? void 0 : json["unique_integration"],
    "integrations": !exists(json, "integrations") ? void 0 : json["integrations"].map(IntegrationFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IntegrationTypeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "identifier": value.identifier,
    "unique_integration": value.uniqueIntegration,
    "integrations": value.integrations === void 0 ? void 0 : value.integrations.map(IntegrationToJSON)
  };
}

// src/generated/models/LabelEntity.ts
var LabelEntityEntityEnum = {
  Employee: "employee",
  Task: "task"
};
function instanceOfLabelEntity(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "text" in value;
  return isInstance;
}
function LabelEntityFromJSON(json) {
  return LabelEntityFromJSONTyped(json, false);
}
function LabelEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "text": json["text"],
    "entity": !exists(json, "entity") ? void 0 : json["entity"],
    "bgColor": !exists(json, "bg_color") ? void 0 : json["bg_color"],
    "textColor": !exists(json, "text_color") ? void 0 : json["text_color"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function LabelEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "text": value.text,
    "entity": value.entity,
    "bg_color": value.bgColor,
    "text_color": value.textColor
  };
}

// src/generated/models/Country.ts
function instanceOfCountry(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "identifier" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function CountryFromJSON(json) {
  return CountryFromJSONTyped(json, false);
}
function CountryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "identifier": json["identifier"],
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "name": json["name"],
    "phoneCode": !exists(json, "phone_code") ? void 0 : json["phone_code"],
    "timeZone": !exists(json, "time_zone") ? void 0 : json["time_zone"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function CountryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "identifier": value.identifier,
    "currency_id": value.currencyId,
    "name": value.name,
    "phone_code": value.phoneCode,
    "time_zone": value.timeZone
  };
}

// src/generated/models/City.ts
function instanceOfCity(value) {
  let isInstance = true;
  return isInstance;
}
function CityFromJSON(json) {
  return CityFromJSONTyped(json, false);
}
function CityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "country": !exists(json, "country") ? void 0 : CountryFromJSON(json["country"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function CityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "zip_code": value.zipCode,
    "name": value.name,
    "country": CountryToJSON(value.country)
  };
}

// src/generated/models/PaymentTermType.ts
function instanceOfPaymentTermType(value) {
  let isInstance = true;
  return isInstance;
}
function PaymentTermTypeFromJSON(json) {
  return PaymentTermTypeFromJSONTyped(json, false);
}
function PaymentTermTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function PaymentTermTypeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "name": value.name,
    "identifier": value.identifier,
    "description": value.description
  };
}

// src/generated/models/PaymentTerm.ts
function instanceOfPaymentTerm(value) {
  let isInstance = true;
  return isInstance;
}
function PaymentTermFromJSON(json) {
  return PaymentTermFromJSONTyped(json, false);
}
function PaymentTermFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "paymentTermTypeId": !exists(json, "payment_term_type_id") ? void 0 : json["payment_term_type_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "daysOfCredit": !exists(json, "days_of_credit") ? void 0 : json["days_of_credit"],
    "paymentTermType": !exists(json, "payment_term_type") ? void 0 : PaymentTermTypeFromJSON(json["payment_term_type"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function PaymentTermToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "payment_term_type_id": value.paymentTermTypeId,
    "created_by_id": value.createdById,
    "days_of_credit": value.daysOfCredit,
    "payment_term_type": PaymentTermTypeToJSON(value.paymentTermType)
  };
}

// src/generated/models/Contact.ts
function instanceOfContact(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "countryId" in value;
  isInstance = isInstance && "cityId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "address" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "website" in value;
  isInstance = isInstance && "phone" in value;
  isInstance = isInstance && "phoneCountrycode" in value;
  isInstance = isInstance && "cvr" in value;
  isInstance = isInstance && "erpId" in value;
  isInstance = isInstance && "discountPercentageHours" in value;
  isInstance = isInstance && "discountPercentageProducts" in value;
  isInstance = isInstance && "tripletexId" in value;
  isInstance = isInstance && "centigaId" in value;
  isInstance = isInstance && "pogoId" in value;
  isInstance = isInstance && "paymentTermId" in value;
  return isInstance;
}
function ContactFromJSON(json) {
  return ContactFromJSONTyped(json, false);
}
function ContactFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "countryId": json["country_id"],
    "cityId": json["city_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "companyId": json["company_id"],
    "name": json["name"],
    "description": json["description"],
    "address": json["address"],
    "email": json["email"],
    "website": json["website"],
    "phone": json["phone"],
    "phoneCountrycode": json["phone_countrycode"],
    "cvr": json["cvr"],
    "erpId": json["erp_id"],
    "discountPercentageHours": json["discount_percentage_hours"],
    "discountPercentageProducts": json["discount_percentage_products"],
    "tripletexId": json["tripletex_id"],
    "centigaId": json["centiga_id"],
    "pogoId": json["pogo_id"],
    "paymentTermId": json["payment_term_id"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "ean": !exists(json, "ean") ? void 0 : json["ean"],
    "paymentTerm": !exists(json, "payment_term") ? void 0 : PaymentTermFromJSON(json["payment_term"]),
    "city": !exists(json, "city") ? void 0 : CityFromJSON(json["city"]),
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ContactToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "country_id": value.countryId,
    "city_id": value.cityId,
    "label_id": value.labelId,
    "company_id": value.companyId,
    "name": value.name,
    "description": value.description,
    "address": value.address,
    "email": value.email,
    "website": value.website,
    "phone": value.phone,
    "phone_countrycode": value.phoneCountrycode,
    "cvr": value.cvr,
    "erp_id": value.erpId,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "tripletex_id": value.tripletexId,
    "centiga_id": value.centigaId,
    "pogo_id": value.pogoId,
    "payment_term_id": value.paymentTermId,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "ean": value.ean,
    "payment_term": PaymentTermToJSON(value.paymentTerm),
    "city": CityToJSON(value.city),
    "label": LabelEntityToJSON(value.label)
  };
}

// src/generated/models/ProjectStatusType.ts
function instanceOfProjectStatusType(value) {
  let isInstance = true;
  return isInstance;
}
function ProjectStatusTypeFromJSON(json) {
  return ProjectStatusTypeFromJSONTyped(json, false);
}
function ProjectStatusTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "locale": !exists(json, "_locale") ? void 0 : json["_locale"]
  };
}
function ProjectStatusTypeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "name": value.name,
    "identifier": value.identifier,
    "description": value.description,
    "_locale": value.locale
  };
}

// src/generated/models/ProjectStatus.ts
var ProjectStatusIdentifierEnum = {
  ReadyForBilling: "ready_for_billing",
  Open: "open",
  Closed: "closed"
};
function instanceOfProjectStatus(value) {
  let isInstance = true;
  return isInstance;
}
function ProjectStatusFromJSON(json) {
  return ProjectStatusFromJSONTyped(json, false);
}
function ProjectStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "projectStatusType": !exists(json, "project_status_type") ? void 0 : ProjectStatusTypeFromJSON(json["project_status_type"]),
    "isCustom": !exists(json, "is_custom") ? void 0 : json["is_custom"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ProjectStatusToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "name": value.name,
    "description": value.description,
    "identifier": value.identifier,
    "project_status_type": ProjectStatusTypeToJSON(value.projectStatusType),
    "is_custom": value.isCustom
  };
}

// src/generated/models/Project.ts
function instanceOfProject(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function ProjectFromJSON(json) {
  return ProjectFromJSONTyped(json, false);
}
function ProjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "fullName": !exists(json, "full_name") ? void 0 : json["full_name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "discountPercentageHours": !exists(json, "discount_percentage_hours") ? void 0 : json["discount_percentage_hours"],
    "discountPercentageProducts": !exists(json, "discount_percentage_products") ? void 0 : json["discount_percentage_products"],
    "projectNumber": !exists(json, "project_number") ? void 0 : json["project_number"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "projectImageUrl": !exists(json, "project_image_url") ? void 0 : json["project_image_url"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "projectStatusId": !exists(json, "project_status_id") ? void 0 : json["project_status_id"],
    "projectStatus": !exists(json, "project_status") ? void 0 : ProjectStatusFromJSON(json["project_status"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"])
  };
}
function ProjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "project_number": value.projectNumber,
    "email": value.email,
    "thumbnail": value.thumbnail,
    "project_image_url": value.projectImageUrl,
    "street_name": value.streetName,
    "zip_code": value.zipCode,
    "city_name": value.cityName,
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "project_status_id": value.projectStatusId,
    "project_status": ProjectStatusToJSON(value.projectStatus),
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/UserMobileAppPreferencesFormsDailyReminderPreferences.ts
function instanceOfUserMobileAppPreferencesFormsDailyReminderPreferences(value) {
  let isInstance = true;
  return isInstance;
}
function UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSON(json) {
  return UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSONTyped(json, false);
}
function UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "monday": !exists(json, "monday") ? void 0 : json["monday"],
    "tuesday": !exists(json, "tuesday") ? void 0 : json["tuesday"],
    "wednesday": !exists(json, "wednesday") ? void 0 : json["wednesday"],
    "thursday": !exists(json, "thursday") ? void 0 : json["thursday"],
    "friday": !exists(json, "friday") ? void 0 : json["friday"],
    "saturday": !exists(json, "saturday") ? void 0 : json["saturday"],
    "sunday": !exists(json, "sunday") ? void 0 : json["sunday"]
  };
}
function UserMobileAppPreferencesFormsDailyReminderPreferencesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "monday": value.monday,
    "tuesday": value.tuesday,
    "wednesday": value.wednesday,
    "thursday": value.thursday,
    "friday": value.friday,
    "saturday": value.saturday,
    "sunday": value.sunday
  };
}

// src/generated/models/UserMobileAppPreferences.ts
function instanceOfUserMobileAppPreferences(value) {
  let isInstance = true;
  return isInstance;
}
function UserMobileAppPreferencesFromJSON(json) {
  return UserMobileAppPreferencesFromJSONTyped(json, false);
}
function UserMobileAppPreferencesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "enableNotificationsTasks": !exists(json, "enable_notifications_tasks") ? void 0 : json["enable_notifications_tasks"],
    "enableNotificationsMessages": !exists(json, "enable_notifications_messages") ? void 0 : json["enable_notifications_messages"],
    "enableNotificationsFormsDailyReminder": !exists(json, "enable_notifications_forms_daily_reminder") ? void 0 : json["enable_notifications_forms_daily_reminder"],
    "manuallyChanged": !exists(json, "manually_changed") ? void 0 : json["manually_changed"],
    "formsDailyReminderPreferences": !exists(json, "forms_daily_reminder_preferences") ? void 0 : UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSON(json["forms_daily_reminder_preferences"])
  };
}
function UserMobileAppPreferencesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "enable_notifications_tasks": value.enableNotificationsTasks,
    "enable_notifications_messages": value.enableNotificationsMessages,
    "enable_notifications_forms_daily_reminder": value.enableNotificationsFormsDailyReminder,
    "manually_changed": value.manuallyChanged,
    "forms_daily_reminder_preferences": UserMobileAppPreferencesFormsDailyReminderPreferencesToJSON(value.formsDailyReminderPreferences)
  };
}

// src/generated/models/UsersPriceGroup.ts
function instanceOfUsersPriceGroup(value) {
  let isInstance = true;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "costPrice" in value;
  isInstance = isInstance && "salePrice" in value;
  return isInstance;
}
function UsersPriceGroupFromJSON(json) {
  return UsersPriceGroupFromJSONTyped(json, false);
}
function UsersPriceGroupFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": json["company_id"],
    "name": json["name"],
    "costPrice": json["cost_price"],
    "salePrice": json["sale_price"],
    "extraPrice": !exists(json, "extra_price") ? void 0 : json["extra_price"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function UsersPriceGroupToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "modified_by_id": value.modifiedById,
    "company_id": value.companyId,
    "name": value.name,
    "cost_price": value.costPrice,
    "sale_price": value.salePrice,
    "extra_price": value.extraPrice
  };
}

// src/generated/models/User.ts
var UserAdminAccessEnum = {
  NoAccessToAdmin: "no_access_to_admin",
  AccessToAdmin: "access_to_admin",
  LimitedAccessToAdmin: "limited_access_to_admin"
};
function instanceOfUser(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "cityId" in value;
  isInstance = isInstance && "languageId" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "password" in value;
  isInstance = isInstance && "firstName" in value;
  isInstance = isInstance && "lastName" in value;
  isInstance = isInstance && "fullName" in value;
  isInstance = isInstance && "initials" in value;
  isInstance = isInstance && "streetName" in value;
  isInstance = isInstance && "website" in value;
  isInstance = isInstance && "phone" in value;
  isInstance = isInstance && "phoneCountrycode" in value;
  isInstance = isInstance && "mobile" in value;
  isInstance = isInstance && "mobileCountrycode" in value;
  isInstance = isInstance && "manualPrice" in value;
  isInstance = isInstance && "costPrice" in value;
  isInstance = isInstance && "effectiveCostPrice" in value;
  isInstance = isInstance && "salePrice" in value;
  isInstance = isInstance && "extraPrice" in value;
  isInstance = isInstance && "effectiveExtraPrice" in value;
  isInstance = isInstance && "isActive" in value;
  isInstance = isInstance && "apiKey" in value;
  isInstance = isInstance && "receiveFormMails" in value;
  isInstance = isInstance && "hideAddress" in value;
  isInstance = isInstance && "hidePhone" in value;
  isInstance = isInstance && "expectedBillableHours" in value;
  isInstance = isInstance && "mobileAppPreferences" in value;
  isInstance = isInstance && "isProjectLeader" in value;
  isInstance = isInstance && "adminAccess" in value;
  return isInstance;
}
function UserFromJSON(json) {
  return UserFromJSONTyped(json, false);
}
function UserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "cityId": json["city_id"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "languageId": json["language_id"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "timeEntryRuleGroupId": !exists(json, "time_entry_rule_group_id") ? void 0 : json["time_entry_rule_group_id"],
    "createdById": json["created_by_id"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "usersPriceGroup": !exists(json, "users_price_group") ? void 0 : UsersPriceGroupFromJSON(json["users_price_group"]),
    "email": json["email"],
    "password": json["password"],
    "firstName": json["first_name"],
    "lastName": json["last_name"],
    "fullName": json["full_name"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "initials": json["initials"],
    "image": !exists(json, "image") ? void 0 : json["image"],
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "streetName": json["street_name"],
    "website": json["website"],
    "phone": json["phone"],
    "phoneCountrycode": json["phone_countrycode"],
    "mobile": json["mobile"],
    "mobileCountrycode": json["mobile_countrycode"],
    "manualPrice": json["manual_price"],
    "costPrice": json["cost_price"],
    "effectiveCostPrice": json["effective_cost_price"],
    "salePrice": json["sale_price"],
    "extraPrice": json["extra_price"],
    "effectiveExtraPrice": json["effective_extra_price"],
    "previewPdf": !exists(json, "preview_pdf") ? void 0 : json["preview_pdf"],
    "isActive": json["is_active"],
    "apiKey": json["api_key"],
    "receiveFormMails": json["receive_form_mails"],
    "hideAddress": json["hide_address"],
    "hidePhone": json["hide_phone"],
    "expectedBillableHours": json["expected_billable_hours"],
    "mobileAppPreferences": UserMobileAppPreferencesFromJSON(json["mobile_app_preferences"]),
    "integrationSettings": !exists(json, "integration_settings") ? void 0 : json["integration_settings"].map(EditUserRequestCustomIntegrationSettingsInnerFromJSON),
    "integrationTypes": !exists(json, "integration_types") ? void 0 : json["integration_types"].map(IntegrationTypeFromJSON),
    "isProjectLeader": json["is_project_leader"],
    "adminAccess": json["admin_access"],
    "adminAccessOptions": !exists(json, "admin_access_options") ? void 0 : json["admin_access_options"],
    "projects": !exists(json, "projects") ? void 0 : json["projects"].map(ProjectFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON)
  };
}
function UserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "city_id": value.cityId,
    "country_id": value.countryId,
    "language_id": value.languageId,
    "erp_id": value.erpId,
    "time_entry_rule_group_id": value.timeEntryRuleGroupId,
    "created_by_id": value.createdById,
    "users_price_group_id": value.usersPriceGroupId,
    "users_price_group": UsersPriceGroupToJSON(value.usersPriceGroup),
    "email": value.email,
    "password": value.password,
    "first_name": value.firstName,
    "last_name": value.lastName,
    "full_name": value.fullName,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "initials": value.initials,
    "image": value.image,
    "image_url": value.imageUrl,
    "street_name": value.streetName,
    "website": value.website,
    "phone": value.phone,
    "phone_countrycode": value.phoneCountrycode,
    "mobile": value.mobile,
    "mobile_countrycode": value.mobileCountrycode,
    "manual_price": value.manualPrice,
    "cost_price": value.costPrice,
    "effective_cost_price": value.effectiveCostPrice,
    "extra_price": value.extraPrice,
    "effective_extra_price": value.effectiveExtraPrice,
    "is_active": value.isActive,
    "api_key": value.apiKey,
    "receive_form_mails": value.receiveFormMails,
    "hide_address": value.hideAddress,
    "hide_phone": value.hidePhone,
    "expected_billable_hours": value.expectedBillableHours,
    "mobile_app_preferences": UserMobileAppPreferencesToJSON(value.mobileAppPreferences),
    "integration_settings": value.integrationSettings === void 0 ? void 0 : value.integrationSettings.map(EditUserRequestCustomIntegrationSettingsInnerToJSON),
    "integration_types": value.integrationTypes === void 0 ? void 0 : value.integrationTypes.map(IntegrationTypeToJSON),
    "is_project_leader": value.isProjectLeader,
    "admin_access": value.adminAccess,
    "admin_access_options": value.adminAccessOptions,
    "projects": value.projects === void 0 ? void 0 : value.projects.map(ProjectToJSON),
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON)
  };
}

// src/generated/models/ActionLog.ts
var ActionLogActionEnum = {
  OfferCreated: "offer_created",
  OfferAccepted: "offer_accepted",
  OfferRejected: "offer_rejected",
  OfferSentToEmail: "offer_sent_to_email",
  OfferExpired: "offer_expired",
  OfferPublicUrlAccessed: "offer_public_url_accessed",
  OfferEmailDelivered: "offer_email_delivered",
  OfferEmailOpened: "offer_email_opened",
  OfferEmailSendingFailed: "offer_email_sending_failed",
  ExpenseSentToErpLedgerByUser: "expense_sent_to_erp_ledger_by_user",
  ExpenseSentToErpLedgerBySystem: "expense_sent_to_erp_ledger_by_system",
  ExpenseErpLedgerSendFailed: "expense_erp_ledger_send_failed"
};
function instanceOfActionLog(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "entityType" in value;
  isInstance = isInstance && "entityId" in value;
  isInstance = isInstance && "action" in value;
  isInstance = isInstance && "created" in value;
  return isInstance;
}
function ActionLogFromJSON(json) {
  return ActionLogFromJSONTyped(json, false);
}
function ActionLogFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "entityType": json["entity_type"],
    "entityId": json["entity_id"],
    "action": json["action"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "metadata": !exists(json, "metadata") ? void 0 : ActionLogMetadataFromJSON(json["metadata"]),
    "created": new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"])
  };
}
function ActionLogToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "action": value.action,
    "created_by": UserToJSON(value.createdBy),
    "metadata": ActionLogMetadataToJSON(value.metadata)
  };
}

// src/generated/models/Activity.ts
function instanceOfActivity(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "hexCode" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ActivityFromJSON(json) {
  return ActivityFromJSONTyped(json, false);
}
function ActivityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "companyId": json["company_id"],
    "hexCode": json["hex_code"],
    "name": json["name"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ActivityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "company_id": value.companyId,
    "hex_code": value.hexCode,
    "name": value.name,
    "erp_id": value.erpId
  };
}

// src/generated/models/AddContactPersonRequest.ts
function instanceOfAddContactPersonRequest(value) {
  let isInstance = true;
  return isInstance;
}
function AddContactPersonRequestFromJSON(json) {
  return AddContactPersonRequestFromJSONTyped(json, false);
}
function AddContactPersonRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "title": !exists(json, "title") ? void 0 : json["title"]
  };
}
function AddContactPersonRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "email": value.email,
    "phone": value.phone,
    "title": value.title
  };
}

// src/generated/models/AddVariantRequest.ts
function instanceOfAddVariantRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "productId" in value;
  return isInstance;
}
function AddVariantRequestFromJSON(json) {
  return AddVariantRequestFromJSONTyped(json, false);
}
function AddVariantRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["product_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"]
  };
}
function AddVariantRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_id": value.productId,
    "expense_line_id": value.expenseLineId,
    "vendor_product_id": value.vendorProductId
  };
}

// src/generated/models/AddressLookup.ts
function instanceOfAddressLookup(value) {
  let isInstance = true;
  isInstance = isInstance && "streetName" in value;
  isInstance = isInstance && "streetNumber" in value;
  isInstance = isInstance && "city" in value;
  isInstance = isInstance && "zipCode" in value;
  isInstance = isInstance && "country" in value;
  isInstance = isInstance && "countryCode" in value;
  isInstance = isInstance && "latitude" in value;
  isInstance = isInstance && "longitude" in value;
  return isInstance;
}
function AddressLookupFromJSON(json) {
  return AddressLookupFromJSONTyped(json, false);
}
function AddressLookupFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "streetName": json["street_name"],
    "streetNumber": json["street_number"],
    "subLocality": !exists(json, "sub_locality") ? void 0 : json["sub_locality"],
    "city": json["city"],
    "zipCode": json["zip_code"],
    "country": json["country"],
    "countryCode": json["country_code"],
    "latitude": json["latitude"],
    "longitude": json["longitude"],
    "apactaCityId": !exists(json, "apacta_city_id") ? void 0 : json["apacta_city_id"]
  };
}
function AddressLookupToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "street_name": value.streetName,
    "street_number": value.streetNumber,
    "sub_locality": value.subLocality,
    "city": value.city,
    "zip_code": value.zipCode,
    "country": value.country,
    "country_code": value.countryCode,
    "latitude": value.latitude,
    "longitude": value.longitude,
    "apacta_city_id": value.apactaCityId
  };
}

// src/generated/models/ApiKey.ts
function instanceOfApiKey(value) {
  let isInstance = true;
  return isInstance;
}
function ApiKeyFromJSON(json) {
  return ApiKeyFromJSONTyped(json, false);
}
function ApiKeyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "apiKey": !exists(json, "api_key") ? void 0 : json["api_key"],
    "scope": !exists(json, "scope") ? void 0 : json["scope"]
  };
}
function ApiKeyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "api_key": value.apiKey,
    "scope": value.scope
  };
}

// src/generated/models/ApvDefaultProject200Response.ts
function instanceOfApvDefaultProject200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ApvDefaultProject200ResponseFromJSON(json) {
  return ApvDefaultProject200ResponseFromJSONTyped(json, false);
}
function ApvDefaultProject200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectFromJSON(json["data"])
  };
}
function ApvDefaultProject200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectToJSON(value.data)
  };
}

// src/generated/models/AutoCompleteAddress200Response.ts
function instanceOfAutoCompleteAddress200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function AutoCompleteAddress200ResponseFromJSON(json) {
  return AutoCompleteAddress200ResponseFromJSONTyped(json, false);
}
function AutoCompleteAddress200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(AddressLookupFromJSON)
  };
}
function AutoCompleteAddress200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(AddressLookupToJSON)
  };
}

// src/generated/models/BadRequestResponseData.ts
function instanceOfBadRequestResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function BadRequestResponseDataFromJSON(json) {
  return BadRequestResponseDataFromJSONTyped(json, false);
}
function BadRequestResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "url": !exists(json, "url") ? void 0 : json["url"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}
function BadRequestResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "url": value.url,
    "code": value.code
  };
}

// src/generated/models/BadRequestResponse.ts
function instanceOfBadRequestResponse(value) {
  let isInstance = true;
  return isInstance;
}
function BadRequestResponseFromJSON(json) {
  return BadRequestResponseFromJSONTyped(json, false);
}
function BadRequestResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : BadRequestResponseDataFromJSON(json["data"])
  };
}
function BadRequestResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": BadRequestResponseDataToJSON(value.data)
  };
}

// src/generated/models/BaseEntity.ts
function instanceOfBaseEntity(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function BaseEntityFromJSON(json) {
  return BaseEntityFromJSONTyped(json, false);
}
function BaseEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}
function BaseEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name
  };
}

// src/generated/models/ImageUrls.ts
function instanceOfImageUrls(value) {
  let isInstance = true;
  return isInstance;
}
function ImageUrlsFromJSON(json) {
  return ImageUrlsFromJSONTyped(json, false);
}
function ImageUrlsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "large": !exists(json, "large") ? void 0 : json["large"],
    "medium": !exists(json, "medium") ? void 0 : json["medium"],
    "small": !exists(json, "small") ? void 0 : json["small"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "original": !exists(json, "original") ? void 0 : json["original"]
  };
}
function ImageUrlsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "large": value.large,
    "medium": value.medium,
    "small": value.small,
    "thumbnail": value.thumbnail,
    "original": value.original
  };
}

// src/generated/models/BaseFile.ts
function instanceOfBaseFile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "originalFilename" in value;
  isInstance = isInstance && "fileUrl" in value;
  isInstance = isInstance && "downloadUrl" in value;
  return isInstance;
}
function BaseFileFromJSON(json) {
  return BaseFileFromJSONTyped(json, false);
}
function BaseFileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "originalFilename": json["original_filename"],
    "fileUrl": json["file_url"],
    "downloadUrl": json["download_url"],
    "mimeType": !exists(json, "mime_type") ? void 0 : json["mime_type"],
    "isStandardFile": !exists(json, "is_standard_file") ? void 0 : json["is_standard_file"],
    "standardFileId": !exists(json, "standard_file_id") ? void 0 : json["standard_file_id"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function BaseFileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "original_filename": value.originalFilename,
    "file_url": value.fileUrl,
    "download_url": value.downloadUrl,
    "mime_type": value.mimeType,
    "is_standard_file": value.isStandardFile,
    "standard_file_id": value.standardFileId,
    "image_urls": ImageUrlsToJSON(value.imageUrls)
  };
}

// src/generated/models/BaseFileAllOf.ts
function instanceOfBaseFileAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function BaseFileAllOfFromJSON(json) {
  return BaseFileAllOfFromJSONTyped(json, false);
}
function BaseFileAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "originalFilename": !exists(json, "original_filename") ? void 0 : json["original_filename"],
    "fileUrl": !exists(json, "file_url") ? void 0 : json["file_url"],
    "downloadUrl": !exists(json, "download_url") ? void 0 : json["download_url"],
    "mimeType": !exists(json, "mime_type") ? void 0 : json["mime_type"],
    "isStandardFile": !exists(json, "is_standard_file") ? void 0 : json["is_standard_file"],
    "standardFileId": !exists(json, "standard_file_id") ? void 0 : json["standard_file_id"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function BaseFileAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "original_filename": value.originalFilename,
    "file_url": value.fileUrl,
    "download_url": value.downloadUrl,
    "mime_type": value.mimeType,
    "is_standard_file": value.isStandardFile,
    "standard_file_id": value.standardFileId,
    "image_urls": ImageUrlsToJSON(value.imageUrls)
  };
}

// src/generated/models/BulkMarkAsInvoiced200Response.ts
function instanceOfBulkMarkAsInvoiced200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "markedProjects" in value;
  return isInstance;
}
function BulkMarkAsInvoiced200ResponseFromJSON(json) {
  return BulkMarkAsInvoiced200ResponseFromJSONTyped(json, false);
}
function BulkMarkAsInvoiced200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "markedProjects": json["marked_projects"]
  };
}
function BulkMarkAsInvoiced200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "marked_projects": value.markedProjects
  };
}

// src/generated/models/BulkMarkAsInvoicedRequest.ts
function instanceOfBulkMarkAsInvoicedRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "projectIds" in value;
  return isInstance;
}
function BulkMarkAsInvoicedRequestFromJSON(json) {
  return BulkMarkAsInvoicedRequestFromJSONTyped(json, false);
}
function BulkMarkAsInvoicedRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectIds": json["project_ids"]
  };
}
function BulkMarkAsInvoicedRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_ids": value.projectIds
  };
}

// src/generated/models/CVRLookup.ts
function instanceOfCVRLookup(value) {
  let isInstance = true;
  isInstance = isInstance && "address" in value;
  isInstance = isInstance && "city" in value;
  isInstance = isInstance && "zipcode" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function CVRLookupFromJSON(json) {
  return CVRLookupFromJSONTyped(json, false);
}
function CVRLookupFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "address": json["address"],
    "city": json["city"],
    "zipcode": json["zipcode"],
    "name": json["name"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "vat": !exists(json, "vat") ? void 0 : json["vat"]
  };
}
function CVRLookupToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "address": value.address,
    "city": value.city,
    "zipcode": value.zipcode,
    "name": value.name,
    "phone": value.phone,
    "email": value.email,
    "vat": value.vat
  };
}

// src/generated/models/CalculateInvoiceDueDate200ResponseData.ts
function instanceOfCalculateInvoiceDueDate200ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CalculateInvoiceDueDate200ResponseDataFromJSON(json) {
  return CalculateInvoiceDueDate200ResponseDataFromJSONTyped(json, false);
}
function CalculateInvoiceDueDate200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "paymentDueDate": !exists(json, "payment_due_date") ? void 0 : fromLocalDateString(json["payment_due_date"])
  };
}
function CalculateInvoiceDueDate200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "payment_due_date": value.paymentDueDate === void 0 ? void 0 : toLocalDateString(value.paymentDueDate)
  };
}

// src/generated/models/CalculateInvoiceDueDate200Response.ts
function instanceOfCalculateInvoiceDueDate200Response(value) {
  let isInstance = true;
  return isInstance;
}
function CalculateInvoiceDueDate200ResponseFromJSON(json) {
  return CalculateInvoiceDueDate200ResponseFromJSONTyped(json, false);
}
function CalculateInvoiceDueDate200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : CalculateInvoiceDueDate200ResponseDataFromJSON(json["data"])
  };
}
function CalculateInvoiceDueDate200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CalculateInvoiceDueDate200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/CalculateInvoiceDueDateRequest.ts
function instanceOfCalculateInvoiceDueDateRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "invoiceId" in value;
  isInstance = isInstance && "paymentTermId" in value;
  return isInstance;
}
function CalculateInvoiceDueDateRequestFromJSON(json) {
  return CalculateInvoiceDueDateRequestFromJSONTyped(json, false);
}
function CalculateInvoiceDueDateRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoice_id"],
    "paymentTermId": json["payment_term_id"],
    "issueDate": !exists(json, "issue_date") ? void 0 : fromLocalDateString(json["issue_date"])
  };
}
function CalculateInvoiceDueDateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoice_id": value.invoiceId,
    "payment_term_id": value.paymentTermId,
    "issue_date": value.issueDate === void 0 ? void 0 : toLocalDateString(value.issueDate)
  };
}

// src/generated/models/Card.ts
var CardTypeEnum = {
  Task: "task",
  Absence: "absence"
};
var CardStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
function instanceOfCard(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "taskId" in value;
  isInstance = isInstance && "listIndex" in value;
  return isInstance;
}
function CardFromJSON(json) {
  return CardFromJSONTyped(json, false);
}
function CardFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "userId": json["user_id"],
    "taskId": json["task_id"],
    "entityId": !exists(json, "entity_id") ? void 0 : json["entity_id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "productsAdded": !exists(json, "products_added") ? void 0 : json["products_added"],
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"],
    "listIndex": json["list_index"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "endDate": !exists(json, "end_date") ? void 0 : json["end_date"] === null ? null : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"] === null ? null : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"])
  };
}
function CardToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "task_id": value.taskId,
    "entity_id": value.entityId,
    "type": value.type,
    "status": value.status,
    "products_added": value.productsAdded,
    "form_templates": value.formTemplates,
    "list_index": value.listIndex,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime === null ? null : value.endTime.toISOString(),
    "estimate": value.estimate,
    "user": UserToJSON(value.user)
  };
}

// src/generated/models/CardUpdateDTO.ts
var CardUpdateDTOTypeEnum = {
  Task: "task"
};
var CardUpdateDTOStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
function instanceOfCardUpdateDTO(value) {
  let isInstance = true;
  return isInstance;
}
function CardUpdateDTOFromJSON(json) {
  return CardUpdateDTOFromJSONTyped(json, false);
}
function CardUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "entityId": !exists(json, "entity_id") ? void 0 : json["entity_id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "listIndex": !exists(json, "list_index") ? void 0 : json["list_index"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}
function CardUpdateDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "entity_id": value.entityId,
    "type": value.type,
    "list_index": value.listIndex,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "estimate": value.estimate,
    "status": value.status
  };
}

// src/generated/models/CardsDeleteManyRequest.ts
function instanceOfCardsDeleteManyRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "cardIds" in value;
  return isInstance;
}
function CardsDeleteManyRequestFromJSON(json) {
  return CardsDeleteManyRequestFromJSONTyped(json, false);
}
function CardsDeleteManyRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cardIds": json["cardIds"],
    "deleteCardsForAllUsers": !exists(json, "deleteCardsForAllUsers") ? void 0 : json["deleteCardsForAllUsers"]
  };
}
function CardsDeleteManyRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cardIds": value.cardIds,
    "deleteCardsForAllUsers": value.deleteCardsForAllUsers
  };
}

// src/generated/models/ChangePasswordRequest.ts
function instanceOfChangePasswordRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "password" in value;
  return isInstance;
}
function ChangePasswordRequestFromJSON(json) {
  return ChangePasswordRequestFromJSONTyped(json, false);
}
function ChangePasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "password": json["password"]
  };
}
function ChangePasswordRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "password": value.password
  };
}

// src/generated/models/ChangePasswordWithTokenRequest.ts
function instanceOfChangePasswordWithTokenRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "token" in value;
  isInstance = isInstance && "passwordOne" in value;
  isInstance = isInstance && "passwordTwo" in value;
  return isInstance;
}
function ChangePasswordWithTokenRequestFromJSON(json) {
  return ChangePasswordWithTokenRequestFromJSONTyped(json, false);
}
function ChangePasswordWithTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"],
    "passwordOne": json["passwordOne"],
    "passwordTwo": json["passwordTwo"]
  };
}
function ChangePasswordWithTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token,
    "passwordOne": value.passwordOne,
    "passwordTwo": value.passwordTwo
  };
}

// src/generated/models/ChangeStatusRequest.ts
function instanceOfChangeStatusRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "forms" in value;
  isInstance = isInstance && "approve" in value;
  return isInstance;
}
function ChangeStatusRequestFromJSON(json) {
  return ChangeStatusRequestFromJSONTyped(json, false);
}
function ChangeStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "forms": json["forms"],
    "approve": json["approve"]
  };
}
function ChangeStatusRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "forms": value.forms,
    "approve": value.approve
  };
}

// src/generated/models/CheckInRequest.ts
function instanceOfCheckInRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "projectId" in value;
  return isInstance;
}
function CheckInRequestFromJSON(json) {
  return CheckInRequestFromJSONTyped(json, false);
}
function CheckInRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectId": json["project_id"],
    "checkedIn": !exists(json, "checked_in") ? void 0 : new Date(json["checked_in"]),
    "checkinLongitude": !exists(json, "checkin_longitude") ? void 0 : json["checkin_longitude"],
    "checkinLatitude": !exists(json, "checkin_latitude") ? void 0 : json["checkin_latitude"]
  };
}
function CheckInRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "checked_in": value.checkedIn === void 0 ? void 0 : value.checkedIn.toISOString(),
    "checkin_longitude": value.checkinLongitude,
    "checkin_latitude": value.checkinLatitude
  };
}

// src/generated/models/CheckOutRequest.ts
function instanceOfCheckOutRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CheckOutRequestFromJSON(json) {
  return CheckOutRequestFromJSONTyped(json, false);
}
function CheckOutRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "checkedOut": !exists(json, "checked_out") ? void 0 : new Date(json["checked_out"]),
    "checkoutLatitude": !exists(json, "checkout_latitude") ? void 0 : json["checkout_latitude"],
    "checkoutLongitude": !exists(json, "checkout_longitude") ? void 0 : json["checkout_longitude"]
  };
}
function CheckOutRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "checked_out": value.checkedOut === void 0 ? void 0 : value.checkedOut.toISOString(),
    "checkout_latitude": value.checkoutLatitude,
    "checkout_longitude": value.checkoutLongitude
  };
}

// src/generated/models/Company.ts
function instanceOfCompany(value) {
  let isInstance = true;
  return isInstance;
}
function CompanyFromJSON(json) {
  return CompanyFromJSONTyped(json, false);
}
function CompanyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "fileId": !exists(json, "file_id") ? void 0 : json["file_id"],
    "languageId": !exists(json, "language_id") ? void 0 : json["language_id"],
    "cvr": !exists(json, "cvr") ? void 0 : json["cvr"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "invoiceEmail": !exists(json, "invoice_email") ? void 0 : json["invoice_email"],
    "contactEmail": !exists(json, "contact_email") ? void 0 : json["contact_email"],
    "receiveFormMails": !exists(json, "receive_form_mails") ? void 0 : json["receive_form_mails"],
    "phoneCountrycode": !exists(json, "phone_countrycode") ? void 0 : json["phone_countrycode"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "website": !exists(json, "website") ? void 0 : json["website"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "nextInvoiceNumber": !exists(json, "next_invoice_number") ? void 0 : json["next_invoice_number"],
    "nextProjectNumber": !exists(json, "next_project_number") ? void 0 : json["next_project_number"],
    "nextOfferNumber": !exists(json, "next_offer_number") ? void 0 : json["next_offer_number"],
    "expired": !exists(json, "expired") ? void 0 : new Date(json["expired"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "city": !exists(json, "city") ? void 0 : CityFromJSON(json["city"]),
    "file": !exists(json, "file") ? void 0 : BaseFileFromJSON(json["file"])
  };
}
function CompanyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "contact_person_id": value.contactPersonId,
    "country_id": value.countryId,
    "city_id": value.cityId,
    "file_id": value.fileId,
    "language_id": value.languageId,
    "cvr": value.cvr,
    "name": value.name,
    "street_name": value.streetName,
    "invoice_email": value.invoiceEmail,
    "contact_email": value.contactEmail,
    "receive_form_mails": value.receiveFormMails,
    "phone_countrycode": value.phoneCountrycode,
    "phone": value.phone,
    "website": value.website,
    "vat_percent": value.vatPercent,
    "next_invoice_number": value.nextInvoiceNumber,
    "next_project_number": value.nextProjectNumber,
    "next_offer_number": value.nextOfferNumber,
    "expired": value.expired === void 0 ? void 0 : value.expired.toISOString(),
    "city": CityToJSON(value.city),
    "file": BaseFileToJSON(value.file)
  };
}

// src/generated/models/ContactPerson.ts
function instanceOfContactPerson(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function ContactPersonFromJSON(json) {
  return ContactPersonFromJSONTyped(json, false);
}
function ContactPersonFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "name": json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ContactPersonToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "contact_id": value.contactId,
    "name": value.name,
    "email": value.email,
    "phone": value.phone,
    "title": value.title
  };
}

// src/generated/models/ControlPanelApiOfferStatusResponse.ts
function instanceOfControlPanelApiOfferStatusResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "identifier" in value;
  return isInstance;
}
function ControlPanelApiOfferStatusResponseFromJSON(json) {
  return ControlPanelApiOfferStatusResponseFromJSONTyped(json, false);
}
function ControlPanelApiOfferStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "identifier": json["identifier"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function ControlPanelApiOfferStatusResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "identifier": value.identifier,
    "name": value.name
  };
}

// src/generated/models/ControlPanelApiPaymentTerm.ts
function instanceOfControlPanelApiPaymentTerm(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function ControlPanelApiPaymentTermFromJSON(json) {
  return ControlPanelApiPaymentTermFromJSONTyped(json, false);
}
function ControlPanelApiPaymentTermFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function ControlPanelApiPaymentTermToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name
  };
}

// src/generated/models/Vendor.ts
function instanceOfVendor(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function VendorFromJSON(json) {
  return VendorFromJSONTyped(json, false);
}
function VendorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "cvr": !exists(json, "cvr") ? void 0 : json["cvr"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "supportAutomaticPriceFiles": !exists(json, "support_automatic_price_files") ? void 0 : json["support_automatic_price_files"]
  };
}
function VendorToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "cvr": value.cvr,
    "email": value.email,
    "identifier": value.identifier,
    "image_url": value.imageUrl,
    "support_automatic_price_files": value.supportAutomaticPriceFiles
  };
}

// src/generated/models/ExpenseReadDTO.ts
var ExpenseReadDTOStatusEnum = {
  NotHandled: "not_handled",
  ExpiredSubscription: "expired_subscription",
  Approved: "approved"
};
function instanceOfExpenseReadDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "isImported" in value;
  isInstance = isInstance && "sentToEmail" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ExpenseReadDTOFromJSON(json) {
  return ExpenseReadDTOFromJSONTyped(json, false);
}
function ExpenseReadDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "createdById": json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "projectId": json["project_id"],
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "rogerId": !exists(json, "roger_id") ? void 0 : json["roger_id"],
    "deliveryDate": !exists(json, "delivery_date") ? void 0 : new Date(json["delivery_date"]),
    "dueDate": !exists(json, "due_date") ? void 0 : new Date(json["due_date"]),
    "shortText": !exists(json, "short_text") ? void 0 : json["short_text"],
    "supplierInvoiceNumber": !exists(json, "supplier_invoice_number") ? void 0 : json["supplier_invoice_number"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "fileReference": !exists(json, "file_reference") ? void 0 : json["file_reference"],
    "status": json["status"],
    "comment": !exists(json, "comment") ? void 0 : json["comment"],
    "isImported": json["is_imported"],
    "sentToEmail": json["sent_to_email"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "totalBuyingPrice": !exists(json, "total_buying_price") ? void 0 : json["total_buying_price"],
    "totalSellingPrice": !exists(json, "total_selling_price") ? void 0 : json["total_selling_price"],
    "profitPercentage": !exists(json, "profit_percentage") ? void 0 : json["profit_percentage"],
    "isLocked": !exists(json, "is_locked") ? void 0 : json["is_locked"]
  };
}
function ExpenseReadDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "created_by_id": value.createdById,
    "created_by": UserToJSON(value.createdBy),
    "vendor_id": value.vendorId,
    "vendor": VendorToJSON(value.vendor),
    "project_id": value.projectId,
    "project": ProjectToJSON(value.project),
    "currency_id": value.currencyId,
    "activity_id": value.activityId,
    "roger_id": value.rogerId,
    "delivery_date": value.deliveryDate === void 0 ? void 0 : value.deliveryDate.toISOString(),
    "due_date": value.dueDate === void 0 ? void 0 : value.dueDate.toISOString(),
    "short_text": value.shortText,
    "supplier_invoice_number": value.supplierInvoiceNumber,
    "reference": value.reference,
    "description": value.description,
    "file_reference": value.fileReference,
    "status": value.status,
    "comment": value.comment,
    "is_imported": value.isImported,
    "sent_to_email": value.sentToEmail,
    "total_buying_price": value.totalBuyingPrice,
    "total_selling_price": value.totalSellingPrice,
    "profit_percentage": value.profitPercentage,
    "is_locked": value.isLocked
  };
}

// src/generated/models/FeedItemExpense.ts
var FeedItemExpenseTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItemExpense(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemExpenseFromJSON(json) {
  return FeedItemExpenseFromJSONTyped(json, false);
}
function FeedItemExpenseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"]),
    "data": ExpenseReadDTOFromJSON(json["data"])
  };
}
function FeedItemExpenseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date),
    "data": ExpenseReadDTOToJSON(value.data)
  };
}

// src/generated/models/FormReadDTO.ts
function instanceOfFormReadDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "formTemplateId" in value;
  isInstance = isInstance && "isDraft" in value;
  isInstance = isInstance && "isShared" in value;
  isInstance = isInstance && "sharedWithContact" in value;
  isInstance = isInstance && "sharedWithVendor" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function FormReadDTOFromJSON(json) {
  return FormReadDTOFromJSONTyped(json, false);
}
function FormReadDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "formTemplateId": json["form_template_id"],
    "formTemplate": !exists(json, "form_template") ? void 0 : BaseEntityFromJSON(json["form_template"]),
    "massFormId": !exists(json, "mass_form_id") ? void 0 : json["mass_form_id"],
    "approvedById": !exists(json, "approved_by_id") ? void 0 : json["approved_by_id"],
    "approvedBy": !exists(json, "approved_by") ? void 0 : UserFromJSON(json["approved_by"]),
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "clockingRecordId": !exists(json, "clocking_record_id") ? void 0 : json["clocking_record_id"],
    "formDate": !exists(json, "form_date") ? void 0 : new Date(json["form_date"]),
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : new Date(json["is_invoiced"]),
    "isDraft": json["is_draft"],
    "isShared": json["is_shared"],
    "sharedWithContact": json["shared_with_contact"],
    "sharedWithVendor": json["shared_with_vendor"],
    "approved": !exists(json, "approved") ? void 0 : new Date(json["approved"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "linkToPdf": !exists(json, "link_to_pdf") ? void 0 : json["link_to_pdf"],
    "linkToHtml": !exists(json, "link_to_html") ? void 0 : json["link_to_html"],
    "isEdited": !exists(json, "is_edited") ? void 0 : json["is_edited"]
  };
}
function FormReadDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "modified_by_id": value.modifiedById,
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "company_id": value.companyId,
    "project_id": value.projectId,
    "project": ProjectToJSON(value.project),
    "form_template_id": value.formTemplateId,
    "form_template": BaseEntityToJSON(value.formTemplate),
    "mass_form_id": value.massFormId,
    "approved_by_id": value.approvedById,
    "approved_by": UserToJSON(value.approvedBy),
    "activity_id": value.activityId,
    "clocking_record_id": value.clockingRecordId,
    "form_date": value.formDate === void 0 ? void 0 : value.formDate.toISOString(),
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced.toISOString(),
    "is_draft": value.isDraft,
    "is_shared": value.isShared,
    "shared_with_contact": value.sharedWithContact,
    "shared_with_vendor": value.sharedWithVendor,
    "approved": value.approved === void 0 ? void 0 : value.approved.toISOString(),
    "link_to_pdf": value.linkToPdf,
    "link_to_html": value.linkToHtml,
    "is_edited": value.isEdited
  };
}

// src/generated/models/FeedItemForm.ts
var FeedItemFormTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItemForm(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemFormFromJSON(json) {
  return FeedItemFormFromJSONTyped(json, false);
}
function FeedItemFormFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"]),
    "data": FormReadDTOFromJSON(json["data"])
  };
}
function FeedItemFormToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date),
    "data": FormReadDTOToJSON(value.data)
  };
}

// src/generated/models/InvoiceReadDTO.ts
function instanceOfInvoiceReadDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function InvoiceReadDTOFromJSON(json) {
  return InvoiceReadDTOFromJSONTyped(json, false);
}
function InvoiceReadDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"]),
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "orderLineGroupId": !exists(json, "order_line_group_id") ? void 0 : json["order_line_group_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "integrationId": !exists(json, "integration_id") ? void 0 : json["integration_id"],
    "invoiceNumber": !exists(json, "invoice_number") ? void 0 : json["invoice_number"],
    "offerNumber": !exists(json, "offer_number") ? void 0 : json["offer_number"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "message": !exists(json, "message") ? void 0 : json["message"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "issuedDate": !exists(json, "issued_date") ? void 0 : fromLocalDateString(json["issued_date"]),
    "paymentDueDate": !exists(json, "payment_due_date") ? void 0 : fromLocalDateString(json["payment_due_date"]),
    "dateFrom": !exists(json, "date_from") ? void 0 : fromLocalDateString(json["date_from"]),
    "dateTo": !exists(json, "date_to") ? void 0 : fromLocalDateString(json["date_to"]),
    "grossPayment": !exists(json, "gross_payment") ? void 0 : json["gross_payment"],
    "totalCostPrice": !exists(json, "total_cost_price") ? void 0 : json["total_cost_price"],
    "netPayment": !exists(json, "net_payment") ? void 0 : json["net_payment"],
    "isDraft": !exists(json, "is_draft") ? void 0 : json["is_draft"],
    "isOffer": !exists(json, "is_offer") ? void 0 : json["is_offer"],
    "isLocked": !exists(json, "is_locked") ? void 0 : json["is_locked"],
    "euCustomer": !exists(json, "eu_customer") ? void 0 : json["eu_customer"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "erpPaymentTermId": !exists(json, "erp_payment_term_id") ? void 0 : json["erp_payment_term_id"],
    "projectOverviewAttached": !exists(json, "project_overview_attached") ? void 0 : json["project_overview_attached"],
    "downloaded": !exists(json, "downloaded") ? void 0 : json["downloaded"],
    "includeInvoicedLines": !exists(json, "include_invoiced_lines") ? void 0 : json["include_invoiced_lines"],
    "showPricesProductsAndHours": !exists(json, "show_prices_products_and_hours") ? void 0 : json["show_prices_products_and_hours"],
    "showProductImages": !exists(json, "show_product_images") ? void 0 : json["show_product_images"],
    "showEmployeeName": !exists(json, "show_employee_name") ? void 0 : json["show_employee_name"],
    "groupByForms": !exists(json, "group_by_forms") ? void 0 : json["group_by_forms"],
    "isFinalInvoice": !exists(json, "is_final_invoice") ? void 0 : json["is_final_invoice"],
    "totalDiscountPercent": !exists(json, "total_discount_percent") ? void 0 : json["total_discount_percent"],
    "paymentTerm": !exists(json, "payment_term") ? void 0 : PaymentTermFromJSON(json["payment_term"]),
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "pdfUrl": !exists(json, "pdf_url") ? void 0 : json["pdf_url"]
  };
}
function InvoiceReadDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contact_id": value.contactId,
    "contact": ContactToJSON(value.contact),
    "vendor_id": value.vendorId,
    "project_id": value.projectId,
    "currency_id": value.currencyId,
    "payment_term_id": value.paymentTermId,
    "invoice_number": value.invoiceNumber,
    "offer_number": value.offerNumber,
    "title": value.title,
    "message": value.message,
    "reference": value.reference,
    "issued_date": value.issuedDate === void 0 ? void 0 : toLocalDateString(value.issuedDate),
    "payment_due_date": value.paymentDueDate === void 0 ? void 0 : toLocalDateString(value.paymentDueDate),
    "date_from": value.dateFrom === void 0 ? void 0 : toLocalDateString(value.dateFrom),
    "date_to": value.dateTo === void 0 ? void 0 : toLocalDateString(value.dateTo),
    "is_draft": value.isDraft,
    "is_offer": value.isOffer,
    "payment_term": PaymentTermToJSON(value.paymentTerm),
    "project": ProjectToJSON(value.project)
  };
}

// src/generated/models/FeedItemInvoice.ts
var FeedItemInvoiceTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItemInvoice(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemInvoiceFromJSON(json) {
  return FeedItemInvoiceFromJSONTyped(json, false);
}
function FeedItemInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"]),
    "data": InvoiceReadDTOFromJSON(json["data"])
  };
}
function FeedItemInvoiceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date),
    "data": InvoiceReadDTOToJSON(value.data)
  };
}

// src/generated/models/ProjectFileReadDTO.ts
var ProjectFileReadDTOTypeEnum = {
  Form: "form",
  WallPost: "wall_post",
  ExpenseFile: "expense_file",
  ProjectFile: "project_file"
};
function instanceOfProjectFileReadDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "file" in value;
  isInstance = isInstance && "fileType" in value;
  isInstance = isInstance && "fileOriginalName" in value;
  isInstance = isInstance && "fileSize" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "path" in value;
  isInstance = isInstance && "downloadUrl" in value;
  isInstance = isInstance && "parentId" in value;
  return isInstance;
}
function ProjectFileReadDTOFromJSON(json) {
  return ProjectFileReadDTOFromJSONTyped(json, false);
}
function ProjectFileReadDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "projectId": json["project_id"],
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "file": json["file"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "fileType": json["file_type"],
    "fileOriginalName": json["file_original_name"],
    "fileSize": json["file_size"],
    "description": json["description"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "path": json["path"],
    "downloadUrl": json["download_url"],
    "parentId": json["parent_id"]
  };
}
function ProjectFileReadDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "created_by": UserToJSON(value.createdBy),
    "project_id": value.projectId,
    "project": ProjectToJSON(value.project),
    "file": value.file,
    "type": value.type,
    "file_type": value.fileType,
    "file_original_name": value.fileOriginalName,
    "file_size": value.fileSize,
    "description": value.description,
    "path": value.path,
    "download_url": value.downloadUrl,
    "parent_id": value.parentId
  };
}

// src/generated/models/FeedItemProjectFile.ts
var FeedItemProjectFileTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItemProjectFile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemProjectFileFromJSON(json) {
  return FeedItemProjectFileFromJSONTyped(json, false);
}
function FeedItemProjectFileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"]),
    "data": ProjectFileReadDTOFromJSON(json["data"])
  };
}
function FeedItemProjectFileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date),
    "data": ProjectFileReadDTOToJSON(value.data)
  };
}

// src/generated/models/WallPostWallCommentsInner.ts
function instanceOfWallPostWallCommentsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function WallPostWallCommentsInnerFromJSON(json) {
  return WallPostWallCommentsInnerFromJSONTyped(json, false);
}
function WallPostWallCommentsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "wallPostId": !exists(json, "wall_post_id") ? void 0 : json["wall_post_id"],
    "created": new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "id": json["id"]
  };
}
function WallPostWallCommentsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "wall_post_id": value.wallPostId
  };
}

// src/generated/models/WallPost.ts
function instanceOfWallPost(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function WallPostFromJSON(json) {
  return WallPostFromJSONTyped(json, false);
}
function WallPostFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "message": !exists(json, "message") ? void 0 : json["message"],
    "files": !exists(json, "files") ? void 0 : json["files"].map(BaseFileFromJSON),
    "wallComments": !exists(json, "wall_comments") ? void 0 : json["wall_comments"].map(WallPostWallCommentsInnerFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function WallPostToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "project_id": value.projectId,
    "project": ProjectToJSON(value.project),
    "message": value.message,
    "files": value.files === void 0 ? void 0 : value.files.map(BaseFileToJSON),
    "wall_comments": value.wallComments === void 0 ? void 0 : value.wallComments.map(WallPostWallCommentsInnerToJSON)
  };
}

// src/generated/models/FeedItemWallPost.ts
var FeedItemWallPostTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItemWallPost(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemWallPostFromJSON(json) {
  return FeedItemWallPostFromJSONTyped(json, false);
}
function FeedItemWallPostFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"]),
    "data": WallPostFromJSON(json["data"])
  };
}
function FeedItemWallPostToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date),
    "data": WallPostToJSON(value.data)
  };
}

// src/generated/models/ControlPanelApiProjectFeedResponseDTODataInner.ts
function ControlPanelApiProjectFeedResponseDTODataInnerFromJSON(json) {
  return ControlPanelApiProjectFeedResponseDTODataInnerFromJSONTyped(json, false);
}
function ControlPanelApiProjectFeedResponseDTODataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "expense":
      return __spreadProps(__spreadValues({}, FeedItemExpenseFromJSONTyped(json, true)), { type: "expense" });
    case "form":
      return __spreadProps(__spreadValues({}, FeedItemFormFromJSONTyped(json, true)), { type: "form" });
    case "invoice":
      return __spreadProps(__spreadValues({}, FeedItemInvoiceFromJSONTyped(json, true)), { type: "invoice" });
    case "project_file":
      return __spreadProps(__spreadValues({}, FeedItemProjectFileFromJSONTyped(json, true)), { type: "project_file" });
    case "wall_post":
      return __spreadProps(__spreadValues({}, FeedItemWallPostFromJSONTyped(json, true)), { type: "wall_post" });
    default:
      throw new Error(`No variant of ControlPanelApiProjectFeedResponseDTODataInner exists with 'type=${json["type"]}'`);
  }
}
function ControlPanelApiProjectFeedResponseDTODataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "expense":
      return FeedItemExpenseToJSON(value);
    case "form":
      return FeedItemFormToJSON(value);
    case "invoice":
      return FeedItemInvoiceToJSON(value);
    case "project_file":
      return FeedItemProjectFileToJSON(value);
    case "wall_post":
      return FeedItemWallPostToJSON(value);
    default:
      throw new Error(`No variant of ControlPanelApiProjectFeedResponseDTODataInner exists with 'type=${value["type"]}'`);
  }
}

// src/generated/models/ControlPanelApiProjectFeedResponseDTOPagination.ts
function instanceOfControlPanelApiProjectFeedResponseDTOPagination(value) {
  let isInstance = true;
  isInstance = isInstance && "currentPage" in value;
  isInstance = isInstance && "hasNextPage" in value;
  isInstance = isInstance && "hasPrevPage" in value;
  isInstance = isInstance && "limit" in value;
  return isInstance;
}
function ControlPanelApiProjectFeedResponseDTOPaginationFromJSON(json) {
  return ControlPanelApiProjectFeedResponseDTOPaginationFromJSONTyped(json, false);
}
function ControlPanelApiProjectFeedResponseDTOPaginationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "currentPage": json["current_page"],
    "hasNextPage": json["has_next_page"],
    "hasPrevPage": json["has_prev_page"],
    "limit": json["limit"]
  };
}
function ControlPanelApiProjectFeedResponseDTOPaginationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "current_page": value.currentPage,
    "has_next_page": value.hasNextPage,
    "has_prev_page": value.hasPrevPage,
    "limit": value.limit
  };
}

// src/generated/models/ControlPanelApiProjectFeedResponseDTO.ts
function instanceOfControlPanelApiProjectFeedResponseDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ControlPanelApiProjectFeedResponseDTOFromJSON(json) {
  return ControlPanelApiProjectFeedResponseDTOFromJSONTyped(json, false);
}
function ControlPanelApiProjectFeedResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": ControlPanelApiProjectFeedResponseDTOPaginationFromJSON(json["pagination"]),
    "data": json["data"].map(ControlPanelApiProjectFeedResponseDTODataInnerFromJSON)
  };
}
function ControlPanelApiProjectFeedResponseDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": ControlPanelApiProjectFeedResponseDTOPaginationToJSON(value.pagination),
    "data": value.data.map(ControlPanelApiProjectFeedResponseDTODataInnerToJSON)
  };
}

// src/generated/models/ControlPanelApiProjectStatusResponse.ts
function instanceOfControlPanelApiProjectStatusResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "projectStatusTypeId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "isCustom" in value;
  isInstance = isInstance && "projectStatusType" in value;
  return isInstance;
}
function ControlPanelApiProjectStatusResponseFromJSON(json) {
  return ControlPanelApiProjectStatusResponseFromJSONTyped(json, false);
}
function ControlPanelApiProjectStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "projectStatusTypeId": json["project_status_type_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "isCustom": json["is_custom"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "projectStatusType": ProjectStatusTypeFromJSON(json["project_status_type"])
  };
}
function ControlPanelApiProjectStatusResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "project_status_type_id": value.projectStatusTypeId,
    "name": value.name,
    "description": value.description,
    "identifier": value.identifier,
    "is_custom": value.isCustom,
    "project_status_type": ProjectStatusTypeToJSON(value.projectStatusType)
  };
}

// src/generated/models/ProjectCustomFieldAttribute.ts
var ProjectCustomFieldAttributeAccessTypeEnum = {
  Panel: "control_panel",
  PanelMobileInvoices: "control_panel_mobile_invoices",
  PanelInvoices: "control_panel_invoices",
  PanelMobile: "control_panel_mobile"
};
function instanceOfProjectCustomFieldAttribute(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accessType" in value;
  isInstance = isInstance && "isActive" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function ProjectCustomFieldAttributeFromJSON(json) {
  return ProjectCustomFieldAttributeFromJSONTyped(json, false);
}
function ProjectCustomFieldAttributeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "companyId": json["company_id"],
    "name": json["name"],
    "accessType": json["access_type"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "isActive": json["is_active"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ProjectCustomFieldAttributeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "access_type": value.accessType,
    "placement": value.placement,
    "is_active": value.isActive
  };
}

// src/generated/models/ControlPanelApiProjectViewOrIndexResponse.ts
var ControlPanelApiProjectViewOrIndexResponseProjectTypeEnum = {
  Hourly: "hourly",
  FixedPrice: "fixed_price",
  Offer: "offer",
  Estimate: "estimate"
};
function instanceOfControlPanelApiProjectViewOrIndexResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "projectStatusId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "discountPercentageHours" in value;
  isInstance = isInstance && "discountPercentageProducts" in value;
  isInstance = isInstance && "isFixedPrice" in value;
  isInstance = isInstance && "workingHoursTotalCostPrice" in value;
  isInstance = isInstance && "productsTotalCostPrice" in value;
  isInstance = isInstance && "totalSalesPrice" in value;
  isInstance = isInstance && "notInvoicedAmount" in value;
  isInstance = isInstance && "ignoredNotInvoicedProducts" in value;
  isInstance = isInstance && "ignoredNotInvoicedHours" in value;
  isInstance = isInstance && "projectType" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "fullName" in value;
  isInstance = isInstance && "isOffer" in value;
  isInstance = isInstance && "isRotten" in value;
  isInstance = isInstance && "hasFinalInvoice" in value;
  return isInstance;
}
function ControlPanelApiProjectViewOrIndexResponseFromJSON(json) {
  return ControlPanelApiProjectViewOrIndexResponseFromJSONTyped(json, false);
}
function ControlPanelApiProjectViewOrIndexResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "modifiedBy": !exists(json, "modified_by") ? void 0 : UserFromJSON(json["modified_by"]),
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"]),
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "contactPerson": !exists(json, "contact_person") ? void 0 : ContactPersonFromJSON(json["contact_person"]),
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "projectStatusId": json["project_status_id"],
    "offerId": !exists(json, "offer_id") ? void 0 : json["offer_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "projectNumber": !exists(json, "project_number") ? void 0 : json["project_number"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "invoiceDiscountPercent": !exists(json, "invoice_discount_percent") ? void 0 : json["invoice_discount_percent"],
    "discountPercentageHours": json["discount_percentage_hours"],
    "discountPercentageProducts": json["discount_percentage_products"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "latitude": !exists(json, "latitude") ? void 0 : json["latitude"],
    "longitude": !exists(json, "longitude") ? void 0 : json["longitude"],
    "firstActivityDate": !exists(json, "first_activity_date") ? void 0 : new Date(json["first_activity_date"]),
    "isFixedPrice": json["is_fixed_price"],
    "parentId": !exists(json, "parent_id") ? void 0 : json["parent_id"],
    "parentProject": !exists(json, "parent_project") ? void 0 : ControlPanelApiProjectViewOrIndexResponseFromJSON(json["parent_project"]),
    "childProjects": !exists(json, "child_projects") ? void 0 : json["child_projects"].map(ControlPanelApiProjectViewOrIndexResponseFromJSON),
    "workingHoursTotalCostPrice": json["working_hours_total_cost_price"],
    "productsTotalCostPrice": json["products_total_cost_price"],
    "totalSalesPrice": json["total_sales_price"],
    "notInvoicedAmount": json["not_invoiced_amount"],
    "bookedInvoicedAmount": !exists(json, "booked_invoiced_amount") ? void 0 : json["booked_invoiced_amount"],
    "ignoredNotInvoicedProducts": json["ignored_not_invoiced_products"],
    "ignoredNotInvoicedHours": json["ignored_not_invoiced_hours"],
    "projectImageUrl": !exists(json, "project_image_url") ? void 0 : json["project_image_url"],
    "projectType": json["project_type"],
    "customFields": !exists(json, "custom_fields") ? void 0 : json["custom_fields"],
    "customFieldAttributes": !exists(json, "custom_field_attributes") ? void 0 : json["custom_field_attributes"].map(ProjectCustomFieldAttributeFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "fullName": json["full_name"],
    "isOffer": json["is_offer"],
    "isRotten": json["is_rotten"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "hasFinalInvoice": json["has_final_invoice"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"])
  };
}
function ControlPanelApiProjectViewOrIndexResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "created_by": UserToJSON(value.createdBy),
    "modified_by": UserToJSON(value.modifiedBy),
    "contact_id": value.contactId,
    "contact": ContactToJSON(value.contact),
    "contact_person_id": value.contactPersonId,
    "contact_person": ContactPersonToJSON(value.contactPerson),
    "city_id": value.cityId,
    "project_status_id": value.projectStatusId,
    "offer_id": value.offerId,
    "label_id": value.labelId,
    "name": value.name,
    "description": value.description,
    "invoice_discount_percent": value.invoiceDiscountPercent,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "street_name": value.streetName,
    "latitude": value.latitude,
    "longitude": value.longitude,
    "is_fixed_price": value.isFixedPrice,
    "parent_id": value.parentId,
    "parent_project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.parentProject),
    "child_projects": value.childProjects === void 0 ? void 0 : value.childProjects.map(ControlPanelApiProjectViewOrIndexResponseToJSON),
    "working_hours_total_cost_price": value.workingHoursTotalCostPrice,
    "products_total_cost_price": value.productsTotalCostPrice,
    "total_sales_price": value.totalSalesPrice,
    "project_type": value.projectType,
    "custom_fields": value.customFields,
    "custom_field_attributes": value.customFieldAttributes === void 0 ? void 0 : value.customFieldAttributes.map(ProjectCustomFieldAttributeToJSON),
    "is_offer": value.isOffer,
    "zip_code": value.zipCode,
    "city_name": value.cityName,
    "label": LabelEntityToJSON(value.label)
  };
}

// src/generated/models/ControlPanelProductsToTaskProduct.ts
function instanceOfControlPanelProductsToTaskProduct(value) {
  let isInstance = true;
  return isInstance;
}
function ControlPanelProductsToTaskProductFromJSON(json) {
  return ControlPanelProductsToTaskProductFromJSONTyped(json, false);
}
function ControlPanelProductsToTaskProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"]
  };
}
function ControlPanelProductsToTaskProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "product_number": value.productNumber,
    "barcode": value.barcode,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice
  };
}

// src/generated/models/ControlPanelProductsToTask.ts
function instanceOfControlPanelProductsToTask(value) {
  let isInstance = true;
  isInstance = isInstance && "amount" in value;
  return isInstance;
}
function ControlPanelProductsToTaskFromJSON(json) {
  return ControlPanelProductsToTaskFromJSONTyped(json, false);
}
function ControlPanelProductsToTaskFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "amount": json["amount"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "expenseLineId": !exists(json, "expense_line-id") ? void 0 : json["expense_line-id"],
    "product": !exists(json, "product") ? void 0 : ControlPanelProductsToTaskProductFromJSON(json["product"])
  };
}
function ControlPanelProductsToTaskToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_id": value.productId,
    "amount": value.amount,
    "name": value.name,
    "vendor_product_id": value.vendorProductId,
    "expense_line-id": value.expenseLineId,
    "product": ControlPanelProductsToTaskProductToJSON(value.product)
  };
}

// src/generated/models/CreateAbsence201ResponseData.ts
function instanceOfCreateAbsence201ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CreateAbsence201ResponseDataFromJSON(json) {
  return CreateAbsence201ResponseDataFromJSONTyped(json, false);
}
function CreateAbsence201ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON),
    "absences": !exists(json, "absences") ? void 0 : json["absences"].map(AbsenceFromJSON)
  };
}
function CreateAbsence201ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON),
    "absences": value.absences === void 0 ? void 0 : value.absences.map(AbsenceToJSON)
  };
}

// src/generated/models/CreateAbsence201Response.ts
function instanceOfCreateAbsence201Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CreateAbsence201ResponseFromJSON(json) {
  return CreateAbsence201ResponseFromJSONTyped(json, false);
}
function CreateAbsence201ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateAbsence201ResponseDataFromJSON(json["data"])
  };
}
function CreateAbsence201ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateAbsence201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/CreateAbsenceRequest.ts
function instanceOfCreateAbsenceRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "absenceTypeId" in value;
  isInstance = isInstance && "startDate" in value;
  return isInstance;
}
function CreateAbsenceRequestFromJSON(json) {
  return CreateAbsenceRequestFromJSONTyped(json, false);
}
function CreateAbsenceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "userIds": !exists(json, "user_ids") ? void 0 : json["user_ids"],
    "absenceTypeId": json["absence_type_id"],
    "startDate": new Date(json["start_date"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "includeWeekend": !exists(json, "include_weekend") ? void 0 : json["include_weekend"],
    "isFullDay": !exists(json, "is_full_day") ? void 0 : json["is_full_day"]
  };
}
function CreateAbsenceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_ids": value.userIds,
    "absence_type_id": value.absenceTypeId,
    "start_date": value.startDate.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "duration": value.duration,
    "include_weekend": value.includeWeekend,
    "is_full_day": value.isFullDay
  };
}

// src/generated/models/CreateAbsenceType201ResponseData.ts
function instanceOfCreateAbsenceType201ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CreateAbsenceType201ResponseDataFromJSON(json) {
  return CreateAbsenceType201ResponseDataFromJSONTyped(json, false);
}
function CreateAbsenceType201ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"]
  };
}
function CreateAbsenceType201ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// src/generated/models/CreateAbsenceType201Response.ts
function instanceOfCreateAbsenceType201Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CreateAbsenceType201ResponseFromJSON(json) {
  return CreateAbsenceType201ResponseFromJSONTyped(json, false);
}
function CreateAbsenceType201ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateAbsenceType201ResponseDataFromJSON(json["data"])
  };
}
function CreateAbsenceType201ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateAbsenceType201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/CreateAbsenceTypeRequest.ts
function instanceOfCreateAbsenceTypeRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function CreateAbsenceTypeRequestFromJSON(json) {
  return CreateAbsenceTypeRequestFromJSONTyped(json, false);
}
function CreateAbsenceTypeRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "salaryId": !exists(json, "salary_id") ? void 0 : json["salary_id"]
  };
}
function CreateAbsenceTypeRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "salary_id": value.salaryId
  };
}

// src/generated/models/CreateCardAndAbsences201ResponseData.ts
function instanceOfCreateCardAndAbsences201ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CreateCardAndAbsences201ResponseDataFromJSON(json) {
  return CreateCardAndAbsences201ResponseDataFromJSONTyped(json, false);
}
function CreateCardAndAbsences201ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON)
  };
}
function CreateCardAndAbsences201ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON)
  };
}

// src/generated/models/CreateCardAndAbsences201Response.ts
function instanceOfCreateCardAndAbsences201Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CreateCardAndAbsences201ResponseFromJSON(json) {
  return CreateCardAndAbsences201ResponseFromJSONTyped(json, false);
}
function CreateCardAndAbsences201ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateCardAndAbsences201ResponseDataFromJSON(json["data"])
  };
}
function CreateCardAndAbsences201ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateCardAndAbsences201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskId.ts
var RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
var RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskId(value) {
  let isInstance = true;
  isInstance = isInstance && "entityId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "userId" in value;
  return isInstance;
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSON(json) {
  return RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSONTyped(json, false);
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "entityId": json["entity_id"],
    "projectId": json["project_id"],
    "userId": json["user_id"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"] === null ? null : new Date(json["end_time"]),
    "indexes": !exists(json, "indexes") ? void 0 : json["indexes"],
    "listIndex": !exists(json, "list_index") ? void 0 : json["list_index"],
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"]
  };
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "entity_id": value.entityId,
    "project_id": value.projectId,
    "user_id": value.userId,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime === null ? null : value.endTime.toISOString(),
    "indexes": value.indexes,
    "list_index": value.listIndex,
    "estimate": value.estimate,
    "label_ids": value.labelIds,
    "status": value.status,
    "repeat": value.repeat,
    "interval": value.interval
  };
}

// src/generated/models/RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskName.ts
var RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
var RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskName(value) {
  let isInstance = true;
  isInstance = isInstance && "taskName" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "taskDescription" in value;
  return isInstance;
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSON(json) {
  return RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSONTyped(json, false);
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "taskName": json["task_name"],
    "projectId": json["project_id"],
    "userId": json["user_id"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"] === null ? null : new Date(json["end_time"]),
    "indexes": !exists(json, "indexes") ? void 0 : json["indexes"],
    "listIndex": !exists(json, "list_index") ? void 0 : json["list_index"],
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "taskDescription": json["task_description"],
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"]
  };
}
function RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "task_name": value.taskName,
    "project_id": value.projectId,
    "user_id": value.userId,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime === null ? null : value.endTime.toISOString(),
    "indexes": value.indexes,
    "list_index": value.listIndex,
    "estimate": value.estimate,
    "task_description": value.taskDescription,
    "label_ids": value.labelIds,
    "status": value.status,
    "repeat": value.repeat,
    "interval": value.interval
  };
}

// src/generated/models/CreateCardAndTaskRequestCardsInner.ts
function CreateCardAndTaskRequestCardsInnerFromJSON(json) {
  return CreateCardAndTaskRequestCardsInnerFromJSONTyped(json, false);
}
function CreateCardAndTaskRequestCardsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return __spreadValues(__spreadValues({}, RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSONTyped(json, true)), RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSONTyped(json, true));
}
function CreateCardAndTaskRequestCardsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskId(value)) {
    return RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdToJSON(value);
  }
  if (instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskName(value)) {
    return RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameToJSON(value);
  }
  return {};
}

// src/generated/models/CreateCardAndAbsencesRequest.ts
function instanceOfCreateCardAndAbsencesRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "cards" in value;
  return isInstance;
}
function CreateCardAndAbsencesRequestFromJSON(json) {
  return CreateCardAndAbsencesRequestFromJSONTyped(json, false);
}
function CreateCardAndAbsencesRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": json["cards"].map(CreateCardAndTaskRequestCardsInnerFromJSON),
    "originalCards": !exists(json, "original_cards") ? void 0 : json["original_cards"]
  };
}
function CreateCardAndAbsencesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards.map(CreateCardAndTaskRequestCardsInnerToJSON),
    "original_cards": value.originalCards
  };
}

// src/generated/models/FormTemplateSimpleEntity.ts
function instanceOfFormTemplateSimpleEntity(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "identifier" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function FormTemplateSimpleEntityFromJSON(json) {
  return FormTemplateSimpleEntityFromJSONTyped(json, false);
}
function FormTemplateSimpleEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "identifier": json["identifier"],
    "pdfTemplateIdentifier": !exists(json, "pdf_template_identifier") ? void 0 : json["pdf_template_identifier"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "isActive": !exists(json, "is_active") ? void 0 : json["is_active"],
    "isTimeSheet": !exists(json, "is_time_sheet") ? void 0 : json["is_time_sheet"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function FormTemplateSimpleEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "identifier": value.identifier,
    "pdf_template_identifier": value.pdfTemplateIdentifier,
    "description": value.description,
    "is_active": value.isActive,
    "is_time_sheet": value.isTimeSheet
  };
}

// src/generated/models/FormTemplateModelWithJsonFormsDataFields.ts
function instanceOfFormTemplateModelWithJsonFormsDataFields(value) {
  let isInstance = true;
  isInstance = isInstance && "schema" in value;
  isInstance = isInstance && "uiSchema" in value;
  return isInstance;
}
function FormTemplateModelWithJsonFormsDataFieldsFromJSON(json) {
  return FormTemplateModelWithJsonFormsDataFieldsFromJSONTyped(json, false);
}
function FormTemplateModelWithJsonFormsDataFieldsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "schema": json["schema"],
    "uiSchema": json["ui-schema"]
  };
}
function FormTemplateModelWithJsonFormsDataFieldsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "schema": value.schema,
    "ui-schema": value.uiSchema
  };
}

// src/generated/models/FormTemplateModelWithJsonFormsData.ts
function instanceOfFormTemplateModelWithJsonFormsData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "identifier" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  isInstance = isInstance && "fields" in value;
  return isInstance;
}
function FormTemplateModelWithJsonFormsDataFromJSON(json) {
  return FormTemplateModelWithJsonFormsDataFromJSONTyped(json, false);
}
function FormTemplateModelWithJsonFormsDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "formCategoryId": !exists(json, "form_category_id") ? void 0 : json["form_category_id"],
    "formOverviewCategoryId": !exists(json, "form_overview_category_id") ? void 0 : json["form_overview_category_id"],
    "name": json["name"],
    "identifier": json["identifier"],
    "pdfTemplateIdentifier": !exists(json, "pdf_template_identifier") ? void 0 : json["pdf_template_identifier"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "isActive": !exists(json, "is_active") ? void 0 : json["is_active"],
    "isTimeSheet": !exists(json, "is_time_sheet") ? void 0 : json["is_time_sheet"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"]),
    "fields": FormTemplateModelWithJsonFormsDataFieldsFromJSON(json["fields"])
  };
}
function FormTemplateModelWithJsonFormsDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "form_category_id": value.formCategoryId,
    "form_overview_category_id": value.formOverviewCategoryId,
    "name": value.name,
    "identifier": value.identifier,
    "pdf_template_identifier": value.pdfTemplateIdentifier,
    "description": value.description,
    "is_active": value.isActive,
    "is_time_sheet": value.isTimeSheet,
    "fields": FormTemplateModelWithJsonFormsDataFieldsToJSON(value.fields)
  };
}

// src/generated/models/FormTemplatesTasksModel.ts
function instanceOfFormTemplatesTasksModel(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "taskId" in value;
  isInstance = isInstance && "formTemplateId" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function FormTemplatesTasksModelFromJSON(json) {
  return FormTemplatesTasksModelFromJSONTyped(json, false);
}
function FormTemplatesTasksModelFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "taskId": json["task_id"],
    "formTemplateId": json["form_template_id"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"]),
    "formTemplate": !exists(json, "form_template") ? void 0 : FormTemplateModelWithJsonFormsDataFromJSON(json["form_template"])
  };
}
function FormTemplatesTasksModelToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "task_id": value.taskId,
    "form_template_id": value.formTemplateId,
    "form_template": FormTemplateModelWithJsonFormsDataToJSON(value.formTemplate)
  };
}

// src/generated/models/ProductVariant.ts
var ProductVariantTypeEnum = {
  ExpenseLine: "expense_line",
  VendorProduct: "vendor_product"
};
function instanceOfProductVariant(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "isPrimaryBuyingOption" in value;
  isInstance = isInstance && "latestPrice" in value;
  isInstance = isInstance && "latestUpdated" in value;
  return isInstance;
}
function ProductVariantFromJSON(json) {
  return ProductVariantFromJSONTyped(json, false);
}
function ProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "type": json["type"],
    "isPrimaryBuyingOption": json["is_primary_buying_option"],
    "latestPrice": json["latest_price"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "latestUpdated": new Date(json["latest_updated"]),
    "msrpPrice": !exists(json, "msrp_price") ? void 0 : json["msrp_price"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"])
  };
}
function ProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "image_urls": ImageUrlsToJSON(value.imageUrls)
  };
}

// src/generated/models/Product.ts
var ProductPriceTypeEnum = {
  Manual: "manual",
  CostBased: "cost_based"
};
function instanceOfProduct(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ProductFromJSON(json) {
  return ProductFromJSONTyped(json, false);
}
function ProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "origin": !exists(json, "origin") ? void 0 : json["origin"],
    "priceType": !exists(json, "price_type") ? void 0 : json["price_type"],
    "name": json["name"],
    "nickname": !exists(json, "nickname") ? void 0 : json["nickname"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "unit": !exists(json, "unit") ? void 0 : json["unit"],
    "productRule": !exists(json, "product_rule") ? void 0 : json["product_rule"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "isManualBuyingPrice": !exists(json, "is_manual_buying_price") ? void 0 : json["is_manual_buying_price"],
    "isManualSellingPrice": !exists(json, "is_manual_selling_price") ? void 0 : json["is_manual_selling_price"],
    "image": !exists(json, "image") ? void 0 : json["image"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "versionId": !exists(json, "version_id") ? void 0 : json["version_id"],
    "variants": !exists(json, "variants") ? void 0 : json["variants"].map(ProductVariantFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "translatedOrigin": !exists(json, "translated_origin") ? void 0 : json["translated_origin"],
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"]),
    "hasCheaperVariantAvailable": !exists(json, "has_cheaper_variant_available") ? void 0 : json["has_cheaper_variant_available"],
    "minimumMarketPrice": !exists(json, "minimum_market_price") ? void 0 : json["minimum_market_price"],
    "averageMarketPrice": !exists(json, "average_market_price") ? void 0 : json["average_market_price"],
    "optimizationPotential": !exists(json, "optimization_potential") ? void 0 : json["optimization_potential"]
  };
}
function ProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "label_id": value.labelId,
    "price_type": value.priceType,
    "name": value.name,
    "nickname": value.nickname,
    "description": value.description,
    "product_number": value.productNumber,
    "barcode": value.barcode,
    "unit": value.unit,
    "product_rule": value.productRule,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "is_manual_buying_price": value.isManualBuyingPrice,
    "is_manual_selling_price": value.isManualSellingPrice,
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType,
    "variants": value.variants === void 0 ? void 0 : value.variants.map(ProductVariantToJSON),
    "label": LabelEntityToJSON(value.label)
  };
}

// src/generated/models/ProductsTask.ts
function instanceOfProductsTask(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "taskId" in value;
  isInstance = isInstance && "productId" in value;
  return isInstance;
}
function ProductsTaskFromJSON(json) {
  return ProductsTaskFromJSONTyped(json, false);
}
function ProductsTaskFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "taskId": json["task_id"],
    "productId": json["product_id"],
    "amount": !exists(json, "amount") ? void 0 : json["amount"],
    "product": !exists(json, "product") ? void 0 : ProductFromJSON(json["product"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ProductsTaskToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amount": value.amount,
    "product": ProductToJSON(value.product)
  };
}

// src/generated/models/TaskReadDTO.ts
var TaskReadDTORepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfTaskReadDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function TaskReadDTOFromJSON(json) {
  return TaskReadDTOFromJSONTyped(json, false);
}
function TaskReadDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "active": !exists(json, "active") ? void 0 : json["active"],
    "recurringRule": !exists(json, "recurring_rule") ? void 0 : json["recurring_rule"],
    "startDate": !exists(json, "start_date") ? void 0 : new Date(json["start_date"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"].map(FormTemplateSimpleEntityFromJSON),
    "formTemplatesTasks": !exists(json, "form_templates_tasks") ? void 0 : json["form_templates_tasks"].map(FormTemplatesTasksModelFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "productsTasks": !exists(json, "products_tasks") ? void 0 : json["products_tasks"].map(ProductsTaskFromJSON),
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function TaskReadDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "active": value.active,
    "recurring_rule": value.recurringRule,
    "start_date": value.startDate === void 0 ? void 0 : value.startDate.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "estimate": value.estimate,
    "repeat": value.repeat,
    "interval": value.interval,
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "form_templates": value.formTemplates === void 0 ? void 0 : value.formTemplates.map(FormTemplateSimpleEntityToJSON),
    "form_templates_tasks": value.formTemplatesTasks === void 0 ? void 0 : value.formTemplatesTasks.map(FormTemplatesTasksModelToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "products_tasks": value.productsTasks === void 0 ? void 0 : value.productsTasks.map(ProductsTaskToJSON),
    "project": ProjectToJSON(value.project)
  };
}

// src/generated/models/CreateCardAndTask201ResponseData.ts
function instanceOfCreateCardAndTask201ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function CreateCardAndTask201ResponseDataFromJSON(json) {
  return CreateCardAndTask201ResponseDataFromJSONTyped(json, false);
}
function CreateCardAndTask201ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON),
    "tasks": !exists(json, "tasks") ? void 0 : json["tasks"].map(TaskReadDTOFromJSON)
  };
}
function CreateCardAndTask201ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON),
    "tasks": value.tasks === void 0 ? void 0 : value.tasks.map(TaskReadDTOToJSON)
  };
}

// src/generated/models/CreateCardAndTask201Response.ts
function instanceOfCreateCardAndTask201Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CreateCardAndTask201ResponseFromJSON(json) {
  return CreateCardAndTask201ResponseFromJSONTyped(json, false);
}
function CreateCardAndTask201ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateCardAndTask201ResponseDataFromJSON(json["data"])
  };
}
function CreateCardAndTask201ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateCardAndTask201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/CreateCardAndTaskRequest.ts
function instanceOfCreateCardAndTaskRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "cards" in value;
  return isInstance;
}
function CreateCardAndTaskRequestFromJSON(json) {
  return CreateCardAndTaskRequestFromJSONTyped(json, false);
}
function CreateCardAndTaskRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "deleteExistingCards": !exists(json, "delete_existing_cards") ? void 0 : json["delete_existing_cards"],
    "includeWeekends": !exists(json, "include_weekends") ? void 0 : json["include_weekends"],
    "cards": json["cards"].map(CreateCardAndTaskRequestCardsInnerFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "formTemplateIds": !exists(json, "form_template_ids") ? void 0 : json["form_template_ids"],
    "originalCardId": !exists(json, "original_card_id") ? void 0 : json["original_card_id"]
  };
}
function CreateCardAndTaskRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "delete_existing_cards": value.deleteExistingCards,
    "include_weekends": value.includeWeekends,
    "cards": value.cards.map(CreateCardAndTaskRequestCardsInnerToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "form_template_ids": value.formTemplateIds,
    "original_card_id": value.originalCardId
  };
}

// src/generated/models/CreateContactRequestContactTypes.ts
function instanceOfCreateContactRequestContactTypes(value) {
  let isInstance = true;
  return isInstance;
}
function CreateContactRequestContactTypesFromJSON(json) {
  return CreateContactRequestContactTypesFromJSONTyped(json, false);
}
function CreateContactRequestContactTypesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ids": !exists(json, "_ids") ? void 0 : json["_ids"]
  };
}
function CreateContactRequestContactTypesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "_ids": value.ids
  };
}

// src/generated/models/CreateContactRequest.ts
function instanceOfCreateContactRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "contactTypes" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function CreateContactRequestFromJSON(json) {
  return CreateContactRequestFromJSONTyped(json, false);
}
function CreateContactRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "contactTypes": CreateContactRequestContactTypesFromJSON(json["contact_types"]),
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "address": !exists(json, "address") ? void 0 : json["address"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "website": !exists(json, "website") ? void 0 : json["website"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "cvr": !exists(json, "cvr") ? void 0 : json["cvr"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "discountPercentageHours": !exists(json, "discount_percentage_hours") ? void 0 : json["discount_percentage_hours"],
    "discountPercentageProducts": !exists(json, "discount_percentage_products") ? void 0 : json["discount_percentage_products"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "ean": !exists(json, "ean") ? void 0 : json["ean"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"]
  };
}
function CreateContactRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "city_id": value.cityId,
    "contact_types": CreateContactRequestContactTypesToJSON(value.contactTypes),
    "name": value.name,
    "description": value.description,
    "address": value.address,
    "email": value.email,
    "website": value.website,
    "phone": value.phone,
    "cvr": value.cvr,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "country_id": value.countryId,
    "label_id": value.labelId,
    "ean": value.ean,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "payment_term_id": value.paymentTermId
  };
}

// src/generated/models/CreateCustomEmailTemplateRequest.ts
function instanceOfCreateCustomEmailTemplateRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "subject" in value;
  isInstance = isInstance && "content" in value;
  return isInstance;
}
function CreateCustomEmailTemplateRequestFromJSON(json) {
  return CreateCustomEmailTemplateRequestFromJSONTyped(json, false);
}
function CreateCustomEmailTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "subject": json["subject"],
    "content": json["content"],
    "lang": !exists(json, "lang") ? void 0 : json["lang"]
  };
}
function CreateCustomEmailTemplateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "subject": value.subject,
    "content": value.content,
    "lang": value.lang
  };
}

// src/generated/models/CreateExpenseFromFile200ResponseData.ts
function instanceOfCreateExpenseFromFile200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function CreateExpenseFromFile200ResponseDataFromJSON(json) {
  return CreateExpenseFromFile200ResponseDataFromJSONTyped(json, false);
}
function CreateExpenseFromFile200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}
function CreateExpenseFromFile200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id
  };
}

// src/generated/models/CreateExpenseFromFile200Response.ts
function instanceOfCreateExpenseFromFile200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CreateExpenseFromFile200ResponseFromJSON(json) {
  return CreateExpenseFromFile200ResponseFromJSONTyped(json, false);
}
function CreateExpenseFromFile200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateExpenseFromFile200ResponseDataFromJSON(json["data"])
  };
}
function CreateExpenseFromFile200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateExpenseFromFile200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/CreateExpenseRequest.ts
var CreateExpenseRequestStatusEnum = {
  NotHandled: "not_handled",
  ExpiredSubscription: "expired_subscription",
  Approved: "approved"
};
function instanceOfCreateExpenseRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateExpenseRequestFromJSON(json) {
  return CreateExpenseRequestFromJSONTyped(json, false);
}
function CreateExpenseRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "deliveryDate": !exists(json, "delivery_date") ? void 0 : fromLocalDateString(json["delivery_date"]),
    "issueDate": !exists(json, "issue_date") ? void 0 : fromLocalDateString(json["issue_date"]),
    "dueDate": !exists(json, "due_date") ? void 0 : fromLocalDateString(json["due_date"]),
    "shortText": !exists(json, "short_text") ? void 0 : json["short_text"],
    "supplierInvoiceNumber": !exists(json, "supplier_invoice_number") ? void 0 : json["supplier_invoice_number"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "comment": !exists(json, "comment") ? void 0 : json["comment"],
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}
function CreateExpenseRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_id": value.vendorId,
    "project_id": value.projectId,
    "activity_id": value.activityId,
    "delivery_date": value.deliveryDate === void 0 ? void 0 : toLocalDateString(value.deliveryDate),
    "issue_date": value.issueDate === void 0 ? void 0 : toLocalDateString(value.issueDate),
    "due_date": value.dueDate === void 0 ? void 0 : toLocalDateString(value.dueDate),
    "short_text": value.shortText,
    "supplier_invoice_number": value.supplierInvoiceNumber,
    "reference": value.reference,
    "description": value.description,
    "comment": value.comment,
    "status": value.status
  };
}

// src/generated/models/CreateFirebaseTokenRequest.ts
function instanceOfCreateFirebaseTokenRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "token" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "deviceId" in value;
  return isInstance;
}
function CreateFirebaseTokenRequestFromJSON(json) {
  return CreateFirebaseTokenRequestFromJSONTyped(json, false);
}
function CreateFirebaseTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"],
    "userId": json["user_id"],
    "deviceId": json["device_id"]
  };
}
function CreateFirebaseTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token,
    "user_id": value.userId,
    "device_id": value.deviceId
  };
}

// src/generated/models/CreateFormRequest.ts
function instanceOfCreateFormRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateFormRequestFromJSON(json) {
  return CreateFormRequestFromJSONTyped(json, false);
}
function CreateFormRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "formTemplateId": !exists(json, "form_template_id") ? void 0 : json["form_template_id"],
    "approvedById": !exists(json, "approved_by_id") ? void 0 : json["approved_by_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "clockingRecordId": !exists(json, "clocking_record_id") ? void 0 : json["clocking_record_id"],
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : new Date(json["is_invoiced"]),
    "isDraft": !exists(json, "is_draft") ? void 0 : json["is_draft"],
    "approved": !exists(json, "approved") ? void 0 : new Date(json["approved"]),
    "fields": !exists(json, "fields") ? void 0 : json["fields"]
  };
}
function CreateFormRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "company_id": value.companyId,
    "project_id": value.projectId,
    "form_template_id": value.formTemplateId,
    "approved_by_id": value.approvedById,
    "activity_id": value.activityId,
    "clocking_record_id": value.clockingRecordId,
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced.toISOString(),
    "is_draft": value.isDraft,
    "approved": value.approved === void 0 ? void 0 : value.approved.toISOString(),
    "fields": value.fields
  };
}

// src/generated/models/CreateInvoiceRequest.ts
function instanceOfCreateInvoiceRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateInvoiceRequestFromJSON(json) {
  return CreateInvoiceRequestFromJSONTyped(json, false);
}
function CreateInvoiceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "issuedDate": !exists(json, "issued_date") ? void 0 : fromLocalDateString(json["issued_date"]),
    "dateFrom": !exists(json, "date_from") ? void 0 : fromLocalDateString(json["date_from"]),
    "dateTo": !exists(json, "date_to") ? void 0 : fromLocalDateString(json["date_to"]),
    "activityIds": !exists(json, "activity_ids") ? void 0 : json["activity_ids"],
    "includeInvoicedForms": !exists(json, "include_invoiced_forms") ? void 0 : json["include_invoiced_forms"],
    "combineProductLines": !exists(json, "combine_product_lines") ? void 0 : json["combine_product_lines"],
    "combineWorkingTimeLines": !exists(json, "combine_working_time_lines") ? void 0 : json["combine_working_time_lines"],
    "groupByForms": !exists(json, "group_by_forms") ? void 0 : json["group_by_forms"],
    "hideUsagePrices": !exists(json, "hide_usage_prices") ? void 0 : json["hide_usage_prices"],
    "isFinalInvoice": !exists(json, "is_final_invoice") ? void 0 : json["is_final_invoice"],
    "amount": !exists(json, "amount") ? void 0 : json["amount"],
    "completionPercentage": !exists(json, "completion_percentage") ? void 0 : json["completion_percentage"],
    "includeOfferLines": !exists(json, "include_offer_lines") ? void 0 : json["include_offer_lines"],
    "includeNotInvoicedHoursAndProducts": !exists(json, "include_not_invoiced_hours_and_products") ? void 0 : json["include_not_invoiced_hours_and_products"]
  };
}
function CreateInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "contact_id": value.contactId,
    "contact_person_id": value.contactPersonId,
    "issued_date": value.issuedDate === void 0 ? void 0 : toLocalDateString(value.issuedDate),
    "date_from": value.dateFrom === void 0 ? void 0 : toLocalDateString(value.dateFrom),
    "date_to": value.dateTo === void 0 ? void 0 : toLocalDateString(value.dateTo),
    "activity_ids": value.activityIds,
    "include_invoiced_forms": value.includeInvoicedForms,
    "combine_product_lines": value.combineProductLines,
    "combine_working_time_lines": value.combineWorkingTimeLines,
    "group_by_forms": value.groupByForms,
    "hide_usage_prices": value.hideUsagePrices,
    "is_final_invoice": value.isFinalInvoice,
    "amount": value.amount,
    "completion_percentage": value.completionPercentage,
    "include_offer_lines": value.includeOfferLines,
    "include_not_invoiced_hours_and_products": value.includeNotInvoicedHoursAndProducts
  };
}

// src/generated/models/CreateLabelRequest.ts
var CreateLabelRequestEntityEnum = {
  Employee: "employee",
  Task: "task"
};
function instanceOfCreateLabelRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "text" in value;
  return isInstance;
}
function CreateLabelRequestFromJSON(json) {
  return CreateLabelRequestFromJSONTyped(json, false);
}
function CreateLabelRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "text": json["text"],
    "bgColor": !exists(json, "bg_color") ? void 0 : json["bg_color"],
    "textColor": !exists(json, "text_color") ? void 0 : json["text_color"],
    "entity": !exists(json, "entity") ? void 0 : json["entity"]
  };
}
function CreateLabelRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "text": value.text,
    "bg_color": value.bgColor,
    "text_color": value.textColor,
    "entity": value.entity
  };
}

// src/generated/models/CreateProductRequest.ts
var CreateProductRequestPriceTypeEnum = {
  CostBased: "cost_based",
  Manual: "manual"
};
var CreateProductRequestProductRuleEnum = {
  ReduceWorkingHours: "REDUCE_WORKING_HOURS",
  ReplaceWorkingHours: "REPLACE_WORKING_HOURS"
};
function instanceOfCreateProductRequest(value) {
  let isInstance = true;
  return isInstance;
}
function CreateProductRequestFromJSON(json) {
  return CreateProductRequestFromJSONTyped(json, false);
}
function CreateProductRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "variantType": !exists(json, "variant_type") ? void 0 : json["variant_type"],
    "variantId": !exists(json, "variant_id") ? void 0 : json["variant_id"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "unit": !exists(json, "unit") ? void 0 : json["unit"],
    "priceType": !exists(json, "price_type") ? void 0 : json["price_type"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "productRule": !exists(json, "product_rule") ? void 0 : json["product_rule"],
    "image": !exists(json, "image") ? void 0 : json["image"]
  };
}
function CreateProductRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "company_id": value.companyId,
    "name": value.name,
    "vendor_product_id": value.vendorProductId,
    "expense_line_id": value.expenseLineId,
    "label_id": value.labelId,
    "variant_type": value.variantType,
    "variant_id": value.variantId,
    "description": value.description,
    "product_number": value.productNumber,
    "barcode": value.barcode,
    "unit": value.unit,
    "price_type": value.priceType,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "product_rule": value.productRule,
    "image": value.image
  };
}

// src/generated/models/CreateProjectCustomFieldAttributeRequest.ts
var CreateProjectCustomFieldAttributeRequestAccessTypeEnum = {
  Panel: "control_panel",
  PanelMobileInvoices: "control_panel_mobile_invoices",
  PanelInvoices: "control_panel_invoices",
  PanelMobile: "control_panel_mobile"
};
function instanceOfCreateProjectCustomFieldAttributeRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "accessType" in value;
  isInstance = isInstance && "isActive" in value;
  return isInstance;
}
function CreateProjectCustomFieldAttributeRequestFromJSON(json) {
  return CreateProjectCustomFieldAttributeRequestFromJSONTyped(json, false);
}
function CreateProjectCustomFieldAttributeRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "accessType": json["access_type"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "isActive": json["is_active"]
  };
}
function CreateProjectCustomFieldAttributeRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "access_type": value.accessType,
    "placement": value.placement,
    "is_active": value.isActive
  };
}

// src/generated/models/CreateTextTemplateRequest.ts
function instanceOfCreateTextTemplateRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "content" in value;
  return isInstance;
}
function CreateTextTemplateRequestFromJSON(json) {
  return CreateTextTemplateRequestFromJSONTyped(json, false);
}
function CreateTextTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "title": json["title"],
    "content": json["content"],
    "expense": !exists(json, "expense") ? void 0 : json["expense"],
    "offer": !exists(json, "offer") ? void 0 : json["offer"],
    "invoice": !exists(json, "invoice") ? void 0 : json["invoice"]
  };
}
function CreateTextTemplateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "title": value.title,
    "content": value.content,
    "expense": value.expense,
    "offer": value.offer,
    "invoice": value.invoice
  };
}

// src/generated/models/CreateUserRequest.ts
function instanceOfCreateUserRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "firstName" in value;
  return isInstance;
}
function CreateUserRequestFromJSON(json) {
  return CreateUserRequestFromJSONTyped(json, false);
}
function CreateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "languageId": !exists(json, "language_id") ? void 0 : json["language_id"],
    "firstName": json["first_name"],
    "lastName": !exists(json, "last_name") ? void 0 : json["last_name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "mobile": !exists(json, "mobile") ? void 0 : json["mobile"],
    "mobileCountrycode": !exists(json, "mobile_countrycode") ? void 0 : json["mobile_countrycode"],
    "manualPrice": !exists(json, "manual_price") ? void 0 : json["manual_price"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "costPrice": !exists(json, "cost_price") ? void 0 : json["cost_price"],
    "salePrice": !exists(json, "sale_price") ? void 0 : json["sale_price"],
    "extraPrice": !exists(json, "extra_price") ? void 0 : json["extra_price"],
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"]
  };
}
function CreateUserRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "city_id": value.cityId,
    "language_id": value.languageId,
    "first_name": value.firstName,
    "last_name": value.lastName,
    "email": value.email,
    "mobile": value.mobile,
    "mobile_countrycode": value.mobileCountrycode,
    "manual_price": value.manualPrice,
    "users_price_group_id": value.usersPriceGroupId,
    "cost_price": value.costPrice,
    "extra_price": value.extraPrice,
    "label_ids": value.labelIds
  };
}

// src/generated/models/EmailTemplate.ts
function instanceOfEmailTemplate(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "identifier" in value;
  isInstance = isInstance && "subject" in value;
  isInstance = isInstance && "content" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function EmailTemplateFromJSON(json) {
  return EmailTemplateFromJSONTyped(json, false);
}
function EmailTemplateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "identifier": json["identifier"],
    "subject": json["subject"],
    "content": json["content"],
    "_default": !exists(json, "default") ? void 0 : json["default"],
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function EmailTemplateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "identifier": value.identifier,
    "subject": value.subject,
    "content": value.content,
    "default": value._default,
    "deleted": value.deleted === null ? null : value.deleted.toISOString()
  };
}

// src/generated/models/CustomEmailTemplate.ts
function instanceOfCustomEmailTemplate(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "emailTemplateId" in value;
  isInstance = isInstance && "lang" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "subject" in value;
  isInstance = isInstance && "content" in value;
  return isInstance;
}
function CustomEmailTemplateFromJSON(json) {
  return CustomEmailTemplateFromJSONTyped(json, false);
}
function CustomEmailTemplateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "emailTemplateId": json["email_template_id"],
    "lang": json["lang"],
    "name": json["name"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "subject": json["subject"],
    "content": json["content"],
    "_default": !exists(json, "default") ? void 0 : json["default"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "emailTemplate": !exists(json, "email_template") ? void 0 : EmailTemplateFromJSON(json["email_template"])
  };
}
function CustomEmailTemplateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "email_template_id": value.emailTemplateId,
    "lang": value.lang,
    "name": value.name,
    "identifier": value.identifier,
    "subject": value.subject,
    "content": value.content,
    "default": value._default,
    "created": value.created === void 0 ? void 0 : value.created.toISOString(),
    "modified": value.modified === void 0 ? void 0 : value.modified.toISOString(),
    "deleted": value.deleted === void 0 ? void 0 : value.deleted === null ? null : value.deleted.toISOString(),
    "email_template": EmailTemplateToJSON(value.emailTemplate)
  };
}

// src/generated/models/CustomEmailTemplateView200Response.ts
function instanceOfCustomEmailTemplateView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CustomEmailTemplateView200ResponseFromJSON(json) {
  return CustomEmailTemplateView200ResponseFromJSONTyped(json, false);
}
function CustomEmailTemplateView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CustomEmailTemplateFromJSON(json["data"])
  };
}
function CustomEmailTemplateView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CustomEmailTemplateToJSON(value.data)
  };
}

// src/generated/models/CvrSearchByName200Response.ts
function instanceOfCvrSearchByName200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function CvrSearchByName200ResponseFromJSON(json) {
  return CvrSearchByName200ResponseFromJSONTyped(json, false);
}
function CvrSearchByName200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(CVRLookupFromJSON)
  };
}
function CvrSearchByName200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(CVRLookupToJSON)
  };
}

// src/generated/models/DeleteAbsenceType200Response.ts
function instanceOfDeleteAbsenceType200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function DeleteAbsenceType200ResponseFromJSON(json) {
  return DeleteAbsenceType200ResponseFromJSONTyped(json, false);
}
function DeleteAbsenceType200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"]
  };
}
function DeleteAbsenceType200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data
  };
}

// src/generated/models/DeleteCard200Response.ts
function instanceOfDeleteCard200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function DeleteCard200ResponseFromJSON(json) {
  return DeleteCard200ResponseFromJSONTyped(json, false);
}
function DeleteCard200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"]
  };
}
function DeleteCard200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data
  };
}

// src/generated/models/DeleteProductVariantsRequest.ts
function instanceOfDeleteProductVariantsRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "productId" in value;
  return isInstance;
}
function DeleteProductVariantsRequestFromJSON(json) {
  return DeleteProductVariantsRequestFromJSONTyped(json, false);
}
function DeleteProductVariantsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["product_id"],
    "vendorProducts": !exists(json, "vendor_products") ? void 0 : json["vendor_products"],
    "expenseLines": !exists(json, "expense_lines") ? void 0 : json["expense_lines"]
  };
}
function DeleteProductVariantsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_id": value.productId,
    "vendor_products": value.vendorProducts,
    "expense_lines": value.expenseLines
  };
}

// src/generated/models/DeleteTokenByDeviceIdRequest.ts
function instanceOfDeleteTokenByDeviceIdRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "deviceId" in value;
  return isInstance;
}
function DeleteTokenByDeviceIdRequestFromJSON(json) {
  return DeleteTokenByDeviceIdRequestFromJSONTyped(json, false);
}
function DeleteTokenByDeviceIdRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "deviceId": json["device_id"]
  };
}
function DeleteTokenByDeviceIdRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "device_id": value.deviceId
  };
}

// src/generated/models/DuplicateInvoiceRequest.ts
function instanceOfDuplicateInvoiceRequest(value) {
  let isInstance = true;
  return isInstance;
}
function DuplicateInvoiceRequestFromJSON(json) {
  return DuplicateInvoiceRequestFromJSONTyped(json, false);
}
function DuplicateInvoiceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "markInvoiced": !exists(json, "mark_invoiced") ? void 0 : json["mark_invoiced"]
  };
}
function DuplicateInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "mark_invoiced": value.markInvoiced
  };
}

// src/generated/models/EconomicImportContacts200Response.ts
function instanceOfEconomicImportContacts200Response(value) {
  let isInstance = true;
  return isInstance;
}
function EconomicImportContacts200ResponseFromJSON(json) {
  return EconomicImportContacts200ResponseFromJSONTyped(json, false);
}
function EconomicImportContacts200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": !exists(json, "data") ? void 0 : json["data"],
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}
function EconomicImportContacts200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data,
    "status": value.status
  };
}

// src/generated/models/EditAbsenceType200Response.ts
function instanceOfEditAbsenceType200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function EditAbsenceType200ResponseFromJSON(json) {
  return EditAbsenceType200ResponseFromJSONTyped(json, false);
}
function EditAbsenceType200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"]
  };
}
function EditAbsenceType200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data
  };
}

// src/generated/models/EditContactPersonRequest.ts
function instanceOfEditContactPersonRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditContactPersonRequestFromJSON(json) {
  return EditContactPersonRequestFromJSONTyped(json, false);
}
function EditContactPersonRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "title": !exists(json, "title") ? void 0 : json["title"]
  };
}
function EditContactPersonRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "email": value.email,
    "phone": value.phone,
    "title": value.title
  };
}

// src/generated/models/Expense.ts
var ExpenseStatusEnum = {
  NotHandled: "not_handled",
  ExpiredSubscription: "expired_subscription",
  Approved: "approved"
};
function instanceOfExpense(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "status" in value;
  isInstance = isInstance && "isImported" in value;
  isInstance = isInstance && "sentToEmail" in value;
  isInstance = isInstance && "isInvoiced" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ExpenseFromJSON(json) {
  return ExpenseFromJSONTyped(json, false);
}
function ExpenseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "expenseFiles": !exists(json, "expense_files") ? void 0 : json["expense_files"].map(BaseFileFromJSON),
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "project": !exists(json, "project") ? void 0 : ControlPanelApiProjectViewOrIndexResponseFromJSON(json["project"]),
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "rogerId": !exists(json, "roger_id") ? void 0 : json["roger_id"],
    "deliveryDate": !exists(json, "delivery_date") ? void 0 : new Date(json["delivery_date"]),
    "dueDate": !exists(json, "due_date") ? void 0 : new Date(json["due_date"]),
    "issuedDate": !exists(json, "issued_date") ? void 0 : new Date(json["issued_date"]),
    "shortText": !exists(json, "short_text") ? void 0 : json["short_text"],
    "supplierInvoiceNumber": !exists(json, "supplier_invoice_number") ? void 0 : json["supplier_invoice_number"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "orderNumber": !exists(json, "order_number") ? void 0 : json["order_number"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "fileReference": !exists(json, "file_reference") ? void 0 : json["file_reference"],
    "status": json["status"],
    "comment": !exists(json, "comment") ? void 0 : json["comment"],
    "isImported": json["is_imported"],
    "isExcludedFromErpSync": !exists(json, "is_excluded_from_erp_sync") ? void 0 : json["is_excluded_from_erp_sync"],
    "sentToEmail": json["sent_to_email"],
    "isInvoiced": new Date(json["is_invoiced"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "totalBuyingPrice": !exists(json, "total_buying_price") ? void 0 : json["total_buying_price"],
    "totalSellingPrice": !exists(json, "total_selling_price") ? void 0 : json["total_selling_price"],
    "totalNetPrice": !exists(json, "total_net_price") ? void 0 : json["total_net_price"],
    "profitPercentage": !exists(json, "profit_percentage") ? void 0 : json["profit_percentage"],
    "isLocked": !exists(json, "is_locked") ? void 0 : json["is_locked"],
    "pdfUrl": !exists(json, "pdf_url") ? void 0 : json["pdf_url"],
    "expenseLines": !exists(json, "expense_lines") ? void 0 : json["expense_lines"].map(ExpenseLineFromJSON)
  };
}
function ExpenseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_id": value.vendorId,
    "expense_files": value.expenseFiles === void 0 ? void 0 : value.expenseFiles.map(BaseFileToJSON),
    "project_id": value.projectId,
    "currency_id": value.currencyId,
    "activity_id": value.activityId,
    "delivery_date": value.deliveryDate === void 0 ? void 0 : value.deliveryDate.toISOString(),
    "due_date": value.dueDate === void 0 ? void 0 : value.dueDate.toISOString(),
    "issued_date": value.issuedDate === void 0 ? void 0 : value.issuedDate.toISOString(),
    "supplier_invoice_number": value.supplierInvoiceNumber,
    "reference": value.reference,
    "description": value.description,
    "status": value.status,
    "comment": value.comment,
    "is_excluded_from_erp_sync": value.isExcludedFromErpSync,
    "pdf_url": value.pdfUrl,
    "expense_lines": value.expenseLines === void 0 ? void 0 : value.expenseLines.map(ExpenseLineToJSON)
  };
}

// src/generated/models/VendorProductPrice.ts
function instanceOfVendorProductPrice(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "vendorProductId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "vendorProductPriceFileId" in value;
  isInstance = isInstance && "price" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function VendorProductPriceFromJSON(json) {
  return VendorProductPriceFromJSONTyped(json, false);
}
function VendorProductPriceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "vendorProductId": json["vendor_product_id"],
    "vendorProduct": !exists(json, "vendor_product") ? void 0 : VendorProductFromJSON(json["vendor_product"]),
    "companyId": json["company_id"],
    "vendorProductPriceFileId": json["vendor_product_price_file_id"],
    "price": json["price"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function VendorProductPriceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_product_id": value.vendorProductId,
    "vendor_product": VendorProductToJSON(value.vendorProduct),
    "company_id": value.companyId,
    "vendor_product_price_file_id": value.vendorProductPriceFileId,
    "price": value.price
  };
}

// src/generated/models/VendorProduct.ts
var VendorProductBuyingPriceSourceEnum = {
  PriceFile: "price_file",
  VendorGrossPrice: "vendor_gross_price"
};
function instanceOfVendorProduct(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function VendorProductFromJSON(json) {
  return VendorProductFromJSONTyped2(json, false);
}
function VendorProductFromJSONTyped2(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "productCategoryNumber": !exists(json, "product_category_number") ? void 0 : json["product_category_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "buyingPriceSource": !exists(json, "buying_price_source") ? void 0 : json["buying_price_source"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "unitName": !exists(json, "unit_name") ? void 0 : json["unit_name"],
    "unitFactor": !exists(json, "unit_factor") ? void 0 : json["unit_factor"],
    "pricePerUnit": !exists(json, "price_per_unit") ? void 0 : json["price_per_unit"],
    "priceHistory": !exists(json, "price_history") ? void 0 : json["price_history"] === null ? null : json["price_history"].map(VendorProductPriceFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function VendorProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_id": value.vendorId,
    "name": value.name,
    "description": value.description,
    "product_number": value.productNumber,
    "product_category_number": value.productCategoryNumber,
    "barcode": value.barcode,
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType,
    "buying_price": value.buyingPrice,
    "buying_price_source": value.buyingPriceSource,
    "selling_price": value.sellingPrice,
    "price": value.price,
    "unit_name": value.unitName,
    "unit_factor": value.unitFactor,
    "price_per_unit": value.pricePerUnit
  };
}

// src/generated/models/ExpenseLine.ts
function instanceOfExpenseLine(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "expenseId" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ExpenseLineFromJSON(json) {
  return ExpenseLineFromJSONTyped2(json, false);
}
function ExpenseLineFromJSONTyped2(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "expenseId": json["expense_id"],
    "expense": !exists(json, "expense") ? void 0 : ExpenseFromJSON(json["expense"]),
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "vendorProduct": !exists(json, "vendor_product") ? void 0 : VendorProductFromJSON(json["vendor_product"]),
    "text": !exists(json, "text") ? void 0 : json["text"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"],
    "ratio": !exists(json, "ratio") ? void 0 : json["ratio"],
    "priceType": !exists(json, "price_type") ? void 0 : json["price_type"],
    "isPrimaryBuyingOption": !exists(json, "is_primary_buying_option") ? void 0 : json["is_primary_buying_option"],
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : json["is_invoiced"] === null ? null : new Date(json["is_invoiced"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "translatedOrigin": !exists(json, "translated_origin") ? void 0 : json["translated_origin"],
    "priceHistory": !exists(json, "price_history") ? void 0 : json["price_history"] === null ? null : json["price_history"].map(ExpenseLineFromJSON)
  };
}
function ExpenseLineToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "expense_id": value.expenseId,
    "product_id": value.productId,
    "vendor": VendorToJSON(value.vendor),
    "vendor_product_id": value.vendorProductId,
    "vendor_product": VendorProductToJSON(value.vendorProduct),
    "text": value.text,
    "barcode": value.barcode,
    "product_number": value.productNumber,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "quantity": value.quantity,
    "ratio": value.ratio,
    "price_type": value.priceType,
    "is_primary_buying_option": value.isPrimaryBuyingOption,
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced === null ? null : value.isInvoiced.toISOString(),
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType
  };
}

// src/generated/models/EditExpenseRequest.ts
var EditExpenseRequestStatusEnum = {
  NotHandled: "not_handled",
  ExpiredSubscription: "expired_subscription",
  Approved: "approved"
};
function instanceOfEditExpenseRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditExpenseRequestFromJSON(json) {
  return EditExpenseRequestFromJSONTyped(json, false);
}
function EditExpenseRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "issueDate": !exists(json, "issue_date") ? void 0 : fromLocalDateString(json["issue_date"]),
    "deliveryDate": !exists(json, "delivery_date") ? void 0 : fromLocalDateString(json["delivery_date"]),
    "dueDate": !exists(json, "due_date") ? void 0 : fromLocalDateString(json["due_date"]),
    "shortText": !exists(json, "short_text") ? void 0 : json["short_text"],
    "supplierInvoiceNumber": !exists(json, "supplier_invoice_number") ? void 0 : json["supplier_invoice_number"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "fileReference": !exists(json, "file_reference") ? void 0 : json["file_reference"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "comment": !exists(json, "comment") ? void 0 : json["comment"],
    "expenseLines": !exists(json, "expense_lines") ? void 0 : json["expense_lines"].map(ExpenseLineFromJSON)
  };
}
function EditExpenseRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_id": value.vendorId,
    "project_id": value.projectId,
    "activity_id": value.activityId,
    "issue_date": value.issueDate === void 0 ? void 0 : toLocalDateString(value.issueDate),
    "delivery_date": value.deliveryDate === void 0 ? void 0 : toLocalDateString(value.deliveryDate),
    "due_date": value.dueDate === void 0 ? void 0 : toLocalDateString(value.dueDate),
    "short_text": value.shortText,
    "supplier_invoice_number": value.supplierInvoiceNumber,
    "reference": value.reference,
    "description": value.description,
    "file_reference": value.fileReference,
    "status": value.status,
    "comment": value.comment,
    "expense_lines": value.expenseLines === void 0 ? void 0 : value.expenseLines.map(ExpenseLineToJSON)
  };
}

// src/generated/models/InvoiceLine.ts
var InvoiceLineTypeEnum = {
  Normal: "normal",
  User: "user",
  Text: "text",
  Bundle: "bundle"
};
var InvoiceLineInvoiceTypeEnum = {
  Normal: "normal",
  User: "user",
  Text: "text",
  Product: "product"
};
function instanceOfInvoiceLine(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "invoiceId" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function InvoiceLineFromJSON(json) {
  return InvoiceLineFromJSONTyped(json, false);
}
function InvoiceLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "invoiceId": json["invoice_id"],
    "formId": !exists(json, "form_id") ? void 0 : json["form_id"],
    "parentId": !exists(json, "parent_id") ? void 0 : json["parent_id"],
    "materialId": !exists(json, "material_id") ? void 0 : json["material_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "eanProductId": !exists(json, "ean_product_id") ? void 0 : json["ean_product_id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "type": json["type"],
    "invoiceType": !exists(json, "invoice_type") ? void 0 : json["invoice_type"],
    "discountText": !exists(json, "discount_text") ? void 0 : json["discount_text"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "totalPrice": !exists(json, "total_price") ? void 0 : json["total_price"],
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"],
    "productUnit": !exists(json, "product_unit") ? void 0 : json["product_unit"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "isPriceHidden": !exists(json, "is_price_hidden") ? void 0 : json["is_price_hidden"]
  };
}
function InvoiceLineToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "invoice_id": value.invoiceId,
    "form_id": value.formId,
    "parent_id": value.parentId,
    "material_id": value.materialId,
    "expense_line_id": value.expenseLineId,
    "vendor_product_id": value.vendorProductId,
    "ean_product_id": value.eanProductId,
    "user_id": value.userId,
    "product_id": value.productId,
    "name": value.name,
    "description": value.description,
    "type": value.type,
    "invoice_type": value.invoiceType,
    "discount_text": value.discountText,
    "selling_price": value.sellingPrice,
    "buying_price": value.buyingPrice,
    "reference": value.reference,
    "placement": value.placement,
    "discount_percent": value.discountPercent,
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "total_price": value.totalPrice,
    "quantity": value.quantity,
    "product_unit": value.productUnit,
    "users_price_group_id": value.usersPriceGroupId,
    "is_price_hidden": value.isPriceHidden
  };
}

// src/generated/models/EditInvoiceRequest.ts
function instanceOfEditInvoiceRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditInvoiceRequestFromJSON(json) {
  return EditInvoiceRequestFromJSONTyped(json, false);
}
function EditInvoiceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "projectStatusId": !exists(json, "project_status_id") ? void 0 : json["project_status_id"],
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "message": !exists(json, "message") ? void 0 : json["message"],
    "issuedDate": !exists(json, "issued_date") ? void 0 : fromLocalDateString(json["issued_date"]),
    "dateFrom": !exists(json, "date_from") ? void 0 : fromLocalDateString(json["date_from"]),
    "dateTo": !exists(json, "date_to") ? void 0 : fromLocalDateString(json["date_to"]),
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "toErp": !exists(json, "to_erp") ? void 0 : json["to_erp"],
    "sendToEan": !exists(json, "send_to_ean") ? void 0 : json["send_to_ean"],
    "ean": !exists(json, "ean") ? void 0 : json["ean"],
    "isDraft": !exists(json, "is_draft") ? void 0 : json["is_draft"],
    "isLocked": !exists(json, "is_locked") ? void 0 : json["is_locked"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "invoiceLines": !exists(json, "invoice_lines") ? void 0 : json["invoice_lines"].map(InvoiceLineFromJSON)
  };
}
function EditInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contact_id": value.contactId,
    "contact_person_id": value.contactPersonId,
    "project_id": value.projectId,
    "project_status_id": value.projectStatusId,
    "payment_term_id": value.paymentTermId,
    "title": value.title,
    "message": value.message,
    "issued_date": value.issuedDate === void 0 ? void 0 : toLocalDateString(value.issuedDate),
    "date_from": value.dateFrom === void 0 ? void 0 : toLocalDateString(value.dateFrom),
    "date_to": value.dateTo === void 0 ? void 0 : toLocalDateString(value.dateTo),
    "discount_percent": value.discountPercent,
    "to_erp": value.toErp,
    "send_to_ean": value.sendToEan,
    "ean": value.ean,
    "is_draft": value.isDraft,
    "is_locked": value.isLocked,
    "reference": value.reference,
    "vat_percent": value.vatPercent,
    "invoice_lines": value.invoiceLines === void 0 ? void 0 : value.invoiceLines.map(InvoiceLineToJSON)
  };
}

// src/generated/models/OfferLine.ts
var OfferLineTypeEnum = {
  Normal: "normal",
  Text: "text",
  User: "user"
};
var OfferLineDiscountTypeEnum = {
  Percent: "percent",
  Fixed: "fixed"
};
function instanceOfOfferLine(value) {
  let isInstance = true;
  isInstance = isInstance && "offerId" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function OfferLineFromJSON(json) {
  return OfferLineFromJSONTyped(json, false);
}
function OfferLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "offerId": json["offer_id"],
    "productBundleId": !exists(json, "product_bundle_id") ? void 0 : json["product_bundle_id"],
    "productBundleLineId": !exists(json, "product_bundle_line_id") ? void 0 : json["product_bundle_line_id"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "discountAmount": !exists(json, "discount_amount") ? void 0 : json["discount_amount"],
    "discountType": !exists(json, "discount_type") ? void 0 : json["discount_type"],
    "costPrice": !exists(json, "cost_price") ? void 0 : json["cost_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"],
    "productUnit": !exists(json, "product_unit") ? void 0 : json["product_unit"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "childOfferLines": !exists(json, "child_offer_lines") ? void 0 : json["child_offer_lines"].map(OfferLineFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function OfferLineToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "offer_id": value.offerId,
    "product_bundle_id": value.productBundleId,
    "product_bundle_line_id": value.productBundleLineId,
    "users_price_group_id": value.usersPriceGroupId,
    "expense_line_id": value.expenseLineId,
    "vendor_product_id": value.vendorProductId,
    "product_id": value.productId,
    "user_id": value.userId,
    "type": value.type,
    "name": value.name,
    "description": value.description,
    "discount_percent": value.discountPercent,
    "discount_amount": value.discountAmount,
    "discount_type": value.discountType,
    "cost_price": value.costPrice,
    "selling_price": value.sellingPrice,
    "quantity": value.quantity,
    "product_unit": value.productUnit,
    "placement": value.placement,
    "child_offer_lines": value.childOfferLines === void 0 ? void 0 : value.childOfferLines.map(OfferLineToJSON)
  };
}

// src/generated/models/EditOfferRequest.ts
var EditOfferRequestOfferLinesRuleEnum = {
  GatherOfferLines: "gather_offer_lines",
  DistributionHoursOverProducts: "distribution_hours_over_products",
  ShowOnlyProductBundles: "show_only_product_bundles",
  GroupByProductAndHours: "group_by_product_and_hours",
  TotalPriceLine: "total_price_line"
};
function instanceOfEditOfferRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "title" in value;
  return isInstance;
}
function EditOfferRequestFromJSON(json) {
  return EditOfferRequestFromJSONTyped(json, false);
}
function EditOfferRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"],
    "title": json["title"],
    "offerStatusId": !exists(json, "offer_status_id") ? void 0 : json["offer_status_id"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "address": !exists(json, "address") ? void 0 : json["address"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "expirationDate": !exists(json, "expiration_date") ? void 0 : json["expiration_date"] === null ? null : new Date(json["expiration_date"]),
    "isQuote": !exists(json, "is_quote") ? void 0 : json["is_quote"],
    "issuedDate": !exists(json, "issued_date") ? void 0 : json["issued_date"] === null ? null : new Date(json["issued_date"]),
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "v3Origin": !exists(json, "v3_origin") ? void 0 : json["v3_origin"],
    "manualTotalSalesPrice": !exists(json, "manual_total_sales_price") ? void 0 : json["manual_total_sales_price"],
    "offerLines": !exists(json, "offer_lines") ? void 0 : json["offer_lines"].map(OfferLineFromJSON),
    "offerLinesRule": !exists(json, "offer_lines_rule") ? void 0 : json["offer_lines_rule"],
    "pdfUrl": !exists(json, "pdf_url") ? void 0 : json["pdf_url"]
  };
}
function EditOfferRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "city_id": value.cityId,
    "contact_id": value.contactId,
    "contact_person_id": value.contactPersonId,
    "payment_term_id": value.paymentTermId,
    "title": value.title,
    "offer_status_id": value.offerStatusId,
    "description": value.description,
    "address": value.address,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "expiration_date": value.expirationDate === void 0 ? void 0 : value.expirationDate === null ? null : value.expirationDate.toISOString(),
    "is_quote": value.isQuote,
    "issued_date": value.issuedDate === void 0 ? void 0 : value.issuedDate === null ? null : value.issuedDate.toISOString(),
    "vat_percent": value.vatPercent,
    "discount_percent": value.discountPercent,
    "v3_origin": value.v3Origin,
    "manual_total_sales_price": value.manualTotalSalesPrice,
    "offer_lines": value.offerLines === void 0 ? void 0 : value.offerLines.map(OfferLineToJSON),
    "offer_lines_rule": value.offerLinesRule,
    "pdf_url": value.pdfUrl
  };
}

// src/generated/models/EditSubscriptionRequest.ts
function instanceOfEditSubscriptionRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditSubscriptionRequestFromJSON(json) {
  return EditSubscriptionRequestFromJSONTyped(json, false);
}
function EditSubscriptionRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "seats": !exists(json, "seats") ? void 0 : json["seats"],
    "viewOnlySeats": !exists(json, "view_only_seats") ? void 0 : json["view_only_seats"]
  };
}
function EditSubscriptionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "seats": value.seats,
    "view_only_seats": value.viewOnlySeats
  };
}

// src/generated/models/EditTextTemplateRequest.ts
function instanceOfEditTextTemplateRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditTextTemplateRequestFromJSON(json) {
  return EditTextTemplateRequestFromJSONTyped(json, false);
}
function EditTextTemplateRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "title": !exists(json, "title") ? void 0 : json["title"],
    "content": !exists(json, "content") ? void 0 : json["content"],
    "expense": !exists(json, "expense") ? void 0 : json["expense"],
    "offer": !exists(json, "offer") ? void 0 : json["offer"],
    "invoice": !exists(json, "invoice") ? void 0 : json["invoice"]
  };
}
function EditTextTemplateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "title": value.title,
    "content": value.content,
    "expense": value.expense,
    "offer": value.offer,
    "invoice": value.invoice
  };
}

// src/generated/models/EditUserRequest.ts
var EditUserRequestAdminAccessEnum = {
  NoAccessToAdmin: "no_access_to_admin",
  AccessToAdmin: "access_to_admin",
  LimitedAccessToAdmin: "limited_access_to_admin"
};
function instanceOfEditUserRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EditUserRequestFromJSON(json) {
  return EditUserRequestFromJSONTyped(json, false);
}
function EditUserRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "languageId": !exists(json, "language_id") ? void 0 : json["language_id"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "firstName": !exists(json, "first_name") ? void 0 : json["first_name"],
    "lastName": !exists(json, "last_name") ? void 0 : json["last_name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "mobile": !exists(json, "mobile") ? void 0 : json["mobile"],
    "mobileCountrycode": !exists(json, "mobile_countrycode") ? void 0 : json["mobile_countrycode"],
    "manualPrice": !exists(json, "manual_price") ? void 0 : json["manual_price"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "costPrice": !exists(json, "cost_price") ? void 0 : json["cost_price"],
    "salePrice": !exists(json, "sale_price") ? void 0 : json["sale_price"],
    "extraPrice": !exists(json, "extra_price") ? void 0 : json["extra_price"],
    "isActive": !exists(json, "is_active") ? void 0 : json["is_active"],
    "apiKey": !exists(json, "api_key") ? void 0 : json["api_key"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "receiveFormMails": !exists(json, "receive_form_mails") ? void 0 : json["receive_form_mails"],
    "hideAddress": !exists(json, "hide_address") ? void 0 : json["hide_address"],
    "hidePhone": !exists(json, "hide_phone") ? void 0 : json["hide_phone"],
    "expectedBillableHours": !exists(json, "expected_billable_hours") ? void 0 : json["expected_billable_hours"],
    "isProjectLeader": !exists(json, "is_project_leader") ? void 0 : json["is_project_leader"],
    "timeEntryRuleGroupId": !exists(json, "time_entry_rule_group_id") ? void 0 : json["time_entry_rule_group_id"],
    "adminAccess": !exists(json, "admin_access") ? void 0 : json["admin_access"],
    "adminAccessOptions": !exists(json, "admin_access_options") ? void 0 : json["admin_access_options"],
    "projectIds": !exists(json, "project_ids") ? void 0 : json["project_ids"],
    "projects": !exists(json, "projects") ? void 0 : json["projects"].map(ProjectFromJSON),
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"],
    "customIntegrationSettings": !exists(json, "custom_integration_settings") ? void 0 : json["custom_integration_settings"].map(EditUserRequestCustomIntegrationSettingsInnerFromJSON)
  };
}
function EditUserRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "city_id": value.cityId,
    "language_id": value.languageId,
    "country_id": value.countryId,
    "first_name": value.firstName,
    "last_name": value.lastName,
    "email": value.email,
    "street_name": value.streetName,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "mobile": value.mobile,
    "mobile_countrycode": value.mobileCountrycode,
    "manual_price": value.manualPrice,
    "users_price_group_id": value.usersPriceGroupId,
    "cost_price": value.costPrice,
    "extra_price": value.extraPrice,
    "is_active": value.isActive,
    "api_key": value.apiKey,
    "erp_id": value.erpId,
    "receive_form_mails": value.receiveFormMails,
    "hide_address": value.hideAddress,
    "hide_phone": value.hidePhone,
    "expected_billable_hours": value.expectedBillableHours,
    "is_project_leader": value.isProjectLeader,
    "time_entry_rule_group_id": value.timeEntryRuleGroupId,
    "admin_access": value.adminAccess,
    "admin_access_options": value.adminAccessOptions,
    "project_ids": value.projectIds,
    "projects": value.projects === void 0 ? void 0 : value.projects.map(ProjectToJSON),
    "label_ids": value.labelIds,
    "custom_integration_settings": value.customIntegrationSettings === void 0 ? void 0 : value.customIntegrationSettings.map(EditUserRequestCustomIntegrationSettingsInnerToJSON)
  };
}

// src/generated/models/Email.ts
function instanceOfEmail(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "recipients" in value;
  isInstance = isInstance && "replyTo" in value;
  isInstance = isInstance && "subject" in value;
  isInstance = isInstance && "body" in value;
  return isInstance;
}
function EmailFromJSON(json) {
  return EmailFromJSONTyped(json, false);
}
function EmailFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "companyId": json["company_id"],
    "recipients": json["recipients"],
    "replyTo": json["reply_to"],
    "subject": json["subject"],
    "body": json["body"],
    "isSent": !exists(json, "is_sent") ? void 0 : json["is_sent"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function EmailToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "company_id": value.companyId,
    "recipients": value.recipients,
    "reply_to": value.replyTo,
    "subject": value.subject,
    "body": value.body,
    "is_sent": value.isSent
  };
}

// src/generated/models/EmailAction.ts
var EmailActionEventEnum = {
  Accepted: "accepted",
  Opened: "opened",
  Clicked: "clicked",
  Unsubscribed: "unsubscribed",
  Delivered: "delivered",
  PermanentlyFailed: "permanently_failed",
  TemporarilyFailed: "temporarily_failed",
  Complained: "complained"
};
function instanceOfEmailAction(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "emailId" in value;
  isInstance = isInstance && "event" in value;
  isInstance = isInstance && "eventId" in value;
  isInstance = isInstance && "eventTime" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function EmailActionFromJSON(json) {
  return EmailActionFromJSONTyped(json, false);
}
function EmailActionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "emailId": json["email_id"],
    "event": json["event"],
    "eventId": json["event_id"],
    "eventTime": new Date(json["event_time"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function EmailActionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email_id": value.emailId,
    "event": value.event,
    "event_id": value.eventId,
    "event_time": value.eventTime.toISOString()
  };
}

// src/generated/models/EntityId.ts
function instanceOfEntityId(value) {
  let isInstance = true;
  return isInstance;
}
function EntityIdFromJSON(json) {
  return EntityIdFromJSONTyped(json, false);
}
function EntityIdFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"]
  };
}
function EntityIdToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ErrorNotFoundData.ts
function instanceOfErrorNotFoundData(value) {
  let isInstance = true;
  return isInstance;
}
function ErrorNotFoundDataFromJSON(json) {
  return ErrorNotFoundDataFromJSONTyped(json, false);
}
function ErrorNotFoundDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "code": !exists(json, "code") ? void 0 : json["code"],
    "url": !exists(json, "url") ? void 0 : json["url"],
    "message": !exists(json, "message") ? void 0 : json["message"]
  };
}
function ErrorNotFoundDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "code": value.code,
    "url": value.url,
    "message": value.message
  };
}

// src/generated/models/ErrorNotFound.ts
function instanceOfErrorNotFound(value) {
  let isInstance = true;
  return isInstance;
}
function ErrorNotFoundFromJSON(json) {
  return ErrorNotFoundFromJSONTyped(json, false);
}
function ErrorNotFoundFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : ErrorNotFoundDataFromJSON(json["data"])
  };
}
function ErrorNotFoundToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ErrorNotFoundDataToJSON(value.data)
  };
}

// src/generated/models/ErrorValidationData.ts
function instanceOfErrorValidationData(value) {
  let isInstance = true;
  return isInstance;
}
function ErrorValidationDataFromJSON(json) {
  return ErrorValidationDataFromJSONTyped(json, false);
}
function ErrorValidationDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "code": !exists(json, "code") ? void 0 : json["code"],
    "url": !exists(json, "url") ? void 0 : json["url"],
    "message": !exists(json, "message") ? void 0 : json["message"],
    "errorCount": !exists(json, "errorCount") ? void 0 : json["errorCount"],
    "errors": !exists(json, "errors") ? void 0 : json["errors"]
  };
}
function ErrorValidationDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "code": value.code,
    "url": value.url,
    "message": value.message,
    "errorCount": value.errorCount,
    "errors": value.errors
  };
}

// src/generated/models/ErrorValidation.ts
function instanceOfErrorValidation(value) {
  let isInstance = true;
  return isInstance;
}
function ErrorValidationFromJSON(json) {
  return ErrorValidationFromJSONTyped(json, false);
}
function ErrorValidationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : ErrorValidationDataFromJSON(json["data"])
  };
}
function ErrorValidationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ErrorValidationDataToJSON(value.data)
  };
}

// src/generated/models/ExpenseLinesList200ResponseAllOfDataInner.ts
function instanceOfExpenseLinesList200ResponseAllOfDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "expenseId" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ExpenseLinesList200ResponseAllOfDataInnerFromJSON(json) {
  return ExpenseLinesList200ResponseAllOfDataInnerFromJSONTyped(json, false);
}
function ExpenseLinesList200ResponseAllOfDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "expenseId": json["expense_id"],
    "expense": !exists(json, "expense") ? void 0 : ExpenseFromJSON(json["expense"]),
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "vendorProduct": !exists(json, "vendor_product") ? void 0 : VendorProductFromJSON(json["vendor_product"]),
    "text": !exists(json, "text") ? void 0 : json["text"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"],
    "ratio": !exists(json, "ratio") ? void 0 : json["ratio"],
    "priceType": !exists(json, "price_type") ? void 0 : json["price_type"],
    "isPrimaryBuyingOption": !exists(json, "is_primary_buying_option") ? void 0 : json["is_primary_buying_option"],
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : json["is_invoiced"] === null ? null : new Date(json["is_invoiced"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "translatedOrigin": !exists(json, "translated_origin") ? void 0 : json["translated_origin"],
    "priceHistory": !exists(json, "price_history") ? void 0 : json["price_history"] === null ? null : json["price_history"].map(ExpenseLineFromJSON),
    "grossPrice": !exists(json, "gross_price") ? void 0 : json["gross_price"]
  };
}
function ExpenseLinesList200ResponseAllOfDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "expense_id": value.expenseId,
    "product_id": value.productId,
    "vendor": VendorToJSON(value.vendor),
    "vendor_product_id": value.vendorProductId,
    "vendor_product": VendorProductToJSON(value.vendorProduct),
    "text": value.text,
    "barcode": value.barcode,
    "product_number": value.productNumber,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "quantity": value.quantity,
    "ratio": value.ratio,
    "price_type": value.priceType,
    "is_primary_buying_option": value.isPrimaryBuyingOption,
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced === null ? null : value.isInvoiced.toISOString(),
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType,
    "gross_price": value.grossPrice
  };
}

// src/generated/models/PaginationDetails.ts
function instanceOfPaginationDetails(value) {
  let isInstance = true;
  isInstance = isInstance && "currentPage" in value;
  isInstance = isInstance && "hasNextPage" in value;
  isInstance = isInstance && "hasPrevPage" in value;
  return isInstance;
}
function PaginationDetailsFromJSON(json) {
  return PaginationDetailsFromJSONTyped(json, false);
}
function PaginationDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pageCount": !exists(json, "page_count") ? void 0 : json["page_count"],
    "currentPage": json["current_page"],
    "hasNextPage": json["has_next_page"],
    "hasPrevPage": json["has_prev_page"],
    "count": !exists(json, "count") ? void 0 : json["count"],
    "limit": !exists(json, "limit") ? void 0 : json["limit"]
  };
}
function PaginationDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ExpenseLinesList200Response.ts
function instanceOfExpenseLinesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpenseLinesList200ResponseFromJSON(json) {
  return ExpenseLinesList200ResponseFromJSONTyped(json, false);
}
function ExpenseLinesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ExpenseLinesList200ResponseAllOfDataInnerFromJSON)
  };
}
function ExpenseLinesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ExpenseLinesList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/ExpenseLinesList200ResponseAllOf.ts
function instanceOfExpenseLinesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpenseLinesList200ResponseAllOfFromJSON(json) {
  return ExpenseLinesList200ResponseAllOfFromJSONTyped(json, false);
}
function ExpenseLinesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ExpenseLinesList200ResponseAllOfDataInnerFromJSON)
  };
}
function ExpenseLinesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ExpenseLinesList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/ExpenseLinesList200ResponseAllOfDataInnerAllOf.ts
function instanceOfExpenseLinesList200ResponseAllOfDataInnerAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function ExpenseLinesList200ResponseAllOfDataInnerAllOfFromJSON(json) {
  return ExpenseLinesList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, false);
}
function ExpenseLinesList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "grossPrice": !exists(json, "gross_price") ? void 0 : json["gross_price"]
  };
}
function ExpenseLinesList200ResponseAllOfDataInnerAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "gross_price": value.grossPrice
  };
}

// src/generated/models/ExpenseLinesView200Response.ts
function instanceOfExpenseLinesView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpenseLinesView200ResponseFromJSON(json) {
  return ExpenseLinesView200ResponseFromJSONTyped(json, false);
}
function ExpenseLinesView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ExpenseLineFromJSON(json["data"])
  };
}
function ExpenseLinesView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ExpenseLineToJSON(value.data)
  };
}

// src/generated/models/ExpensesList200Response.ts
function instanceOfExpensesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpensesList200ResponseFromJSON(json) {
  return ExpensesList200ResponseFromJSONTyped(json, false);
}
function ExpensesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ExpenseFromJSON)
  };
}
function ExpensesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ExpenseToJSON)
  };
}

// src/generated/models/ExpensesList200ResponseAllOf.ts
function instanceOfExpensesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpensesList200ResponseAllOfFromJSON(json) {
  return ExpensesList200ResponseAllOfFromJSONTyped(json, false);
}
function ExpensesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ExpenseFromJSON)
  };
}
function ExpensesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ExpenseToJSON)
  };
}

// src/generated/models/ExpensesView200Response.ts
function instanceOfExpensesView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ExpensesView200ResponseFromJSON(json) {
  return ExpensesView200ResponseFromJSONTyped(json, false);
}
function ExpensesView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ExpenseFromJSON(json["data"])
  };
}
function ExpensesView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ExpenseToJSON(value.data)
  };
}

// src/generated/models/Feature.ts
function instanceOfFeature(value) {
  let isInstance = true;
  return isInstance;
}
function FeatureFromJSON(json) {
  return FeatureFromJSONTyped(json, false);
}
function FeatureFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"]
  };
}
function FeatureToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "identifier": value.identifier
  };
}

// src/generated/models/FeedItem.ts
var FeedItemTypeEnum = {
  Invoice: "invoice",
  WallPost: "wall_post",
  Expense: "expense",
  Form: "form",
  ProjectFile: "project_file"
};
function instanceOfFeedItem(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "date" in value;
  return isInstance;
}
function FeedItemFromJSON(json) {
  return FeedItemFromJSONTyped(json, false);
}
function FeedItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "date": fromLocalDateString(json["date"])
  };
}
function FeedItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "date": toLocalDateString(value.date)
  };
}

// src/generated/models/FeedItemExpenseAllOf.ts
function instanceOfFeedItemExpenseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemExpenseAllOfFromJSON(json) {
  return FeedItemExpenseAllOfFromJSONTyped(json, false);
}
function FeedItemExpenseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": ExpenseReadDTOFromJSON(json["data"])
  };
}
function FeedItemExpenseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ExpenseReadDTOToJSON(value.data)
  };
}

// src/generated/models/FeedItemFormAllOf.ts
function instanceOfFeedItemFormAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemFormAllOfFromJSON(json) {
  return FeedItemFormAllOfFromJSONTyped(json, false);
}
function FeedItemFormAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": FormReadDTOFromJSON(json["data"])
  };
}
function FeedItemFormAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": FormReadDTOToJSON(value.data)
  };
}

// src/generated/models/FeedItemInvoiceAllOf.ts
function instanceOfFeedItemInvoiceAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemInvoiceAllOfFromJSON(json) {
  return FeedItemInvoiceAllOfFromJSONTyped(json, false);
}
function FeedItemInvoiceAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": InvoiceReadDTOFromJSON(json["data"])
  };
}
function FeedItemInvoiceAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": InvoiceReadDTOToJSON(value.data)
  };
}

// src/generated/models/FeedItemProjectFileAllOf.ts
function instanceOfFeedItemProjectFileAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemProjectFileAllOfFromJSON(json) {
  return FeedItemProjectFileAllOfFromJSONTyped(json, false);
}
function FeedItemProjectFileAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": ProjectFileReadDTOFromJSON(json["data"])
  };
}
function FeedItemProjectFileAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": ProjectFileReadDTOToJSON(value.data)
  };
}

// src/generated/models/FeedItemWallPostAllOf.ts
function instanceOfFeedItemWallPostAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FeedItemWallPostAllOfFromJSON(json) {
  return FeedItemWallPostAllOfFromJSONTyped(json, false);
}
function FeedItemWallPostAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": WallPostFromJSON(json["data"])
  };
}
function FeedItemWallPostAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": WallPostToJSON(value.data)
  };
}

// src/generated/models/FeedMetadataDTO.ts
function instanceOfFeedMetadataDTO(value) {
  let isInstance = true;
  return isInstance;
}
function FeedMetadataDTOFromJSON(json) {
  return FeedMetadataDTOFromJSONTyped(json, false);
}
function FeedMetadataDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "oldestDate": !exists(json, "oldest_date") ? void 0 : fromLocalDateString(json["oldest_date"]),
    "newestDate": !exists(json, "newest_date") ? void 0 : fromLocalDateString(json["newest_date"])
  };
}
function FeedMetadataDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "oldest_date": value.oldestDate === void 0 ? void 0 : toLocalDateString(value.oldestDate),
    "newest_date": value.newestDate === void 0 ? void 0 : toLocalDateString(value.newestDate)
  };
}

// src/generated/models/FeedPaginationDTO.ts
function instanceOfFeedPaginationDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "hasMore" in value;
  return isInstance;
}
function FeedPaginationDTOFromJSON(json) {
  return FeedPaginationDTOFromJSONTyped(json, false);
}
function FeedPaginationDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "hasMore": json["has_more"]
  };
}
function FeedPaginationDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "has_more": value.hasMore
  };
}

// src/generated/models/Form.ts
function instanceOfForm(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "formTemplateId" in value;
  isInstance = isInstance && "formDate" in value;
  isInstance = isInstance && "isDraft" in value;
  return isInstance;
}
function FormFromJSON(json) {
  return FormFromJSONTyped(json, false);
}
function FormFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "modifiedBy": !exists(json, "modified_by") ? void 0 : UserFromJSON(json["modified_by"]),
    "userId": json["user_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "formTemplateId": json["form_template_id"],
    "approvedById": !exists(json, "approved_by_id") ? void 0 : json["approved_by_id"],
    "approvedBy": !exists(json, "approved_by") ? void 0 : UserFromJSON(json["approved_by"]),
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "clockingRecordId": !exists(json, "clocking_record_id") ? void 0 : json["clocking_record_id"],
    "formDate": new Date(json["form_date"]),
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : new Date(json["is_invoiced"]),
    "isDraft": json["is_draft"],
    "approved": !exists(json, "approved") ? void 0 : new Date(json["approved"]),
    "linkToPdf": !exists(json, "link_to_pdf") ? void 0 : json["link_to_pdf"],
    "linkToHtml": !exists(json, "link_to_html") ? void 0 : json["link_to_html"],
    "workDescription": !exists(json, "work_description") ? void 0 : json["work_description"],
    "project": !exists(json, "project") ? void 0 : ControlPanelApiProjectViewOrIndexResponseFromJSON(json["project"]),
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "formTemplate": !exists(json, "form_template") ? void 0 : FormTemplateModelWithJsonFormsDataFromJSON(json["form_template"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function FormToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "modified_by": UserToJSON(value.modifiedBy),
    "user_id": value.userId,
    "company_id": value.companyId,
    "project_id": value.projectId,
    "form_template_id": value.formTemplateId,
    "approved_by_id": value.approvedById,
    "approved_by": UserToJSON(value.approvedBy),
    "activity_id": value.activityId,
    "clocking_record_id": value.clockingRecordId,
    "form_date": value.formDate.toISOString(),
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced.toISOString(),
    "is_draft": value.isDraft,
    "approved": value.approved === void 0 ? void 0 : value.approved.toISOString(),
    "link_to_pdf": value.linkToPdf,
    "link_to_html": value.linkToHtml,
    "work_description": value.workDescription,
    "project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.project),
    "user": UserToJSON(value.user),
    "form_template": FormTemplateModelWithJsonFormsDataToJSON(value.formTemplate)
  };
}

// src/generated/models/FormDtoWithJsonFormsData.ts
function instanceOfFormDtoWithJsonFormsData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "formTemplateId" in value;
  isInstance = isInstance && "formDate" in value;
  isInstance = isInstance && "isDraft" in value;
  isInstance = isInstance && "workDescription" in value;
  isInstance = isInstance && "project" in value;
  isInstance = isInstance && "user" in value;
  isInstance = isInstance && "formTemplate" in value;
  isInstance = isInstance && "hoursSum" in value;
  isInstance = isInstance && "timeFrom" in value;
  isInstance = isInstance && "timeTo" in value;
  isInstance = isInstance && "hoursBreak" in value;
  isInstance = isInstance && "template" in value;
  return isInstance;
}
function FormDtoWithJsonFormsDataFromJSON(json) {
  return FormDtoWithJsonFormsDataFromJSONTyped(json, false);
}
function FormDtoWithJsonFormsDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "modifiedBy": !exists(json, "modified_by") ? void 0 : UserFromJSON(json["modified_by"]),
    "userId": json["user_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "formTemplateId": json["form_template_id"],
    "approvedById": !exists(json, "approved_by_id") ? void 0 : json["approved_by_id"],
    "approvedBy": !exists(json, "approved_by") ? void 0 : UserFromJSON(json["approved_by"]),
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "clockingRecordId": !exists(json, "clocking_record_id") ? void 0 : json["clocking_record_id"],
    "formDate": new Date(json["form_date"]),
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : new Date(json["is_invoiced"]),
    "isDraft": json["is_draft"],
    "approved": !exists(json, "approved") ? void 0 : new Date(json["approved"]),
    "linkToPdf": !exists(json, "link_to_pdf") ? void 0 : json["link_to_pdf"],
    "linkToHtml": !exists(json, "link_to_html") ? void 0 : json["link_to_html"],
    "workDescription": json["work_description"],
    "project": ControlPanelApiProjectViewOrIndexResponseFromJSON(json["project"]),
    "user": UserFromJSON(json["user"]),
    "formTemplate": FormTemplateModelWithJsonFormsDataFromJSON(json["form_template"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "hoursSum": json["hours_sum"],
    "timeFrom": json["time_from"],
    "timeTo": json["time_to"],
    "hoursBreak": json["hours_break"],
    "template": FormTemplateModelWithJsonFormsDataFromJSON(json["template"])
  };
}
function FormDtoWithJsonFormsDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "modified_by": UserToJSON(value.modifiedBy),
    "user_id": value.userId,
    "company_id": value.companyId,
    "project_id": value.projectId,
    "form_template_id": value.formTemplateId,
    "approved_by_id": value.approvedById,
    "approved_by": UserToJSON(value.approvedBy),
    "activity_id": value.activityId,
    "clocking_record_id": value.clockingRecordId,
    "form_date": value.formDate.toISOString(),
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced.toISOString(),
    "is_draft": value.isDraft,
    "approved": value.approved === void 0 ? void 0 : value.approved.toISOString(),
    "link_to_pdf": value.linkToPdf,
    "link_to_html": value.linkToHtml,
    "project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.project),
    "user": UserToJSON(value.user),
    "form_template": FormTemplateModelWithJsonFormsDataToJSON(value.formTemplate),
    "template": FormTemplateModelWithJsonFormsDataToJSON(value.template)
  };
}

// src/generated/models/FormDtoWithJsonFormsDataAllOf.ts
function instanceOfFormDtoWithJsonFormsDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "workDescription" in value;
  isInstance = isInstance && "hoursSum" in value;
  isInstance = isInstance && "timeFrom" in value;
  isInstance = isInstance && "timeTo" in value;
  isInstance = isInstance && "hoursBreak" in value;
  isInstance = isInstance && "template" in value;
  return isInstance;
}
function FormDtoWithJsonFormsDataAllOfFromJSON(json) {
  return FormDtoWithJsonFormsDataAllOfFromJSONTyped(json, false);
}
function FormDtoWithJsonFormsDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workDescription": json["work_description"],
    "hoursSum": json["hours_sum"],
    "timeFrom": json["time_from"],
    "timeTo": json["time_to"],
    "hoursBreak": json["hours_break"],
    "template": FormTemplateModelWithJsonFormsDataFromJSON(json["template"])
  };
}
function FormDtoWithJsonFormsDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "template": FormTemplateModelWithJsonFormsDataToJSON(value.template)
  };
}

// src/generated/models/FormField.ts
function instanceOfFormField(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "formId" in value;
  isInstance = isInstance && "formFieldTypeId" in value;
  isInstance = isInstance && "formTemplateFieldId" in value;
  isInstance = isInstance && "placement" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function FormFieldFromJSON(json) {
  return FormFieldFromJSONTyped(json, false);
}
function FormFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "formId": json["form_id"],
    "formFieldTypeId": json["form_field_type_id"],
    "formTemplateFieldId": json["form_template_field_id"],
    "fileId": !exists(json, "file_id") ? void 0 : json["file_id"],
    "contentValue": !exists(json, "content_value") ? void 0 : json["content_value"],
    "comment": !exists(json, "comment") ? void 0 : json["comment"],
    "placement": json["placement"],
    "form": !exists(json, "form") ? void 0 : FormFromJSON(json["form"]),
    "file": !exists(json, "file") ? void 0 : BaseFileFromJSON(json["file"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function FormFieldToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "form_id": value.formId,
    "form_field_type_id": value.formFieldTypeId,
    "form_template_field_id": value.formTemplateFieldId,
    "file_id": value.fileId,
    "content_value": value.contentValue,
    "comment": value.comment,
    "placement": value.placement,
    "form": FormToJSON(value.form),
    "file": BaseFileToJSON(value.file)
  };
}

// src/generated/models/FormTemplateView200Response.ts
function instanceOfFormTemplateView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormTemplateView200ResponseFromJSON(json) {
  return FormTemplateView200ResponseFromJSONTyped(json, false);
}
function FormTemplateView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": FormTemplateModelWithJsonFormsDataFromJSON(json["data"])
  };
}
function FormTemplateView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": FormTemplateModelWithJsonFormsDataToJSON(value.data)
  };
}

// src/generated/models/FormTemplatesList200Response.ts
function instanceOfFormTemplatesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormTemplatesList200ResponseFromJSON(json) {
  return FormTemplatesList200ResponseFromJSONTyped(json, false);
}
function FormTemplatesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(FormTemplateModelWithJsonFormsDataFromJSON)
  };
}
function FormTemplatesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(FormTemplateModelWithJsonFormsDataToJSON)
  };
}

// src/generated/models/FormTemplatesList200ResponseAllOf.ts
function instanceOfFormTemplatesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormTemplatesList200ResponseAllOfFromJSON(json) {
  return FormTemplatesList200ResponseAllOfFromJSONTyped(json, false);
}
function FormTemplatesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(FormTemplateModelWithJsonFormsDataFromJSON)
  };
}
function FormTemplatesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(FormTemplateModelWithJsonFormsDataToJSON)
  };
}

// src/generated/models/FormView200ResponseData.ts
function instanceOfFormView200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "formTemplateId" in value;
  isInstance = isInstance && "formDate" in value;
  isInstance = isInstance && "isDraft" in value;
  isInstance = isInstance && "workDescription" in value;
  isInstance = isInstance && "project" in value;
  isInstance = isInstance && "user" in value;
  isInstance = isInstance && "formTemplate" in value;
  isInstance = isInstance && "hoursSum" in value;
  isInstance = isInstance && "timeFrom" in value;
  isInstance = isInstance && "timeTo" in value;
  isInstance = isInstance && "hoursBreak" in value;
  isInstance = isInstance && "template" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormView200ResponseDataFromJSON(json) {
  return FormView200ResponseDataFromJSONTyped(json, false);
}
function FormView200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "modifiedBy": !exists(json, "modified_by") ? void 0 : UserFromJSON(json["modified_by"]),
    "userId": json["user_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "formTemplateId": json["form_template_id"],
    "approvedById": !exists(json, "approved_by_id") ? void 0 : json["approved_by_id"],
    "approvedBy": !exists(json, "approved_by") ? void 0 : UserFromJSON(json["approved_by"]),
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "clockingRecordId": !exists(json, "clocking_record_id") ? void 0 : json["clocking_record_id"],
    "formDate": new Date(json["form_date"]),
    "isInvoiced": !exists(json, "is_invoiced") ? void 0 : new Date(json["is_invoiced"]),
    "isDraft": json["is_draft"],
    "approved": !exists(json, "approved") ? void 0 : new Date(json["approved"]),
    "linkToPdf": !exists(json, "link_to_pdf") ? void 0 : json["link_to_pdf"],
    "linkToHtml": !exists(json, "link_to_html") ? void 0 : json["link_to_html"],
    "workDescription": json["work_description"],
    "project": ControlPanelApiProjectViewOrIndexResponseFromJSON(json["project"]),
    "user": UserFromJSON(json["user"]),
    "formTemplate": FormTemplateModelWithJsonFormsDataFromJSON(json["form_template"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "hoursSum": json["hours_sum"],
    "timeFrom": json["time_from"],
    "timeTo": json["time_to"],
    "hoursBreak": json["hours_break"],
    "template": FormTemplateModelWithJsonFormsDataFromJSON(json["template"]),
    "data": json["data"]
  };
}
function FormView200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "modified_by": UserToJSON(value.modifiedBy),
    "user_id": value.userId,
    "company_id": value.companyId,
    "project_id": value.projectId,
    "form_template_id": value.formTemplateId,
    "approved_by_id": value.approvedById,
    "approved_by": UserToJSON(value.approvedBy),
    "activity_id": value.activityId,
    "clocking_record_id": value.clockingRecordId,
    "form_date": value.formDate.toISOString(),
    "is_invoiced": value.isInvoiced === void 0 ? void 0 : value.isInvoiced.toISOString(),
    "is_draft": value.isDraft,
    "approved": value.approved === void 0 ? void 0 : value.approved.toISOString(),
    "link_to_pdf": value.linkToPdf,
    "link_to_html": value.linkToHtml,
    "project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.project),
    "user": UserToJSON(value.user),
    "form_template": FormTemplateModelWithJsonFormsDataToJSON(value.formTemplate),
    "template": FormTemplateModelWithJsonFormsDataToJSON(value.template),
    "data": value.data
  };
}

// src/generated/models/FormView200Response.ts
function instanceOfFormView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormView200ResponseFromJSON(json) {
  return FormView200ResponseFromJSONTyped(json, false);
}
function FormView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": FormView200ResponseDataFromJSON(json["data"])
  };
}
function FormView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": FormView200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/FormView200ResponseDataAllOf.ts
function instanceOfFormView200ResponseDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormView200ResponseDataAllOfFromJSON(json) {
  return FormView200ResponseDataAllOfFromJSONTyped(json, false);
}
function FormView200ResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"]
  };
}
function FormView200ResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data
  };
}

// src/generated/models/FormsList200Response.ts
function instanceOfFormsList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormsList200ResponseFromJSON(json) {
  return FormsList200ResponseFromJSONTyped(json, false);
}
function FormsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(FormDtoWithJsonFormsDataFromJSON)
  };
}
function FormsList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(FormDtoWithJsonFormsDataToJSON)
  };
}

// src/generated/models/FormsList200ResponseAllOf.ts
function instanceOfFormsList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function FormsList200ResponseAllOfFromJSON(json) {
  return FormsList200ResponseAllOfFromJSONTyped(json, false);
}
function FormsList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(FormDtoWithJsonFormsDataFromJSON)
  };
}
function FormsList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(FormDtoWithJsonFormsDataToJSON)
  };
}

// src/generated/models/FrontpageFeedDTOFormFields.ts
function instanceOfFrontpageFeedDTOFormFields(value) {
  let isInstance = true;
  return isInstance;
}
function FrontpageFeedDTOFormFieldsFromJSON(json) {
  return FrontpageFeedDTOFormFieldsFromJSONTyped(json, false);
}
function FrontpageFeedDTOFormFieldsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "images": !exists(json, "images") ? void 0 : json["images"].map(BaseFileFromJSON),
    "timeIntervalFrom": !exists(json, "time_interval_from") ? void 0 : json["time_interval_from"],
    "timeIntervalTo": !exists(json, "time_interval_to") ? void 0 : json["time_interval_to"],
    "timeRegistration": !exists(json, "time_registration") ? void 0 : json["time_registration"],
    "timepicker": !exists(json, "timepicker") ? void 0 : json["timepicker"],
    "pause": !exists(json, "pause") ? void 0 : json["pause"]
  };
}
function FrontpageFeedDTOFormFieldsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "images": value.images === void 0 ? void 0 : value.images.map(BaseFileToJSON),
    "time_interval_from": value.timeIntervalFrom,
    "time_interval_to": value.timeIntervalTo,
    "time_registration": value.timeRegistration,
    "timepicker": value.timepicker,
    "pause": value.pause
  };
}

// src/generated/models/InvoiceIntegration.ts
function instanceOfInvoiceIntegration(value) {
  let isInstance = true;
  return isInstance;
}
function InvoiceIntegrationFromJSON(json) {
  return InvoiceIntegrationFromJSONTyped(json, false);
}
function InvoiceIntegrationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function InvoiceIntegrationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name
  };
}

// src/generated/models/Invoice.ts
function instanceOfInvoice(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "project" in value;
  isInstance = isInstance && "issuedDate" in value;
  isInstance = isInstance && "created" in value;
  return isInstance;
}
function InvoiceFromJSON(json) {
  return InvoiceFromJSONTyped(json, false);
}
function InvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "senderId": !exists(json, "sender_id") ? void 0 : json["sender_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"]),
    "contactPerson": !exists(json, "contact_person") ? void 0 : ContactPersonFromJSON(json["contact_person"]),
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "projectId": !exists(json, "project_id") ? void 0 : json["project_id"],
    "project": ControlPanelApiProjectViewOrIndexResponseFromJSON(json["project"]),
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"],
    "paymentTerm": !exists(json, "payment_term") ? void 0 : PaymentTermFromJSON(json["payment_term"]),
    "integrationId": !exists(json, "integration_id") ? void 0 : json["integration_id"],
    "integration": !exists(json, "integration") ? void 0 : InvoiceIntegrationFromJSON(json["integration"]),
    "invoiceLines": !exists(json, "invoice_lines") ? void 0 : json["invoice_lines"].map(InvoiceLineFromJSON),
    "ean": !exists(json, "ean") ? void 0 : json["ean"],
    "sendToEan": !exists(json, "send_to_ean") ? void 0 : json["send_to_ean"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "erpPaymentTermId": !exists(json, "erp_payment_term_id") ? void 0 : json["erp_payment_term_id"],
    "offerNumber": !exists(json, "offer_number") ? void 0 : json["offer_number"],
    "invoiceNumber": !exists(json, "invoice_number") ? void 0 : json["invoice_number"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "message": !exists(json, "message") ? void 0 : json["message"],
    "reference": !exists(json, "reference") ? void 0 : json["reference"],
    "issuedDate": new Date(json["issued_date"]),
    "paymentDueDate": !exists(json, "payment_due_date") ? void 0 : new Date(json["payment_due_date"]),
    "paidDate": !exists(json, "paid_date") ? void 0 : new Date(json["paid_date"]),
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "dateFrom": !exists(json, "date_from") ? void 0 : new Date(json["date_from"]),
    "dateTo": !exists(json, "date_to") ? void 0 : new Date(json["date_to"]),
    "isDraft": !exists(json, "is_draft") ? void 0 : json["is_draft"],
    "isCreditNote": !exists(json, "is_credit_note") ? void 0 : json["is_credit_note"],
    "isOffer": !exists(json, "is_offer") ? void 0 : json["is_offer"],
    "isLocked": !exists(json, "is_locked") ? void 0 : json["is_locked"],
    "isPaid": !exists(json, "is_paid") ? void 0 : json["is_paid"],
    "isFinalInvoice": !exists(json, "is_final_invoice") ? void 0 : json["is_final_invoice"],
    "isManuallyInvoiced": !exists(json, "is_manually_invoiced") ? void 0 : json["is_manually_invoiced"],
    "includingVat": !exists(json, "including_vat") ? void 0 : json["including_vat"],
    "projectOverviewAttached": !exists(json, "project_overview_attached") ? void 0 : json["project_overview_attached"],
    "euCustomer": !exists(json, "eu_customer") ? void 0 : json["eu_customer"],
    "downloaded": !exists(json, "downloaded") ? void 0 : new Date(json["downloaded"]),
    "includeInvoicedForms": !exists(json, "include_invoiced_forms") ? void 0 : json["include_invoiced_forms"],
    "combineProductLines": !exists(json, "combine_product_lines") ? void 0 : json["combine_product_lines"],
    "combineWorkingTimeLines": !exists(json, "combine_working_time_lines") ? void 0 : json["combine_working_time_lines"],
    "includeNotInvoicedHoursAndProducts": !exists(json, "include_not_invoiced_hours_and_products") ? void 0 : json["include_not_invoiced_hours_and_products"],
    "includeOfferLines": !exists(json, "include_offer_lines") ? void 0 : json["include_offer_lines"],
    "showPaymentTerm": !exists(json, "show_payment_term") ? void 0 : json["show_payment_term"],
    "showPrices": !exists(json, "show_prices") ? void 0 : json["show_prices"],
    "showProductImages": !exists(json, "show_product_images") ? void 0 : json["show_product_images"],
    "showEmployeeName": !exists(json, "show_employee_name") ? void 0 : json["show_employee_name"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "created": new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "pdfUrl": !exists(json, "pdf_url") ? void 0 : json["pdf_url"],
    "hasProjectPdfAttached": !exists(json, "has_project_pdf_attached") ? void 0 : json["has_project_pdf_attached"],
    "grossPayment": !exists(json, "gross_payment") ? void 0 : json["gross_payment"],
    "netPayment": !exists(json, "net_payment") ? void 0 : json["net_payment"],
    "totalDiscountPercent": !exists(json, "total_discount_percent") ? void 0 : json["total_discount_percent"],
    "totalCostPrice": !exists(json, "total_cost_price") ? void 0 : json["total_cost_price"],
    "integrationImageUrl": !exists(json, "integration_image_url") ? void 0 : json["integration_image_url"]
  };
}
function InvoiceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "created_by_id": value.createdById,
    "sender_id": value.senderId,
    "contact_id": value.contactId,
    "contact_person_id": value.contactPersonId,
    "contact": ContactToJSON(value.contact),
    "contact_person": ContactPersonToJSON(value.contactPerson),
    "currency_id": value.currencyId,
    "project_id": value.projectId,
    "project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.project),
    "payment_term_id": value.paymentTermId,
    "payment_term": PaymentTermToJSON(value.paymentTerm),
    "integration_id": value.integrationId,
    "integration": InvoiceIntegrationToJSON(value.integration),
    "invoice_lines": value.invoiceLines === void 0 ? void 0 : value.invoiceLines.map(InvoiceLineToJSON),
    "ean": value.ean,
    "send_to_ean": value.sendToEan,
    "erp_id": value.erpId,
    "erp_payment_term_id": value.erpPaymentTermId,
    "offer_number": value.offerNumber,
    "invoice_number": value.invoiceNumber,
    "title": value.title,
    "message": value.message,
    "reference": value.reference,
    "issued_date": value.issuedDate.toISOString(),
    "payment_due_date": value.paymentDueDate === void 0 ? void 0 : value.paymentDueDate.toISOString(),
    "paid_date": value.paidDate === void 0 ? void 0 : value.paidDate.toISOString(),
    "discount_percent": value.discountPercent,
    "date_from": value.dateFrom === void 0 ? void 0 : value.dateFrom.toISOString(),
    "date_to": value.dateTo === void 0 ? void 0 : value.dateTo.toISOString(),
    "is_draft": value.isDraft,
    "is_credit_note": value.isCreditNote,
    "is_offer": value.isOffer,
    "is_locked": value.isLocked,
    "is_paid": value.isPaid,
    "is_final_invoice": value.isFinalInvoice,
    "is_manually_invoiced": value.isManuallyInvoiced,
    "including_vat": value.includingVat,
    "project_overview_attached": value.projectOverviewAttached,
    "eu_customer": value.euCustomer,
    "downloaded": value.downloaded === void 0 ? void 0 : value.downloaded.toISOString(),
    "include_invoiced_forms": value.includeInvoicedForms,
    "combine_product_lines": value.combineProductLines,
    "combine_working_time_lines": value.combineWorkingTimeLines,
    "include_not_invoiced_hours_and_products": value.includeNotInvoicedHoursAndProducts,
    "include_offer_lines": value.includeOfferLines,
    "show_payment_term": value.showPaymentTerm,
    "show_prices": value.showPrices,
    "show_product_images": value.showProductImages,
    "show_employee_name": value.showEmployeeName,
    "vat_percent": value.vatPercent
  };
}

// src/generated/models/TemplateType.ts
var TemplateType = {
  TimeRegistration: "time_registration",
  Qa: "qa",
  Other: "other"
};
function TemplateTypeFromJSON(json) {
  return TemplateTypeFromJSONTyped(json, false);
}
function TemplateTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function TemplateTypeToJSON(value) {
  return value;
}

// src/generated/models/FrontpageFeedDTO.ts
var FrontpageFeedDTOTypeEnum = {
  Form: "form",
  Expense: "expense",
  Invoice: "invoice",
  WallPost: "wall_post"
};
function instanceOfFrontpageFeedDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "template" in value;
  isInstance = isInstance && "link" in value;
  isInstance = isInstance && "employee" in value;
  return isInstance;
}
function FrontpageFeedDTOFromJSON(json) {
  return FrontpageFeedDTOFromJSONTyped(json, false);
}
function FrontpageFeedDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": json["date"] === null ? null : new Date(json["date"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "type": json["type"],
    "sum": !exists(json, "sum") ? void 0 : json["sum"],
    "template": json["template"],
    "templateType": !exists(json, "template_type") ? void 0 : TemplateTypeFromJSON(json["template_type"]),
    "link": json["link"],
    "failedControlPoints": !exists(json, "failed_control_points") ? void 0 : json["failed_control_points"],
    "invoiced": !exists(json, "invoiced") ? void 0 : json["invoiced"],
    "approved": !exists(json, "approved") ? void 0 : json["approved"],
    "employee": UserFromJSON(json["employee"]),
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "form": !exists(json, "form") ? void 0 : FormFromJSON(json["form"]),
    "expense": !exists(json, "expense") ? void 0 : ExpenseFromJSON(json["expense"]),
    "invoice": !exists(json, "invoice") ? void 0 : InvoiceFromJSON(json["invoice"]),
    "wallPost": !exists(json, "wall_post") ? void 0 : WallPostFromJSON(json["wall_post"]),
    "formFields": !exists(json, "form_fields") ? void 0 : FrontpageFeedDTOFormFieldsFromJSON(json["form_fields"])
  };
}
function FrontpageFeedDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "date": value.date === null ? null : value.date.toISOString(),
    "deleted": value.deleted === void 0 ? void 0 : value.deleted === null ? null : value.deleted.toISOString(),
    "sum": value.sum,
    "template": value.template,
    "template_type": TemplateTypeToJSON(value.templateType),
    "link": value.link,
    "failed_control_points": value.failedControlPoints,
    "invoiced": value.invoiced,
    "approved": value.approved,
    "employee": UserToJSON(value.employee),
    "project": ProjectToJSON(value.project),
    "form": FormToJSON(value.form),
    "expense": ExpenseToJSON(value.expense),
    "invoice": InvoiceToJSON(value.invoice),
    "wall_post": WallPostToJSON(value.wallPost),
    "form_fields": FrontpageFeedDTOFormFieldsToJSON(value.formFields)
  };
}

// src/generated/models/FrontpageTotalConsumptionDTO.ts
function instanceOfFrontpageTotalConsumptionDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "productCost" in value;
  isInstance = isInstance && "hoursCost" in value;
  isInstance = isInstance && "contribution" in value;
  return isInstance;
}
function FrontpageTotalConsumptionDTOFromJSON(json) {
  return FrontpageTotalConsumptionDTOFromJSONTyped(json, false);
}
function FrontpageTotalConsumptionDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productCost": json["product_cost"],
    "hoursCost": json["hours_cost"],
    "contribution": json["contribution"]
  };
}
function FrontpageTotalConsumptionDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_cost": value.productCost,
    "hours_cost": value.hoursCost,
    "contribution": value.contribution
  };
}

// src/generated/models/FrontpageWeeklyConsumptionDTO.ts
function instanceOfFrontpageWeeklyConsumptionDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "week" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function FrontpageWeeklyConsumptionDTOFromJSON(json) {
  return FrontpageWeeklyConsumptionDTOFromJSONTyped(json, false);
}
function FrontpageWeeklyConsumptionDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "week": json["week"],
    "value": json["value"]
  };
}
function FrontpageWeeklyConsumptionDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "week": value.week,
    "value": value.value
  };
}

// src/generated/models/GatherOfferLines200Response.ts
function instanceOfGatherOfferLines200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GatherOfferLines200ResponseFromJSON(json) {
  return GatherOfferLines200ResponseFromJSONTyped(json, false);
}
function GatherOfferLines200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(OfferLineFromJSON)
  };
}
function GatherOfferLines200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(OfferLineToJSON)
  };
}

// src/generated/models/GenericIndexResponseWithEntitiesAndPaginationOk.ts
function instanceOfGenericIndexResponseWithEntitiesAndPaginationOk(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function GenericIndexResponseWithEntitiesAndPaginationOkFromJSON(json) {
  return GenericIndexResponseWithEntitiesAndPaginationOkFromJSONTyped(json, false);
}
function GenericIndexResponseWithEntitiesAndPaginationOkFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"])
  };
}
function GenericIndexResponseWithEntitiesAndPaginationOkToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination)
  };
}

// src/generated/models/GetAbsence200Response.ts
function instanceOfGetAbsence200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsence200ResponseFromJSON(json) {
  return GetAbsence200ResponseFromJSONTyped(json, false);
}
function GetAbsence200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": AbsenceFromJSON(json["data"])
  };
}
function GetAbsence200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": AbsenceToJSON(value.data)
  };
}

// src/generated/models/GetAbsenceType200Response.ts
function instanceOfGetAbsenceType200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsenceType200ResponseFromJSON(json) {
  return GetAbsenceType200ResponseFromJSONTyped(json, false);
}
function GetAbsenceType200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": AbsenceTypeFromJSON(json["data"])
  };
}
function GetAbsenceType200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": AbsenceTypeToJSON(value.data)
  };
}

// src/generated/models/GetAbsenceTypes200Response.ts
function instanceOfGetAbsenceTypes200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsenceTypes200ResponseFromJSON(json) {
  return GetAbsenceTypes200ResponseFromJSONTyped(json, false);
}
function GetAbsenceTypes200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(AbsenceTypeFromJSON)
  };
}
function GetAbsenceTypes200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(AbsenceTypeToJSON)
  };
}

// src/generated/models/GetAbsenceTypes200ResponseAllOf.ts
function instanceOfGetAbsenceTypes200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsenceTypes200ResponseAllOfFromJSON(json) {
  return GetAbsenceTypes200ResponseAllOfFromJSONTyped(json, false);
}
function GetAbsenceTypes200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(AbsenceTypeFromJSON)
  };
}
function GetAbsenceTypes200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(AbsenceTypeToJSON)
  };
}

// src/generated/models/GetAbsences200Response.ts
function instanceOfGetAbsences200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsences200ResponseFromJSON(json) {
  return GetAbsences200ResponseFromJSONTyped(json, false);
}
function GetAbsences200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(AbsenceFromJSON)
  };
}
function GetAbsences200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(AbsenceToJSON)
  };
}

// src/generated/models/GetAbsences200ResponseAllOf.ts
function instanceOfGetAbsences200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetAbsences200ResponseAllOfFromJSON(json) {
  return GetAbsences200ResponseAllOfFromJSONTyped(json, false);
}
function GetAbsences200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(AbsenceFromJSON)
  };
}
function GetAbsences200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(AbsenceToJSON)
  };
}

// src/generated/models/RegistrationsDTO.ts
var RegistrationsDTOTypeEnum = {
  Form: "form",
  Expense: "expense",
  Invoice: "invoice"
};
function instanceOfRegistrationsDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "activityId" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "link" in value;
  isInstance = isInstance && "employee" in value;
  isInstance = isInstance && "invoicedDate" in value;
  isInstance = isInstance && "invoiced" in value;
  isInstance = isInstance && "template" in value;
  isInstance = isInstance && "workDescription" in value;
  isInstance = isInstance && "vendorName" in value;
  isInstance = isInstance && "approvedDate" in value;
  isInstance = isInstance && "approved" in value;
  isInstance = isInstance && "deletedDate" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function RegistrationsDTOFromJSON(json) {
  return RegistrationsDTOFromJSONTyped(json, false);
}
function RegistrationsDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "activityId": json["activity_id"],
    "date": json["date"] === null ? null : new Date(json["date"]),
    "type": json["type"],
    "link": json["link"],
    "preview": !exists(json, "preview") ? void 0 : json["preview"],
    "employee": json["employee"],
    "avatar": !exists(json, "avatar") ? void 0 : json["avatar"],
    "invoicedDate": json["invoiced_date"] === null ? null : new Date(json["invoiced_date"]),
    "invoiced": json["invoiced"],
    "template": json["template"],
    "workDescription": json["work_description"],
    "vendorName": json["vendor_name"],
    "approvedDate": json["approved_date"] === null ? null : new Date(json["approved_date"]),
    "approved": json["approved"],
    "activity": !exists(json, "activity") ? void 0 : ActivityFromJSON(json["activity"]),
    "deletedDate": json["deleted_date"] === null ? null : new Date(json["deleted_date"]),
    "deleted": json["deleted"]
  };
}
function RegistrationsDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "activity_id": value.activityId,
    "date": value.date === null ? null : value.date.toISOString(),
    "type": value.type,
    "link": value.link,
    "preview": value.preview,
    "employee": value.employee,
    "avatar": value.avatar,
    "invoiced_date": value.invoicedDate === null ? null : value.invoicedDate.toISOString(),
    "invoiced": value.invoiced,
    "template": value.template,
    "work_description": value.workDescription,
    "vendor_name": value.vendorName,
    "approved_date": value.approvedDate === null ? null : value.approvedDate.toISOString(),
    "approved": value.approved,
    "activity": ActivityToJSON(value.activity),
    "deleted_date": value.deletedDate === null ? null : value.deletedDate.toISOString(),
    "deleted": value.deleted
  };
}

// src/generated/models/RegistrationsInvoiceDTOAllOfCustomMetadata.ts
function instanceOfRegistrationsInvoiceDTOAllOfCustomMetadata(value) {
  let isInstance = true;
  return isInstance;
}
function RegistrationsInvoiceDTOAllOfCustomMetadataFromJSON(json) {
  return RegistrationsInvoiceDTOAllOfCustomMetadataFromJSONTyped(json, false);
}
function RegistrationsInvoiceDTOAllOfCustomMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "editable": !exists(json, "editable") ? void 0 : json["editable"]
  };
}
function RegistrationsInvoiceDTOAllOfCustomMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "editable": value.editable
  };
}

// src/generated/models/RegistrationsInvoiceDTO.ts
var RegistrationsInvoiceDTOTypeEnum = {
  Form: "form",
  Expense: "expense",
  Invoice: "invoice"
};
function instanceOfRegistrationsInvoiceDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "activityId" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "link" in value;
  isInstance = isInstance && "employee" in value;
  isInstance = isInstance && "invoicedDate" in value;
  isInstance = isInstance && "invoiced" in value;
  isInstance = isInstance && "template" in value;
  isInstance = isInstance && "workDescription" in value;
  isInstance = isInstance && "vendorName" in value;
  isInstance = isInstance && "approvedDate" in value;
  isInstance = isInstance && "approved" in value;
  isInstance = isInstance && "deletedDate" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function RegistrationsInvoiceDTOFromJSON(json) {
  return RegistrationsInvoiceDTOFromJSONTyped(json, false);
}
function RegistrationsInvoiceDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "activityId": json["activity_id"],
    "date": json["date"] === null ? null : new Date(json["date"]),
    "type": json["type"],
    "link": json["link"],
    "preview": !exists(json, "preview") ? void 0 : json["preview"],
    "employee": json["employee"],
    "avatar": !exists(json, "avatar") ? void 0 : json["avatar"],
    "invoicedDate": json["invoiced_date"] === null ? null : new Date(json["invoiced_date"]),
    "invoiced": json["invoiced"],
    "template": json["template"],
    "workDescription": json["work_description"],
    "vendorName": json["vendor_name"],
    "approvedDate": json["approved_date"] === null ? null : new Date(json["approved_date"]),
    "approved": json["approved"],
    "activity": !exists(json, "activity") ? void 0 : ActivityFromJSON(json["activity"]),
    "deletedDate": json["deleted_date"] === null ? null : new Date(json["deleted_date"]),
    "deleted": json["deleted"],
    "customMetadata": !exists(json, "custom_metadata") ? void 0 : RegistrationsInvoiceDTOAllOfCustomMetadataFromJSON(json["custom_metadata"])
  };
}
function RegistrationsInvoiceDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "activity_id": value.activityId,
    "date": value.date === null ? null : value.date.toISOString(),
    "type": value.type,
    "link": value.link,
    "preview": value.preview,
    "employee": value.employee,
    "avatar": value.avatar,
    "invoiced_date": value.invoicedDate === null ? null : value.invoicedDate.toISOString(),
    "invoiced": value.invoiced,
    "template": value.template,
    "work_description": value.workDescription,
    "vendor_name": value.vendorName,
    "approved_date": value.approvedDate === null ? null : value.approvedDate.toISOString(),
    "approved": value.approved,
    "activity": ActivityToJSON(value.activity),
    "deleted_date": value.deletedDate === null ? null : value.deletedDate.toISOString(),
    "deleted": value.deleted,
    "custom_metadata": RegistrationsInvoiceDTOAllOfCustomMetadataToJSON(value.customMetadata)
  };
}

// src/generated/models/GetAllRegistrations200ResponseDataInner.ts
function GetAllRegistrations200ResponseDataInnerFromJSON(json) {
  return GetAllRegistrations200ResponseDataInnerFromJSONTyped(json, false);
}
function GetAllRegistrations200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "expense":
      return __spreadProps(__spreadValues({}, RegistrationsDTOFromJSONTyped(json, true)), { type: "expense" });
    case "form":
      return __spreadProps(__spreadValues({}, RegistrationsDTOFromJSONTyped(json, true)), { type: "form" });
    case "invoice":
      return __spreadProps(__spreadValues({}, RegistrationsInvoiceDTOFromJSONTyped(json, true)), { type: "invoice" });
    default:
      throw new Error(`No variant of GetAllRegistrations200ResponseDataInner exists with 'type=${json["type"]}'`);
  }
}
function GetAllRegistrations200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "expense":
      return RegistrationsDTOToJSON(value);
    case "form":
      return RegistrationsDTOToJSON(value);
    case "invoice":
      return RegistrationsInvoiceDTOToJSON(value);
    default:
      throw new Error(`No variant of GetAllRegistrations200ResponseDataInner exists with 'type=${value["type"]}'`);
  }
}

// src/generated/models/GetAllRegistrations200ResponseDocumentTypesInner.ts
function instanceOfGetAllRegistrations200ResponseDocumentTypesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function GetAllRegistrations200ResponseDocumentTypesInnerFromJSON(json) {
  return GetAllRegistrations200ResponseDocumentTypesInnerFromJSONTyped(json, false);
}
function GetAllRegistrations200ResponseDocumentTypesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "formTemplateId": !exists(json, "form_template_id") ? void 0 : json["form_template_id"],
    "formTitle": !exists(json, "form_title") ? void 0 : json["form_title"]
  };
}
function GetAllRegistrations200ResponseDocumentTypesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "form_template_id": value.formTemplateId,
    "form_title": value.formTitle
  };
}

// src/generated/models/GetAllRegistrations200Response.ts
function instanceOfGetAllRegistrations200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "documentTypes" in value;
  return isInstance;
}
function GetAllRegistrations200ResponseFromJSON(json) {
  return GetAllRegistrations200ResponseFromJSONTyped(json, false);
}
function GetAllRegistrations200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(GetAllRegistrations200ResponseDataInnerFromJSON),
    "documentTypes": json["document_types"].map(GetAllRegistrations200ResponseDocumentTypesInnerFromJSON)
  };
}
function GetAllRegistrations200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(GetAllRegistrations200ResponseDataInnerToJSON),
    "document_types": value.documentTypes.map(GetAllRegistrations200ResponseDocumentTypesInnerToJSON)
  };
}

// src/generated/models/GetCard200Response.ts
function instanceOfGetCard200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function GetCard200ResponseFromJSON(json) {
  return GetCard200ResponseFromJSONTyped(json, false);
}
function GetCard200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CardFromJSON(json["data"]),
    "pagination": PaginationDetailsFromJSON(json["pagination"])
  };
}
function GetCard200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CardToJSON(value.data),
    "pagination": PaginationDetailsToJSON(value.pagination)
  };
}

// src/generated/models/GetCardsWithTaskAndUsers200ResponseDataAbsencesValue.ts
function instanceOfGetCardsWithTaskAndUsers200ResponseDataAbsencesValue(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "absenceTypeId" in value;
  return isInstance;
}
function GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSON(json) {
  return GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSONTyped(json, false);
}
function GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": json["company_id"],
    "userId": json["user_id"],
    "absenceTypeId": json["absence_type_id"],
    "taskId": !exists(json, "task_id") ? void 0 : json["task_id"],
    "isFullDay": !exists(json, "is_full_day") ? void 0 : json["is_full_day"],
    "includeWeekend": !exists(json, "include_weekend") ? void 0 : json["include_weekend"],
    "date": !exists(json, "date") ? void 0 : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "duration": !exists(json, "duration") ? void 0 : json["duration"],
    "futureAbsenceCardsInSequence": !exists(json, "futureAbsenceCardsInSequence") ? void 0 : json["futureAbsenceCardsInSequence"],
    "previousAbsenceCardsInSequence": !exists(json, "previousAbsenceCardsInSequence") ? void 0 : json["previousAbsenceCardsInSequence"],
    "absenceType": !exists(json, "absence_type") ? void 0 : AbsenceTypeFromJSON(json["absence_type"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function GetCardsWithTaskAndUsers200ResponseDataAbsencesValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "user_id": value.userId,
    "absence_type_id": value.absenceTypeId,
    "task_id": value.taskId,
    "is_full_day": value.isFullDay,
    "include_weekend": value.includeWeekend,
    "date": value.date === void 0 ? void 0 : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "duration": value.duration,
    "futureAbsenceCardsInSequence": value.futureAbsenceCardsInSequence,
    "previousAbsenceCardsInSequence": value.previousAbsenceCardsInSequence,
    "absence_type": AbsenceTypeToJSON(value.absenceType)
  };
}

// src/generated/models/GetCardsWithTaskAndUsers200ResponseDataTasksValue.ts
var GetCardsWithTaskAndUsers200ResponseDataTasksValueRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfGetCardsWithTaskAndUsers200ResponseDataTasksValue(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSON(json) {
  return GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSONTyped(json, false);
}
function GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "active": !exists(json, "active") ? void 0 : json["active"],
    "recurringRule": !exists(json, "recurring_rule") ? void 0 : json["recurring_rule"],
    "startDate": !exists(json, "start_date") ? void 0 : new Date(json["start_date"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"].map(FormTemplateSimpleEntityFromJSON),
    "formTemplatesTasks": !exists(json, "form_templates_tasks") ? void 0 : json["form_templates_tasks"].map(FormTemplatesTasksModelFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "productsTasks": !exists(json, "products_tasks") ? void 0 : json["products_tasks"].map(ProductsTaskFromJSON),
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function GetCardsWithTaskAndUsers200ResponseDataTasksValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "active": value.active,
    "recurring_rule": value.recurringRule,
    "start_date": value.startDate === void 0 ? void 0 : value.startDate.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "estimate": value.estimate,
    "repeat": value.repeat,
    "interval": value.interval,
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "form_templates": value.formTemplates === void 0 ? void 0 : value.formTemplates.map(FormTemplateSimpleEntityToJSON),
    "form_templates_tasks": value.formTemplatesTasks === void 0 ? void 0 : value.formTemplatesTasks.map(FormTemplatesTasksModelToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "products_tasks": value.productsTasks === void 0 ? void 0 : value.productsTasks.map(ProductsTaskToJSON),
    "project": ProjectToJSON(value.project)
  };
}

// src/generated/models/GetCardsWithTaskAndUsers200ResponseData.ts
function instanceOfGetCardsWithTaskAndUsers200ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function GetCardsWithTaskAndUsers200ResponseDataFromJSON(json) {
  return GetCardsWithTaskAndUsers200ResponseDataFromJSONTyped(json, false);
}
function GetCardsWithTaskAndUsers200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : mapValues(json["cards"], CardFromJSON),
    "users": !exists(json, "users") ? void 0 : mapValues(json["users"], UserFromJSON),
    "tasks": !exists(json, "tasks") ? void 0 : mapValues(json["tasks"], GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSON),
    "absences": !exists(json, "absences") ? void 0 : mapValues(json["absences"], GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSON)
  };
}
function GetCardsWithTaskAndUsers200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards === void 0 ? void 0 : mapValues(value.cards, CardToJSON),
    "users": value.users === void 0 ? void 0 : mapValues(value.users, UserToJSON),
    "tasks": value.tasks === void 0 ? void 0 : mapValues(value.tasks, GetCardsWithTaskAndUsers200ResponseDataTasksValueToJSON),
    "absences": value.absences === void 0 ? void 0 : mapValues(value.absences, GetCardsWithTaskAndUsers200ResponseDataAbsencesValueToJSON)
  };
}

// src/generated/models/GetCardsWithTaskAndUsers200Response.ts
function instanceOfGetCardsWithTaskAndUsers200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCardsWithTaskAndUsers200ResponseFromJSON(json) {
  return GetCardsWithTaskAndUsers200ResponseFromJSONTyped(json, false);
}
function GetCardsWithTaskAndUsers200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": GetCardsWithTaskAndUsers200ResponseDataFromJSON(json["data"])
  };
}
function GetCardsWithTaskAndUsers200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GetCardsWithTaskAndUsers200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/GetCities200Response.ts
function instanceOfGetCities200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCities200ResponseFromJSON(json) {
  return GetCities200ResponseFromJSONTyped(json, false);
}
function GetCities200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(CityFromJSON)
  };
}
function GetCities200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(CityToJSON)
  };
}

// src/generated/models/GetCities200ResponseAllOf.ts
function instanceOfGetCities200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCities200ResponseAllOfFromJSON(json) {
  return GetCities200ResponseAllOfFromJSONTyped(json, false);
}
function GetCities200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(CityFromJSON)
  };
}
function GetCities200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(CityToJSON)
  };
}

// src/generated/models/GetCity200Response.ts
function instanceOfGetCity200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCity200ResponseFromJSON(json) {
  return GetCity200ResponseFromJSONTyped(json, false);
}
function GetCity200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CityFromJSON(json["data"])
  };
}
function GetCity200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CityToJSON(value.data)
  };
}

// src/generated/models/GetCompanies200Response.ts
function instanceOfGetCompanies200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCompanies200ResponseFromJSON(json) {
  return GetCompanies200ResponseFromJSONTyped(json, false);
}
function GetCompanies200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(CompanyFromJSON)
  };
}
function GetCompanies200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(CompanyToJSON)
  };
}

// src/generated/models/GetCompanies200ResponseAllOf.ts
function instanceOfGetCompanies200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCompanies200ResponseAllOfFromJSON(json) {
  return GetCompanies200ResponseAllOfFromJSONTyped(json, false);
}
function GetCompanies200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(CompanyFromJSON)
  };
}
function GetCompanies200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(CompanyToJSON)
  };
}

// src/generated/models/GetCompany200Response.ts
function instanceOfGetCompany200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCompany200ResponseFromJSON(json) {
  return GetCompany200ResponseFromJSONTyped(json, false);
}
function GetCompany200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CompanyFromJSON(json["data"])
  };
}
function GetCompany200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CompanyToJSON(value.data)
  };
}

// src/generated/models/GetContact200Response.ts
function instanceOfGetContact200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContact200ResponseFromJSON(json) {
  return GetContact200ResponseFromJSONTyped(json, false);
}
function GetContact200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ContactFromJSON(json["data"])
  };
}
function GetContact200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ContactToJSON(value.data)
  };
}

// src/generated/models/GetContactPerson200Response.ts
function instanceOfGetContactPerson200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContactPerson200ResponseFromJSON(json) {
  return GetContactPerson200ResponseFromJSONTyped(json, false);
}
function GetContactPerson200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ContactPersonFromJSON(json["data"])
  };
}
function GetContactPerson200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ContactPersonToJSON(value.data)
  };
}

// src/generated/models/GetContactPersonsList200Response.ts
function instanceOfGetContactPersonsList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContactPersonsList200ResponseFromJSON(json) {
  return GetContactPersonsList200ResponseFromJSONTyped(json, false);
}
function GetContactPersonsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ContactPersonFromJSON)
  };
}
function GetContactPersonsList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ContactPersonToJSON)
  };
}

// src/generated/models/GetContactPersonsList200ResponseAllOf.ts
function instanceOfGetContactPersonsList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContactPersonsList200ResponseAllOfFromJSON(json) {
  return GetContactPersonsList200ResponseAllOfFromJSONTyped(json, false);
}
function GetContactPersonsList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ContactPersonFromJSON)
  };
}
function GetContactPersonsList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ContactPersonToJSON)
  };
}

// src/generated/models/GetContacts200Response.ts
function instanceOfGetContacts200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContacts200ResponseFromJSON(json) {
  return GetContacts200ResponseFromJSONTyped(json, false);
}
function GetContacts200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ContactFromJSON)
  };
}
function GetContacts200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ContactToJSON)
  };
}

// src/generated/models/GetContacts200ResponseAllOf.ts
function instanceOfGetContacts200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetContacts200ResponseAllOfFromJSON(json) {
  return GetContacts200ResponseAllOfFromJSONTyped(json, false);
}
function GetContacts200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ContactFromJSON)
  };
}
function GetContacts200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ContactToJSON)
  };
}

// src/generated/models/GetCountries200Response.ts
function instanceOfGetCountries200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetCountries200ResponseFromJSON(json) {
  return GetCountries200ResponseFromJSONTyped(json, false);
}
function GetCountries200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(CountryFromJSON)
  };
}
function GetCountries200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(CountryToJSON)
  };
}

// src/generated/models/GetEmailAction200Response.ts
function instanceOfGetEmailAction200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetEmailAction200ResponseFromJSON(json) {
  return GetEmailAction200ResponseFromJSONTyped(json, false);
}
function GetEmailAction200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(EmailActionFromJSON)
  };
}
function GetEmailAction200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(EmailActionToJSON)
  };
}

// src/generated/models/GetEmailAction200ResponseAllOf.ts
function instanceOfGetEmailAction200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetEmailAction200ResponseAllOfFromJSON(json) {
  return GetEmailAction200ResponseAllOfFromJSONTyped(json, false);
}
function GetEmailAction200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(EmailActionFromJSON)
  };
}
function GetEmailAction200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(EmailActionToJSON)
  };
}

// src/generated/models/GetFeatures200Response.ts
function instanceOfGetFeatures200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetFeatures200ResponseFromJSON(json) {
  return GetFeatures200ResponseFromJSONTyped(json, false);
}
function GetFeatures200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(FeatureFromJSON)
  };
}
function GetFeatures200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(FeatureToJSON)
  };
}

// src/generated/models/GetFeatures200ResponseAllOf.ts
function instanceOfGetFeatures200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetFeatures200ResponseAllOfFromJSON(json) {
  return GetFeatures200ResponseAllOfFromJSONTyped(json, false);
}
function GetFeatures200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(FeatureFromJSON)
  };
}
function GetFeatures200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(FeatureToJSON)
  };
}

// src/generated/models/GetIntegrationTypes200Response.ts
function instanceOfGetIntegrationTypes200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetIntegrationTypes200ResponseFromJSON(json) {
  return GetIntegrationTypes200ResponseFromJSONTyped(json, false);
}
function GetIntegrationTypes200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(IntegrationTypeFromJSON)
  };
}
function GetIntegrationTypes200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(IntegrationTypeToJSON)
  };
}

// src/generated/models/GetIntegrationTypes200ResponseAllOf.ts
function instanceOfGetIntegrationTypes200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetIntegrationTypes200ResponseAllOfFromJSON(json) {
  return GetIntegrationTypes200ResponseAllOfFromJSONTyped(json, false);
}
function GetIntegrationTypes200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(IntegrationTypeFromJSON)
  };
}
function GetIntegrationTypes200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(IntegrationTypeToJSON)
  };
}

// src/generated/models/InvoiceActivityLog.ts
var InvoiceActivityLogActionEnum = {
  Created: "created",
  Sent: "sent",
  SentToErp: "sent_to_erp",
  SentViaEan: "sent_via_ean",
  EmailDelivered: "email_delivered",
  EmailOpened: "email_opened",
  EmailSendingFailed: "email_sending_failed",
  PaymentStatusPaid: "payment_status_paid",
  PaymentStatusUnpaid: "payment_status_unpaid"
};
function instanceOfInvoiceActivityLog(value) {
  let isInstance = true;
  isInstance = isInstance && "invoiceId" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "action" in value;
  return isInstance;
}
function InvoiceActivityLogFromJSON(json) {
  return InvoiceActivityLogFromJSONTyped(json, false);
}
function InvoiceActivityLogFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoice_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "date": new Date(json["date"]),
    "action": json["action"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "invoice": !exists(json, "invoice") ? void 0 : InvoiceFromJSON(json["invoice"]),
    "recipient": !exists(json, "recipient") ? void 0 : json["recipient"],
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"])
  };
}
function InvoiceActivityLogToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoice_id": value.invoiceId,
    "contact_id": value.contactId,
    "date": value.date.toISOString(),
    "action": value.action,
    "user": UserToJSON(value.user),
    "invoice": InvoiceToJSON(value.invoice),
    "recipient": value.recipient,
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/GetInvoiceActivityLog200Response.ts
function instanceOfGetInvoiceActivityLog200Response(value) {
  let isInstance = true;
  return isInstance;
}
function GetInvoiceActivityLog200ResponseFromJSON(json) {
  return GetInvoiceActivityLog200ResponseFromJSONTyped(json, false);
}
function GetInvoiceActivityLog200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : json["data"].map(InvoiceActivityLogFromJSON)
  };
}
function GetInvoiceActivityLog200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data === void 0 ? void 0 : value.data.map(InvoiceActivityLogToJSON)
  };
}

// src/generated/models/GetInvoiceEmails200Response.ts
function instanceOfGetInvoiceEmails200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoiceEmails200ResponseFromJSON(json) {
  return GetInvoiceEmails200ResponseFromJSONTyped(json, false);
}
function GetInvoiceEmails200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(EmailFromJSON)
  };
}
function GetInvoiceEmails200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(EmailToJSON)
  };
}

// src/generated/models/GetInvoiceEmails200ResponseAllOf.ts
function instanceOfGetInvoiceEmails200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoiceEmails200ResponseAllOfFromJSON(json) {
  return GetInvoiceEmails200ResponseAllOfFromJSONTyped(json, false);
}
function GetInvoiceEmails200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(EmailFromJSON)
  };
}
function GetInvoiceEmails200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(EmailToJSON)
  };
}

// src/generated/models/GetInvoiceFiles200Response.ts
function instanceOfGetInvoiceFiles200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoiceFiles200ResponseFromJSON(json) {
  return GetInvoiceFiles200ResponseFromJSONTyped(json, false);
}
function GetInvoiceFiles200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(BaseFileFromJSON)
  };
}
function GetInvoiceFiles200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(BaseFileToJSON)
  };
}

// src/generated/models/GetInvoiceFiles200ResponseAllOf.ts
function instanceOfGetInvoiceFiles200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoiceFiles200ResponseAllOfFromJSON(json) {
  return GetInvoiceFiles200ResponseAllOfFromJSONTyped(json, false);
}
function GetInvoiceFiles200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(BaseFileFromJSON)
  };
}
function GetInvoiceFiles200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(BaseFileToJSON)
  };
}

// src/generated/models/GetInvoices200Response.ts
function instanceOfGetInvoices200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoices200ResponseFromJSON(json) {
  return GetInvoices200ResponseFromJSONTyped(json, false);
}
function GetInvoices200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(InvoiceReadDTOFromJSON)
  };
}
function GetInvoices200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(InvoiceReadDTOToJSON)
  };
}

// src/generated/models/GetInvoices200ResponseAllOf.ts
function instanceOfGetInvoices200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetInvoices200ResponseAllOfFromJSON(json) {
  return GetInvoices200ResponseAllOfFromJSONTyped(json, false);
}
function GetInvoices200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(InvoiceReadDTOFromJSON)
  };
}
function GetInvoices200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(InvoiceReadDTOToJSON)
  };
}

// src/generated/models/GetLabel200Response.ts
function instanceOfGetLabel200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetLabel200ResponseFromJSON(json) {
  return GetLabel200ResponseFromJSONTyped(json, false);
}
function GetLabel200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": LabelEntityFromJSON(json["data"])
  };
}
function GetLabel200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": LabelEntityToJSON(value.data)
  };
}

// src/generated/models/GetLabels200Response.ts
function instanceOfGetLabels200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetLabels200ResponseFromJSON(json) {
  return GetLabels200ResponseFromJSONTyped(json, false);
}
function GetLabels200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(LabelEntityFromJSON)
  };
}
function GetLabels200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(LabelEntityToJSON)
  };
}

// src/generated/models/GetLabels200ResponseAllOf.ts
function instanceOfGetLabels200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetLabels200ResponseAllOfFromJSON(json) {
  return GetLabels200ResponseAllOfFromJSONTyped(json, false);
}
function GetLabels200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(LabelEntityFromJSON)
  };
}
function GetLabels200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(LabelEntityToJSON)
  };
}

// src/generated/models/Language.ts
function instanceOfLanguage(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "shortCode" in value;
  return isInstance;
}
function LanguageFromJSON(json) {
  return LanguageFromJSONTyped(json, false);
}
function LanguageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "currencyId": !exists(json, "currency_id") ? void 0 : json["currency_id"],
    "id": json["id"],
    "name": json["name"],
    "shortCode": json["short_code"]
  };
}
function LanguageToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "currency_id": value.currencyId,
    "id": value.id,
    "name": value.name,
    "short_code": value.shortCode
  };
}

// src/generated/models/GetLanguages200Response.ts
function instanceOfGetLanguages200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetLanguages200ResponseFromJSON(json) {
  return GetLanguages200ResponseFromJSONTyped(json, false);
}
function GetLanguages200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(LanguageFromJSON)
  };
}
function GetLanguages200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(LanguageToJSON)
  };
}

// src/generated/models/GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTime.ts
function instanceOfGetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTime(value) {
  let isInstance = true;
  return isInstance;
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSON(json) {
  return GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSONTyped(json, false);
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "hour": !exists(json, "hour") ? void 0 : json["hour"],
    "minute": !exists(json, "minute") ? void 0 : json["minute"]
  };
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "hour": value.hour,
    "minute": value.minute
  };
}

// src/generated/models/GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInner.ts
function instanceOfGetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInner(value) {
  let isInstance = true;
  return isInstance;
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSON(json) {
  return GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSONTyped(json, false);
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": !exists(json, "start_time") ? void 0 : GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSON(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSON(json["end_time"]),
    "breakHours": !exists(json, "break_hours") ? void 0 : json["break_hours"]
  };
}
function GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "start_time": GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeToJSON(value.startTime),
    "end_time": GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeToJSON(value.endTime),
    "break_hours": value.breakHours
  };
}

// src/generated/models/GetMe200ResponseCompanySettings.ts
var GetMe200ResponseCompanySettingsProductPricesSettingEnum = {
  KostbaseretPrisstning: "Kostbaseret priss\xE6tning",
  ManuelPrisstning: "Manuel priss\xE6tning"
};
var GetMe200ResponseCompanySettingsSalesPriceByCostPriceEnum = {
  HjesteKostpris: "H\xF8jeste kostpris",
  LavesteKostpris: "Laveste kostpris",
  GennemsnitligeKostpris: "Gennemsnitlige kostpris"
};
function instanceOfGetMe200ResponseCompanySettings(value) {
  let isInstance = true;
  isInstance = isInstance && "activateTimeEntryTypes" in value;
  isInstance = isInstance && "addEmployeesToProject" in value;
  isInstance = isInstance && "allowEmployeesToAddNewContacts" in value;
  isInstance = isInstance && "allowEmployeesToAddNewProducts" in value;
  isInstance = isInstance && "allowEmployeesToAddNewProjects" in value;
  isInstance = isInstance && "allowEmployeesToViewProjectExpenses" in value;
  isInstance = isInstance && "allowEmployeesToViewProjectPhotos" in value;
  isInstance = isInstance && "allowEmployeesToViewProjectProducts" in value;
  isInstance = isInstance && "allowEmployeesToViewProjectRegistrations" in value;
  isInstance = isInstance && "allowEmployeesToViewProjectWorkingHours" in value;
  isInstance = isInstance && "allowEmployeesToViewRentalMachines" in value;
  isInstance = isInstance && "allowIndividualLoginForEmployees" in value;
  isInstance = isInstance && "approveForms" in value;
  isInstance = isInstance && "checkInOutEnabled" in value;
  isInstance = isInstance && "checkAtSpecificTime" in value;
  isInstance = isInstance && "customProjectStatuses" in value;
  isInstance = isInstance && "dagseddelDefaultWorkingTime" in value;
  isInstance = isInstance && "dagseddelDefaultTimeIntervalMinutes" in value;
  isInstance = isInstance && "daysOfFormEditingWindow" in value;
  isInstance = isInstance && "deselectUsersProjects" in value;
  isInstance = isInstance && "distributeProjectExpenseAutomatically" in value;
  isInstance = isInstance && "emailDeliveryCheck" in value;
  isInstance = isInstance && "mobileAppAdvancedCreateProjectEnabled" in value;
  isInstance = isInstance && "multipleLocations" in value;
  isInstance = isInstance && "procurementDeactivateVendorAoJohansen" in value;
  isInstance = isInstance && "productPricesSetting" in value;
  isInstance = isInstance && "projectNumbers" in value;
  isInstance = isInstance && "projectsRottenAfterDays" in value;
  isInstance = isInstance && "receiveNotificationsMails" in value;
  isInstance = isInstance && "receivePdfForms" in value;
  isInstance = isInstance && "salesPriceByCostPrice" in value;
  isInstance = isInstance && "showBenchmarkIcons" in value;
  isInstance = isInstance && "showEmployeeInitials" in value;
  isInstance = isInstance && "showFormEditOnCheckOut" in value;
  isInstance = isInstance && "showSellingPriceApp" in value;
  isInstance = isInstance && "defaultPaymentTermId" in value;
  return isInstance;
}
function GetMe200ResponseCompanySettingsFromJSON(json) {
  return GetMe200ResponseCompanySettingsFromJSONTyped(json, false);
}
function GetMe200ResponseCompanySettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "activateTimeEntryTypes": json["activate_time_entry_types"],
    "addEmployeesToProject": json["add_employees_to_project"],
    "allowEmployeesToAddNewContacts": json["allow_employees_to_add_new_contacts"],
    "allowEmployeesToAddNewProducts": json["allow_employees_to_add_new_products"],
    "allowEmployeesToAddNewProjects": json["allow_employees_to_add_new_projects"],
    "allowEmployeesToViewProjectExpenses": json["allow_employees_to_view_project_expenses"],
    "allowEmployeesToViewProjectPhotos": json["allow_employees_to_view_project_photos"],
    "allowEmployeesToViewProjectProducts": json["allow_employees_to_view_project_products"],
    "allowEmployeesToViewProjectRegistrations": json["allow_employees_to_view_project_registrations"],
    "allowEmployeesToViewProjectWorkingHours": json["allow_employees_to_view_project_working_hours"],
    "allowEmployeesToViewRentalMachines": json["allow_employees_to_view_rental_machines"],
    "allowIndividualLoginForEmployees": json["allow_individual_login_for_employees"],
    "approveForms": json["approve_forms"],
    "checkInOutEnabled": json["check_in_out_enabled"],
    "checkAtSpecificTime": json["check_at_specific_time"],
    "customProjectStatuses": json["custom_project_statuses"],
    "dagseddelDefaultWorkingTime": json["dagseddel_default_working_time"].map(GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSON),
    "dagseddelDefaultTimeIntervalMinutes": json["dagseddel_default_time_interval_minutes"],
    "daysOfFormEditingWindow": json["days_of_form_editing_window"],
    "deselectUsersProjects": json["deselect_users_projects"],
    "distributeProjectExpenseAutomatically": json["distribute_project_expense_automatically"],
    "emailDeliveryCheck": json["email_delivery_check"],
    "mobileAppAdvancedCreateProjectEnabled": json["mobile_app_advanced_create_project_enabled"],
    "multipleLocations": json["multiple_locations"],
    "procurementDeactivateVendorAoJohansen": json["procurement_deactivate_vendor_ao_johansen"],
    "productPricesSetting": json["product_prices_setting"],
    "projectNumbers": json["project_numbers"],
    "projectsRottenAfterDays": json["projects_rotten_after_days"],
    "receiveNotificationsMails": json["receive_notifications_mails"],
    "receivePdfForms": json["receive_pdf_forms"],
    "salesPriceByCostPrice": json["sales_price_by_cost_price"],
    "showBenchmarkIcons": json["show_benchmark_icons"],
    "showEmployeeInitials": json["show_employee_initials"],
    "showFormEditOnCheckOut": json["show_form_edit_on_check_out"],
    "showSellingPriceApp": json["show_selling_price_app"],
    "defaultPaymentTermId": json["default_payment_term_id"]
  };
}
function GetMe200ResponseCompanySettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "activate_time_entry_types": value.activateTimeEntryTypes,
    "add_employees_to_project": value.addEmployeesToProject,
    "allow_employees_to_add_new_contacts": value.allowEmployeesToAddNewContacts,
    "allow_employees_to_add_new_products": value.allowEmployeesToAddNewProducts,
    "allow_employees_to_add_new_projects": value.allowEmployeesToAddNewProjects,
    "allow_employees_to_view_project_expenses": value.allowEmployeesToViewProjectExpenses,
    "allow_employees_to_view_project_photos": value.allowEmployeesToViewProjectPhotos,
    "allow_employees_to_view_project_products": value.allowEmployeesToViewProjectProducts,
    "allow_employees_to_view_project_registrations": value.allowEmployeesToViewProjectRegistrations,
    "allow_employees_to_view_project_working_hours": value.allowEmployeesToViewProjectWorkingHours,
    "allow_employees_to_view_rental_machines": value.allowEmployeesToViewRentalMachines,
    "allow_individual_login_for_employees": value.allowIndividualLoginForEmployees,
    "approve_forms": value.approveForms,
    "check_in_out_enabled": value.checkInOutEnabled,
    "check_at_specific_time": value.checkAtSpecificTime,
    "custom_project_statuses": value.customProjectStatuses,
    "dagseddel_default_working_time": value.dagseddelDefaultWorkingTime.map(GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerToJSON),
    "dagseddel_default_time_interval_minutes": value.dagseddelDefaultTimeIntervalMinutes,
    "days_of_form_editing_window": value.daysOfFormEditingWindow,
    "deselect_users_projects": value.deselectUsersProjects,
    "distribute_project_expense_automatically": value.distributeProjectExpenseAutomatically,
    "email_delivery_check": value.emailDeliveryCheck,
    "mobile_app_advanced_create_project_enabled": value.mobileAppAdvancedCreateProjectEnabled,
    "multiple_locations": value.multipleLocations,
    "procurement_deactivate_vendor_ao_johansen": value.procurementDeactivateVendorAoJohansen,
    "product_prices_setting": value.productPricesSetting,
    "project_numbers": value.projectNumbers,
    "projects_rotten_after_days": value.projectsRottenAfterDays,
    "receive_notifications_mails": value.receiveNotificationsMails,
    "receive_pdf_forms": value.receivePdfForms,
    "sales_price_by_cost_price": value.salesPriceByCostPrice,
    "show_benchmark_icons": value.showBenchmarkIcons,
    "show_employee_initials": value.showEmployeeInitials,
    "show_form_edit_on_check_out": value.showFormEditOnCheckOut,
    "show_selling_price_app": value.showSellingPriceApp,
    "default_payment_term_id": value.defaultPaymentTermId
  };
}

// src/generated/models/GetMe200ResponseErpIntegrationCapabilities.ts
function instanceOfGetMe200ResponseErpIntegrationCapabilities(value) {
  let isInstance = true;
  return isInstance;
}
function GetMe200ResponseErpIntegrationCapabilitiesFromJSON(json) {
  return GetMe200ResponseErpIntegrationCapabilitiesFromJSONTyped(json, false);
}
function GetMe200ResponseErpIntegrationCapabilitiesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contactPersonInvoiceSupport": !exists(json, "contact_person_invoice_support") ? void 0 : json["contact_person_invoice_support"],
    "sendInvoiceAsEan": !exists(json, "send_invoice_as_ean") ? void 0 : json["send_invoice_as_ean"],
    "invoiceDescriptionLength": !exists(json, "invoice_description_length") ? void 0 : json["invoice_description_length"]
  };
}
function GetMe200ResponseErpIntegrationCapabilitiesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contact_person_invoice_support": value.contactPersonInvoiceSupport,
    "send_invoice_as_ean": value.sendInvoiceAsEan,
    "invoice_description_length": value.invoiceDescriptionLength
  };
}

// src/generated/models/GetMe200ResponseIntegrations.ts
var GetMe200ResponseIntegrationsErpEnum = {
  Economic: "economic",
  Billys: "billys",
  Dinero: "dinero"
};
var GetMe200ResponseIntegrationsSalaryEnum = {
  Dataloen: "dataloen",
  Zenegy: "zenegy",
  Danloen: "danloen",
  EgLoen: "eg_loen",
  Proloen: "proloen"
};
function instanceOfGetMe200ResponseIntegrations(value) {
  let isInstance = true;
  return isInstance;
}
function GetMe200ResponseIntegrationsFromJSON(json) {
  return GetMe200ResponseIntegrationsFromJSONTyped(json, false);
}
function GetMe200ResponseIntegrationsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "erp": !exists(json, "erp") ? void 0 : json["erp"],
    "salary": !exists(json, "salary") ? void 0 : json["salary"]
  };
}
function GetMe200ResponseIntegrationsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "erp": value.erp,
    "salary": value.salary
  };
}

// src/generated/models/GetMe200ResponseIntegrationsEnabled.ts
function instanceOfGetMe200ResponseIntegrationsEnabled(value) {
  let isInstance = true;
  isInstance = isInstance && "erp" in value;
  isInstance = isInstance && "salary" in value;
  isInstance = isInstance && "roger" in value;
  isInstance = isInstance && "dropbox" in value;
  return isInstance;
}
function GetMe200ResponseIntegrationsEnabledFromJSON(json) {
  return GetMe200ResponseIntegrationsEnabledFromJSONTyped(json, false);
}
function GetMe200ResponseIntegrationsEnabledFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "erp": json["erp"],
    "salary": json["salary"],
    "roger": json["roger"],
    "dropbox": json["dropbox"]
  };
}
function GetMe200ResponseIntegrationsEnabledToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "erp": value.erp,
    "salary": value.salary,
    "roger": value.roger,
    "dropbox": value.dropbox
  };
}

// src/generated/models/GetMe200ResponseLogos.ts
function instanceOfGetMe200ResponseLogos(value) {
  let isInstance = true;
  isInstance = isInstance && "small" in value;
  isInstance = isInstance && "large" in value;
  return isInstance;
}
function GetMe200ResponseLogosFromJSON(json) {
  return GetMe200ResponseLogosFromJSONTyped(json, false);
}
function GetMe200ResponseLogosFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "small": json["small"],
    "large": json["large"]
  };
}
function GetMe200ResponseLogosToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "small": value.small,
    "large": value.large
  };
}

// src/generated/models/GetMe200ResponseSubscription.ts
function instanceOfGetMe200ResponseSubscription(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "isActive" in value;
  isInstance = isInstance && "missingPaymentMethod" in value;
  isInstance = isInstance && "activeUsers" in value;
  isInstance = isInstance && "seatsScheduledChanges" in value;
  isInstance = isInstance && "totalSeats" in value;
  return isInstance;
}
function GetMe200ResponseSubscriptionFromJSON(json) {
  return GetMe200ResponseSubscriptionFromJSONTyped(json, false);
}
function GetMe200ResponseSubscriptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "isActive": json["is_active"],
    "missingPaymentMethod": json["missing_payment_method"],
    "activeUsers": json["active_users"],
    "seatsScheduledChanges": json["seats_scheduled_changes"],
    "totalSeats": json["total_seats"]
  };
}
function GetMe200ResponseSubscriptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "is_active": value.isActive,
    "missing_payment_method": value.missingPaymentMethod,
    "active_users": value.activeUsers,
    "seats_scheduled_changes": value.seatsScheduledChanges,
    "total_seats": value.totalSeats
  };
}

// src/generated/models/Role.ts
var RoleIdentifierEnum = {
  Admin: "admin",
  CompanyEmployee: "company_employee",
  Company: "company",
  AnonymousFormLinkUser: "anonymous_form_link_user",
  ProjectWatcher: "project_watcher",
  AnonymousCompanyEmployee: "anonymous_company_employee",
  ProjectCollaborator: "project_collaborator",
  CompanyEmployeeIndividualLogin: "company_employee_individual_login",
  Salesman: "salesman",
  ProjectOwner: "project_owner"
};
function instanceOfRole(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "identifier" in value;
  return isInstance;
}
function RoleFromJSON(json) {
  return RoleFromJSONTyped(json, false);
}
function RoleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "identifier": json["identifier"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function RoleToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "identifier": value.identifier,
    "name": value.name,
    "description": value.description
  };
}

// src/generated/models/GetMe200ResponseUser.ts
var GetMe200ResponseUserAdminAccessEnum = {
  NoAccessToAdmin: "no_access_to_admin",
  AccessToAdmin: "access_to_admin",
  LimitedAccessToAdmin: "limited_access_to_admin"
};
function instanceOfGetMe200ResponseUser(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "cityId" in value;
  isInstance = isInstance && "languageId" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "password" in value;
  isInstance = isInstance && "firstName" in value;
  isInstance = isInstance && "lastName" in value;
  isInstance = isInstance && "fullName" in value;
  isInstance = isInstance && "initials" in value;
  isInstance = isInstance && "streetName" in value;
  isInstance = isInstance && "website" in value;
  isInstance = isInstance && "phone" in value;
  isInstance = isInstance && "phoneCountrycode" in value;
  isInstance = isInstance && "mobile" in value;
  isInstance = isInstance && "mobileCountrycode" in value;
  isInstance = isInstance && "manualPrice" in value;
  isInstance = isInstance && "costPrice" in value;
  isInstance = isInstance && "effectiveCostPrice" in value;
  isInstance = isInstance && "salePrice" in value;
  isInstance = isInstance && "extraPrice" in value;
  isInstance = isInstance && "effectiveExtraPrice" in value;
  isInstance = isInstance && "isActive" in value;
  isInstance = isInstance && "apiKey" in value;
  isInstance = isInstance && "receiveFormMails" in value;
  isInstance = isInstance && "hideAddress" in value;
  isInstance = isInstance && "hidePhone" in value;
  isInstance = isInstance && "expectedBillableHours" in value;
  isInstance = isInstance && "mobileAppPreferences" in value;
  isInstance = isInstance && "isProjectLeader" in value;
  isInstance = isInstance && "adminAccess" in value;
  isInstance = isInstance && "roles" in value;
  isInstance = isInstance && "language" in value;
  return isInstance;
}
function GetMe200ResponseUserFromJSON(json) {
  return GetMe200ResponseUserFromJSONTyped(json, false);
}
function GetMe200ResponseUserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "cityId": json["city_id"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "languageId": json["language_id"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "timeEntryRuleGroupId": !exists(json, "time_entry_rule_group_id") ? void 0 : json["time_entry_rule_group_id"],
    "createdById": json["created_by_id"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "usersPriceGroup": !exists(json, "users_price_group") ? void 0 : UsersPriceGroupFromJSON(json["users_price_group"]),
    "email": json["email"],
    "password": json["password"],
    "firstName": json["first_name"],
    "lastName": json["last_name"],
    "fullName": json["full_name"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "initials": json["initials"],
    "image": !exists(json, "image") ? void 0 : json["image"],
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "streetName": json["street_name"],
    "website": json["website"],
    "phone": json["phone"],
    "phoneCountrycode": json["phone_countrycode"],
    "mobile": json["mobile"],
    "mobileCountrycode": json["mobile_countrycode"],
    "manualPrice": json["manual_price"],
    "costPrice": json["cost_price"],
    "effectiveCostPrice": json["effective_cost_price"],
    "salePrice": json["sale_price"],
    "extraPrice": json["extra_price"],
    "effectiveExtraPrice": json["effective_extra_price"],
    "previewPdf": !exists(json, "preview_pdf") ? void 0 : json["preview_pdf"],
    "isActive": json["is_active"],
    "apiKey": json["api_key"],
    "receiveFormMails": json["receive_form_mails"],
    "hideAddress": json["hide_address"],
    "hidePhone": json["hide_phone"],
    "expectedBillableHours": json["expected_billable_hours"],
    "mobileAppPreferences": UserMobileAppPreferencesFromJSON(json["mobile_app_preferences"]),
    "integrationSettings": !exists(json, "integration_settings") ? void 0 : json["integration_settings"].map(EditUserRequestCustomIntegrationSettingsInnerFromJSON),
    "integrationTypes": !exists(json, "integration_types") ? void 0 : json["integration_types"].map(IntegrationTypeFromJSON),
    "isProjectLeader": json["is_project_leader"],
    "adminAccess": json["admin_access"],
    "adminAccessOptions": !exists(json, "admin_access_options") ? void 0 : json["admin_access_options"],
    "projects": !exists(json, "projects") ? void 0 : json["projects"].map(ProjectFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "roles": json["roles"].map(RoleFromJSON),
    "language": LanguageFromJSON(json["language"])
  };
}
function GetMe200ResponseUserToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "city_id": value.cityId,
    "country_id": value.countryId,
    "language_id": value.languageId,
    "erp_id": value.erpId,
    "time_entry_rule_group_id": value.timeEntryRuleGroupId,
    "created_by_id": value.createdById,
    "users_price_group_id": value.usersPriceGroupId,
    "users_price_group": UsersPriceGroupToJSON(value.usersPriceGroup),
    "email": value.email,
    "password": value.password,
    "first_name": value.firstName,
    "last_name": value.lastName,
    "full_name": value.fullName,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "initials": value.initials,
    "image": value.image,
    "image_url": value.imageUrl,
    "street_name": value.streetName,
    "website": value.website,
    "phone": value.phone,
    "phone_countrycode": value.phoneCountrycode,
    "mobile": value.mobile,
    "mobile_countrycode": value.mobileCountrycode,
    "manual_price": value.manualPrice,
    "cost_price": value.costPrice,
    "effective_cost_price": value.effectiveCostPrice,
    "extra_price": value.extraPrice,
    "effective_extra_price": value.effectiveExtraPrice,
    "is_active": value.isActive,
    "api_key": value.apiKey,
    "receive_form_mails": value.receiveFormMails,
    "hide_address": value.hideAddress,
    "hide_phone": value.hidePhone,
    "expected_billable_hours": value.expectedBillableHours,
    "mobile_app_preferences": UserMobileAppPreferencesToJSON(value.mobileAppPreferences),
    "integration_settings": value.integrationSettings === void 0 ? void 0 : value.integrationSettings.map(EditUserRequestCustomIntegrationSettingsInnerToJSON),
    "integration_types": value.integrationTypes === void 0 ? void 0 : value.integrationTypes.map(IntegrationTypeToJSON),
    "is_project_leader": value.isProjectLeader,
    "admin_access": value.adminAccess,
    "admin_access_options": value.adminAccessOptions,
    "projects": value.projects === void 0 ? void 0 : value.projects.map(ProjectToJSON),
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "roles": value.roles.map(RoleToJSON),
    "language": LanguageToJSON(value.language)
  };
}

// src/generated/models/PriceMargin.ts
function instanceOfPriceMargin(value) {
  let isInstance = true;
  isInstance = isInstance && "amountFrom" in value;
  isInstance = isInstance && "amountTo" in value;
  isInstance = isInstance && "percentageRatio" in value;
  return isInstance;
}
function PriceMarginFromJSON(json) {
  return PriceMarginFromJSONTyped(json, false);
}
function PriceMarginFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amountFrom": json["amount_from"],
    "amountTo": json["amount_to"],
    "percentageRatio": json["percentage_ratio"]
  };
}
function PriceMarginToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amount_from": value.amountFrom,
    "amount_to": value.amountTo,
    "percentage_ratio": value.percentageRatio
  };
}

// src/generated/models/GetMe200Response.ts
var GetMe200ResponseFeaturesEnum = {
  AccessToErpLedgerIntegration: "access_to_erp_ledger_integration",
  Activities: "activities",
  AllowIndividualLoginForEmployees: "allow_individual_login_for_employees",
  AllowNoSubscription: "allow_no_subscription",
  Apv: "apv",
  ArkaSoftwareIntegration: "arka_software_integration",
  ArkaTimeEntryTypesDescription: "arka_time_entry_types_description",
  Calendar: "calendar",
  CheckInOut: "check_in_out",
  CompanySettingsV3: "company_settings_v3",
  Contacts: "contacts",
  Cp3CreateNavbutton: "cp3.create_navbutton",
  Cp3Customers: "cp3.customers",
  Cp3Expenses: "cp3.expenses",
  Cp3Forms: "cp3.forms",
  Cp3Frontpage: "cp3.frontpage",
  Cp3HackRedirectFrontpageToOffers: "cp3.hack.redirect_frontpage_to_offers",
  Cp3Invoices: "cp3.invoices",
  Cp3InvoicesInsider: "cp3.invoices.insider",
  Cp3Offers: "cp3.offers",
  Cp3Planner: "cp3.planner",
  Cp3Procurement: "cp3.procurement",
  Cp3ProcurementOrderComplaints: "cp3.procurement.order_complaints",
  Cp3ProcurementPriceFileAnalysis: "cp3.procurement.price_file_analysis",
  Cp3ProcurementPotentialInProductsList: "cp3.procurement.potential_in_products_list",
  Cp3Products: "cp3.products",
  Cp3Projects: "cp3.projects",
  Cp3Registrations: "cp3.registrations",
  Cp3Reports: "cp3.reports",
  Cp3Settings: "cp3.settings",
  Cp3Users: "cp3.users",
  CreateOffers: "create_offers",
  CustomFields: "custom_fields",
  CustomSubprojects: "custom_subprojects",
  DataExport: "data_export",
  DistributorVendors: "distributor_vendors",
  DoNotUseV2Frontend: "do_not_use_v2_frontend",
  DoNotUseV3Frontend: "do_not_use_v3_frontend",
  DrivingKilometers: "driving_kilometers",
  ErpIntegration: "erp_integration",
  ErpStockLocationManagement: "erp_stock_location_management",
  ExpenseExtraction: "expense_extraction",
  ExportProjectsCsv: "export_projects_csv",
  FixedProjectPrices: "fixed_project_prices",
  GraphqlIntrospection: "graphql_introspection",
  ImportProductsContactsErp: "import_products_contacts_erp",
  IntercomChat: "intercom_chat",
  Invoices: "invoices",
  LimitedAccess: "limited_access",
  LinkingExpenseLinesEanProducts: "linking_expense_lines_ean_products",
  LockedInvoices: "locked_invoices",
  MachineryRental: "machinery_rental",
  MassInvoices: "mass_invoices",
  MobileAppAdvancedCreateProject: "mobile_app_advanced_create_project",
  MobileAppProjectExpenses: "mobile_app_project_expenses",
  MobileAppProjectOverview: "mobile_app_project_overview",
  Offers: "offers",
  OrderComplaints: "order_complaints",
  PayrollFileIntegration: "payroll_file_integration",
  PriceFiles: "price_files",
  ProductBundlesManageLines: "product_bundles_manage_lines",
  ProductLabels: "product_labels",
  ProductRules: "product_rules",
  Products: "products",
  ProjectExpenses: "project_expenses",
  ProjectLeader: "project_leader",
  ProjectNumbers: "project_numbers",
  ProjectOverview: "project_overview",
  ProjectStatus: "project_status",
  Projects: "projects",
  PublicProjects: "public_projects",
  QualityAssurance: "quality_assurance",
  Reports: "reports",
  RogerIntegration: "roger_integration",
  SchedulingV2: "scheduling_v2",
  SchedulingV2InV3: "scheduling_v2_in_v3",
  SettingsIntegrationsTab: "settings_integrations_tab",
  ShowErpIds: "show_erp_ids",
  WriteErpIds: "write_erp_ids",
  StockLocations: "stock_locations",
  SubscriptionPaywall: "subscription_paywall",
  TimeEntryTypes: "time_entry_types",
  TimeRegistration: "time_registration",
  Timereg: "timereg",
  UseTypesenseSearch: "use_typesense_search",
  Users: "users",
  UsersOverview: "users_overview",
  ViewOnlyUsers: "view_only_users",
  Wall: "wall"
};
function instanceOfGetMe200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "user" in value;
  isInstance = isInstance && "company" in value;
  isInstance = isInstance && "intercomHash" in value;
  isInstance = isInstance && "features" in value;
  isInstance = isInstance && "companySettings" in value;
  isInstance = isInstance && "subscription" in value;
  isInstance = isInstance && "priceMargins" in value;
  isInstance = isInstance && "logos" in value;
  isInstance = isInstance && "integrationsEnabled" in value;
  isInstance = isInstance && "integrations" in value;
  isInstance = isInstance && "erpIntegrationCapabilities" in value;
  return isInstance;
}
function GetMe200ResponseFromJSON(json) {
  return GetMe200ResponseFromJSONTyped(json, false);
}
function GetMe200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "user": GetMe200ResponseUserFromJSON(json["user"]),
    "company": CompanyFromJSON(json["company"]),
    "intercomHash": json["intercomHash"],
    "features": json["features"],
    "companySettings": GetMe200ResponseCompanySettingsFromJSON(json["company_settings"]),
    "subscription": GetMe200ResponseSubscriptionFromJSON(json["subscription"]),
    "priceMargins": json["price_margins"].map(PriceMarginFromJSON),
    "dineroAuthUrl": !exists(json, "dinero_auth_url") ? void 0 : json["dinero_auth_url"],
    "dineroTokenExpired": !exists(json, "dinero_token_expired") ? void 0 : json["dinero_token_expired"],
    "dineroTokenExpireDate": !exists(json, "dinero_token_expire_date") ? void 0 : json["dinero_token_expire_date"] === null ? null : new Date(json["dinero_token_expire_date"]),
    "logos": GetMe200ResponseLogosFromJSON(json["logos"]),
    "integrationsEnabled": GetMe200ResponseIntegrationsEnabledFromJSON(json["integrations_enabled"]),
    "integrations": GetMe200ResponseIntegrationsFromJSON(json["integrations"]),
    "erpIntegrationCapabilities": GetMe200ResponseErpIntegrationCapabilitiesFromJSON(json["erp_integration_capabilities"]),
    "oauthRedirectBaseUrl": !exists(json, "oauth_redirect_base_url") ? void 0 : json["oauth_redirect_base_url"]
  };
}
function GetMe200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "user": GetMe200ResponseUserToJSON(value.user),
    "company": CompanyToJSON(value.company),
    "intercomHash": value.intercomHash,
    "features": value.features,
    "company_settings": GetMe200ResponseCompanySettingsToJSON(value.companySettings),
    "subscription": GetMe200ResponseSubscriptionToJSON(value.subscription),
    "price_margins": value.priceMargins.map(PriceMarginToJSON),
    "dinero_auth_url": value.dineroAuthUrl,
    "dinero_token_expired": value.dineroTokenExpired,
    "logos": GetMe200ResponseLogosToJSON(value.logos),
    "integrations_enabled": GetMe200ResponseIntegrationsEnabledToJSON(value.integrationsEnabled),
    "integrations": GetMe200ResponseIntegrationsToJSON(value.integrations),
    "erp_integration_capabilities": GetMe200ResponseErpIntegrationCapabilitiesToJSON(value.erpIntegrationCapabilities),
    "oauth_redirect_base_url": value.oauthRedirectBaseUrl
  };
}

// src/generated/models/GetMe200ResponseUserAllOf.ts
function instanceOfGetMe200ResponseUserAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "roles" in value;
  isInstance = isInstance && "language" in value;
  return isInstance;
}
function GetMe200ResponseUserAllOfFromJSON(json) {
  return GetMe200ResponseUserAllOfFromJSONTyped(json, false);
}
function GetMe200ResponseUserAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "roles": json["roles"].map(RoleFromJSON),
    "language": LanguageFromJSON(json["language"])
  };
}
function GetMe200ResponseUserAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "roles": value.roles.map(RoleToJSON),
    "language": LanguageToJSON(value.language)
  };
}

// src/generated/models/GetOfferActionLogs200Response.ts
function instanceOfGetOfferActionLogs200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferActionLogs200ResponseFromJSON(json) {
  return GetOfferActionLogs200ResponseFromJSONTyped(json, false);
}
function GetOfferActionLogs200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ActionLogFromJSON)
  };
}
function GetOfferActionLogs200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ActionLogToJSON)
  };
}

// src/generated/models/GetOfferActionLogs200ResponseAllOf.ts
function instanceOfGetOfferActionLogs200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferActionLogs200ResponseAllOfFromJSON(json) {
  return GetOfferActionLogs200ResponseAllOfFromJSONTyped(json, false);
}
function GetOfferActionLogs200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ActionLogFromJSON)
  };
}
function GetOfferActionLogs200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ActionLogToJSON)
  };
}

// src/generated/models/OfferAction.ts
var OfferActionActionEnum = {
  Created: "created",
  Accepted: "accepted",
  Rejected: "rejected",
  Sent: "sent",
  Expired: "expired",
  PublicUrlAccessed: "public_url_accessed",
  EmailDelivered: "email_delivered",
  EmailOpened: "email_opened",
  EmailSendingFailed: "email_sending_failed"
};
function instanceOfOfferAction(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "offerId" in value;
  isInstance = isInstance && "action" in value;
  return isInstance;
}
function OfferActionFromJSON(json) {
  return OfferActionFromJSONTyped(json, false);
}
function OfferActionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "email": !exists(json, "email") ? void 0 : EmailFromJSON(json["email"]),
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "offerId": json["offer_id"],
    "action": json["action"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function OfferActionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": UserToJSON(value.user),
    "email": EmailToJSON(value.email),
    "offer_id": value.offerId,
    "action": value.action
  };
}

// src/generated/models/GetOfferActions200Response.ts
function instanceOfGetOfferActions200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferActions200ResponseFromJSON(json) {
  return GetOfferActions200ResponseFromJSONTyped(json, false);
}
function GetOfferActions200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(OfferActionFromJSON)
  };
}
function GetOfferActions200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(OfferActionToJSON)
  };
}

// src/generated/models/GetOfferActions200ResponseAllOf.ts
function instanceOfGetOfferActions200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferActions200ResponseAllOfFromJSON(json) {
  return GetOfferActions200ResponseAllOfFromJSONTyped(json, false);
}
function GetOfferActions200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(OfferActionFromJSON)
  };
}
function GetOfferActions200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(OfferActionToJSON)
  };
}

// src/generated/models/GetOfferLine200Response.ts
function instanceOfGetOfferLine200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferLine200ResponseFromJSON(json) {
  return GetOfferLine200ResponseFromJSONTyped(json, false);
}
function GetOfferLine200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": OfferLineFromJSON(json["data"])
  };
}
function GetOfferLine200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": OfferLineToJSON(value.data)
  };
}

// src/generated/models/GetOfferLines200Response.ts
function instanceOfGetOfferLines200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferLines200ResponseFromJSON(json) {
  return GetOfferLines200ResponseFromJSONTyped(json, false);
}
function GetOfferLines200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(OfferLineFromJSON)
  };
}
function GetOfferLines200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(OfferLineToJSON)
  };
}

// src/generated/models/GetOfferLines200ResponseAllOf.ts
function instanceOfGetOfferLines200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferLines200ResponseAllOfFromJSON(json) {
  return GetOfferLines200ResponseAllOfFromJSONTyped(json, false);
}
function GetOfferLines200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(OfferLineFromJSON)
  };
}
function GetOfferLines200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(OfferLineToJSON)
  };
}

// src/generated/models/GetOfferPdf200Response.ts
function instanceOfGetOfferPdf200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferPdf200ResponseFromJSON(json) {
  return GetOfferPdf200ResponseFromJSONTyped(json, false);
}
function GetOfferPdf200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": BaseFileFromJSON(json["data"])
  };
}
function GetOfferPdf200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": BaseFileToJSON(value.data)
  };
}

// src/generated/models/GetOfferPdf200ResponseAllOf.ts
function instanceOfGetOfferPdf200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetOfferPdf200ResponseAllOfFromJSON(json) {
  return GetOfferPdf200ResponseAllOfFromJSONTyped(json, false);
}
function GetOfferPdf200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": BaseFileFromJSON(json["data"])
  };
}
function GetOfferPdf200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": BaseFileToJSON(value.data)
  };
}

// src/generated/models/GetPaymentTerms200Response.ts
function instanceOfGetPaymentTerms200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetPaymentTerms200ResponseFromJSON(json) {
  return GetPaymentTerms200ResponseFromJSONTyped(json, false);
}
function GetPaymentTerms200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ControlPanelApiPaymentTermFromJSON)
  };
}
function GetPaymentTerms200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ControlPanelApiPaymentTermToJSON)
  };
}

// src/generated/models/GetProductCustomFieldAttribute200Response.ts
function instanceOfGetProductCustomFieldAttribute200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProductCustomFieldAttribute200ResponseFromJSON(json) {
  return GetProductCustomFieldAttribute200ResponseFromJSONTyped(json, false);
}
function GetProductCustomFieldAttribute200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectCustomFieldAttributeFromJSON(json["data"])
  };
}
function GetProductCustomFieldAttribute200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectCustomFieldAttributeToJSON(value.data)
  };
}

// src/generated/models/GetProject200Response.ts
function instanceOfGetProject200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProject200ResponseFromJSON(json) {
  return GetProject200ResponseFromJSONTyped(json, false);
}
function GetProject200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectFromJSON(json["data"])
  };
}
function GetProject200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectToJSON(value.data)
  };
}

// src/generated/models/GetProjectCustomFieldAttributes200Response.ts
function instanceOfGetProjectCustomFieldAttributes200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProjectCustomFieldAttributes200ResponseFromJSON(json) {
  return GetProjectCustomFieldAttributes200ResponseFromJSONTyped(json, false);
}
function GetProjectCustomFieldAttributes200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProjectCustomFieldAttributeFromJSON)
  };
}
function GetProjectCustomFieldAttributes200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProjectCustomFieldAttributeToJSON)
  };
}

// src/generated/models/GetProjectCustomFieldAttributes200ResponseAllOf.ts
function instanceOfGetProjectCustomFieldAttributes200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProjectCustomFieldAttributes200ResponseAllOfFromJSON(json) {
  return GetProjectCustomFieldAttributes200ResponseAllOfFromJSONTyped(json, false);
}
function GetProjectCustomFieldAttributes200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProjectCustomFieldAttributeFromJSON)
  };
}
function GetProjectCustomFieldAttributes200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProjectCustomFieldAttributeToJSON)
  };
}

// src/generated/models/GetProjects200Response.ts
function instanceOfGetProjects200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProjects200ResponseFromJSON(json) {
  return GetProjects200ResponseFromJSONTyped(json, false);
}
function GetProjects200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProjectFromJSON)
  };
}
function GetProjects200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProjectToJSON)
  };
}

// src/generated/models/GetProjects200ResponseAllOf.ts
function instanceOfGetProjects200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetProjects200ResponseAllOfFromJSON(json) {
  return GetProjects200ResponseAllOfFromJSONTyped(json, false);
}
function GetProjects200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProjectFromJSON)
  };
}
function GetProjects200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProjectToJSON)
  };
}

// src/generated/models/GetTask200Response.ts
function instanceOfGetTask200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function GetTask200ResponseFromJSON(json) {
  return GetTask200ResponseFromJSONTyped(json, false);
}
function GetTask200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": TaskReadDTOFromJSON(json["data"]),
    "pagination": PaginationDetailsFromJSON(json["pagination"])
  };
}
function GetTask200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": TaskReadDTOToJSON(value.data),
    "pagination": PaginationDetailsToJSON(value.pagination)
  };
}

// src/generated/models/GetTaskProduct200Response.ts
function instanceOfGetTaskProduct200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTaskProduct200ResponseFromJSON(json) {
  return GetTaskProduct200ResponseFromJSONTyped(json, false);
}
function GetTaskProduct200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProductsTaskFromJSON(json["data"])
  };
}
function GetTaskProduct200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProductsTaskToJSON(value.data)
  };
}

// src/generated/models/GetTaskProducts200Response.ts
function instanceOfGetTaskProducts200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTaskProducts200ResponseFromJSON(json) {
  return GetTaskProducts200ResponseFromJSONTyped(json, false);
}
function GetTaskProducts200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ProductsTaskFromJSON)
  };
}
function GetTaskProducts200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ProductsTaskToJSON)
  };
}

// src/generated/models/TextTemplate.ts
function instanceOfTextTemplate(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "content" in value;
  return isInstance;
}
function TextTemplateFromJSON(json) {
  return TextTemplateFromJSONTyped(json, false);
}
function TextTemplateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "expense": !exists(json, "expense") ? void 0 : json["expense"],
    "offer": !exists(json, "offer") ? void 0 : json["offer"],
    "invoice": !exists(json, "invoice") ? void 0 : json["invoice"],
    "title": json["title"],
    "content": json["content"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function TextTemplateToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "company_id": value.companyId,
    "created_by_id": value.createdById,
    "modified_by_id": value.modifiedById,
    "expense": value.expense,
    "offer": value.offer,
    "invoice": value.invoice,
    "title": value.title,
    "content": value.content
  };
}

// src/generated/models/GetTextTemplate200Response.ts
function instanceOfGetTextTemplate200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTextTemplate200ResponseFromJSON(json) {
  return GetTextTemplate200ResponseFromJSONTyped(json, false);
}
function GetTextTemplate200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": TextTemplateFromJSON(json["data"])
  };
}
function GetTextTemplate200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": TextTemplateToJSON(value.data)
  };
}

// src/generated/models/GetTextTemplates200Response.ts
function instanceOfGetTextTemplates200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTextTemplates200ResponseFromJSON(json) {
  return GetTextTemplates200ResponseFromJSONTyped(json, false);
}
function GetTextTemplates200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(TextTemplateFromJSON)
  };
}
function GetTextTemplates200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(TextTemplateToJSON)
  };
}

// src/generated/models/GetTextTemplates200ResponseAllOf.ts
function instanceOfGetTextTemplates200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTextTemplates200ResponseAllOfFromJSON(json) {
  return GetTextTemplates200ResponseAllOfFromJSONTyped(json, false);
}
function GetTextTemplates200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(TextTemplateFromJSON)
  };
}
function GetTextTemplates200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(TextTemplateToJSON)
  };
}

// src/generated/models/TimeEntryRuleGroup.ts
function instanceOfTimeEntryRuleGroup(value) {
  let isInstance = true;
  return isInstance;
}
function TimeEntryRuleGroupFromJSON(json) {
  return TimeEntryRuleGroupFromJSONTyped(json, false);
}
function TimeEntryRuleGroupFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "salaryPeriodFrom": !exists(json, "salary_period_from") ? void 0 : fromLocalDateString(json["salary_period_from"]),
    "salaryPeriodDays": !exists(json, "salary_period_days") ? void 0 : json["salary_period_days"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function TimeEntryRuleGroupToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "modified_by_id": value.modifiedById,
    "company_id": value.companyId,
    "name": value.name,
    "salary_period_from": value.salaryPeriodFrom === void 0 ? void 0 : toLocalDateString(value.salaryPeriodFrom),
    "salary_period_days": value.salaryPeriodDays
  };
}

// src/generated/models/GetTimeEntryRuleGroups200Response.ts
function instanceOfGetTimeEntryRuleGroups200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetTimeEntryRuleGroups200ResponseFromJSON(json) {
  return GetTimeEntryRuleGroups200ResponseFromJSONTyped(json, false);
}
function GetTimeEntryRuleGroups200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(TimeEntryRuleGroupFromJSON)
  };
}
function GetTimeEntryRuleGroups200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(TimeEntryRuleGroupToJSON)
  };
}

// src/generated/models/UserNotification.ts
function instanceOfUserNotification(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UserNotificationFromJSON(json) {
  return UserNotificationFromJSONTyped(json, false);
}
function UserNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "userId": json["user_id"],
    "readAt": !exists(json, "read_at") ? void 0 : new Date(json["read_at"]),
    "type": json["type"],
    "data": json["data"],
    "decodedData": !exists(json, "decoded_data") ? void 0 : json["decoded_data"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function UserNotificationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "read_at": value.readAt === void 0 ? void 0 : value.readAt.toISOString(),
    "type": value.type,
    "data": value.data,
    "decoded_data": value.decodedData
  };
}

// src/generated/models/GetUserNotifications200Response.ts
function instanceOfGetUserNotifications200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetUserNotifications200ResponseFromJSON(json) {
  return GetUserNotifications200ResponseFromJSONTyped(json, false);
}
function GetUserNotifications200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(UserNotificationFromJSON)
  };
}
function GetUserNotifications200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(UserNotificationToJSON)
  };
}

// src/generated/models/GetUserNotifications200ResponseAllOf.ts
function instanceOfGetUserNotifications200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetUserNotifications200ResponseAllOfFromJSON(json) {
  return GetUserNotifications200ResponseAllOfFromJSONTyped(json, false);
}
function GetUserNotifications200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(UserNotificationFromJSON)
  };
}
function GetUserNotifications200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(UserNotificationToJSON)
  };
}

// src/generated/models/GetUsers200Response.ts
function instanceOfGetUsers200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetUsers200ResponseFromJSON(json) {
  return GetUsers200ResponseFromJSONTyped(json, false);
}
function GetUsers200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(UserFromJSON)
  };
}
function GetUsers200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(UserToJSON)
  };
}

// src/generated/models/GetUsers200ResponseAllOf.ts
function instanceOfGetUsers200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetUsers200ResponseAllOfFromJSON(json) {
  return GetUsers200ResponseAllOfFromJSONTyped(json, false);
}
function GetUsers200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(UserFromJSON)
  };
}
function GetUsers200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(UserToJSON)
  };
}

// src/generated/models/GetVendor200Response.ts
function instanceOfGetVendor200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetVendor200ResponseFromJSON(json) {
  return GetVendor200ResponseFromJSONTyped(json, false);
}
function GetVendor200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": VendorFromJSON(json["data"])
  };
}
function GetVendor200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": VendorToJSON(value.data)
  };
}

// src/generated/models/GetVendors200Response.ts
function instanceOfGetVendors200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetVendors200ResponseFromJSON(json) {
  return GetVendors200ResponseFromJSONTyped(json, false);
}
function GetVendors200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(VendorFromJSON)
  };
}
function GetVendors200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(VendorToJSON)
  };
}

// src/generated/models/GetVendors200ResponseAllOf.ts
function instanceOfGetVendors200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetVendors200ResponseAllOfFromJSON(json) {
  return GetVendors200ResponseAllOfFromJSONTyped(json, false);
}
function GetVendors200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(VendorFromJSON)
  };
}
function GetVendors200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(VendorToJSON)
  };
}

// src/generated/models/GetWallPost200Response.ts
function instanceOfGetWallPost200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetWallPost200ResponseFromJSON(json) {
  return GetWallPost200ResponseFromJSONTyped(json, false);
}
function GetWallPost200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": WallPostFromJSON(json["data"])
  };
}
function GetWallPost200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": WallPostToJSON(value.data)
  };
}

// src/generated/models/GetWallPosts200Response.ts
function instanceOfGetWallPosts200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetWallPosts200ResponseFromJSON(json) {
  return GetWallPosts200ResponseFromJSONTyped(json, false);
}
function GetWallPosts200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(WallPostFromJSON)
  };
}
function GetWallPosts200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(WallPostToJSON)
  };
}

// src/generated/models/GetWallPosts200ResponseAllOf.ts
function instanceOfGetWallPosts200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function GetWallPosts200ResponseAllOfFromJSON(json) {
  return GetWallPosts200ResponseAllOfFromJSONTyped(json, false);
}
function GetWallPosts200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(WallPostFromJSON)
  };
}
function GetWallPosts200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(WallPostToJSON)
  };
}

// src/generated/models/HasIntegrationOfType200Response.ts
function instanceOfHasIntegrationOfType200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function HasIntegrationOfType200ResponseFromJSON(json) {
  return HasIntegrationOfType200ResponseFromJSONTyped(json, false);
}
function HasIntegrationOfType200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}
function HasIntegrationOfType200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success
  };
}

// src/generated/models/ICreateProductBundleLineRequest.ts
function instanceOfICreateProductBundleLineRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "quantity" in value;
  return isInstance;
}
function ICreateProductBundleLineRequestFromJSON(json) {
  return ICreateProductBundleLineRequestFromJSONTyped(json, false);
}
function ICreateProductBundleLineRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "productBundleId": !exists(json, "product_bundle_id") ? void 0 : json["product_bundle_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "quantity": json["quantity"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function ICreateProductBundleLineRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "product_bundle_id": value.productBundleId,
    "vendor_product_id": value.vendorProductId,
    "product_id": value.productId,
    "quantity": value.quantity,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "placement": value.placement,
    "name": value.name
  };
}

// src/generated/models/ICreateProductBundleRequestProductBundleLinesInner.ts
function instanceOfICreateProductBundleRequestProductBundleLinesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "quantity" in value;
  return isInstance;
}
function ICreateProductBundleRequestProductBundleLinesInnerFromJSON(json) {
  return ICreateProductBundleRequestProductBundleLinesInnerFromJSONTyped(json, false);
}
function ICreateProductBundleRequestProductBundleLinesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "productBundleId": !exists(json, "product_bundle_id") ? void 0 : json["product_bundle_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "quantity": json["quantity"],
    "productUnit": !exists(json, "product_unit") ? void 0 : json["product_unit"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function ICreateProductBundleRequestProductBundleLinesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_bundle_id": value.productBundleId,
    "vendor_product_id": value.vendorProductId,
    "users_price_group_id": value.usersPriceGroupId,
    "expense_line_id": value.expenseLineId,
    "product_id": value.productId,
    "quantity": value.quantity,
    "product_unit": value.productUnit,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "placement": value.placement,
    "name": value.name
  };
}

// src/generated/models/ICreateProductBundleRequest.ts
function instanceOfICreateProductBundleRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function ICreateProductBundleRequestFromJSON(json) {
  return ICreateProductBundleRequestFromJSONTyped(json, false);
}
function ICreateProductBundleRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "fileId": !exists(json, "file_id") ? void 0 : json["file_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "unit": !exists(json, "unit") ? void 0 : json["unit"],
    "salesPrice": !exists(json, "sales_price") ? void 0 : json["sales_price"],
    "productBundleLines": !exists(json, "product_bundle_lines") ? void 0 : json["product_bundle_lines"].map(ICreateProductBundleRequestProductBundleLinesInnerFromJSON)
  };
}
function ICreateProductBundleRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "activity_id": value.activityId,
    "file_id": value.fileId,
    "name": value.name,
    "description": value.description,
    "unit": value.unit,
    "sales_price": value.salesPrice,
    "product_bundle_lines": value.productBundleLines === void 0 ? void 0 : value.productBundleLines.map(ICreateProductBundleRequestProductBundleLinesInnerToJSON)
  };
}

// src/generated/models/ICreateProjectRequest.ts
function instanceOfICreateProjectRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function ICreateProjectRequestFromJSON(json) {
  return ICreateProjectRequestFromJSONTyped(json, false);
}
function ICreateProjectRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "parentId": !exists(json, "parent_id") ? void 0 : json["parent_id"],
    "projectStatusId": !exists(json, "project_status_id") ? void 0 : json["project_status_id"],
    "offerId": !exists(json, "offer_id") ? void 0 : json["offer_id"],
    "name": json["name"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "invoiceDiscountPercent": !exists(json, "invoice_discount_percent") ? void 0 : json["invoice_discount_percent"],
    "discountPercentageHours": !exists(json, "discount_percentage_hours") ? void 0 : json["discount_percentage_hours"],
    "discountPercentageProducts": !exists(json, "discount_percentage_products") ? void 0 : json["discount_percentage_products"],
    "latitude": !exists(json, "latitude") ? void 0 : json["latitude"],
    "longitude": !exists(json, "longitude") ? void 0 : json["longitude"],
    "erpProjectId": !exists(json, "erp_project_id") ? void 0 : json["erp_project_id"],
    "erpTaskId": !exists(json, "erp_task_id") ? void 0 : json["erp_task_id"],
    "isFixedPrice": !exists(json, "is_fixed_price") ? void 0 : json["is_fixed_price"],
    "workingHoursTotalCostPrice": !exists(json, "working_hours_total_cost_price") ? void 0 : json["working_hours_total_cost_price"],
    "productsTotalCostPrice": !exists(json, "products_total_cost_price") ? void 0 : json["products_total_cost_price"],
    "totalSalesPrice": !exists(json, "total_sales_price") ? void 0 : json["total_sales_price"],
    "customFields": !exists(json, "custom_fields") ? void 0 : json["custom_fields"]
  };
}
function ICreateProjectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "company_id": value.companyId,
    "contact_id": value.contactId,
    "contact_person_id": value.contactPersonId,
    "city_id": value.cityId,
    "label_id": value.labelId,
    "parent_id": value.parentId,
    "project_status_id": value.projectStatusId,
    "offer_id": value.offerId,
    "name": value.name,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "street_name": value.streetName,
    "description": value.description,
    "invoice_discount_percent": value.invoiceDiscountPercent,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "latitude": value.latitude,
    "longitude": value.longitude,
    "erp_project_id": value.erpProjectId,
    "erp_task_id": value.erpTaskId,
    "is_fixed_price": value.isFixedPrice,
    "working_hours_total_cost_price": value.workingHoursTotalCostPrice,
    "products_total_cost_price": value.productsTotalCostPrice,
    "total_sales_price": value.totalSalesPrice,
    "custom_fields": value.customFields
  };
}

// src/generated/models/IDeleteCard200Response.ts
function instanceOfIDeleteCard200Response(value) {
  let isInstance = true;
  return isInstance;
}
function IDeleteCard200ResponseFromJSON(json) {
  return IDeleteCard200ResponseFromJSONTyped(json, false);
}
function IDeleteCard200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : json["data"]
  };
}
function IDeleteCard200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data
  };
}

// src/generated/models/IDeleteCardRequest.ts
function instanceOfIDeleteCardRequest(value) {
  let isInstance = true;
  return isInstance;
}
function IDeleteCardRequestFromJSON(json) {
  return IDeleteCardRequestFromJSONTyped(json, false);
}
function IDeleteCardRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "indexes": !exists(json, "indexes") ? void 0 : json["indexes"]
  };
}
function IDeleteCardRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "indexes": value.indexes
  };
}

// src/generated/models/IEditWallCommentRequest.ts
function instanceOfIEditWallCommentRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  return isInstance;
}
function IEditWallCommentRequestFromJSON(json) {
  return IEditWallCommentRequestFromJSONTyped(json, false);
}
function IEditWallCommentRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "message": json["message"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "wallPostId": !exists(json, "wall_post_id") ? void 0 : json["wall_post_id"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IEditWallCommentRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "wall_post_id": value.wallPostId
  };
}

// src/generated/models/IEditWallPost200Response.ts
function instanceOfIEditWallPost200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IEditWallPost200ResponseFromJSON(json) {
  return IEditWallPost200ResponseFromJSONTyped(json, false);
}
function IEditWallPost200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"]
  };
}
function IEditWallPost200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data
  };
}

// src/generated/models/IFormUploadFiles200ResponseDataInner.ts
function instanceOfIFormUploadFiles200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "url" in value;
  isInstance = isInstance && "mime" in value;
  return isInstance;
}
function IFormUploadFiles200ResponseDataInnerFromJSON(json) {
  return IFormUploadFiles200ResponseDataInnerFromJSONTyped(json, false);
}
function IFormUploadFiles200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "url": json["url"],
    "mime": json["mime"]
  };
}
function IFormUploadFiles200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "url": value.url,
    "mime": value.mime
  };
}

// src/generated/models/IFormUploadFiles200Response.ts
function instanceOfIFormUploadFiles200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IFormUploadFiles200ResponseFromJSON(json) {
  return IFormUploadFiles200ResponseFromJSONTyped(json, false);
}
function IFormUploadFiles200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(IFormUploadFiles200ResponseDataInnerFromJSON)
  };
}
function IFormUploadFiles200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(IFormUploadFiles200ResponseDataInnerToJSON)
  };
}

// src/generated/models/IGetActivities200Response.ts
function instanceOfIGetActivities200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetActivities200ResponseFromJSON(json) {
  return IGetActivities200ResponseFromJSONTyped(json, false);
}
function IGetActivities200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ActivityFromJSON)
  };
}
function IGetActivities200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ActivityToJSON)
  };
}

// src/generated/models/IGetActivities200ResponseAllOf.ts
function instanceOfIGetActivities200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetActivities200ResponseAllOfFromJSON(json) {
  return IGetActivities200ResponseAllOfFromJSONTyped(json, false);
}
function IGetActivities200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ActivityFromJSON)
  };
}
function IGetActivities200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ActivityToJSON)
  };
}

// src/generated/models/IGetConsumption200ResponseDataWeeklyConsumption.ts
function instanceOfIGetConsumption200ResponseDataWeeklyConsumption(value) {
  let isInstance = true;
  isInstance = isInstance && "productCost" in value;
  isInstance = isInstance && "hoursCost" in value;
  isInstance = isInstance && "contribution" in value;
  return isInstance;
}
function IGetConsumption200ResponseDataWeeklyConsumptionFromJSON(json) {
  return IGetConsumption200ResponseDataWeeklyConsumptionFromJSONTyped(json, false);
}
function IGetConsumption200ResponseDataWeeklyConsumptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productCost": json["product_cost"].map(FrontpageWeeklyConsumptionDTOFromJSON),
    "hoursCost": json["hours_cost"].map(FrontpageWeeklyConsumptionDTOFromJSON),
    "contribution": json["contribution"].map(FrontpageWeeklyConsumptionDTOFromJSON)
  };
}
function IGetConsumption200ResponseDataWeeklyConsumptionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_cost": value.productCost.map(FrontpageWeeklyConsumptionDTOToJSON),
    "hours_cost": value.hoursCost.map(FrontpageWeeklyConsumptionDTOToJSON),
    "contribution": value.contribution.map(FrontpageWeeklyConsumptionDTOToJSON)
  };
}

// src/generated/models/IGetConsumption200ResponseData.ts
function instanceOfIGetConsumption200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "weeklyConsumption" in value;
  isInstance = isInstance && "totalConsumption" in value;
  return isInstance;
}
function IGetConsumption200ResponseDataFromJSON(json) {
  return IGetConsumption200ResponseDataFromJSONTyped(json, false);
}
function IGetConsumption200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "weeklyConsumption": IGetConsumption200ResponseDataWeeklyConsumptionFromJSON(json["weekly_consumption"]),
    "totalConsumption": FrontpageTotalConsumptionDTOFromJSON(json["total_consumption"])
  };
}
function IGetConsumption200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "weekly_consumption": IGetConsumption200ResponseDataWeeklyConsumptionToJSON(value.weeklyConsumption),
    "total_consumption": FrontpageTotalConsumptionDTOToJSON(value.totalConsumption)
  };
}

// src/generated/models/IGetConsumption200Response.ts
function instanceOfIGetConsumption200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetConsumption200ResponseFromJSON(json) {
  return IGetConsumption200ResponseFromJSONTyped(json, false);
}
function IGetConsumption200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": IGetConsumption200ResponseDataFromJSON(json["data"])
  };
}
function IGetConsumption200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": IGetConsumption200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/IGetCustomEmailTemplates200Response.ts
function instanceOfIGetCustomEmailTemplates200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetCustomEmailTemplates200ResponseFromJSON(json) {
  return IGetCustomEmailTemplates200ResponseFromJSONTyped(json, false);
}
function IGetCustomEmailTemplates200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(CustomEmailTemplateFromJSON)
  };
}
function IGetCustomEmailTemplates200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(CustomEmailTemplateToJSON)
  };
}

// src/generated/models/IGetFeed200Response.ts
function instanceOfIGetFeed200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function IGetFeed200ResponseFromJSON(json) {
  return IGetFeed200ResponseFromJSONTyped(json, false);
}
function IGetFeed200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(FrontpageFeedDTOFromJSON),
    "pagination": FeedPaginationDTOFromJSON(json["pagination"])
  };
}
function IGetFeed200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(FrontpageFeedDTOToJSON),
    "pagination": FeedPaginationDTOToJSON(value.pagination)
  };
}

// src/generated/models/IGetFeedMetadata200Response.ts
function instanceOfIGetFeedMetadata200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetFeedMetadata200ResponseFromJSON(json) {
  return IGetFeedMetadata200ResponseFromJSONTyped(json, false);
}
function IGetFeedMetadata200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": FeedMetadataDTOFromJSON(json["data"])
  };
}
function IGetFeedMetadata200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": FeedMetadataDTOToJSON(value.data)
  };
}

// src/generated/models/IGetFrontpageInvoiced200ResponseDataTotal.ts
function instanceOfIGetFrontpageInvoiced200ResponseDataTotal(value) {
  let isInstance = true;
  isInstance = isInstance && "invoiced" in value;
  isInstance = isInstance && "notInvoiced" in value;
  return isInstance;
}
function IGetFrontpageInvoiced200ResponseDataTotalFromJSON(json) {
  return IGetFrontpageInvoiced200ResponseDataTotalFromJSONTyped(json, false);
}
function IGetFrontpageInvoiced200ResponseDataTotalFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiced": json["invoiced"],
    "notInvoiced": json["not_invoiced"]
  };
}
function IGetFrontpageInvoiced200ResponseDataTotalToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiced": value.invoiced,
    "not_invoiced": value.notInvoiced
  };
}

// src/generated/models/IGetFrontpageInvoiced200ResponseDataWeekly.ts
function instanceOfIGetFrontpageInvoiced200ResponseDataWeekly(value) {
  let isInstance = true;
  isInstance = isInstance && "invoiced" in value;
  isInstance = isInstance && "notInvoiced" in value;
  return isInstance;
}
function IGetFrontpageInvoiced200ResponseDataWeeklyFromJSON(json) {
  return IGetFrontpageInvoiced200ResponseDataWeeklyFromJSONTyped(json, false);
}
function IGetFrontpageInvoiced200ResponseDataWeeklyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiced": json["invoiced"].map(FrontpageWeeklyConsumptionDTOFromJSON),
    "notInvoiced": json["not_invoiced"].map(FrontpageWeeklyConsumptionDTOFromJSON)
  };
}
function IGetFrontpageInvoiced200ResponseDataWeeklyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiced": value.invoiced.map(FrontpageWeeklyConsumptionDTOToJSON),
    "not_invoiced": value.notInvoiced.map(FrontpageWeeklyConsumptionDTOToJSON)
  };
}

// src/generated/models/IGetFrontpageInvoiced200ResponseData.ts
function instanceOfIGetFrontpageInvoiced200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "weekly" in value;
  isInstance = isInstance && "total" in value;
  return isInstance;
}
function IGetFrontpageInvoiced200ResponseDataFromJSON(json) {
  return IGetFrontpageInvoiced200ResponseDataFromJSONTyped(json, false);
}
function IGetFrontpageInvoiced200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "weekly": IGetFrontpageInvoiced200ResponseDataWeeklyFromJSON(json["weekly"]),
    "total": IGetFrontpageInvoiced200ResponseDataTotalFromJSON(json["total"])
  };
}
function IGetFrontpageInvoiced200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "weekly": IGetFrontpageInvoiced200ResponseDataWeeklyToJSON(value.weekly),
    "total": IGetFrontpageInvoiced200ResponseDataTotalToJSON(value.total)
  };
}

// src/generated/models/IGetFrontpageInvoiced200Response.ts
function instanceOfIGetFrontpageInvoiced200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetFrontpageInvoiced200ResponseFromJSON(json) {
  return IGetFrontpageInvoiced200ResponseFromJSONTyped(json, false);
}
function IGetFrontpageInvoiced200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": IGetFrontpageInvoiced200ResponseDataFromJSON(json["data"])
  };
}
function IGetFrontpageInvoiced200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": IGetFrontpageInvoiced200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/IGetInvoice200Response.ts
function instanceOfIGetInvoice200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetInvoice200ResponseFromJSON(json) {
  return IGetInvoice200ResponseFromJSONTyped(json, false);
}
function IGetInvoice200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": InvoiceFromJSON(json["data"])
  };
}
function IGetInvoice200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": InvoiceToJSON(value.data)
  };
}

// src/generated/models/IGetProject200ResponseData.ts
var IGetProject200ResponseDataProjectTypeEnum = {
  Hourly: "hourly",
  FixedPrice: "fixed_price",
  Offer: "offer",
  Estimate: "estimate"
};
function instanceOfIGetProject200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "projectStatusId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "discountPercentageHours" in value;
  isInstance = isInstance && "discountPercentageProducts" in value;
  isInstance = isInstance && "isFixedPrice" in value;
  isInstance = isInstance && "workingHoursTotalCostPrice" in value;
  isInstance = isInstance && "productsTotalCostPrice" in value;
  isInstance = isInstance && "totalSalesPrice" in value;
  isInstance = isInstance && "notInvoicedAmount" in value;
  isInstance = isInstance && "ignoredNotInvoicedProducts" in value;
  isInstance = isInstance && "ignoredNotInvoicedHours" in value;
  isInstance = isInstance && "projectType" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "fullName" in value;
  isInstance = isInstance && "isOffer" in value;
  isInstance = isInstance && "isRotten" in value;
  isInstance = isInstance && "hasFinalInvoice" in value;
  isInstance = isInstance && "userAccess" in value;
  return isInstance;
}
function IGetProject200ResponseDataFromJSON(json) {
  return IGetProject200ResponseDataFromJSONTyped(json, false);
}
function IGetProject200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": json["created_by_id"],
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"]),
    "modifiedBy": !exists(json, "modified_by") ? void 0 : UserFromJSON(json["modified_by"]),
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"]),
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "contactPerson": !exists(json, "contact_person") ? void 0 : ContactPersonFromJSON(json["contact_person"]),
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "projectStatusId": json["project_status_id"],
    "offerId": !exists(json, "offer_id") ? void 0 : json["offer_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "projectNumber": !exists(json, "project_number") ? void 0 : json["project_number"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "invoiceDiscountPercent": !exists(json, "invoice_discount_percent") ? void 0 : json["invoice_discount_percent"],
    "discountPercentageHours": json["discount_percentage_hours"],
    "discountPercentageProducts": json["discount_percentage_products"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "latitude": !exists(json, "latitude") ? void 0 : json["latitude"],
    "longitude": !exists(json, "longitude") ? void 0 : json["longitude"],
    "firstActivityDate": !exists(json, "first_activity_date") ? void 0 : new Date(json["first_activity_date"]),
    "isFixedPrice": json["is_fixed_price"],
    "parentId": !exists(json, "parent_id") ? void 0 : json["parent_id"],
    "parentProject": !exists(json, "parent_project") ? void 0 : ControlPanelApiProjectViewOrIndexResponseFromJSON(json["parent_project"]),
    "childProjects": !exists(json, "child_projects") ? void 0 : json["child_projects"].map(ControlPanelApiProjectViewOrIndexResponseFromJSON),
    "workingHoursTotalCostPrice": json["working_hours_total_cost_price"],
    "productsTotalCostPrice": json["products_total_cost_price"],
    "totalSalesPrice": json["total_sales_price"],
    "notInvoicedAmount": json["not_invoiced_amount"],
    "bookedInvoicedAmount": !exists(json, "booked_invoiced_amount") ? void 0 : json["booked_invoiced_amount"],
    "ignoredNotInvoicedProducts": json["ignored_not_invoiced_products"],
    "ignoredNotInvoicedHours": json["ignored_not_invoiced_hours"],
    "projectImageUrl": !exists(json, "project_image_url") ? void 0 : json["project_image_url"],
    "projectType": json["project_type"],
    "customFields": !exists(json, "custom_fields") ? void 0 : json["custom_fields"],
    "customFieldAttributes": !exists(json, "custom_field_attributes") ? void 0 : json["custom_field_attributes"].map(ProjectCustomFieldAttributeFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "fullName": json["full_name"],
    "isOffer": json["is_offer"],
    "isRotten": json["is_rotten"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "hasFinalInvoice": json["has_final_invoice"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"]),
    "userAccess": json["user_access"]
  };
}
function IGetProject200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "created_by": UserToJSON(value.createdBy),
    "modified_by": UserToJSON(value.modifiedBy),
    "contact_id": value.contactId,
    "contact": ContactToJSON(value.contact),
    "contact_person_id": value.contactPersonId,
    "contact_person": ContactPersonToJSON(value.contactPerson),
    "city_id": value.cityId,
    "project_status_id": value.projectStatusId,
    "offer_id": value.offerId,
    "label_id": value.labelId,
    "name": value.name,
    "description": value.description,
    "invoice_discount_percent": value.invoiceDiscountPercent,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "street_name": value.streetName,
    "latitude": value.latitude,
    "longitude": value.longitude,
    "is_fixed_price": value.isFixedPrice,
    "parent_id": value.parentId,
    "parent_project": ControlPanelApiProjectViewOrIndexResponseToJSON(value.parentProject),
    "child_projects": value.childProjects === void 0 ? void 0 : value.childProjects.map(ControlPanelApiProjectViewOrIndexResponseToJSON),
    "working_hours_total_cost_price": value.workingHoursTotalCostPrice,
    "products_total_cost_price": value.productsTotalCostPrice,
    "total_sales_price": value.totalSalesPrice,
    "project_type": value.projectType,
    "custom_fields": value.customFields,
    "custom_field_attributes": value.customFieldAttributes === void 0 ? void 0 : value.customFieldAttributes.map(ProjectCustomFieldAttributeToJSON),
    "is_offer": value.isOffer,
    "zip_code": value.zipCode,
    "city_name": value.cityName,
    "label": LabelEntityToJSON(value.label),
    "user_access": value.userAccess
  };
}

// src/generated/models/IGetProject200Response.ts
function instanceOfIGetProject200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetProject200ResponseFromJSON(json) {
  return IGetProject200ResponseFromJSONTyped(json, false);
}
function IGetProject200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": IGetProject200ResponseDataFromJSON(json["data"])
  };
}
function IGetProject200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": IGetProject200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/IGetProject200ResponseDataAllOf.ts
function instanceOfIGetProject200ResponseDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "userAccess" in value;
  return isInstance;
}
function IGetProject200ResponseDataAllOfFromJSON(json) {
  return IGetProject200ResponseDataAllOfFromJSONTyped(json, false);
}
function IGetProject200ResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "userAccess": json["user_access"]
  };
}
function IGetProject200ResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_access": value.userAccess
  };
}

// src/generated/models/IGetTask200ResponseData.ts
var IGetTask200ResponseDataRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfIGetTask200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function IGetTask200ResponseDataFromJSON(json) {
  return IGetTask200ResponseDataFromJSONTyped(json, false);
}
function IGetTask200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "active": !exists(json, "active") ? void 0 : json["active"],
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "employees": !exists(json, "employees") ? void 0 : json["employees"].map(UserFromJSON),
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON),
    "project": !exists(json, "project") ? void 0 : ProjectFromJSON(json["project"]),
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"].map(FormTemplateSimpleEntityFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON)
  };
}
function IGetTask200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "modified_by_id": value.modifiedById,
    "company_id": value.companyId,
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "active": value.active,
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "repeat": value.repeat,
    "interval": value.interval,
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "employees": value.employees === void 0 ? void 0 : value.employees.map(UserToJSON),
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON),
    "project": ProjectToJSON(value.project),
    "form_templates": value.formTemplates === void 0 ? void 0 : value.formTemplates.map(FormTemplateSimpleEntityToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON)
  };
}

// src/generated/models/IGetTask200Response.ts
function instanceOfIGetTask200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetTask200ResponseFromJSON(json) {
  return IGetTask200ResponseFromJSONTyped(json, false);
}
function IGetTask200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": IGetTask200ResponseDataFromJSON(json["data"])
  };
}
function IGetTask200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": IGetTask200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/IGetTasksForProject200Response.ts
function instanceOfIGetTasksForProject200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetTasksForProject200ResponseFromJSON(json) {
  return IGetTasksForProject200ResponseFromJSONTyped(json, false);
}
function IGetTasksForProject200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(TaskReadDTOFromJSON)
  };
}
function IGetTasksForProject200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(TaskReadDTOToJSON)
  };
}

// src/generated/models/IGetTasksForProject200ResponseAllOf.ts
function instanceOfIGetTasksForProject200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetTasksForProject200ResponseAllOfFromJSON(json) {
  return IGetTasksForProject200ResponseAllOfFromJSONTyped(json, false);
}
function IGetTasksForProject200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(TaskReadDTOFromJSON)
  };
}
function IGetTasksForProject200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(TaskReadDTOToJSON)
  };
}

// src/generated/models/IGetWorkRelated200ResponseAllOfData.ts
function instanceOfIGetWorkRelated200ResponseAllOfData(value) {
  let isInstance = true;
  isInstance = isInstance && "notApprovedForms" in value;
  return isInstance;
}
function IGetWorkRelated200ResponseAllOfDataFromJSON(json) {
  return IGetWorkRelated200ResponseAllOfDataFromJSONTyped(json, false);
}
function IGetWorkRelated200ResponseAllOfDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "notApprovedForms": json["not_approved_forms"]
  };
}
function IGetWorkRelated200ResponseAllOfDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/IGetWorkRelated200Response.ts
function instanceOfIGetWorkRelated200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetWorkRelated200ResponseFromJSON(json) {
  return IGetWorkRelated200ResponseFromJSONTyped(json, false);
}
function IGetWorkRelated200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": IGetWorkRelated200ResponseAllOfDataFromJSON(json["data"])
  };
}
function IGetWorkRelated200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": IGetWorkRelated200ResponseAllOfDataToJSON(value.data)
  };
}

// src/generated/models/IGetWorkRelated200ResponseAllOf.ts
function instanceOfIGetWorkRelated200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IGetWorkRelated200ResponseAllOfFromJSON(json) {
  return IGetWorkRelated200ResponseAllOfFromJSONTyped(json, false);
}
function IGetWorkRelated200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": IGetWorkRelated200ResponseAllOfDataFromJSON(json["data"])
  };
}
function IGetWorkRelated200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": IGetWorkRelated200ResponseAllOfDataToJSON(value.data)
  };
}

// src/generated/models/IListInvoices200Response.ts
function instanceOfIListInvoices200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListInvoices200ResponseFromJSON(json) {
  return IListInvoices200ResponseFromJSONTyped(json, false);
}
function IListInvoices200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(InvoiceFromJSON)
  };
}
function IListInvoices200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(InvoiceToJSON)
  };
}

// src/generated/models/IListInvoices200ResponseAllOf.ts
function instanceOfIListInvoices200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListInvoices200ResponseAllOfFromJSON(json) {
  return IListInvoices200ResponseAllOfFromJSONTyped(json, false);
}
function IListInvoices200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(InvoiceFromJSON)
  };
}
function IListInvoices200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(InvoiceToJSON)
  };
}

// src/generated/models/IListOfferStatuses200Response.ts
function instanceOfIListOfferStatuses200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListOfferStatuses200ResponseFromJSON(json) {
  return IListOfferStatuses200ResponseFromJSONTyped(json, false);
}
function IListOfferStatuses200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ControlPanelApiOfferStatusResponseFromJSON)
  };
}
function IListOfferStatuses200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ControlPanelApiOfferStatusResponseToJSON)
  };
}

// src/generated/models/IListOfferStatuses200ResponseAllOf.ts
function instanceOfIListOfferStatuses200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListOfferStatuses200ResponseAllOfFromJSON(json) {
  return IListOfferStatuses200ResponseAllOfFromJSONTyped(json, false);
}
function IListOfferStatuses200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ControlPanelApiOfferStatusResponseFromJSON)
  };
}
function IListOfferStatuses200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ControlPanelApiOfferStatusResponseToJSON)
  };
}

// src/generated/models/IListProjectStatuses200Response.ts
function instanceOfIListProjectStatuses200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListProjectStatuses200ResponseFromJSON(json) {
  return IListProjectStatuses200ResponseFromJSONTyped(json, false);
}
function IListProjectStatuses200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ControlPanelApiProjectStatusResponseFromJSON)
  };
}
function IListProjectStatuses200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ControlPanelApiProjectStatusResponseToJSON)
  };
}

// src/generated/models/IListProjectStatuses200ResponseAllOf.ts
function instanceOfIListProjectStatuses200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListProjectStatuses200ResponseAllOfFromJSON(json) {
  return IListProjectStatuses200ResponseAllOfFromJSONTyped(json, false);
}
function IListProjectStatuses200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ControlPanelApiProjectStatusResponseFromJSON)
  };
}
function IListProjectStatuses200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ControlPanelApiProjectStatusResponseToJSON)
  };
}

// src/generated/models/IListProjects200Response.ts
function instanceOfIListProjects200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListProjects200ResponseFromJSON(json) {
  return IListProjects200ResponseFromJSONTyped(json, false);
}
function IListProjects200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ControlPanelApiProjectViewOrIndexResponseFromJSON)
  };
}
function IListProjects200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ControlPanelApiProjectViewOrIndexResponseToJSON)
  };
}

// src/generated/models/IListProjects200ResponseAllOf.ts
function instanceOfIListProjects200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListProjects200ResponseAllOfFromJSON(json) {
  return IListProjects200ResponseAllOfFromJSONTyped(json, false);
}
function IListProjects200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ControlPanelApiProjectViewOrIndexResponseFromJSON)
  };
}
function IListProjects200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ControlPanelApiProjectViewOrIndexResponseToJSON)
  };
}

// src/generated/models/IListTasks200Response.ts
function instanceOfIListTasks200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListTasks200ResponseFromJSON(json) {
  return IListTasks200ResponseFromJSONTyped(json, false);
}
function IListTasks200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(TaskReadDTOFromJSON)
  };
}
function IListTasks200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(TaskReadDTOToJSON)
  };
}

// src/generated/models/IListTasks200ResponseAllOf.ts
function instanceOfIListTasks200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IListTasks200ResponseAllOfFromJSON(json) {
  return IListTasks200ResponseAllOfFromJSONTyped(json, false);
}
function IListTasks200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(TaskReadDTOFromJSON)
  };
}
function IListTasks200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(TaskReadDTOToJSON)
  };
}

// src/generated/models/IListWallComments200ResponseInner.ts
function instanceOfIListWallComments200ResponseInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "message" in value;
  isInstance = isInstance && "created" in value;
  return isInstance;
}
function IListWallComments200ResponseInnerFromJSON(json) {
  return IListWallComments200ResponseInnerFromJSONTyped(json, false);
}
function IListWallComments200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "message": json["message"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "wallPostId": !exists(json, "wall_post_id") ? void 0 : json["wall_post_id"],
    "created": new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function IListWallComments200ResponseInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "wall_post_id": value.wallPostId
  };
}

// src/generated/models/ProductBundleFile.ts
function instanceOfProductBundleFile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "originalFilename" in value;
  isInstance = isInstance && "fileUrl" in value;
  isInstance = isInstance && "downloadUrl" in value;
  return isInstance;
}
function ProductBundleFileFromJSON(json) {
  return ProductBundleFileFromJSONTyped(json, false);
}
function ProductBundleFileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "originalFilename": json["original_filename"],
    "fileUrl": json["file_url"],
    "downloadUrl": json["download_url"],
    "mimeType": !exists(json, "mime_type") ? void 0 : json["mime_type"],
    "isStandardFile": !exists(json, "is_standard_file") ? void 0 : json["is_standard_file"],
    "standardFileId": !exists(json, "standard_file_id") ? void 0 : json["standard_file_id"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ProductBundleFileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "original_filename": value.originalFilename,
    "file_url": value.fileUrl,
    "download_url": value.downloadUrl,
    "mime_type": value.mimeType,
    "is_standard_file": value.isStandardFile,
    "standard_file_id": value.standardFileId,
    "image_urls": ImageUrlsToJSON(value.imageUrls)
  };
}

// src/generated/models/ProductBundleLine.ts
function instanceOfProductBundleLine(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "productBundleId" in value;
  isInstance = isInstance && "quantity" in value;
  isInstance = isInstance && "sellingPrice" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ProductBundleLineFromJSON(json) {
  return ProductBundleLineFromJSONTyped(json, false);
}
function ProductBundleLineFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "productBundleId": json["product_bundle_id"],
    "vendorProductId": !exists(json, "vendor_product_id") ? void 0 : json["vendor_product_id"],
    "usersPriceGroupId": !exists(json, "users_price_group_id") ? void 0 : json["users_price_group_id"],
    "expenseLineId": !exists(json, "expense_line_id") ? void 0 : json["expense_line_id"],
    "productId": !exists(json, "product_id") ? void 0 : json["product_id"],
    "quantity": json["quantity"],
    "productUnit": !exists(json, "product_unit") ? void 0 : json["product_unit"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": json["selling_price"],
    "placement": !exists(json, "placement") ? void 0 : json["placement"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "product": !exists(json, "product") ? void 0 : ProductFromJSON(json["product"])
  };
}
function ProductBundleLineToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_bundle_id": value.productBundleId,
    "vendor_product_id": value.vendorProductId,
    "users_price_group_id": value.usersPriceGroupId,
    "expense_line_id": value.expenseLineId,
    "product_id": value.productId,
    "quantity": value.quantity,
    "product_unit": value.productUnit,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "placement": value.placement,
    "name": value.name,
    "product": ProductToJSON(value.product)
  };
}

// src/generated/models/ProductBundle.ts
function instanceOfProductBundle(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ProductBundleFromJSON(json) {
  return ProductBundleFromJSONTyped(json, false);
}
function ProductBundleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "activityId": !exists(json, "activity_id") ? void 0 : json["activity_id"],
    "activity": !exists(json, "activity") ? void 0 : ActivityFromJSON(json["activity"]),
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "fileId": !exists(json, "file_id") ? void 0 : json["file_id"],
    "file": !exists(json, "file") ? void 0 : ProductBundleFileFromJSON(json["file"]),
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "unit": !exists(json, "unit") ? void 0 : json["unit"],
    "salesPrice": !exists(json, "sales_price") ? void 0 : json["sales_price"],
    "productBundleLines": !exists(json, "product_bundle_lines") ? void 0 : json["product_bundle_lines"].map(ProductBundleLineFromJSON),
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function ProductBundleToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "activity_id": value.activityId,
    "activity": ActivityToJSON(value.activity),
    "file_id": value.fileId,
    "file": ProductBundleFileToJSON(value.file),
    "name": value.name,
    "description": value.description,
    "unit": value.unit,
    "sales_price": value.salesPrice,
    "product_bundle_lines": value.productBundleLines === void 0 ? void 0 : value.productBundleLines.map(ProductBundleLineToJSON),
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType
  };
}

// src/generated/models/IProductBundleSetSalesPrice200Response.ts
function instanceOfIProductBundleSetSalesPrice200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IProductBundleSetSalesPrice200ResponseFromJSON(json) {
  return IProductBundleSetSalesPrice200ResponseFromJSONTyped(json, false);
}
function IProductBundleSetSalesPrice200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ProductBundleFromJSON)
  };
}
function IProductBundleSetSalesPrice200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ProductBundleToJSON)
  };
}

// src/generated/models/IProductBundleSetSalesPriceRequest.ts
function instanceOfIProductBundleSetSalesPriceRequest(value) {
  let isInstance = true;
  return isInstance;
}
function IProductBundleSetSalesPriceRequestFromJSON(json) {
  return IProductBundleSetSalesPriceRequestFromJSONTyped(json, false);
}
function IProductBundleSetSalesPriceRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contributionMargin": !exists(json, "contribution_margin") ? void 0 : json["contribution_margin"]
  };
}
function IProductBundleSetSalesPriceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contribution_margin": value.contributionMargin
  };
}

// src/generated/models/IProductBundleUploadFile200Response.ts
function instanceOfIProductBundleUploadFile200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IProductBundleUploadFile200ResponseFromJSON(json) {
  return IProductBundleUploadFile200ResponseFromJSONTyped(json, false);
}
function IProductBundleUploadFile200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CreateAbsenceType201ResponseDataFromJSON(json["data"])
  };
}
function IProductBundleUploadFile200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CreateAbsenceType201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/IProjectDeleteFileRequestInner.ts
var IProjectDeleteFileRequestInnerTypeEnum = {
  Form: "form",
  WallPost: "wall_post",
  ExpenseFile: "expense_file",
  ProjectFile: "project_file"
};
function instanceOfIProjectDeleteFileRequestInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function IProjectDeleteFileRequestInnerFromJSON(json) {
  return IProjectDeleteFileRequestInnerFromJSONTyped(json, false);
}
function IProjectDeleteFileRequestInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"]
  };
}
function IProjectDeleteFileRequestInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type
  };
}

// src/generated/models/IProjectListFiles200ResponseAllOfDataInnerImageUrls.ts
function instanceOfIProjectListFiles200ResponseAllOfDataInnerImageUrls(value) {
  let isInstance = true;
  return isInstance;
}
function IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSON(json) {
  return IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSONTyped(json, false);
}
function IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "small": !exists(json, "small") ? void 0 : json["small"],
    "medium": !exists(json, "medium") ? void 0 : json["medium"],
    "large": !exists(json, "large") ? void 0 : json["large"],
    "original": !exists(json, "original") ? void 0 : json["original"]
  };
}
function IProjectListFiles200ResponseAllOfDataInnerImageUrlsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "thumbnail": value.thumbnail,
    "small": value.small,
    "medium": value.medium,
    "large": value.large,
    "original": value.original
  };
}

// src/generated/models/IProjectListFiles200ResponseAllOfDataInner.ts
var IProjectListFiles200ResponseAllOfDataInnerTypeEnum = {
  ProjectFile: "project_file",
  ExpenseFile: "expense_file",
  WallPost: "wall_post",
  Form: "form"
};
function instanceOfIProjectListFiles200ResponseAllOfDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "file" in value;
  isInstance = isInstance && "fileType" in value;
  isInstance = isInstance && "fileOriginalName" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "downloadUrl" in value;
  return isInstance;
}
function IProjectListFiles200ResponseAllOfDataInnerFromJSON(json) {
  return IProjectListFiles200ResponseAllOfDataInnerFromJSONTyped(json, false);
}
function IProjectListFiles200ResponseAllOfDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "file": json["file"],
    "fileType": json["file_type"],
    "fileOriginalName": json["file_original_name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "activityName": !exists(json, "activity_name") ? void 0 : json["activity_name"],
    "activityColor": !exists(json, "activity_color") ? void 0 : json["activity_color"],
    "fileSize": !exists(json, "file_size") ? void 0 : json["file_size"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "downloadUrl": json["download_url"],
    "viewUrl": !exists(json, "view_url") ? void 0 : json["view_url"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSON(json["image_urls"]),
    "parentId": !exists(json, "parent_id") ? void 0 : json["parent_id"]
  };
}
function IProjectListFiles200ResponseAllOfDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "type": value.type,
    "created_by_id": value.createdById,
    "file": value.file,
    "file_type": value.fileType,
    "file_original_name": value.fileOriginalName,
    "description": value.description,
    "activity_name": value.activityName,
    "activity_color": value.activityColor,
    "file_size": value.fileSize,
    "download_url": value.downloadUrl,
    "view_url": value.viewUrl,
    "image_urls": IProjectListFiles200ResponseAllOfDataInnerImageUrlsToJSON(value.imageUrls),
    "parent_id": value.parentId
  };
}

// src/generated/models/IProjectListFiles200Response.ts
function instanceOfIProjectListFiles200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IProjectListFiles200ResponseFromJSON(json) {
  return IProjectListFiles200ResponseFromJSONTyped(json, false);
}
function IProjectListFiles200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(IProjectListFiles200ResponseAllOfDataInnerFromJSON)
  };
}
function IProjectListFiles200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(IProjectListFiles200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/IProjectListFiles200ResponseAllOf.ts
function instanceOfIProjectListFiles200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IProjectListFiles200ResponseAllOfFromJSON(json) {
  return IProjectListFiles200ResponseAllOfFromJSONTyped(json, false);
}
function IProjectListFiles200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(IProjectListFiles200ResponseAllOfDataInnerFromJSON)
  };
}
function IProjectListFiles200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(IProjectListFiles200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/IProjectSendFilesRequest.ts
var IProjectSendFilesRequestTypeEnum = {
  Pdf: "pdf",
  Zip: "zip"
};
function instanceOfIProjectSendFilesRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "projectFiles" in value;
  return isInstance;
}
function IProjectSendFilesRequestFromJSON(json) {
  return IProjectSendFilesRequestFromJSONTyped(json, false);
}
function IProjectSendFilesRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": !exists(json, "type") ? void 0 : json["type"],
    "projectFiles": json["project_files"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "subject": !exists(json, "subject") ? void 0 : json["subject"],
    "message": !exists(json, "message") ? void 0 : json["message"]
  };
}
function IProjectSendFilesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "project_files": value.projectFiles,
    "email": value.email,
    "subject": value.subject,
    "message": value.message
  };
}

// src/generated/models/ISendProjectForms200Response.ts
function instanceOfISendProjectForms200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function ISendProjectForms200ResponseFromJSON(json) {
  return ISendProjectForms200ResponseFromJSONTyped(json, false);
}
function ISendProjectForms200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}
function ISendProjectForms200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success
  };
}

// src/generated/models/ISendProjectFormsRequest.ts
function instanceOfISendProjectFormsRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "forms" in value;
  isInstance = isInstance && "recipient" in value;
  isInstance = isInstance && "subject" in value;
  isInstance = isInstance && "body" in value;
  return isInstance;
}
function ISendProjectFormsRequestFromJSON(json) {
  return ISendProjectFormsRequestFromJSONTyped(json, false);
}
function ISendProjectFormsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "forms": json["forms"],
    "recipient": json["recipient"],
    "subject": json["subject"],
    "body": json["body"]
  };
}
function ISendProjectFormsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "forms": value.forms,
    "recipient": value.recipient,
    "subject": value.subject,
    "body": value.body
  };
}

// src/generated/models/StandardFile.ts
var StandardFileTypeEnum = {
  Quote: "quote",
  Estimate: "estimate"
};
function instanceOfStandardFile(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "fileId" in value;
  isInstance = isInstance && "file" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function StandardFileFromJSON(json) {
  return StandardFileFromJSONTyped(json, false);
}
function StandardFileFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "fileId": json["file_id"],
    "file": ProductBundleFileFromJSON(json["file"]),
    "type": json["type"],
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function StandardFileToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "company_id": value.companyId,
    "file_id": value.fileId,
    "file": ProductBundleFileToJSON(value.file),
    "type": value.type
  };
}

// src/generated/models/IStandardFilesList200Response.ts
function instanceOfIStandardFilesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IStandardFilesList200ResponseFromJSON(json) {
  return IStandardFilesList200ResponseFromJSONTyped(json, false);
}
function IStandardFilesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(StandardFileFromJSON)
  };
}
function IStandardFilesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(StandardFileToJSON)
  };
}

// src/generated/models/IStandardFilesList200ResponseAllOf.ts
function instanceOfIStandardFilesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IStandardFilesList200ResponseAllOfFromJSON(json) {
  return IStandardFilesList200ResponseAllOfFromJSONTyped(json, false);
}
function IStandardFilesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(StandardFileFromJSON)
  };
}
function IStandardFilesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(StandardFileToJSON)
  };
}

// src/generated/models/IWallpostDeleteFile200Response.ts
function instanceOfIWallpostDeleteFile200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function IWallpostDeleteFile200ResponseFromJSON(json) {
  return IWallpostDeleteFile200ResponseFromJSONTyped(json, false);
}
function IWallpostDeleteFile200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}
function IWallpostDeleteFile200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success
  };
}

// src/generated/models/InvoicesView200Response.ts
function instanceOfInvoicesView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function InvoicesView200ResponseFromJSON(json) {
  return InvoicesView200ResponseFromJSONTyped(json, false);
}
function InvoicesView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": InvoiceReadDTOFromJSON(json["data"])
  };
}
function InvoicesView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": InvoiceReadDTOToJSON(value.data)
  };
}

// src/generated/models/IsCheckedIn200ResponseData.ts
function instanceOfIsCheckedIn200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "checkedIn" in value;
  isInstance = isInstance && "projectId" in value;
  return isInstance;
}
function IsCheckedIn200ResponseDataFromJSON(json) {
  return IsCheckedIn200ResponseDataFromJSONTyped(json, false);
}
function IsCheckedIn200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "checkedIn": json["checked_in"],
    "projectId": json["project_id"]
  };
}
function IsCheckedIn200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId
  };
}

// src/generated/models/IsCheckedIn200Response.ts
function instanceOfIsCheckedIn200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function IsCheckedIn200ResponseFromJSON(json) {
  return IsCheckedIn200ResponseFromJSONTyped(json, false);
}
function IsCheckedIn200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": IsCheckedIn200ResponseDataFromJSON(json["data"])
  };
}
function IsCheckedIn200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": IsCheckedIn200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/KpiCardEconomyPrice.ts
function instanceOfKpiCardEconomyPrice(value) {
  let isInstance = true;
  isInstance = isInstance && "costPrice" in value;
  return isInstance;
}
function KpiCardEconomyPriceFromJSON(json) {
  return KpiCardEconomyPriceFromJSONTyped(json, false);
}
function KpiCardEconomyPriceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "costPrice": json["cost_price"],
    "salesPrice": !exists(json, "sales_price") ? void 0 : json["sales_price"],
    "contributionRatio": !exists(json, "contribution_ratio") ? void 0 : json["contribution_ratio"],
    "contributionMargin": !exists(json, "contribution_margin") ? void 0 : json["contribution_margin"],
    "percentage": !exists(json, "percentage") ? void 0 : json["percentage"]
  };
}
function KpiCardEconomyPriceToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cost_price": value.costPrice,
    "sales_price": value.salesPrice,
    "contribution_ratio": value.contributionRatio,
    "contribution_margin": value.contributionMargin,
    "percentage": value.percentage
  };
}

// src/generated/models/KpiCardHoursSummedIndividualEntry.ts
var KpiCardHoursSummedIndividualEntryTypeEnum = {
  Hourly: "hourly",
  Reduce: "reduce",
  Replace: "replace",
  Daily: "daily",
  Driving: "driving",
  Absence: "absence"
};
function instanceOfKpiCardHoursSummedIndividualEntry(value) {
  let isInstance = true;
  isInstance = isInstance && "label" in value;
  isInstance = isInstance && "count" in value;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function KpiCardHoursSummedIndividualEntryFromJSON(json) {
  return KpiCardHoursSummedIndividualEntryFromJSONTyped(json, false);
}
function KpiCardHoursSummedIndividualEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "label": json["label"],
    "count": json["count"],
    "type": json["type"],
    "isAbsent": !exists(json, "is_absent") ? void 0 : json["is_absent"]
  };
}
function KpiCardHoursSummedIndividualEntryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/KpiCardPreCalculationIndividualEntry.ts
function instanceOfKpiCardPreCalculationIndividualEntry(value) {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "quantity" in value;
  isInstance = isInstance && "costPrice" in value;
  isInstance = isInstance && "totalCostPrice" in value;
  return isInstance;
}
function KpiCardPreCalculationIndividualEntryFromJSON(json) {
  return KpiCardPreCalculationIndividualEntryFromJSONTyped(json, false);
}
function KpiCardPreCalculationIndividualEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "quantity": json["quantity"],
    "costPrice": json["cost_price"],
    "totalCostPrice": json["total_cost_price"]
  };
}
function KpiCardPreCalculationIndividualEntryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/KpiCardProductsIndividualEntry.ts
var KpiCardProductsIndividualEntryTypeEnum = {
  Product: "product",
  ExpenseLine: "expense_line"
};
var KpiCardProductsIndividualEntryOriginTypeEnum = {
  Form: "form",
  Expense: "expense"
};
function instanceOfKpiCardProductsIndividualEntry(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "originType" in value;
  isInstance = isInstance && "originId" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "buyingPricePerUnit" in value;
  isInstance = isInstance && "buyingPriceTotal" in value;
  isInstance = isInstance && "sellingPricePerUnit" in value;
  isInstance = isInstance && "sellingPriceTotal" in value;
  return isInstance;
}
function KpiCardProductsIndividualEntryFromJSON(json) {
  return KpiCardProductsIndividualEntryFromJSONTyped(json, false);
}
function KpiCardProductsIndividualEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "originType": json["origin_type"],
    "originId": json["origin_id"],
    "date": fromLocalDateString(json["date"]),
    "quantity": !exists(json, "quantity") ? void 0 : json["quantity"],
    "buyingPricePerUnit": json["buying_price_per_unit"],
    "buyingPriceTotal": json["buying_price_total"],
    "sellingPricePerUnit": json["selling_price_per_unit"],
    "sellingPriceTotal": json["selling_price_total"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "createdBy": !exists(json, "created_by") ? void 0 : UserFromJSON(json["created_by"])
  };
}
function KpiCardProductsIndividualEntryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": toLocalDateString(value.date),
    "vendor": VendorToJSON(value.vendor),
    "created_by": UserToJSON(value.createdBy)
  };
}

// src/generated/models/KpiCardsIndexResponseContributionMargins.ts
function instanceOfKpiCardsIndexResponseContributionMargins(value) {
  let isInstance = true;
  isInstance = isInstance && "contributionMargin" in value;
  isInstance = isInstance && "contributionMarginPerHour" in value;
  return isInstance;
}
function KpiCardsIndexResponseContributionMarginsFromJSON(json) {
  return KpiCardsIndexResponseContributionMarginsFromJSONTyped(json, false);
}
function KpiCardsIndexResponseContributionMarginsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contributionMargin": json["contribution_margin"],
    "contributionMarginPerHour": json["contribution_margin_per_hour"],
    "contributionRatio": !exists(json, "contribution_ratio") ? void 0 : json["contribution_ratio"]
  };
}
function KpiCardsIndexResponseContributionMarginsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contribution_margin": value.contributionMargin,
    "contribution_margin_per_hour": value.contributionMarginPerHour,
    "contribution_ratio": value.contributionRatio
  };
}

// src/generated/models/KpiCardsIndexResponsePreCalculation.ts
function instanceOfKpiCardsIndexResponsePreCalculation(value) {
  let isInstance = true;
  isInstance = isInstance && "costPrice" in value;
  isInstance = isInstance && "salesPrice" in value;
  isInstance = isInstance && "contributionMargin" in value;
  isInstance = isInstance && "contributionMarginPerHour" in value;
  return isInstance;
}
function KpiCardsIndexResponsePreCalculationFromJSON(json) {
  return KpiCardsIndexResponsePreCalculationFromJSONTyped(json, false);
}
function KpiCardsIndexResponsePreCalculationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "costPrice": json["cost_price"],
    "salesPrice": json["sales_price"],
    "contributionMargin": json["contribution_margin"],
    "contributionMarginPerHour": json["contribution_margin_per_hour"],
    "contributionRatio": !exists(json, "contribution_ratio") ? void 0 : json["contribution_ratio"]
  };
}
function KpiCardsIndexResponsePreCalculationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cost_price": value.costPrice,
    "sales_price": value.salesPrice,
    "contribution_margin": value.contributionMargin,
    "contribution_margin_per_hour": value.contributionMarginPerHour,
    "contribution_ratio": value.contributionRatio
  };
}

// src/generated/models/KpiCardsIndexResponse.ts
function instanceOfKpiCardsIndexResponse(value) {
  let isInstance = true;
  isInstance = isInstance && "isProjectFinished" in value;
  isInstance = isInstance && "costPriceCurrent" in value;
  isInstance = isInstance && "salesPriceCurrent" in value;
  isInstance = isInstance && "invoicedCurrent" in value;
  isInstance = isInstance && "notInvoiced" in value;
  isInstance = isInstance && "ignoredNotInvoiced" in value;
  isInstance = isInstance && "creditNotes" in value;
  isInstance = isInstance && "productsCostPriceDelivered" in value;
  isInstance = isInstance && "hoursCostPriceDelivered" in value;
  isInstance = isInstance && "hoursCountDelivered" in value;
  isInstance = isInstance && "hasZeroPricedProducts" in value;
  return isInstance;
}
function KpiCardsIndexResponseFromJSON(json) {
  return KpiCardsIndexResponseFromJSONTyped(json, false);
}
function KpiCardsIndexResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "completionPercentage": !exists(json, "completion_percentage") ? void 0 : json["completion_percentage"],
    "dateBefore": !exists(json, "date_before") ? void 0 : fromLocalDateString(json["date_before"]),
    "dateAfter": !exists(json, "date_after") ? void 0 : fromLocalDateString(json["date_after"]),
    "isProjectFinished": json["is_project_finished"],
    "costPriceCurrent": json["cost_price_current"],
    "costPriceEstimated": !exists(json, "cost_price_estimated") ? void 0 : json["cost_price_estimated"],
    "salesPriceCurrent": json["sales_price_current"],
    "salesPriceEstimated": !exists(json, "sales_price_estimated") ? void 0 : json["sales_price_estimated"],
    "invoicedCurrent": json["invoiced_current"],
    "notInvoiced": json["not_invoiced"],
    "ignoredNotInvoiced": json["ignored_not_invoiced"],
    "creditNotes": json["credit_notes"],
    "productsCostPriceEstimated": !exists(json, "products_cost_price_estimated") ? void 0 : json["products_cost_price_estimated"],
    "productsCostPriceDelivered": json["products_cost_price_delivered"],
    "productsSalesPriceDelivered": !exists(json, "products_sales_price_delivered") ? void 0 : json["products_sales_price_delivered"],
    "hoursCostPriceEstimated": !exists(json, "hours_cost_price_estimated") ? void 0 : json["hours_cost_price_estimated"],
    "hoursCountEstimated": !exists(json, "hours_count_estimated") ? void 0 : json["hours_count_estimated"],
    "hoursCostPriceDelivered": json["hours_cost_price_delivered"],
    "hoursCountDelivered": json["hours_count_delivered"],
    "hoursSalesPriceDelivered": !exists(json, "hours_sales_price_delivered") ? void 0 : json["hours_sales_price_delivered"],
    "hasZeroPricedProducts": json["has_zero_priced_products"],
    "hasZeroPricedHours": !exists(json, "has_zero_priced_hours") ? void 0 : json["has_zero_priced_hours"],
    "preCalculation": !exists(json, "pre_calculation") ? void 0 : KpiCardsIndexResponsePreCalculationFromJSON(json["pre_calculation"]),
    "contributionMargins": !exists(json, "contribution_margins") ? void 0 : KpiCardsIndexResponseContributionMarginsFromJSON(json["contribution_margins"]),
    "registeredHours": !exists(json, "registered_hours") ? void 0 : json["registered_hours"],
    "registeredProducts": !exists(json, "registered_products") ? void 0 : json["registered_products"],
    "invoicedHours": !exists(json, "invoiced_hours") ? void 0 : json["invoiced_hours"],
    "invoicedProducts": !exists(json, "invoiced_products") ? void 0 : json["invoiced_products"]
  };
}
function KpiCardsIndexResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "completion_percentage": value.completionPercentage,
    "date_before": value.dateBefore === void 0 ? void 0 : toLocalDateString(value.dateBefore),
    "date_after": value.dateAfter === void 0 ? void 0 : toLocalDateString(value.dateAfter),
    "is_project_finished": value.isProjectFinished,
    "cost_price_current": value.costPriceCurrent,
    "cost_price_estimated": value.costPriceEstimated,
    "sales_price_current": value.salesPriceCurrent,
    "sales_price_estimated": value.salesPriceEstimated,
    "invoiced_current": value.invoicedCurrent,
    "not_invoiced": value.notInvoiced,
    "ignored_not_invoiced": value.ignoredNotInvoiced,
    "credit_notes": value.creditNotes,
    "products_cost_price_estimated": value.productsCostPriceEstimated,
    "products_cost_price_delivered": value.productsCostPriceDelivered,
    "products_sales_price_delivered": value.productsSalesPriceDelivered,
    "hours_cost_price_estimated": value.hoursCostPriceEstimated,
    "hours_count_estimated": value.hoursCountEstimated,
    "hours_cost_price_delivered": value.hoursCostPriceDelivered,
    "hours_count_delivered": value.hoursCountDelivered,
    "hours_sales_price_delivered": value.hoursSalesPriceDelivered,
    "has_zero_priced_products": value.hasZeroPricedProducts,
    "has_zero_priced_hours": value.hasZeroPricedHours,
    "pre_calculation": KpiCardsIndexResponsePreCalculationToJSON(value.preCalculation),
    "contribution_margins": KpiCardsIndexResponseContributionMarginsToJSON(value.contributionMargins),
    "registered_hours": value.registeredHours,
    "registered_products": value.registeredProducts,
    "invoiced_hours": value.invoicedHours,
    "invoiced_products": value.invoicedProducts
  };
}

// src/generated/models/KpiChardHoursIndividualEntry.ts
var KpiChardHoursIndividualEntryTypeEnum = {
  Hourly: "hourly",
  Reduce: "reduce",
  Replace: "replace",
  Daily: "daily",
  Driving: "driving",
  Absence: "absence"
};
function instanceOfKpiChardHoursIndividualEntry(value) {
  let isInstance = true;
  isInstance = isInstance && "entityId" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "label" in value;
  isInstance = isInstance && "count" in value;
  return isInstance;
}
function KpiChardHoursIndividualEntryFromJSON(json) {
  return KpiChardHoursIndividualEntryFromJSONTyped(json, false);
}
function KpiChardHoursIndividualEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "entityId": json["entity_id"],
    "type": json["type"],
    "label": json["label"],
    "count": json["count"]
  };
}
function KpiChardHoursIndividualEntryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/LoginWithEmail200Response.ts
function instanceOfLoginWithEmail200Response(value) {
  let isInstance = true;
  return isInstance;
}
function LoginWithEmail200ResponseFromJSON(json) {
  return LoginWithEmail200ResponseFromJSONTyped(json, false);
}
function LoginWithEmail200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"],
    "data": !exists(json, "data") ? void 0 : ApiKeyFromJSON(json["data"])
  };
}
function LoginWithEmail200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ApiKeyToJSON(value.data)
  };
}

// src/generated/models/LoginWithEmailRequest.ts
function instanceOfLoginWithEmailRequest(value) {
  let isInstance = true;
  return isInstance;
}
function LoginWithEmailRequestFromJSON(json) {
  return LoginWithEmailRequestFromJSONTyped(json, false);
}
function LoginWithEmailRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": !exists(json, "email") ? void 0 : json["email"],
    "password": !exists(json, "password") ? void 0 : json["password"],
    "rememberMe": !exists(json, "rememberMe") ? void 0 : json["rememberMe"]
  };
}
function LoginWithEmailRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "password": value.password,
    "rememberMe": value.rememberMe
  };
}

// src/generated/models/LookupCVR200Response.ts
function instanceOfLookupCVR200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function LookupCVR200ResponseFromJSON(json) {
  return LookupCVR200ResponseFromJSONTyped(json, false);
}
function LookupCVR200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": CVRLookupFromJSON(json["data"])
  };
}
function LookupCVR200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": CVRLookupToJSON(value.data)
  };
}

// src/generated/models/MergeProjectsRequest.ts
function instanceOfMergeProjectsRequest(value) {
  let isInstance = true;
  return isInstance;
}
function MergeProjectsRequestFromJSON(json) {
  return MergeProjectsRequestFromJSONTyped(json, false);
}
function MergeProjectsRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "originalProjectId": !exists(json, "original_project_id") ? void 0 : json["original_project_id"],
    "mergingProjectId": !exists(json, "merging_project_id") ? void 0 : json["merging_project_id"]
  };
}
function MergeProjectsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "original_project_id": value.originalProjectId,
    "merging_project_id": value.mergingProjectId
  };
}

// src/generated/models/MobileGetCards200ResponseDataInnerAllOfTaskAllOfProject.ts
function instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOfProject(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON(json) {
  return MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "fullName": !exists(json, "full_name") ? void 0 : json["full_name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "discountPercentageHours": !exists(json, "discount_percentage_hours") ? void 0 : json["discount_percentage_hours"],
    "discountPercentageProducts": !exists(json, "discount_percentage_products") ? void 0 : json["discount_percentage_products"],
    "projectNumber": !exists(json, "project_number") ? void 0 : json["project_number"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "projectImageUrl": !exists(json, "project_image_url") ? void 0 : json["project_image_url"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "projectStatusId": !exists(json, "project_status_id") ? void 0 : json["project_status_id"],
    "projectStatus": !exists(json, "project_status") ? void 0 : ProjectStatusFromJSON(json["project_status"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"])
  };
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "project_number": value.projectNumber,
    "email": value.email,
    "thumbnail": value.thumbnail,
    "project_image_url": value.projectImageUrl,
    "street_name": value.streetName,
    "zip_code": value.zipCode,
    "city_name": value.cityName,
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "project_status_id": value.projectStatusId,
    "project_status": ProjectStatusToJSON(value.projectStatus),
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/MobileGetCards200ResponseDataInnerAllOfTask.ts
var MobileGetCards200ResponseDataInnerAllOfTaskRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfMobileGetCards200ResponseDataInnerAllOfTask(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "project" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerAllOfTaskFromJSON(json) {
  return MobileGetCards200ResponseDataInnerAllOfTaskFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerAllOfTaskFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "active": !exists(json, "active") ? void 0 : json["active"],
    "recurringRule": !exists(json, "recurring_rule") ? void 0 : json["recurring_rule"],
    "startDate": !exists(json, "start_date") ? void 0 : new Date(json["start_date"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"].map(FormTemplateSimpleEntityFromJSON),
    "formTemplatesTasks": !exists(json, "form_templates_tasks") ? void 0 : json["form_templates_tasks"].map(FormTemplatesTasksModelFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "productsTasks": !exists(json, "products_tasks") ? void 0 : json["products_tasks"].map(ProductsTaskFromJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON(json["project"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function MobileGetCards200ResponseDataInnerAllOfTaskToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "active": value.active,
    "recurring_rule": value.recurringRule,
    "start_date": value.startDate === void 0 ? void 0 : value.startDate.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "estimate": value.estimate,
    "repeat": value.repeat,
    "interval": value.interval,
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "form_templates": value.formTemplates === void 0 ? void 0 : value.formTemplates.map(FormTemplateSimpleEntityToJSON),
    "form_templates_tasks": value.formTemplatesTasks === void 0 ? void 0 : value.formTemplatesTasks.map(FormTemplatesTasksModelToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "products_tasks": value.productsTasks === void 0 ? void 0 : value.productsTasks.map(ProductsTaskToJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON(value.project)
  };
}

// src/generated/models/MobileGetCards200ResponseDataInner.ts
var MobileGetCards200ResponseDataInnerTypeEnum = {
  Task: "task",
  Absence: "absence"
};
var MobileGetCards200ResponseDataInnerStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
function instanceOfMobileGetCards200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "taskId" in value;
  isInstance = isInstance && "listIndex" in value;
  isInstance = isInstance && "task" in value;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerFromJSON(json) {
  return MobileGetCards200ResponseDataInnerFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "userId": json["user_id"],
    "taskId": json["task_id"],
    "entityId": !exists(json, "entity_id") ? void 0 : json["entity_id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "productsAdded": !exists(json, "products_added") ? void 0 : json["products_added"],
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"],
    "listIndex": json["list_index"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "endDate": !exists(json, "end_date") ? void 0 : json["end_date"] === null ? null : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"] === null ? null : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "task": MobileGetCards200ResponseDataInnerAllOfTaskFromJSON(json["task"])
  };
}
function MobileGetCards200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "task_id": value.taskId,
    "entity_id": value.entityId,
    "type": value.type,
    "status": value.status,
    "products_added": value.productsAdded,
    "form_templates": value.formTemplates,
    "list_index": value.listIndex,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime === null ? null : value.endTime.toISOString(),
    "estimate": value.estimate,
    "user": UserToJSON(value.user),
    "task": MobileGetCards200ResponseDataInnerAllOfTaskToJSON(value.task)
  };
}

// src/generated/models/MobileGetCards200Response.ts
function instanceOfMobileGetCards200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function MobileGetCards200ResponseFromJSON(json) {
  return MobileGetCards200ResponseFromJSONTyped(json, false);
}
function MobileGetCards200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(MobileGetCards200ResponseDataInnerFromJSON)
  };
}
function MobileGetCards200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(MobileGetCards200ResponseDataInnerToJSON)
  };
}

// src/generated/models/MobileGetCards200ResponseDataInnerAllOf.ts
function instanceOfMobileGetCards200ResponseDataInnerAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "task" in value;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerAllOfFromJSON(json) {
  return MobileGetCards200ResponseDataInnerAllOfFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "task": MobileGetCards200ResponseDataInnerAllOfTaskFromJSON(json["task"])
  };
}
function MobileGetCards200ResponseDataInnerAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "task": MobileGetCards200ResponseDataInnerAllOfTaskToJSON(value.task)
  };
}

// src/generated/models/MobileGetCards200ResponseDataInnerAllOfTaskAllOf.ts
function instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "project" in value;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfFromJSON(json) {
  return MobileGetCards200ResponseDataInnerAllOfTaskAllOfFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON(json["project"])
  };
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON(value.project)
  };
}

// src/generated/models/MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOf.ts
function instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfFromJSON(json) {
  return MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfFromJSONTyped(json, false);
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"])
  };
}
function MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/MobilePlanningCreateCardAndTask201ResponseData.ts
function instanceOfMobilePlanningCreateCardAndTask201ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function MobilePlanningCreateCardAndTask201ResponseDataFromJSON(json) {
  return MobilePlanningCreateCardAndTask201ResponseDataFromJSONTyped(json, false);
}
function MobilePlanningCreateCardAndTask201ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : CardFromJSON(json["cards"]),
    "tasks": !exists(json, "tasks") ? void 0 : TaskReadDTOFromJSON(json["tasks"])
  };
}
function MobilePlanningCreateCardAndTask201ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": CardToJSON(value.cards),
    "tasks": TaskReadDTOToJSON(value.tasks)
  };
}

// src/generated/models/MobilePlanningCreateCardAndTask201Response.ts
function instanceOfMobilePlanningCreateCardAndTask201Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function MobilePlanningCreateCardAndTask201ResponseFromJSON(json) {
  return MobilePlanningCreateCardAndTask201ResponseFromJSONTyped(json, false);
}
function MobilePlanningCreateCardAndTask201ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": MobilePlanningCreateCardAndTask201ResponseDataFromJSON(json["data"])
  };
}
function MobilePlanningCreateCardAndTask201ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": MobilePlanningCreateCardAndTask201ResponseDataToJSON(value.data)
  };
}

// src/generated/models/MobilePlanningCreateCardAndTaskRequest.ts
function instanceOfMobilePlanningCreateCardAndTaskRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "taskName" in value;
  isInstance = isInstance && "projectId" in value;
  return isInstance;
}
function MobilePlanningCreateCardAndTaskRequestFromJSON(json) {
  return MobilePlanningCreateCardAndTaskRequestFromJSONTyped(json, false);
}
function MobilePlanningCreateCardAndTaskRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "taskName": json["task_name"],
    "projectId": json["project_id"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "taskDescription": !exists(json, "task_description") ? void 0 : json["task_description"],
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"],
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}
function MobilePlanningCreateCardAndTaskRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "task_name": value.taskName,
    "project_id": value.projectId,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "estimate": value.estimate,
    "task_description": value.taskDescription,
    "label_ids": value.labelIds,
    "status": value.status
  };
}

// src/generated/models/MobilePlanningEditCardRequest.ts
function instanceOfMobilePlanningEditCardRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "startTime" in value;
  isInstance = isInstance && "estimate" in value;
  isInstance = isInstance && "taskName" in value;
  isInstance = isInstance && "taskDescription" in value;
  isInstance = isInstance && "labelIds" in value;
  isInstance = isInstance && "status" in value;
  return isInstance;
}
function MobilePlanningEditCardRequestFromJSON(json) {
  return MobilePlanningEditCardRequestFromJSONTyped(json, false);
}
function MobilePlanningEditCardRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": json["date"] === null ? null : new Date(json["date"]),
    "startTime": json["start_time"] === null ? null : new Date(json["start_time"]),
    "estimate": json["estimate"],
    "taskName": json["task_name"],
    "taskDescription": json["task_description"],
    "labelIds": json["label_ids"],
    "status": json["status"]
  };
}
function MobilePlanningEditCardRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": value.date === null ? null : value.date.toISOString(),
    "start_time": value.startTime === null ? null : value.startTime.toISOString(),
    "estimate": value.estimate,
    "task_name": value.taskName,
    "task_description": value.taskDescription,
    "label_ids": value.labelIds,
    "status": value.status
  };
}

// src/generated/models/MobilePlanningGetCard200ResponseDataAllOfTask.ts
var MobilePlanningGetCard200ResponseDataAllOfTaskRepeatEnum = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
  Yearly: "yearly"
};
function instanceOfMobilePlanningGetCard200ResponseDataAllOfTask(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "createdById" in value;
  isInstance = isInstance && "modifiedById" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "project" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function MobilePlanningGetCard200ResponseDataAllOfTaskFromJSON(json) {
  return MobilePlanningGetCard200ResponseDataAllOfTaskFromJSONTyped(json, false);
}
function MobilePlanningGetCard200ResponseDataAllOfTaskFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": json["created_by_id"],
    "modifiedById": json["modified_by_id"],
    "companyId": json["company_id"],
    "projectId": json["project_id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "active": !exists(json, "active") ? void 0 : json["active"],
    "recurringRule": !exists(json, "recurring_rule") ? void 0 : json["recurring_rule"],
    "startDate": !exists(json, "start_date") ? void 0 : new Date(json["start_date"]),
    "endDate": !exists(json, "end_date") ? void 0 : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "repeat": !exists(json, "repeat") ? void 0 : json["repeat"],
    "interval": !exists(json, "interval") ? void 0 : json["interval"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(LabelEntityFromJSON),
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"].map(FormTemplateSimpleEntityFromJSON),
    "formTemplatesTasks": !exists(json, "form_templates_tasks") ? void 0 : json["form_templates_tasks"].map(FormTemplatesTasksModelFromJSON),
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "productsTasks": !exists(json, "products_tasks") ? void 0 : json["products_tasks"].map(ProductsTaskFromJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON(json["project"]),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": json["deleted"] === null ? null : new Date(json["deleted"]),
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON)
  };
}
function MobilePlanningGetCard200ResponseDataAllOfTaskToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "active": value.active,
    "recurring_rule": value.recurringRule,
    "start_date": value.startDate === void 0 ? void 0 : value.startDate.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "estimate": value.estimate,
    "repeat": value.repeat,
    "interval": value.interval,
    "labels": value.labels === void 0 ? void 0 : value.labels.map(LabelEntityToJSON),
    "form_templates": value.formTemplates === void 0 ? void 0 : value.formTemplates.map(FormTemplateSimpleEntityToJSON),
    "form_templates_tasks": value.formTemplatesTasks === void 0 ? void 0 : value.formTemplatesTasks.map(FormTemplatesTasksModelToJSON),
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "products_tasks": value.productsTasks === void 0 ? void 0 : value.productsTasks.map(ProductsTaskToJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON(value.project),
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON)
  };
}

// src/generated/models/MobilePlanningGetCard200ResponseData.ts
var MobilePlanningGetCard200ResponseDataTypeEnum = {
  Task: "task",
  Absence: "absence"
};
var MobilePlanningGetCard200ResponseDataStatusEnum = {
  ToDo: "to_do",
  Doing: "doing",
  Done: "done"
};
function instanceOfMobilePlanningGetCard200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "taskId" in value;
  isInstance = isInstance && "listIndex" in value;
  isInstance = isInstance && "task" in value;
  return isInstance;
}
function MobilePlanningGetCard200ResponseDataFromJSON(json) {
  return MobilePlanningGetCard200ResponseDataFromJSONTyped(json, false);
}
function MobilePlanningGetCard200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "companyId": !exists(json, "company_id") ? void 0 : json["company_id"],
    "userId": json["user_id"],
    "taskId": json["task_id"],
    "entityId": !exists(json, "entity_id") ? void 0 : json["entity_id"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "productsAdded": !exists(json, "products_added") ? void 0 : json["products_added"],
    "formTemplates": !exists(json, "form_templates") ? void 0 : json["form_templates"],
    "listIndex": json["list_index"],
    "date": !exists(json, "date") ? void 0 : json["date"] === null ? null : new Date(json["date"]),
    "endDate": !exists(json, "end_date") ? void 0 : json["end_date"] === null ? null : new Date(json["end_date"]),
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"] === null ? null : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"] === null ? null : new Date(json["end_time"]),
    "estimate": !exists(json, "estimate") ? void 0 : json["estimate"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "forms": !exists(json, "forms") ? void 0 : json["forms"].map(FormFromJSON),
    "task": MobilePlanningGetCard200ResponseDataAllOfTaskFromJSON(json["task"])
  };
}
function MobilePlanningGetCard200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user_id": value.userId,
    "task_id": value.taskId,
    "entity_id": value.entityId,
    "type": value.type,
    "status": value.status,
    "products_added": value.productsAdded,
    "form_templates": value.formTemplates,
    "list_index": value.listIndex,
    "date": value.date === void 0 ? void 0 : value.date === null ? null : value.date.toISOString(),
    "end_date": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "start_time": value.startTime === void 0 ? void 0 : value.startTime === null ? null : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime === null ? null : value.endTime.toISOString(),
    "estimate": value.estimate,
    "user": UserToJSON(value.user),
    "forms": value.forms === void 0 ? void 0 : value.forms.map(FormToJSON),
    "task": MobilePlanningGetCard200ResponseDataAllOfTaskToJSON(value.task)
  };
}

// src/generated/models/MobilePlanningGetCard200Response.ts
function instanceOfMobilePlanningGetCard200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function MobilePlanningGetCard200ResponseFromJSON(json) {
  return MobilePlanningGetCard200ResponseFromJSONTyped(json, false);
}
function MobilePlanningGetCard200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": MobilePlanningGetCard200ResponseDataFromJSON(json["data"])
  };
}
function MobilePlanningGetCard200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": MobilePlanningGetCard200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/MobilePlanningGetCard200ResponseDataAllOf.ts
function instanceOfMobilePlanningGetCard200ResponseDataAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "task" in value;
  return isInstance;
}
function MobilePlanningGetCard200ResponseDataAllOfFromJSON(json) {
  return MobilePlanningGetCard200ResponseDataAllOfFromJSONTyped(json, false);
}
function MobilePlanningGetCard200ResponseDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "forms": !exists(json, "forms") ? void 0 : json["forms"].map(FormFromJSON),
    "task": MobilePlanningGetCard200ResponseDataAllOfTaskFromJSON(json["task"])
  };
}
function MobilePlanningGetCard200ResponseDataAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "forms": value.forms === void 0 ? void 0 : value.forms.map(FormToJSON),
    "task": MobilePlanningGetCard200ResponseDataAllOfTaskToJSON(value.task)
  };
}

// src/generated/models/MobilePlanningGetCard200ResponseDataAllOfTaskAllOf.ts
function instanceOfMobilePlanningGetCard200ResponseDataAllOfTaskAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "project" in value;
  return isInstance;
}
function MobilePlanningGetCard200ResponseDataAllOfTaskAllOfFromJSON(json) {
  return MobilePlanningGetCard200ResponseDataAllOfTaskAllOfFromJSONTyped(json, false);
}
function MobilePlanningGetCard200ResponseDataAllOfTaskAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cards": !exists(json, "cards") ? void 0 : json["cards"].map(CardFromJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON(json["project"])
  };
}
function MobilePlanningGetCard200ResponseDataAllOfTaskAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cards": value.cards === void 0 ? void 0 : value.cards.map(CardToJSON),
    "project": MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON(value.project)
  };
}

// src/generated/models/OfferCompany.ts
function instanceOfOfferCompany(value) {
  let isInstance = true;
  return isInstance;
}
function OfferCompanyFromJSON(json) {
  return OfferCompanyFromJSONTyped(json, false);
}
function OfferCompanyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "countryId": !exists(json, "country_id") ? void 0 : json["country_id"],
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "fileId": !exists(json, "file_id") ? void 0 : json["file_id"],
    "languageId": !exists(json, "language_id") ? void 0 : json["language_id"],
    "cvr": !exists(json, "cvr") ? void 0 : json["cvr"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "invoiceEmail": !exists(json, "invoice_email") ? void 0 : json["invoice_email"],
    "contactEmail": !exists(json, "contact_email") ? void 0 : json["contact_email"],
    "receiveFormMails": !exists(json, "receive_form_mails") ? void 0 : json["receive_form_mails"],
    "phoneCountrycode": !exists(json, "phone_countrycode") ? void 0 : json["phone_countrycode"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "website": !exists(json, "website") ? void 0 : json["website"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "nextInvoiceNumber": !exists(json, "next_invoice_number") ? void 0 : json["next_invoice_number"],
    "nextProjectNumber": !exists(json, "next_project_number") ? void 0 : json["next_project_number"],
    "nextOfferNumber": !exists(json, "next_offer_number") ? void 0 : json["next_offer_number"],
    "expired": !exists(json, "expired") ? void 0 : new Date(json["expired"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "city": !exists(json, "city") ? void 0 : CityFromJSON(json["city"]),
    "file": !exists(json, "file") ? void 0 : BaseFileFromJSON(json["file"])
  };
}
function OfferCompanyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "created_by_id": value.createdById,
    "contact_person_id": value.contactPersonId,
    "country_id": value.countryId,
    "city_id": value.cityId,
    "file_id": value.fileId,
    "language_id": value.languageId,
    "cvr": value.cvr,
    "name": value.name,
    "street_name": value.streetName,
    "invoice_email": value.invoiceEmail,
    "contact_email": value.contactEmail,
    "receive_form_mails": value.receiveFormMails,
    "phone_countrycode": value.phoneCountrycode,
    "phone": value.phone,
    "website": value.website,
    "vat_percent": value.vatPercent,
    "next_invoice_number": value.nextInvoiceNumber,
    "next_project_number": value.nextProjectNumber,
    "next_offer_number": value.nextOfferNumber,
    "expired": value.expired === void 0 ? void 0 : value.expired.toISOString(),
    "city": CityToJSON(value.city),
    "file": BaseFileToJSON(value.file)
  };
}

// src/generated/models/OfferContact.ts
function instanceOfOfferContact(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "countryId" in value;
  isInstance = isInstance && "cityId" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "address" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "website" in value;
  isInstance = isInstance && "phone" in value;
  isInstance = isInstance && "phoneCountrycode" in value;
  isInstance = isInstance && "cvr" in value;
  isInstance = isInstance && "erpId" in value;
  isInstance = isInstance && "discountPercentageHours" in value;
  isInstance = isInstance && "discountPercentageProducts" in value;
  isInstance = isInstance && "tripletexId" in value;
  isInstance = isInstance && "centigaId" in value;
  isInstance = isInstance && "pogoId" in value;
  isInstance = isInstance && "paymentTermId" in value;
  return isInstance;
}
function OfferContactFromJSON(json) {
  return OfferContactFromJSONTyped(json, false);
}
function OfferContactFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "countryId": json["country_id"],
    "cityId": json["city_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "companyId": json["company_id"],
    "name": json["name"],
    "description": json["description"],
    "address": json["address"],
    "email": json["email"],
    "website": json["website"],
    "phone": json["phone"],
    "phoneCountrycode": json["phone_countrycode"],
    "cvr": json["cvr"],
    "erpId": json["erp_id"],
    "discountPercentageHours": json["discount_percentage_hours"],
    "discountPercentageProducts": json["discount_percentage_products"],
    "tripletexId": json["tripletex_id"],
    "centigaId": json["centiga_id"],
    "pogoId": json["pogo_id"],
    "paymentTermId": json["payment_term_id"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "ean": !exists(json, "ean") ? void 0 : json["ean"],
    "paymentTerm": !exists(json, "payment_term") ? void 0 : PaymentTermFromJSON(json["payment_term"]),
    "city": !exists(json, "city") ? void 0 : CityFromJSON(json["city"]),
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function OfferContactToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "country_id": value.countryId,
    "city_id": value.cityId,
    "label_id": value.labelId,
    "company_id": value.companyId,
    "name": value.name,
    "description": value.description,
    "address": value.address,
    "email": value.email,
    "website": value.website,
    "phone": value.phone,
    "phone_countrycode": value.phoneCountrycode,
    "cvr": value.cvr,
    "erp_id": value.erpId,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "tripletex_id": value.tripletexId,
    "centiga_id": value.centigaId,
    "pogo_id": value.pogoId,
    "payment_term_id": value.paymentTermId,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "ean": value.ean,
    "payment_term": PaymentTermToJSON(value.paymentTerm),
    "city": CityToJSON(value.city),
    "label": LabelEntityToJSON(value.label)
  };
}

// src/generated/models/OfferContactPerson.ts
function instanceOfOfferContactPerson(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  return isInstance;
}
function OfferContactPersonFromJSON(json) {
  return OfferContactPersonFromJSONTyped(json, false);
}
function OfferContactPersonFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "name": json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function OfferContactPersonToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "contact_id": value.contactId,
    "name": value.name,
    "email": value.email,
    "phone": value.phone,
    "title": value.title
  };
}

// src/generated/models/OfferOfferStatus.ts
function instanceOfOfferOfferStatus(value) {
  let isInstance = true;
  isInstance = isInstance && "identifier" in value;
  return isInstance;
}
function OfferOfferStatusFromJSON(json) {
  return OfferOfferStatusFromJSONTyped(json, false);
}
function OfferOfferStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "identifier": json["identifier"],
    "name": !exists(json, "name") ? void 0 : json["name"]
  };
}
function OfferOfferStatusToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "identifier": value.identifier,
    "name": value.name
  };
}

// src/generated/models/OfferProject.ts
function instanceOfOfferProject(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function OfferProjectFromJSON(json) {
  return OfferProjectFromJSONTyped(json, false);
}
function OfferProjectFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "fullName": !exists(json, "full_name") ? void 0 : json["full_name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "discountPercentageHours": !exists(json, "discount_percentage_hours") ? void 0 : json["discount_percentage_hours"],
    "discountPercentageProducts": !exists(json, "discount_percentage_products") ? void 0 : json["discount_percentage_products"],
    "projectNumber": !exists(json, "project_number") ? void 0 : json["project_number"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "thumbnail": !exists(json, "thumbnail") ? void 0 : json["thumbnail"],
    "projectImageUrl": !exists(json, "project_image_url") ? void 0 : json["project_image_url"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "endTime": !exists(json, "end_time") ? void 0 : new Date(json["end_time"]),
    "projectStatusId": !exists(json, "project_status_id") ? void 0 : json["project_status_id"],
    "projectStatus": !exists(json, "project_status") ? void 0 : ProjectStatusFromJSON(json["project_status"]),
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"])
  };
}
function OfferProjectToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "discount_percentage_hours": value.discountPercentageHours,
    "discount_percentage_products": value.discountPercentageProducts,
    "project_number": value.projectNumber,
    "email": value.email,
    "thumbnail": value.thumbnail,
    "project_image_url": value.projectImageUrl,
    "street_name": value.streetName,
    "zip_code": value.zipCode,
    "city_name": value.cityName,
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "end_time": value.endTime === void 0 ? void 0 : value.endTime.toISOString(),
    "project_status_id": value.projectStatusId,
    "project_status": ProjectStatusToJSON(value.projectStatus),
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/Offer.ts
var OfferAcceptedByEnum = {
  Company: "company",
  Contact: "contact"
};
var OfferOfferLinesRuleEnum = {
  GatherOfferLines: "gather_offer_lines",
  DistributionHoursOverProducts: "distribution_hours_over_products",
  ShowOnlyProductBundles: "show_only_product_bundles",
  GroupByProductAndHours: "group_by_product_and_hours",
  TotalPriceLine: "total_price_line"
};
var OfferStatusEnum = {
  Draft: "draft",
  Sent: "sent",
  SentAndSeen: "sent_and_seen",
  Accepted: "accepted",
  Rejected: "rejected",
  Expired: "expired",
  Deleted: "deleted"
};
function instanceOfOffer(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "offerStatusId" in value;
  isInstance = isInstance && "companyId" in value;
  return isInstance;
}
function OfferFromJSON(json) {
  return OfferFromJSONTyped(json, false);
}
function OfferFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "modifiedById": !exists(json, "modified_by_id") ? void 0 : json["modified_by_id"],
    "offerStatusId": json["offer_status_id"],
    "cityId": !exists(json, "city_id") ? void 0 : json["city_id"],
    "city": !exists(json, "city") ? void 0 : CityFromJSON(json["city"]),
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "contactId": !exists(json, "contact_id") ? void 0 : json["contact_id"],
    "contact": !exists(json, "contact") ? void 0 : OfferContactFromJSON(json["contact"]),
    "contactPerson": !exists(json, "contact_person") ? void 0 : OfferContactPersonFromJSON(json["contact_person"]),
    "contactPersonId": !exists(json, "contact_person_id") ? void 0 : json["contact_person_id"],
    "companyId": json["company_id"],
    "company": !exists(json, "company") ? void 0 : OfferCompanyFromJSON(json["company"]),
    "offerStatus": !exists(json, "offer_status") ? void 0 : OfferOfferStatusFromJSON(json["offer_status"]),
    "project": !exists(json, "project") ? void 0 : OfferProjectFromJSON(json["project"]),
    "offerNumber": !exists(json, "offer_number") ? void 0 : json["offer_number"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "address": !exists(json, "address") ? void 0 : json["address"],
    "issuedDate": !exists(json, "issued_date") ? void 0 : fromLocalDateString(json["issued_date"]),
    "expirationDate": !exists(json, "expiration_date") ? void 0 : json["expiration_date"] === null ? null : new Date(json["expiration_date"]),
    "acceptedBy": !exists(json, "accepted_by") ? void 0 : json["accepted_by"],
    "vatPercent": !exists(json, "vat_percent") ? void 0 : json["vat_percent"],
    "discountPercent": !exists(json, "discount_percent") ? void 0 : json["discount_percent"],
    "paymentTermId": !exists(json, "payment_term_id") ? void 0 : json["payment_term_id"],
    "erpPaymentTermId": !exists(json, "erp_payment_term_id") ? void 0 : json["erp_payment_term_id"],
    "offerLinesRule": !exists(json, "offer_lines_rule") ? void 0 : json["offer_lines_rule"],
    "isQuote": !exists(json, "is_quote") ? void 0 : json["is_quote"],
    "isV3": !exists(json, "is_v3") ? void 0 : json["is_v3"],
    "v3Origin": !exists(json, "v3_origin") ? void 0 : json["v3_origin"],
    "pdfUrl": !exists(json, "pdf_url") ? void 0 : json["pdf_url"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "publicClientUrl": !exists(json, "public_client_url") ? void 0 : json["public_client_url"],
    "publicViewUrl": !exists(json, "public_view_url") ? void 0 : json["public_view_url"],
    "pdfLink": !exists(json, "pdf_link") ? void 0 : json["pdf_link"],
    "token": !exists(json, "token") ? void 0 : json["token"],
    "subtotal": !exists(json, "subtotal") ? void 0 : json["subtotal"],
    "vatAmount": !exists(json, "vat_amount") ? void 0 : json["vat_amount"],
    "workingHoursTotalCostPrice": !exists(json, "working_hours_total_cost_price") ? void 0 : json["working_hours_total_cost_price"],
    "productsTotalCostPrice": !exists(json, "products_total_cost_price") ? void 0 : json["products_total_cost_price"],
    "status": !exists(json, "status") ? void 0 : json["status"],
    "manualTotalSalesPrice": !exists(json, "manual_total_sales_price") ? void 0 : json["manual_total_sales_price"]
  };
}
function OfferToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "offer_status_id": value.offerStatusId,
    "city_id": value.cityId,
    "city": CityToJSON(value.city),
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "contact_id": value.contactId,
    "contact": OfferContactToJSON(value.contact),
    "contact_person": OfferContactPersonToJSON(value.contactPerson),
    "contact_person_id": value.contactPersonId,
    "company_id": value.companyId,
    "company": OfferCompanyToJSON(value.company),
    "offer_status": OfferOfferStatusToJSON(value.offerStatus),
    "project": OfferProjectToJSON(value.project),
    "title": value.title,
    "description": value.description,
    "address": value.address,
    "issued_date": value.issuedDate === void 0 ? void 0 : toLocalDateString(value.issuedDate),
    "expiration_date": value.expirationDate === void 0 ? void 0 : value.expirationDate === null ? null : value.expirationDate.toISOString(),
    "accepted_by": value.acceptedBy,
    "discount_percent": value.discountPercent,
    "payment_term_id": value.paymentTermId,
    "offer_lines_rule": value.offerLinesRule,
    "is_quote": value.isQuote,
    "is_v3": value.isV3,
    "v3_origin": value.v3Origin
  };
}

// src/generated/models/OfferAcceptRequest.ts
function instanceOfOfferAcceptRequest(value) {
  let isInstance = true;
  return isInstance;
}
function OfferAcceptRequestFromJSON(json) {
  return OfferAcceptRequestFromJSONTyped(json, false);
}
function OfferAcceptRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "offerId": !exists(json, "offer_id") ? void 0 : json["offer_id"]
  };
}
function OfferAcceptRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "offer_id": value.offerId
  };
}

// src/generated/models/OfferAddProductBundleRequest.ts
function instanceOfOfferAddProductBundleRequest(value) {
  let isInstance = true;
  return isInstance;
}
function OfferAddProductBundleRequestFromJSON(json) {
  return OfferAddProductBundleRequestFromJSONTyped(json, false);
}
function OfferAddProductBundleRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productBundleId": !exists(json, "product_bundle_id") ? void 0 : json["product_bundle_id"]
  };
}
function OfferAddProductBundleRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_bundle_id": value.productBundleId
  };
}

// src/generated/models/OfferCancelRequest.ts
function instanceOfOfferCancelRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "offerId" in value;
  return isInstance;
}
function OfferCancelRequestFromJSON(json) {
  return OfferCancelRequestFromJSONTyped(json, false);
}
function OfferCancelRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "offerId": json["offer_id"]
  };
}
function OfferCancelRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "offer_id": value.offerId
  };
}

// src/generated/models/OffersList200Response.ts
function instanceOfOffersList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function OffersList200ResponseFromJSON(json) {
  return OffersList200ResponseFromJSONTyped(json, false);
}
function OffersList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(OfferFromJSON)
  };
}
function OffersList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(OfferToJSON)
  };
}

// src/generated/models/OffersList200ResponseAllOf.ts
function instanceOfOffersList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function OffersList200ResponseAllOfFromJSON(json) {
  return OffersList200ResponseAllOfFromJSONTyped(json, false);
}
function OffersList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(OfferFromJSON)
  };
}
function OffersList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(OfferToJSON)
  };
}

// src/generated/models/OffersView200Response.ts
function instanceOfOffersView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function OffersView200ResponseFromJSON(json) {
  return OffersView200ResponseFromJSONTyped(json, false);
}
function OffersView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": OfferFromJSON(json["data"])
  };
}
function OffersView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": OfferToJSON(value.data)
  };
}

// src/generated/models/PriceHistory.ts
var PriceHistoryTypeEnum = {
  ExpenseLine: "expense_line",
  VendorProduct: "vendor_product"
};
function instanceOfPriceHistory(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "price" in value;
  isInstance = isInstance && "latestUpdate" in value;
  isInstance = isInstance && "vendorName" in value;
  isInstance = isInstance && "vendorImage" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "parentId" in value;
  return isInstance;
}
function PriceHistoryFromJSON(json) {
  return PriceHistoryFromJSONTyped(json, false);
}
function PriceHistoryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "price": json["price"],
    "latestUpdate": new Date(json["latest_update"]),
    "vendorName": json["vendor_name"],
    "vendorImage": json["vendor_image"],
    "type": json["type"],
    "parentId": json["parent_id"]
  };
}
function PriceHistoryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "price": value.price,
    "vendor_name": value.vendorName,
    "vendor_image": value.vendorImage,
    "type": value.type,
    "parent_id": value.parentId
  };
}

// src/generated/models/ProductBundleLineView200Response.ts
function instanceOfProductBundleLineView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundleLineView200ResponseFromJSON(json) {
  return ProductBundleLineView200ResponseFromJSONTyped(json, false);
}
function ProductBundleLineView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProductBundleLineFromJSON(json["data"])
  };
}
function ProductBundleLineView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProductBundleLineToJSON(value.data)
  };
}

// src/generated/models/ProductBundleLinesList200Response.ts
function instanceOfProductBundleLinesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundleLinesList200ResponseFromJSON(json) {
  return ProductBundleLinesList200ResponseFromJSONTyped(json, false);
}
function ProductBundleLinesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProductBundleLineFromJSON)
  };
}
function ProductBundleLinesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProductBundleLineToJSON)
  };
}

// src/generated/models/ProductBundleLinesList200ResponseAllOf.ts
function instanceOfProductBundleLinesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundleLinesList200ResponseAllOfFromJSON(json) {
  return ProductBundleLinesList200ResponseAllOfFromJSONTyped(json, false);
}
function ProductBundleLinesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProductBundleLineFromJSON)
  };
}
function ProductBundleLinesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProductBundleLineToJSON)
  };
}

// src/generated/models/ProductBundlesGetKpiCardsData200ResponseData.ts
function instanceOfProductBundlesGetKpiCardsData200ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function ProductBundlesGetKpiCardsData200ResponseDataFromJSON(json) {
  return ProductBundlesGetKpiCardsData200ResponseDataFromJSONTyped(json, false);
}
function ProductBundlesGetKpiCardsData200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "hoursCostPrice": !exists(json, "hours_cost_price") ? void 0 : json["hours_cost_price"],
    "productsCostPrice": !exists(json, "products_cost_price") ? void 0 : json["products_cost_price"],
    "totalCostPrice": !exists(json, "total_cost_price") ? void 0 : json["total_cost_price"],
    "hoursSalesPrice": !exists(json, "hours_sales_price") ? void 0 : json["hours_sales_price"],
    "productsSalesPrice": !exists(json, "products_sales_price") ? void 0 : json["products_sales_price"],
    "totalSalesPrice": !exists(json, "total_sales_price") ? void 0 : json["total_sales_price"],
    "contributionMargin": !exists(json, "contribution_margin") ? void 0 : json["contribution_margin"],
    "workingHoursMargin": !exists(json, "working_hours_margin") ? void 0 : json["working_hours_margin"],
    "profitMargin": !exists(json, "profit_margin") ? void 0 : json["profit_margin"]
  };
}
function ProductBundlesGetKpiCardsData200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "products_cost_price": value.productsCostPrice,
    "total_cost_price": value.totalCostPrice,
    "hours_sales_price": value.hoursSalesPrice,
    "products_sales_price": value.productsSalesPrice,
    "total_sales_price": value.totalSalesPrice,
    "contribution_margin": value.contributionMargin,
    "working_hours_margin": value.workingHoursMargin,
    "profit_margin": value.profitMargin
  };
}

// src/generated/models/ProductBundlesGetKpiCardsData200Response.ts
function instanceOfProductBundlesGetKpiCardsData200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundlesGetKpiCardsData200ResponseFromJSON(json) {
  return ProductBundlesGetKpiCardsData200ResponseFromJSONTyped(json, false);
}
function ProductBundlesGetKpiCardsData200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProductBundlesGetKpiCardsData200ResponseDataFromJSON(json["data"])
  };
}
function ProductBundlesGetKpiCardsData200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProductBundlesGetKpiCardsData200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/ProductBundlesList200Response.ts
function instanceOfProductBundlesList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundlesList200ResponseFromJSON(json) {
  return ProductBundlesList200ResponseFromJSONTyped(json, false);
}
function ProductBundlesList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProductBundleFromJSON)
  };
}
function ProductBundlesList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProductBundleToJSON)
  };
}

// src/generated/models/ProductBundlesList200ResponseAllOf.ts
function instanceOfProductBundlesList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundlesList200ResponseAllOfFromJSON(json) {
  return ProductBundlesList200ResponseAllOfFromJSONTyped(json, false);
}
function ProductBundlesList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProductBundleFromJSON)
  };
}
function ProductBundlesList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProductBundleToJSON)
  };
}

// src/generated/models/ProductBundlesView200Response.ts
function instanceOfProductBundlesView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductBundlesView200ResponseFromJSON(json) {
  return ProductBundlesView200ResponseFromJSONTyped(json, false);
}
function ProductBundlesView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProductBundleFromJSON(json["data"])
  };
}
function ProductBundlesView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProductBundleToJSON(value.data)
  };
}

// src/generated/models/ProductPriceHistory200Response.ts
function instanceOfProductPriceHistory200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function ProductPriceHistory200ResponseFromJSON(json) {
  return ProductPriceHistory200ResponseFromJSONTyped(json, false);
}
function ProductPriceHistory200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(PriceHistoryFromJSON),
    "pagination": PaginationDetailsFromJSON(json["pagination"])
  };
}
function ProductPriceHistory200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(PriceHistoryToJSON),
    "pagination": PaginationDetailsToJSON(value.pagination)
  };
}

// src/generated/models/ProductPriceHistory200ResponseAllOf.ts
function instanceOfProductPriceHistory200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  isInstance = isInstance && "pagination" in value;
  return isInstance;
}
function ProductPriceHistory200ResponseAllOfFromJSON(json) {
  return ProductPriceHistory200ResponseAllOfFromJSONTyped(json, false);
}
function ProductPriceHistory200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(PriceHistoryFromJSON),
    "pagination": PaginationDetailsFromJSON(json["pagination"])
  };
}
function ProductPriceHistory200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(PriceHistoryToJSON),
    "pagination": PaginationDetailsToJSON(value.pagination)
  };
}

// src/generated/models/ProductVariants200Response.ts
function instanceOfProductVariants200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductVariants200ResponseFromJSON(json) {
  return ProductVariants200ResponseFromJSONTyped(json, false);
}
function ProductVariants200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProductVariantFromJSON)
  };
}
function ProductVariants200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProductVariantToJSON)
  };
}

// src/generated/models/ProductVariants200ResponseAllOf.ts
function instanceOfProductVariants200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductVariants200ResponseAllOfFromJSON(json) {
  return ProductVariants200ResponseAllOfFromJSONTyped(json, false);
}
function ProductVariants200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProductVariantFromJSON)
  };
}
function ProductVariants200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProductVariantToJSON)
  };
}

// src/generated/models/ProductsList200ResponseAllOfDataInner.ts
var ProductsList200ResponseAllOfDataInnerPriceTypeEnum = {
  Manual: "manual",
  CostBased: "cost_based"
};
function instanceOfProductsList200ResponseAllOfDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "companyId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function ProductsList200ResponseAllOfDataInnerFromJSON(json) {
  return ProductsList200ResponseAllOfDataInnerFromJSONTyped(json, false);
}
function ProductsList200ResponseAllOfDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "companyId": json["company_id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "labelId": !exists(json, "label_id") ? void 0 : json["label_id"],
    "origin": !exists(json, "origin") ? void 0 : json["origin"],
    "priceType": !exists(json, "price_type") ? void 0 : json["price_type"],
    "name": json["name"],
    "nickname": !exists(json, "nickname") ? void 0 : json["nickname"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "unit": !exists(json, "unit") ? void 0 : json["unit"],
    "productRule": !exists(json, "product_rule") ? void 0 : json["product_rule"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "isManualBuyingPrice": !exists(json, "is_manual_buying_price") ? void 0 : json["is_manual_buying_price"],
    "isManualSellingPrice": !exists(json, "is_manual_selling_price") ? void 0 : json["is_manual_selling_price"],
    "image": !exists(json, "image") ? void 0 : json["image"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "erpId": !exists(json, "erp_id") ? void 0 : json["erp_id"],
    "versionId": !exists(json, "version_id") ? void 0 : json["version_id"],
    "variants": !exists(json, "variants") ? void 0 : json["variants"].map(ProductVariantFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"]),
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "translatedOrigin": !exists(json, "translated_origin") ? void 0 : json["translated_origin"],
    "label": !exists(json, "label") ? void 0 : LabelEntityFromJSON(json["label"]),
    "hasCheaperVariantAvailable": !exists(json, "has_cheaper_variant_available") ? void 0 : json["has_cheaper_variant_available"],
    "minimumMarketPrice": !exists(json, "minimum_market_price") ? void 0 : json["minimum_market_price"],
    "averageMarketPrice": !exists(json, "average_market_price") ? void 0 : json["average_market_price"],
    "optimizationPotential": !exists(json, "optimization_potential") ? void 0 : json["optimization_potential"],
    "grossPrice": !exists(json, "gross_price") ? void 0 : json["gross_price"]
  };
}
function ProductsList200ResponseAllOfDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "label_id": value.labelId,
    "price_type": value.priceType,
    "name": value.name,
    "nickname": value.nickname,
    "description": value.description,
    "product_number": value.productNumber,
    "barcode": value.barcode,
    "unit": value.unit,
    "product_rule": value.productRule,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "is_manual_buying_price": value.isManualBuyingPrice,
    "is_manual_selling_price": value.isManualSellingPrice,
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType,
    "variants": value.variants === void 0 ? void 0 : value.variants.map(ProductVariantToJSON),
    "label": LabelEntityToJSON(value.label),
    "gross_price": value.grossPrice
  };
}

// src/generated/models/ProductsList200Response.ts
function instanceOfProductsList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductsList200ResponseFromJSON(json) {
  return ProductsList200ResponseFromJSONTyped(json, false);
}
function ProductsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProductsList200ResponseAllOfDataInnerFromJSON)
  };
}
function ProductsList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProductsList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/ProductsList200ResponseAllOf.ts
function instanceOfProductsList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductsList200ResponseAllOfFromJSON(json) {
  return ProductsList200ResponseAllOfFromJSONTyped(json, false);
}
function ProductsList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(ProductsList200ResponseAllOfDataInnerFromJSON)
  };
}
function ProductsList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(ProductsList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/ProductsList200ResponseAllOfDataInnerAllOf.ts
function instanceOfProductsList200ResponseAllOfDataInnerAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function ProductsList200ResponseAllOfDataInnerAllOfFromJSON(json) {
  return ProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, false);
}
function ProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "grossPrice": !exists(json, "gross_price") ? void 0 : json["gross_price"]
  };
}
function ProductsList200ResponseAllOfDataInnerAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "gross_price": value.grossPrice
  };
}

// src/generated/models/ProductsView200Response.ts
function instanceOfProductsView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProductsView200ResponseFromJSON(json) {
  return ProductsView200ResponseFromJSONTyped(json, false);
}
function ProductsView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProductFromJSON(json["data"])
  };
}
function ProductsView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProductToJSON(value.data)
  };
}

// src/generated/models/ProjectGetKpiCardEconomySubPage200ResponseDataInterval.ts
function instanceOfProjectGetKpiCardEconomySubPage200ResponseDataInterval(value) {
  let isInstance = true;
  return isInstance;
}
function ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSON(json) {
  return ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSONTyped(json, false);
}
function ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "dateBefore": !exists(json, "date_before") ? void 0 : new Date(json["date_before"]),
    "dateAfter": !exists(json, "date_after") ? void 0 : new Date(json["date_after"])
  };
}
function ProjectGetKpiCardEconomySubPage200ResponseDataIntervalToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date_before": value.dateBefore === void 0 ? void 0 : value.dateBefore.toISOString(),
    "date_after": value.dateAfter === void 0 ? void 0 : value.dateAfter.toISOString()
  };
}

// src/generated/models/ProjectGetKpiCardEconomySubPage200ResponseData.ts
function instanceOfProjectGetKpiCardEconomySubPage200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "interval" in value;
  isInstance = isInstance && "products" in value;
  isInstance = isInstance && "hours" in value;
  return isInstance;
}
function ProjectGetKpiCardEconomySubPage200ResponseDataFromJSON(json) {
  return ProjectGetKpiCardEconomySubPage200ResponseDataFromJSONTyped(json, false);
}
function ProjectGetKpiCardEconomySubPage200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "interval": ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSON(json["interval"]),
    "products": KpiCardEconomyPriceFromJSON(json["products"]),
    "productRules": !exists(json, "product_rules") ? void 0 : KpiCardEconomyPriceFromJSON(json["product_rules"]),
    "hours": KpiCardEconomyPriceFromJSON(json["hours"]),
    "total": !exists(json, "total") ? void 0 : KpiCardEconomyPriceFromJSON(json["total"])
  };
}
function ProjectGetKpiCardEconomySubPage200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "interval": ProjectGetKpiCardEconomySubPage200ResponseDataIntervalToJSON(value.interval),
    "products": KpiCardEconomyPriceToJSON(value.products),
    "product_rules": KpiCardEconomyPriceToJSON(value.productRules),
    "hours": KpiCardEconomyPriceToJSON(value.hours),
    "total": KpiCardEconomyPriceToJSON(value.total)
  };
}

// src/generated/models/ProjectGetKpiCardEconomySubPage200Response.ts
function instanceOfProjectGetKpiCardEconomySubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardEconomySubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardEconomySubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardEconomySubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectGetKpiCardEconomySubPage200ResponseDataFromJSON(json["data"])
  };
}
function ProjectGetKpiCardEconomySubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectGetKpiCardEconomySubPage200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInner.ts
function instanceOfProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "formDate" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSON(json) {
  return ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "projectId": json["project_id"],
    "userId": json["user_id"],
    "formDate": new Date(json["form_date"]),
    "approved": !exists(json, "approved") ? void 0 : json["approved"] === null ? null : new Date(json["approved"]),
    "invoiced": !exists(json, "invoiced") ? void 0 : json["invoiced"] === null ? null : new Date(json["invoiced"]),
    "workDescription": !exists(json, "work_description") ? void 0 : json["work_description"],
    "totalHours": !exists(json, "total_hours") ? void 0 : json["total_hours"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(KpiChardHoursIndividualEntryFromJSON)
  };
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": UserToJSON(value.user)
  };
}

// src/generated/models/ProjectGetKpiCardHoursAllFormsSubPage200Response.ts
function instanceOfProjectGetKpiCardHoursAllFormsSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": !exists(json, "pagination") ? void 0 : PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSON)
  };
}
function ProjectGetKpiCardHoursAllFormsSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerToJSON)
  };
}

// src/generated/models/ProjectGetKpiCardHoursPreCalculationSubPage200ResponseData.ts
function instanceOfProjectGetKpiCardHoursPreCalculationSubPage200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "preCalculations" in value;
  isInstance = isInstance && "totalCost" in value;
  isInstance = isInstance && "totalHours" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSON(json) {
  return ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "preCalculations": json["pre_calculations"].map(KpiCardPreCalculationIndividualEntryFromJSON),
    "totalCost": json["total_cost"],
    "totalHours": json["total_hours"]
  };
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ProjectGetKpiCardHoursPreCalculationSubPage200Response.ts
function instanceOfProjectGetKpiCardHoursPreCalculationSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSON(json["data"])
  };
}
function ProjectGetKpiCardHoursPreCalculationSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInner.ts
function instanceOfProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSON(json) {
  return ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "userPriceGroup": !exists(json, "userPriceGroup") ? void 0 : UsersPriceGroupFromJSON(json["userPriceGroup"]),
    "totalHours": !exists(json, "total_hours") ? void 0 : json["total_hours"],
    "estimatedHours": !exists(json, "estimated_hours") ? void 0 : json["estimated_hours"],
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(KpiCardHoursSummedIndividualEntryFromJSON)
  };
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200Response.ts
function instanceOfProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSON)
  };
}
function ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerToJSON)
  };
}

// src/generated/models/ProjectGetKpiCardHoursSummedSubPage200ResponseDataInner.ts
function instanceOfProjectGetKpiCardHoursSummedSubPage200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "user" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSON(json) {
  return ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "user": UserFromJSON(json["user"]),
    "totalHours": !exists(json, "total_hours") ? void 0 : json["total_hours"],
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(KpiCardHoursSummedIndividualEntryFromJSON)
  };
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ProjectGetKpiCardHoursSummedSubPage200Response.ts
function instanceOfProjectGetKpiCardHoursSummedSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSON)
  };
}
function ProjectGetKpiCardHoursSummedSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerToJSON)
  };
}

// src/generated/models/ProjectGetKpiCardInvoicesSubPage200Response.ts
function instanceOfProjectGetKpiCardInvoicesSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardInvoicesSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardInvoicesSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardInvoicesSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(InvoiceReadDTOFromJSON)
  };
}
function ProjectGetKpiCardInvoicesSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(InvoiceReadDTOToJSON)
  };
}

// src/generated/models/ProjectGetKpiCardProductsPreCalculationSubPage200ResponseData.ts
function instanceOfProjectGetKpiCardProductsPreCalculationSubPage200ResponseData(value) {
  let isInstance = true;
  isInstance = isInstance && "preCalculations" in value;
  isInstance = isInstance && "totalCost" in value;
  return isInstance;
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSON(json) {
  return ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSONTyped(json, false);
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "preCalculations": json["pre_calculations"].map(KpiCardPreCalculationIndividualEntryFromJSON),
    "totalCost": json["total_cost"]
  };
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ProjectGetKpiCardProductsPreCalculationSubPage200Response.ts
function instanceOfProjectGetKpiCardProductsPreCalculationSubPage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSON(json) {
  return ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSON(json["data"])
  };
}
function ProjectGetKpiCardProductsPreCalculationSubPage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInner.ts
var ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerTypeEnum = {
  Product: "product",
  ExpenseLine: "expense_line"
};
function instanceOfProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "quantityActual" in value;
  isInstance = isInstance && "buyingPricePerUnitActual" in value;
  isInstance = isInstance && "buyingPriceTotalActual" in value;
  isInstance = isInstance && "sellingPricePerUnitActual" in value;
  isInstance = isInstance && "sellingPriceTotalActual" in value;
  return isInstance;
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSON(json) {
  return ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSONTyped(json, false);
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "id": json["id"],
    "title": json["title"],
    "quantityEstimated": !exists(json, "quantity_estimated") ? void 0 : json["quantity_estimated"],
    "quantityActual": json["quantity_actual"],
    "buyingPricePerUnitEstimated": !exists(json, "buying_price_per_unit_estimated") ? void 0 : json["buying_price_per_unit_estimated"],
    "buyingPriceTotalEstimated": !exists(json, "buying_price_total_estimated") ? void 0 : json["buying_price_total_estimated"],
    "buyingPricePerUnitActual": json["buying_price_per_unit_actual"],
    "buyingPriceTotalActual": json["buying_price_total_actual"],
    "sellingPricePerUnitActual": json["selling_price_per_unit_actual"],
    "sellingPriceTotalActual": json["selling_price_total_actual"],
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(KpiCardProductsIndividualEntryFromJSON)
  };
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {};
}

// src/generated/models/ProjectGetKpiCardProductsSubpageProductsTab200Response.ts
function instanceOfProjectGetKpiCardProductsSubpageProductsTab200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSON(json) {
  return ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSON)
  };
}
function ProjectGetKpiCardProductsSubpageProductsTab200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerToJSON)
  };
}

// src/generated/models/ProjectGetKpiCardsData200Response.ts
function instanceOfProjectGetKpiCardsData200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ProjectGetKpiCardsData200ResponseFromJSON(json) {
  return ProjectGetKpiCardsData200ResponseFromJSONTyped(json, false);
}
function ProjectGetKpiCardsData200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": KpiCardsIndexResponseFromJSON(json["data"])
  };
}
function ProjectGetKpiCardsData200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": KpiCardsIndexResponseToJSON(value.data)
  };
}

// src/generated/models/RegistrationsInvoiceDTOAllOf.ts
function instanceOfRegistrationsInvoiceDTOAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function RegistrationsInvoiceDTOAllOfFromJSON(json) {
  return RegistrationsInvoiceDTOAllOfFromJSONTyped(json, false);
}
function RegistrationsInvoiceDTOAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customMetadata": !exists(json, "custom_metadata") ? void 0 : RegistrationsInvoiceDTOAllOfCustomMetadataFromJSON(json["custom_metadata"])
  };
}
function RegistrationsInvoiceDTOAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "custom_metadata": RegistrationsInvoiceDTOAllOfCustomMetadataToJSON(value.customMetadata)
  };
}

// src/generated/models/ReportTypes.ts
var ReportTypes = {
  OngoingWork: "ongoing_work",
  ProjectsMargins: "projects_margins",
  CustomersStatistics: "customers_statistics",
  ExpensesStatistics: "expenses_statistics",
  InvoicedProductsStatistics: "invoiced_products_statistics"
};
function ReportTypesFromJSON(json) {
  return ReportTypesFromJSONTyped(json, false);
}
function ReportTypesFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ReportTypesToJSON(value) {
  return value;
}

// src/generated/models/RequestResetPassword200Response.ts
function instanceOfRequestResetPassword200Response(value) {
  let isInstance = true;
  return isInstance;
}
function RequestResetPassword200ResponseFromJSON(json) {
  return RequestResetPassword200ResponseFromJSONTyped(json, false);
}
function RequestResetPassword200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": !exists(json, "success") ? void 0 : json["success"]
  };
}
function RequestResetPassword200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success
  };
}

// src/generated/models/RequestResetPasswordRequest.ts
function instanceOfRequestResetPasswordRequest(value) {
  let isInstance = true;
  return isInstance;
}
function RequestResetPasswordRequestFromJSON(json) {
  return RequestResetPasswordRequestFromJSONTyped(json, false);
}
function RequestResetPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": !exists(json, "email") ? void 0 : json["email"],
    "mobile": !exists(json, "mobile") ? void 0 : json["mobile"]
  };
}
function RequestResetPasswordRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "mobile": value.mobile
  };
}

// src/generated/models/ResetPasswordRequest.ts
function instanceOfResetPasswordRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  return isInstance;
}
function ResetPasswordRequestFromJSON(json) {
  return ResetPasswordRequestFromJSONTyped(json, false);
}
function ResetPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": json["email"]
  };
}
function ResetPasswordRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email
  };
}

// src/generated/models/ReverseLookup200ResponseData.ts
function instanceOfReverseLookup200ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function ReverseLookup200ResponseDataFromJSON(json) {
  return ReverseLookup200ResponseDataFromJSONTyped(json, false);
}
function ReverseLookup200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "streetName": !exists(json, "streetName") ? void 0 : json["streetName"],
    "streetNumber": !exists(json, "streetNumber") ? void 0 : json["streetNumber"],
    "postalCode": !exists(json, "postalCode") ? void 0 : json["postalCode"],
    "country": !exists(json, "country") ? void 0 : json["country"],
    "locality": !exists(json, "locality") ? void 0 : json["locality"]
  };
}
function ReverseLookup200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "streetName": value.streetName,
    "streetNumber": value.streetNumber,
    "postalCode": value.postalCode,
    "country": value.country,
    "locality": value.locality
  };
}

// src/generated/models/ReverseLookup200Response.ts
function instanceOfReverseLookup200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function ReverseLookup200ResponseFromJSON(json) {
  return ReverseLookup200ResponseFromJSONTyped(json, false);
}
function ReverseLookup200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": ReverseLookup200ResponseDataFromJSON(json["data"])
  };
}
function ReverseLookup200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ReverseLookup200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/SendReportRequest.ts
function instanceOfSendReportRequest(value) {
  let isInstance = true;
  return isInstance;
}
function SendReportRequestFromJSON(json) {
  return SendReportRequestFromJSONTyped(json, false);
}
function SendReportRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "dateFrom": !exists(json, "date_from") ? void 0 : fromLocalDateString(json["date_from"]),
    "dateTo": !exists(json, "date_to") ? void 0 : fromLocalDateString(json["date_to"]),
    "email": !exists(json, "email") ? void 0 : json["email"]
  };
}
function SendReportRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date_from": value.dateFrom === void 0 ? void 0 : toLocalDateString(value.dateFrom),
    "date_to": value.dateTo === void 0 ? void 0 : toLocalDateString(value.dateTo),
    "email": value.email
  };
}

// src/generated/models/SetPrimaryVariantRequest.ts
function instanceOfSetPrimaryVariantRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "productId" in value;
  isInstance = isInstance && "variantId" in value;
  return isInstance;
}
function SetPrimaryVariantRequestFromJSON(json) {
  return SetPrimaryVariantRequestFromJSONTyped(json, false);
}
function SetPrimaryVariantRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["product_id"],
    "variantId": json["variant_id"]
  };
}
function SetPrimaryVariantRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "product_id": value.productId,
    "variant_id": value.variantId
  };
}

// src/generated/models/TaskCreateOrUpdateDTO.ts
function instanceOfTaskCreateOrUpdateDTO(value) {
  let isInstance = true;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "description" in value;
  return isInstance;
}
function TaskCreateOrUpdateDTOFromJSON(json) {
  return TaskCreateOrUpdateDTOFromJSONTyped(json, false);
}
function TaskCreateOrUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectId": json["project_id"],
    "name": json["name"],
    "description": json["description"],
    "labelIds": !exists(json, "label_ids") ? void 0 : json["label_ids"],
    "products": !exists(json, "products") ? void 0 : json["products"].map(ControlPanelProductsToTaskFromJSON),
    "formTemplateIds": !exists(json, "form_template_ids") ? void 0 : json["form_template_ids"],
    "active": !exists(json, "active") ? void 0 : json["active"]
  };
}
function TaskCreateOrUpdateDTOToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "project_id": value.projectId,
    "name": value.name,
    "description": value.description,
    "label_ids": value.labelIds,
    "products": value.products === void 0 ? void 0 : value.products.map(ControlPanelProductsToTaskToJSON),
    "form_template_ids": value.formTemplateIds,
    "active": value.active
  };
}

// src/generated/models/UpdateCardListing200ResponseData.ts
function instanceOfUpdateCardListing200ResponseData(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateCardListing200ResponseDataFromJSON(json) {
  return UpdateCardListing200ResponseDataFromJSONTyped(json, false);
}
function UpdateCardListing200ResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "card": !exists(json, "card") ? void 0 : CardFromJSON(json["card"]),
    "task": !exists(json, "task") ? void 0 : TaskReadDTOFromJSON(json["task"]),
    "absence": !exists(json, "absence") ? void 0 : AbsenceFromJSON(json["absence"])
  };
}
function UpdateCardListing200ResponseDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "card": CardToJSON(value.card),
    "task": TaskReadDTOToJSON(value.task),
    "absence": AbsenceToJSON(value.absence)
  };
}

// src/generated/models/UpdateCardListing200Response.ts
function instanceOfUpdateCardListing200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UpdateCardListing200ResponseFromJSON(json) {
  return UpdateCardListing200ResponseFromJSONTyped(json, false);
}
function UpdateCardListing200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": UpdateCardListing200ResponseDataFromJSON(json["data"])
  };
}
function UpdateCardListing200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": UpdateCardListing200ResponseDataToJSON(value.data)
  };
}

// src/generated/models/UpdateCardListingRequest.ts
function instanceOfUpdateCardListingRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "card" in value;
  isInstance = isInstance && "fromIndexes" in value;
  isInstance = isInstance && "toIndexes" in value;
  return isInstance;
}
function UpdateCardListingRequestFromJSON(json) {
  return UpdateCardListingRequestFromJSONTyped(json, false);
}
function UpdateCardListingRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "card": CardUpdateDTOFromJSON(json["card"]),
    "task": !exists(json, "task") ? void 0 : TaskCreateOrUpdateDTOFromJSON(json["task"]),
    "absence": !exists(json, "absence") ? void 0 : AbsenceCreateOrUpdateDTOFromJSON(json["absence"]),
    "fromIndexes": json["from_indexes"],
    "toIndexes": json["to_indexes"]
  };
}
function UpdateCardListingRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "card": CardUpdateDTOToJSON(value.card),
    "task": TaskCreateOrUpdateDTOToJSON(value.task),
    "absence": AbsenceCreateOrUpdateDTOToJSON(value.absence),
    "from_indexes": value.fromIndexes,
    "to_indexes": value.toIndexes
  };
}

// src/generated/models/UpdateUserIntegrationSettingRequestIntegrationSettingsInner.ts
function instanceOfUpdateUserIntegrationSettingRequestIntegrationSettingsInner(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSON(json) {
  return UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSONTyped(json, false);
}
function UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationSettingId": !exists(json, "integration_setting_id") ? void 0 : json["integration_setting_id"],
    "value": !exists(json, "value") ? void 0 : json["value"]
  };
}
function UpdateUserIntegrationSettingRequestIntegrationSettingsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integration_setting_id": value.integrationSettingId,
    "value": value.value
  };
}

// src/generated/models/UpdateUserIntegrationSettingRequest.ts
function instanceOfUpdateUserIntegrationSettingRequest(value) {
  let isInstance = true;
  return isInstance;
}
function UpdateUserIntegrationSettingRequestFromJSON(json) {
  return UpdateUserIntegrationSettingRequestFromJSONTyped(json, false);
}
function UpdateUserIntegrationSettingRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationSettings": !exists(json, "integration_settings") ? void 0 : json["integration_settings"].map(UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSON)
  };
}
function UpdateUserIntegrationSettingRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integration_settings": value.integrationSettings === void 0 ? void 0 : value.integrationSettings.map(UpdateUserIntegrationSettingRequestIntegrationSettingsInnerToJSON)
  };
}

// src/generated/models/UploadExpenseFile200Response.ts
function instanceOfUploadExpenseFile200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  return isInstance;
}
function UploadExpenseFile200ResponseFromJSON(json) {
  return UploadExpenseFile200ResponseFromJSONTyped(json, false);
}
function UploadExpenseFile200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": !exists(json, "data") ? void 0 : ExpenseFromJSON(json["data"])
  };
}
function UploadExpenseFile200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": ExpenseToJSON(value.data)
  };
}

// src/generated/models/UsersGetKpiCards200ResponseDataInner.ts
var UsersGetKpiCards200ResponseDataInnerTypeEnum = {
  Hours: "hours",
  Currency: "currency",
  Number: "number"
};
function instanceOfUsersGetKpiCards200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "label" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function UsersGetKpiCards200ResponseDataInnerFromJSON(json) {
  return UsersGetKpiCards200ResponseDataInnerFromJSONTyped(json, false);
}
function UsersGetKpiCards200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "label": json["label"],
    "type": !exists(json, "type") ? void 0 : json["type"],
    "value": json["value"],
    "showDescription": !exists(json, "show_description") ? void 0 : json["show_description"],
    "showLink": !exists(json, "show_link") ? void 0 : json["show_link"]
  };
}
function UsersGetKpiCards200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/generated/models/UsersGetKpiCards200Response.ts
function instanceOfUsersGetKpiCards200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersGetKpiCards200ResponseFromJSON(json) {
  return UsersGetKpiCards200ResponseFromJSONTyped(json, false);
}
function UsersGetKpiCards200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(UsersGetKpiCards200ResponseDataInnerFromJSON)
  };
}
function UsersGetKpiCards200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(UsersGetKpiCards200ResponseDataInnerToJSON)
  };
}

// src/generated/models/UsersGetSpecified200ResponseDataInner.ts
var UsersGetSpecified200ResponseDataInnerTypeEnum = {
  Form: "form",
  Absence: "absence"
};
function instanceOfUsersGetSpecified200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "projectId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "formDate" in value;
  isInstance = isInstance && "approved" in value;
  isInstance = isInstance && "invoiced" in value;
  isInstance = isInstance && "deleted" in value;
  return isInstance;
}
function UsersGetSpecified200ResponseDataInnerFromJSON(json) {
  return UsersGetSpecified200ResponseDataInnerFromJSONTyped(json, false);
}
function UsersGetSpecified200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "type": json["type"],
    "projectId": json["project_id"],
    "projectName": !exists(json, "project_name") ? void 0 : json["project_name"],
    "userId": json["user_id"],
    "formDate": new Date(json["form_date"]),
    "approved": json["approved"] === null ? null : new Date(json["approved"]),
    "invoiced": json["invoiced"] === null ? null : new Date(json["invoiced"]),
    "deleted": json["deleted"],
    "workDescription": !exists(json, "work_description") ? void 0 : json["work_description"],
    "preview": !exists(json, "preview") ? void 0 : json["preview"],
    "totalHours": !exists(json, "total_hours") ? void 0 : json["total_hours"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "fields": !exists(json, "fields") ? void 0 : json["fields"].map(FormFieldFromJSON),
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(KpiChardHoursIndividualEntryFromJSON)
  };
}
function UsersGetSpecified200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": UserToJSON(value.user),
    "fields": value.fields === void 0 ? void 0 : value.fields.map(FormFieldToJSON)
  };
}

// src/generated/models/UsersGetSpecified200Response.ts
function instanceOfUsersGetSpecified200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersGetSpecified200ResponseFromJSON(json) {
  return UsersGetSpecified200ResponseFromJSONTyped(json, false);
}
function UsersGetSpecified200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(UsersGetSpecified200ResponseDataInnerFromJSON)
  };
}
function UsersGetSpecified200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(UsersGetSpecified200ResponseDataInnerToJSON)
  };
}

// src/generated/models/UsersGetWeekly200ResponseDateRangeInner.ts
function instanceOfUsersGetWeekly200ResponseDateRangeInner(value) {
  let isInstance = true;
  return isInstance;
}
function UsersGetWeekly200ResponseDateRangeInnerFromJSON(json) {
  return UsersGetWeekly200ResponseDateRangeInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseDateRangeInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "week": !exists(json, "week") ? void 0 : json["week"],
    "fromDate": !exists(json, "from_date") ? void 0 : new Date(json["from_date"]),
    "toDate": !exists(json, "to_date") ? void 0 : new Date(json["to_date"])
  };
}
function UsersGetWeekly200ResponseDateRangeInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "week": value.week,
    "from_date": value.fromDate === void 0 ? void 0 : value.fromDate.toISOString(),
    "to_date": value.toDate === void 0 ? void 0 : value.toDate.toISOString()
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "absenceType" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": new Date(json["date"]),
    "absenceType": json["absence_type"],
    "startTime": !exists(json, "start_time") ? void 0 : new Date(json["start_time"]),
    "value": json["value"]
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "date": value.date.toISOString(),
    "absence_type": value.absenceType,
    "start_time": value.startTime === void 0 ? void 0 : value.startTime.toISOString(),
    "value": value.value
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "formId" in value;
  isInstance = isInstance && "entryType" in value;
  isInstance = isInstance && "timeUnit" in value;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "range" in value;
  isInstance = isInstance && "isSummable" in value;
  isInstance = isInstance && "isAbsence" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": new Date(json["date"]),
    "formId": json["form_id"],
    "entryType": json["entry_type"],
    "formApproved": !exists(json, "form_approved") ? void 0 : json["form_approved"] === null ? null : new Date(json["form_approved"]),
    "timeUnit": json["time_unit"],
    "total": json["total"],
    "range": json["range"],
    "isSummable": json["is_summable"],
    "isAbsence": json["is_absence"]
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "date": value.date.toISOString(),
    "form_id": value.formId,
    "entry_type": value.entryType,
    "form_approved": value.formApproved === void 0 ? void 0 : value.formApproved === null ? null : value.formApproved.toISOString(),
    "time_unit": value.timeUnit,
    "total": value.total,
    "range": value.range,
    "is_summable": value.isSummable,
    "is_absence": value.isAbsence
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "approved" in value;
  isInstance = isInstance && "label" in value;
  isInstance = isInstance && "disabled" in value;
  isInstance = isInstance && "entries" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": !exists(json, "date") ? void 0 : new Date(json["date"]),
    "approved": json["approved"] === null ? null : new Date(json["approved"]),
    "formPdf": !exists(json, "form_pdf") ? void 0 : json["form_pdf"],
    "workDescription": !exists(json, "work_description") ? void 0 : json["work_description"],
    "label": json["label"],
    "startTime": !exists(json, "start_time") ? void 0 : json["start_time"],
    "endTime": !exists(json, "end_time") ? void 0 : json["end_time"],
    "pause": !exists(json, "pause") ? void 0 : json["pause"],
    "disabled": json["disabled"],
    "entries": json["entries"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSON)
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "date": value.date === void 0 ? void 0 : value.date.toISOString(),
    "approved": value.approved === null ? null : value.approved.toISOString(),
    "form_pdf": value.formPdf,
    "label": value.label,
    "start_time": value.startTime,
    "end_time": value.endTime,
    "pause": value.pause,
    "disabled": value.disabled,
    "entries": value.entries.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerToJSON)
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "yearWeek" in value;
  isInstance = isInstance && "forms" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "yearWeek": json["year_week"],
    "streetName": !exists(json, "street_name") ? void 0 : json["street_name"],
    "cityName": !exists(json, "city_name") ? void 0 : json["city_name"],
    "zipCode": !exists(json, "zip_code") ? void 0 : json["zip_code"],
    "forms": json["forms"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSON)
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "year_week": value.yearWeek,
    "street_name": value.streetName,
    "city_name": value.cityName,
    "zip_code": value.zipCode,
    "forms": value.forms.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerToJSON)
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInner(value) {
  let isInstance = true;
  isInstance = isInstance && "date" in value;
  isInstance = isInstance && "value" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "value": json["value"]
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": value.date.toISOString(),
    "value": value.value
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInnerWeeksInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "week" in value;
  isInstance = isInstance && "year" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "week": json["week"],
    "year": json["year"],
    "sumHours": !exists(json, "sum_hours") ? void 0 : json["sum_hours"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSON),
    "notApprovedHours": !exists(json, "not_approved_hours") ? void 0 : json["not_approved_hours"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSON),
    "absences": !exists(json, "absences") ? void 0 : json["absences"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSON),
    "projects": !exists(json, "projects") ? void 0 : json["projects"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSON)
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "week": value.week,
    "year": value.year,
    "sum_hours": value.sumHours === void 0 ? void 0 : value.sumHours.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerToJSON),
    "not_approved_hours": value.notApprovedHours === void 0 ? void 0 : value.notApprovedHours.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerToJSON),
    "absences": value.absences === void 0 ? void 0 : value.absences.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerToJSON),
    "projects": value.projects === void 0 ? void 0 : value.projects.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerToJSON)
  };
}

// src/generated/models/UsersGetWeekly200ResponseWeeklyViewInner.ts
function instanceOfUsersGetWeekly200ResponseWeeklyViewInner(value) {
  let isInstance = true;
  isInstance = isInstance && "user" in value;
  isInstance = isInstance && "weeks" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseWeeklyViewInnerFromJSON(json) {
  return UsersGetWeekly200ResponseWeeklyViewInnerFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseWeeklyViewInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "user": UserFromJSON(json["user"]),
    "weeks": json["weeks"].map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSON)
  };
}
function UsersGetWeekly200ResponseWeeklyViewInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": UserToJSON(value.user),
    "weeks": value.weeks.map(UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerToJSON)
  };
}

// src/generated/models/UsersGetWeekly200Response.ts
function instanceOfUsersGetWeekly200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "canApproveForms" in value;
  isInstance = isInstance && "dateRange" in value;
  isInstance = isInstance && "weeklyView" in value;
  return isInstance;
}
function UsersGetWeekly200ResponseFromJSON(json) {
  return UsersGetWeekly200ResponseFromJSONTyped(json, false);
}
function UsersGetWeekly200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "canApproveForms": json["can_approve_forms"],
    "dateRange": json["date_range"].map(UsersGetWeekly200ResponseDateRangeInnerFromJSON),
    "weeklyView": json["weekly_view"].map(UsersGetWeekly200ResponseWeeklyViewInnerFromJSON)
  };
}
function UsersGetWeekly200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "can_approve_forms": value.canApproveForms,
    "date_range": value.dateRange.map(UsersGetWeekly200ResponseDateRangeInnerToJSON),
    "weekly_view": value.weeklyView.map(UsersGetWeekly200ResponseWeeklyViewInnerToJSON)
  };
}

// src/generated/models/UsersPriceGroupsList200Response.ts
function instanceOfUsersPriceGroupsList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersPriceGroupsList200ResponseFromJSON(json) {
  return UsersPriceGroupsList200ResponseFromJSONTyped(json, false);
}
function UsersPriceGroupsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(UsersPriceGroupFromJSON)
  };
}
function UsersPriceGroupsList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(UsersPriceGroupToJSON)
  };
}

// src/generated/models/UsersPriceGroupsList200ResponseAllOf.ts
function instanceOfUsersPriceGroupsList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersPriceGroupsList200ResponseAllOfFromJSON(json) {
  return UsersPriceGroupsList200ResponseAllOfFromJSONTyped(json, false);
}
function UsersPriceGroupsList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(UsersPriceGroupFromJSON)
  };
}
function UsersPriceGroupsList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(UsersPriceGroupToJSON)
  };
}

// src/generated/models/UsersPriceGroupsView200Response.ts
function instanceOfUsersPriceGroupsView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersPriceGroupsView200ResponseFromJSON(json) {
  return UsersPriceGroupsView200ResponseFromJSONTyped(json, false);
}
function UsersPriceGroupsView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": UsersPriceGroupFromJSON(json["data"])
  };
}
function UsersPriceGroupsView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": UsersPriceGroupToJSON(value.data)
  };
}

// src/generated/models/UsersProductsUsageEntry.ts
var UsersProductsUsageEntryOriginEnum = {
  Registration: "registration"
};
function instanceOfUsersProductsUsageEntry(value) {
  let isInstance = true;
  isInstance = isInstance && "amount" in value;
  isInstance = isInstance && "formId" in value;
  isInstance = isInstance && "formDate" in value;
  isInstance = isInstance && "origin" in value;
  return isInstance;
}
function UsersProductsUsageEntryFromJSON(json) {
  return UsersProductsUsageEntryFromJSONTyped(json, false);
}
function UsersProductsUsageEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amount": json["amount"],
    "formId": json["form_id"],
    "formDate": new Date(json["form_date"]),
    "origin": json["origin"]
  };
}
function UsersProductsUsageEntryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amount": value.amount,
    "form_id": value.formId,
    "form_date": value.formDate.toISOString()
  };
}

// src/generated/models/UsersProductsUsageEntity.ts
function instanceOfUsersProductsUsageEntity(value) {
  let isInstance = true;
  isInstance = isInstance && "amount" in value;
  isInstance = isInstance && "productId" in value;
  isInstance = isInstance && "productNumber" in value;
  isInstance = isInstance && "productName" in value;
  isInstance = isInstance && "formId" in value;
  isInstance = isInstance && "userId" in value;
  isInstance = isInstance && "buyingPrice" in value;
  isInstance = isInstance && "sellingPrice" in value;
  return isInstance;
}
function UsersProductsUsageEntityFromJSON(json) {
  return UsersProductsUsageEntityFromJSONTyped(json, false);
}
function UsersProductsUsageEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amount": json["amount"],
    "productId": json["product_id"],
    "productNumber": json["product_number"],
    "productName": json["product_name"],
    "formId": json["form_id"],
    "userId": json["user_id"],
    "buyingPrice": json["buying_price"],
    "sellingPrice": json["selling_price"],
    "entries": !exists(json, "entries") ? void 0 : json["entries"].map(UsersProductsUsageEntryFromJSON)
  };
}
function UsersProductsUsageEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amount": value.amount,
    "product_id": value.productId,
    "product_number": value.productNumber,
    "product_name": value.productName,
    "form_id": value.formId,
    "user_id": value.userId,
    "buying_price": value.buyingPrice,
    "selling_price": value.sellingPrice,
    "entries": value.entries === void 0 ? void 0 : value.entries.map(UsersProductsUsageEntryToJSON)
  };
}

// src/generated/models/UsersProductsUsage200ResponseDataInner.ts
function instanceOfUsersProductsUsage200ResponseDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "user" in value;
  isInstance = isInstance && "products" in value;
  return isInstance;
}
function UsersProductsUsage200ResponseDataInnerFromJSON(json) {
  return UsersProductsUsage200ResponseDataInnerFromJSONTyped(json, false);
}
function UsersProductsUsage200ResponseDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "user": UserFromJSON(json["user"]),
    "products": json["products"].map(UsersProductsUsageEntityFromJSON)
  };
}
function UsersProductsUsage200ResponseDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "user": UserToJSON(value.user),
    "products": value.products.map(UsersProductsUsageEntityToJSON)
  };
}

// src/generated/models/UsersProductsUsage200Response.ts
function instanceOfUsersProductsUsage200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersProductsUsage200ResponseFromJSON(json) {
  return UsersProductsUsage200ResponseFromJSONTyped(json, false);
}
function UsersProductsUsage200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": json["data"].map(UsersProductsUsage200ResponseDataInnerFromJSON)
  };
}
function UsersProductsUsage200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": value.data.map(UsersProductsUsage200ResponseDataInnerToJSON)
  };
}

// src/generated/models/UsersView200Response.ts
function instanceOfUsersView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function UsersView200ResponseFromJSON(json) {
  return UsersView200ResponseFromJSONTyped(json, false);
}
function UsersView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": UserFromJSON(json["data"])
  };
}
function UsersView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": UserToJSON(value.data)
  };
}

// src/generated/models/VendorAllOf.ts
function instanceOfVendorAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function VendorAllOfFromJSON(json) {
  return VendorAllOfFromJSONTyped(json, false);
}
function VendorAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cvr": !exists(json, "cvr") ? void 0 : json["cvr"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "identifier": !exists(json, "identifier") ? void 0 : json["identifier"],
    "imageUrl": !exists(json, "image_url") ? void 0 : json["image_url"],
    "supportAutomaticPriceFiles": !exists(json, "support_automatic_price_files") ? void 0 : json["support_automatic_price_files"]
  };
}
function VendorAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cvr": value.cvr,
    "email": value.email,
    "identifier": value.identifier,
    "image_url": value.imageUrl,
    "support_automatic_price_files": value.supportAutomaticPriceFiles
  };
}

// src/generated/models/VendorProductsList200ResponseAllOfDataInner.ts
var VendorProductsList200ResponseAllOfDataInnerBuyingPriceSourceEnum = {
  PriceFile: "price_file",
  VendorGrossPrice: "vendor_gross_price"
};
function instanceOfVendorProductsList200ResponseAllOfDataInner(value) {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "created" in value;
  isInstance = isInstance && "modified" in value;
  return isInstance;
}
function VendorProductsList200ResponseAllOfDataInnerFromJSON(json) {
  return VendorProductsList200ResponseAllOfDataInnerFromJSONTyped(json, false);
}
function VendorProductsList200ResponseAllOfDataInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdById": !exists(json, "created_by_id") ? void 0 : json["created_by_id"],
    "vendorId": !exists(json, "vendor_id") ? void 0 : json["vendor_id"],
    "vendor": !exists(json, "vendor") ? void 0 : VendorFromJSON(json["vendor"]),
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productNumber": !exists(json, "product_number") ? void 0 : json["product_number"],
    "productCategoryNumber": !exists(json, "product_category_number") ? void 0 : json["product_category_number"],
    "barcode": !exists(json, "barcode") ? void 0 : json["barcode"],
    "imageUrls": !exists(json, "image_urls") ? void 0 : ImageUrlsFromJSON(json["image_urls"]),
    "imageMimeType": !exists(json, "image_mime_type") ? void 0 : json["image_mime_type"],
    "buyingPrice": !exists(json, "buying_price") ? void 0 : json["buying_price"],
    "buyingPriceSource": !exists(json, "buying_price_source") ? void 0 : json["buying_price_source"],
    "sellingPrice": !exists(json, "selling_price") ? void 0 : json["selling_price"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "unitName": !exists(json, "unit_name") ? void 0 : json["unit_name"],
    "unitFactor": !exists(json, "unit_factor") ? void 0 : json["unit_factor"],
    "pricePerUnit": !exists(json, "price_per_unit") ? void 0 : json["price_per_unit"],
    "priceHistory": !exists(json, "price_history") ? void 0 : json["price_history"] === null ? null : json["price_history"].map(VendorProductPriceFromJSON),
    "created": new Date(json["created"]),
    "modified": new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function VendorProductsList200ResponseAllOfDataInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "vendor_id": value.vendorId,
    "name": value.name,
    "description": value.description,
    "product_number": value.productNumber,
    "product_category_number": value.productCategoryNumber,
    "barcode": value.barcode,
    "image_urls": ImageUrlsToJSON(value.imageUrls),
    "image_mime_type": value.imageMimeType,
    "buying_price": value.buyingPrice,
    "buying_price_source": value.buyingPriceSource,
    "selling_price": value.sellingPrice,
    "price": value.price,
    "unit_name": value.unitName,
    "unit_factor": value.unitFactor,
    "price_per_unit": value.pricePerUnit
  };
}

// src/generated/models/VendorProductView200Response.ts
function instanceOfVendorProductView200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function VendorProductView200ResponseFromJSON(json) {
  return VendorProductView200ResponseFromJSONTyped(json, false);
}
function VendorProductView200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "data": VendorProductsList200ResponseAllOfDataInnerFromJSON(json["data"])
  };
}
function VendorProductView200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "data": VendorProductsList200ResponseAllOfDataInnerToJSON(value.data)
  };
}

// src/generated/models/VendorProductsList200Response.ts
function instanceOfVendorProductsList200Response(value) {
  let isInstance = true;
  isInstance = isInstance && "success" in value;
  isInstance = isInstance && "pagination" in value;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function VendorProductsList200ResponseFromJSON(json) {
  return VendorProductsList200ResponseFromJSONTyped(json, false);
}
function VendorProductsList200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"],
    "pagination": PaginationDetailsFromJSON(json["pagination"]),
    "data": json["data"].map(VendorProductsList200ResponseAllOfDataInnerFromJSON)
  };
}
function VendorProductsList200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "success": value.success,
    "pagination": PaginationDetailsToJSON(value.pagination),
    "data": value.data.map(VendorProductsList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/VendorProductsList200ResponseAllOf.ts
function instanceOfVendorProductsList200ResponseAllOf(value) {
  let isInstance = true;
  isInstance = isInstance && "data" in value;
  return isInstance;
}
function VendorProductsList200ResponseAllOfFromJSON(json) {
  return VendorProductsList200ResponseAllOfFromJSONTyped(json, false);
}
function VendorProductsList200ResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"].map(VendorProductsList200ResponseAllOfDataInnerFromJSON)
  };
}
function VendorProductsList200ResponseAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": value.data.map(VendorProductsList200ResponseAllOfDataInnerToJSON)
  };
}

// src/generated/models/VendorProductsList200ResponseAllOfDataInnerAllOf.ts
var VendorProductsList200ResponseAllOfDataInnerAllOfBuyingPriceSourceEnum = {
  PriceFile: "price_file",
  VendorGrossPrice: "vendor_gross_price"
};
function instanceOfVendorProductsList200ResponseAllOfDataInnerAllOf(value) {
  let isInstance = true;
  return isInstance;
}
function VendorProductsList200ResponseAllOfDataInnerAllOfFromJSON(json) {
  return VendorProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, false);
}
function VendorProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "buyingPriceSource": !exists(json, "buying_price_source") ? void 0 : json["buying_price_source"]
  };
}
function VendorProductsList200ResponseAllOfDataInnerAllOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "buying_price_source": value.buyingPriceSource
  };
}

// src/generated/models/VerifyResetTokenRequest.ts
function instanceOfVerifyResetTokenRequest(value) {
  let isInstance = true;
  isInstance = isInstance && "token" in value;
  return isInstance;
}
function VerifyResetTokenRequestFromJSON(json) {
  return VerifyResetTokenRequestFromJSONTyped(json, false);
}
function VerifyResetTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}
function VerifyResetTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token
  };
}

// src/generated/models/WallComment.ts
function instanceOfWallComment(value) {
  let isInstance = true;
  isInstance = isInstance && "message" in value;
  return isInstance;
}
function WallCommentFromJSON(json) {
  return WallCommentFromJSONTyped(json, false);
}
function WallCommentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"],
    "userId": !exists(json, "user_id") ? void 0 : json["user_id"],
    "user": !exists(json, "user") ? void 0 : UserFromJSON(json["user"]),
    "wallPostId": !exists(json, "wall_post_id") ? void 0 : json["wall_post_id"],
    "created": !exists(json, "created") ? void 0 : new Date(json["created"]),
    "modified": !exists(json, "modified") ? void 0 : new Date(json["modified"]),
    "deleted": !exists(json, "deleted") ? void 0 : json["deleted"] === null ? null : new Date(json["deleted"])
  };
}
function WallCommentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "message": value.message,
    "user_id": value.userId,
    "user": UserToJSON(value.user),
    "wall_post_id": value.wallPostId
  };
}

// src/generated/apis/DefaultApi.ts
var DefaultApi = class extends BaseAPI {
  /**
   * Create contact person
   */
  addContactPersonRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling addContactPerson.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/{contact_id}/contact_persons`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddContactPersonRequestToJSON(requestParameters.addContactPersonRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create contact person
   */
  addContactPerson(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.addContactPersonRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create offer line
   */
  addOfferLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling addOfferLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferLineToJSON(requestParameters.offerLine)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create offer line
   */
  addOfferLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.addOfferLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Hide prices on individual offer lines and add a total price line
   */
  addTotalPriceLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling addTotalPriceLine.");
      }
      if (requestParameters.offerLine === null || requestParameters.offerLine === void 0) {
        throw new RequiredError("offerLine", "Required parameter requestParameters.offerLine was null or undefined when calling addTotalPriceLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/add-total-price-line`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.offerLine.map(OfferLineToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GatherOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Hide prices on individual offer lines and add a total price line
   */
  addTotalPriceLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.addTotalPriceLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Add expense line or vendor product as product variant
   */
  addVariantRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/add-variant`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddVariantRequestToJSON(requestParameters.addVariantRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Add expense line or vendor product as product variant
   */
  addVariant() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.addVariantRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get or create default APV project
   */
  apvDefaultProjectRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/apv-form-templates/get-project`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ApvDefaultProject200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get or create default APV project
   */
  apvDefaultProject(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.apvDefaultProjectRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * List apv form templates
   */
  apvFormTemplatesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/apv-form-templates`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => FormTemplatesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List apv form templates
   */
  apvFormTemplatesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.apvFormTemplatesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Search for address for autocomplete usage
   */
  autoCompleteAddressRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.address === null || requestParameters.address === void 0) {
        throw new RequiredError("address", "Required parameter requestParameters.address was null or undefined when calling autoCompleteAddress.");
      }
      const queryParameters = {};
      if (requestParameters.address !== void 0) {
        queryParameters["address"] = requestParameters.address;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/address-lookup/autocomplete`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => AutoCompleteAddress200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Search for address for autocomplete usage
   */
  autoCompleteAddress(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.autoCompleteAddressRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mark registrations as invoiced for selected projects
   */
  bulkMarkAsInvoicedRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.bulkMarkAsInvoicedRequest === null || requestParameters.bulkMarkAsInvoicedRequest === void 0) {
        throw new RequiredError("bulkMarkAsInvoicedRequest", "Required parameter requestParameters.bulkMarkAsInvoicedRequest was null or undefined when calling bulkMarkAsInvoiced.");
      }
      const queryParameters = {};
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/registrations/bulk-mark-as-invoiced`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: BulkMarkAsInvoicedRequestToJSON(requestParameters.bulkMarkAsInvoicedRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => BulkMarkAsInvoiced200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mark registrations as invoiced for selected projects
   */
  bulkMarkAsInvoiced(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.bulkMarkAsInvoicedRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Calculates the payment due date for a given invoice and payment term.
   * Calculate Payment Due Date
   */
  calculateInvoiceDueDateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.calculateInvoiceDueDateRequest === null || requestParameters.calculateInvoiceDueDateRequest === void 0) {
        throw new RequiredError("calculateInvoiceDueDateRequest", "Required parameter requestParameters.calculateInvoiceDueDateRequest was null or undefined when calling calculateInvoiceDueDate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/calculate-payment-due-date`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CalculateInvoiceDueDateRequestToJSON(requestParameters.calculateInvoiceDueDateRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CalculateInvoiceDueDate200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Calculates the payment due date for a given invoice and payment term.
   * Calculate Payment Due Date
   */
  calculateInvoiceDueDate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.calculateInvoiceDueDateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete list of cards and re-index affected cards
   */
  cardsDeleteManyRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardsDeleteManyRequest === null || requestParameters.cardsDeleteManyRequest === void 0) {
        throw new RequiredError("cardsDeleteManyRequest", "Required parameter requestParameters.cardsDeleteManyRequest was null or undefined when calling cardsDeleteMany.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/cards/delete-many`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: CardsDeleteManyRequestToJSON(requestParameters.cardsDeleteManyRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete list of cards and re-index affected cards
   */
  cardsDeleteMany(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.cardsDeleteManyRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Change password to a specific user
   */
  changePasswordRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling changePassword.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/change-password/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ChangePasswordRequestToJSON(requestParameters.changePasswordRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Change password to a specific user
   */
  changePassword(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.changePasswordRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Change a password by submitting token and new password
   */
  changePasswordWithTokenRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.changePasswordWithTokenRequest === null || requestParameters.changePasswordWithTokenRequest === void 0) {
        throw new RequiredError("changePasswordWithTokenRequest", "Required parameter requestParameters.changePasswordWithTokenRequest was null or undefined when calling changePasswordWithToken.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      const response = yield this.request({
        path: `/control-panel-api/v1/login/change-password`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ChangePasswordWithTokenRequestToJSON(requestParameters.changePasswordWithTokenRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => RequestResetPassword200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Change a password by submitting token and new password
   */
  changePasswordWithToken(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.changePasswordWithTokenRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Change status of the selected forms
   */
  changeStatusRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling changeStatus.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/forms/change-status`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ChangeStatusRequestToJSON(requestParameters.changeStatusRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Change status of the selected forms
   */
  changeStatus(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.changeStatusRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create(check in) clocking record
   */
  checkInRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/clocking-records/add`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CheckInRequestToJSON(requestParameters.checkInRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create(check in) clocking record
   */
  checkIn() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.checkInRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Check out clocking record
   */
  checkOutRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/clocking-records/check_out`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CheckOutRequestToJSON(requestParameters.checkOutRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Check out clocking record
   */
  checkOut() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.checkOutRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create absence
   */
  createAbsenceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absences`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateAbsenceRequestToJSON(requestParameters.createAbsenceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsence201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create absence
   */
  createAbsence() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createAbsenceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create absence type
   */
  createAbsenceTypeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absence-types`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateAbsenceTypeRequestToJSON(requestParameters.createAbsenceTypeRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create absence type
   */
  createAbsenceType() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createAbsenceTypeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create card
   */
  createCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cards`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CardUpdateDTOToJSON(requestParameters.cardUpdateDTO)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create card
   */
  createCard() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Creates absences and card at the same time
   * Create absences and card
   */
  createCardAndAbsencesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.createCardAndAbsencesRequest === null || requestParameters.createCardAndAbsencesRequest === void 0) {
        throw new RequiredError("createCardAndAbsencesRequest", "Required parameter requestParameters.createCardAndAbsencesRequest was null or undefined when calling createCardAndAbsences.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/planning/cards-and-absences`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCardAndAbsencesRequestToJSON(requestParameters.createCardAndAbsencesRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateCardAndAbsences201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Creates absences and card at the same time
   * Create absences and card
   */
  createCardAndAbsences(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.createCardAndAbsencesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Creates a task and card at the same time
   * Create task and card
   */
  createCardAndTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.createCardAndTaskRequest === null || requestParameters.createCardAndTaskRequest === void 0) {
        throw new RequiredError("createCardAndTaskRequest", "Required parameter requestParameters.createCardAndTaskRequest was null or undefined when calling createCardAndTask.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/planning/task-and-card`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCardAndTaskRequestToJSON(requestParameters.createCardAndTaskRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateCardAndTask201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Creates a task and card at the same time
   * Create task and card
   */
  createCardAndTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.createCardAndTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create contact
   */
  createContactRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/contacts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateContactRequestToJSON(requestParameters.createContactRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create contact
   */
  createContact() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createContactRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create custom email template
   */
  createCustomEmailTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/custom-email-templates`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCustomEmailTemplateRequestToJSON(requestParameters.createCustomEmailTemplateRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create custom email template
   */
  createCustomEmailTemplate() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createCustomEmailTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create expense
   */
  createExpenseRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateExpenseRequestToJSON(requestParameters.createExpenseRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create expense
   */
  createExpense() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createExpenseRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create a draft expense from a vendor-invoice PDF and queue AI extraction
   */
  createExpenseFromFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.file === null || requestParameters.file === void 0) {
        throw new RequiredError("file", "Required parameter requestParameters.file was null or undefined when calling createExpenseFromFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/create-from-file`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateExpenseFromFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create a draft expense from a vendor-invoice PDF and queue AI extraction
   */
  createExpenseFromFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.createExpenseFromFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create form with form fields
   */
  createFormRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/forms`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateFormRequestToJSON(requestParameters.createFormRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create form with form fields
   */
  createForm() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createFormRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create invoice
   */
  createInvoiceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateInvoiceRequestToJSON(requestParameters.createInvoiceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create invoice
   */
  createInvoice() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createInvoiceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create label
   */
  createLabelRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/labels`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateLabelRequestToJSON(requestParameters.createLabelRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create label
   */
  createLabel() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createLabelRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create offer
   */
  createOfferRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditOfferRequestToJSON(requestParameters.editOfferRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create offer
   */
  createOffer() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createOfferRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create product
   */
  createProductRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateProductRequestToJSON(requestParameters.createProductRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create product
   */
  createProduct() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createProductRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create project custom field attribute
   */
  createProjectCustomFieldAttributeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-custom-field-attributes`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateProjectCustomFieldAttributeRequestToJSON(requestParameters.createProjectCustomFieldAttributeRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create project custom field attribute
   */
  createProjectCustomFieldAttribute() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createProjectCustomFieldAttributeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create task
   */
  createTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/tasks`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TaskCreateOrUpdateDTOToJSON(requestParameters.taskCreateOrUpdateDTO)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create task
   */
  createTask() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create template
   */
  createTextTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/text-templates`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateTextTemplateRequestToJSON(requestParameters.createTextTemplateRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create template
   */
  createTextTemplate() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createTextTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create user
   */
  createUserRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateUserRequestToJSON(requestParameters.createUserRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create user
   */
  createUser() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createUserRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a company custom email templates
   */
  customEmailTemplateViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling customEmailTemplateView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/custom-email-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CustomEmailTemplateView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a company custom email templates
   */
  customEmailTemplateView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.customEmailTemplateViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Search CVR by company name
   */
  cvrSearchByNameRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.companyName === null || requestParameters.companyName === void 0) {
        throw new RequiredError("companyName", "Required parameter requestParameters.companyName was null or undefined when calling cvrSearchByName.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/cvr_look_up/search/{companyName}`.replace(`{${"companyName"}}`, encodeURIComponent(String(requestParameters.companyName))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CvrSearchByName200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Search CVR by company name
   */
  cvrSearchByName(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.cvrSearchByNameRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete absence
   */
  deleteAbsenceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceId === null || requestParameters.absenceId === void 0) {
        throw new RequiredError("absenceId", "Required parameter requestParameters.absenceId was null or undefined when calling deleteAbsence.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absences/{absence_id}`.replace(`{${"absence_id"}}`, encodeURIComponent(String(requestParameters.absenceId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete absence
   */
  deleteAbsence(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteAbsenceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete absence type
   */
  deleteAbsenceTypeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceTypeId === null || requestParameters.absenceTypeId === void 0) {
        throw new RequiredError("absenceTypeId", "Required parameter requestParameters.absenceTypeId was null or undefined when calling deleteAbsenceType.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absence-types/{absence_type_id}`.replace(`{${"absence_type_id"}}`, encodeURIComponent(String(requestParameters.absenceTypeId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete absence type
   */
  deleteAbsenceType(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteAbsenceTypeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete card
   */
  deleteCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling deleteCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cards/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete card
   */
  deleteCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete contact
   */
  deleteContactRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling deleteContact.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/contacts/{contact_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete contact
   */
  deleteContact(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteContactRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete contact person
   */
  deleteContactPersonRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling deleteContactPerson.");
      }
      if (requestParameters.contactPersonId === null || requestParameters.contactPersonId === void 0) {
        throw new RequiredError("contactPersonId", "Required parameter requestParameters.contactPersonId was null or undefined when calling deleteContactPerson.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/{contact_id}/contact_persons/{contact_person_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))).replace(`{${"contact_person_id"}}`, encodeURIComponent(String(requestParameters.contactPersonId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete contact person
   */
  deleteContactPerson(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteContactPersonRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete expense
   */
  deleteExpenseRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.expenseId === null || requestParameters.expenseId === void 0) {
        throw new RequiredError("expenseId", "Required parameter requestParameters.expenseId was null or undefined when calling deleteExpense.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/{expense_id}`.replace(`{${"expense_id"}}`, encodeURIComponent(String(requestParameters.expenseId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete expense
   */
  deleteExpense(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteExpenseRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete expense files
   */
  deleteExpenseFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.expenseId === null || requestParameters.expenseId === void 0) {
        throw new RequiredError("expenseId", "Required parameter requestParameters.expenseId was null or undefined when calling deleteExpenseFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/delete-files/{expense_id}`.replace(`{${"expense_id"}}`, encodeURIComponent(String(requestParameters.expenseId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete expense files
   */
  deleteExpenseFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteExpenseFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete form
   */
  deleteFormRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.formId === null || requestParameters.formId === void 0) {
        throw new RequiredError("formId", "Required parameter requestParameters.formId was null or undefined when calling deleteForm.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/forms/{form_id}`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete form
   */
  deleteForm(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteFormRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete invoice
   */
  deleteInvoiceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling deleteInvoice.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/invoices/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete invoice
   */
  deleteInvoice(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteInvoiceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete invoice file
   */
  deleteInvoiceFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling deleteInvoiceFile.");
      }
      if (requestParameters.requestBody === null || requestParameters.requestBody === void 0) {
        throw new RequiredError("requestBody", "Required parameter requestParameters.requestBody was null or undefined when calling deleteInvoiceFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/files/delete`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.requestBody
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete invoice file
   */
  deleteInvoiceFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteInvoiceFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete label
   */
  deleteLabelRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.labelId === null || requestParameters.labelId === void 0) {
        throw new RequiredError("labelId", "Required parameter requestParameters.labelId was null or undefined when calling deleteLabel.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/labels/{label_id}`.replace(`{${"label_id"}}`, encodeURIComponent(String(requestParameters.labelId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete label
   */
  deleteLabel(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteLabelRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete offer file
   */
  deleteOfferFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling deleteOfferFile.");
      }
      if (requestParameters.requestBody === null || requestParameters.requestBody === void 0) {
        throw new RequiredError("requestBody", "Required parameter requestParameters.requestBody was null or undefined when calling deleteOfferFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/files/delete`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.requestBody
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete offer file
   */
  deleteOfferFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteOfferFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete offer line
   */
  deleteOfferLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling deleteOfferLine.");
      }
      if (requestParameters.offerLineId === null || requestParameters.offerLineId === void 0) {
        throw new RequiredError("offerLineId", "Required parameter requestParameters.offerLineId was null or undefined when calling deleteOfferLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/{offer_line_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))).replace(`{${"offer_line_id"}}`, encodeURIComponent(String(requestParameters.offerLineId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete offer line
   */
  deleteOfferLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteOfferLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete product
   */
  deleteProductRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productId === null || requestParameters.productId === void 0) {
        throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling deleteProduct.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/{product_id}`.replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.productId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete product
   */
  deleteProduct(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteProductRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete product variants
   */
  deleteProductVariantsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/delete-variants`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteProductVariantsRequestToJSON(requestParameters.deleteProductVariantsRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete product variants
   */
  deleteProductVariants() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.deleteProductVariantsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete project custom field attribute
   */
  deleteProjectCustomFieldAttributeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectCustomFieldAttributeId === null || requestParameters.projectCustomFieldAttributeId === void 0) {
        throw new RequiredError("projectCustomFieldAttributeId", "Required parameter requestParameters.projectCustomFieldAttributeId was null or undefined when calling deleteProjectCustomFieldAttribute.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-custom-field-attributes/{project_custom_field_attribute_id}`.replace(`{${"project_custom_field_attribute_id"}}`, encodeURIComponent(String(requestParameters.projectCustomFieldAttributeId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete project custom field attribute
   */
  deleteProjectCustomFieldAttribute(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteProjectCustomFieldAttributeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete task
   */
  deleteTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling deleteTask.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete task
   */
  deleteTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete text template
   */
  deleteTextTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.textTemplateId === null || requestParameters.textTemplateId === void 0) {
        throw new RequiredError("textTemplateId", "Required parameter requestParameters.textTemplateId was null or undefined when calling deleteTextTemplate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/text-templates/{text_template_id}`.replace(`{${"text_template_id"}}`, encodeURIComponent(String(requestParameters.textTemplateId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete text template
   */
  deleteTextTemplate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteTextTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete user
   */
  deleteUserRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling deleteUser.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete user
   */
  deleteUser(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteUserRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Distribution Hours Over Products
   */
  distributionHoursOverProductsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling distributionHoursOverProducts.");
      }
      if (requestParameters.offerLine === null || requestParameters.offerLine === void 0) {
        throw new RequiredError("offerLine", "Required parameter requestParameters.offerLine was null or undefined when calling distributionHoursOverProducts.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/distribution-hours-over-products`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.offerLine.map(OfferLineToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GatherOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Distribution Hours Over Products
   */
  distributionHoursOverProducts(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.distributionHoursOverProductsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Duplicate form
   */
  duplicateFormRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.formId === null || requestParameters.formId === void 0) {
        throw new RequiredError("formId", "Required parameter requestParameters.formId was null or undefined when calling duplicateForm.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/forms/duplicate/{formId}`.replace(`{${"formId"}}`, encodeURIComponent(String(requestParameters.formId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Duplicate form
   */
  duplicateForm(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.duplicateFormRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Duplicate invoice
   */
  duplicateInvoiceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling duplicateInvoice.");
      }
      const queryParameters = {};
      if (requestParameters.asCreditNote !== void 0) {
        queryParameters["as_credit_note"] = requestParameters.asCreditNote;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/duplicate/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DuplicateInvoiceRequestToJSON(requestParameters.duplicateInvoiceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Duplicate invoice
   */
  duplicateInvoice(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.duplicateInvoiceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Duplicate project
   */
  duplicateProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling duplicateProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/duplicate/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Duplicate project
   */
  duplicateProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.duplicateProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit absence
   */
  editAbsenceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceId === null || requestParameters.absenceId === void 0) {
        throw new RequiredError("absenceId", "Required parameter requestParameters.absenceId was null or undefined when calling editAbsence.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absences/{absence_id}`.replace(`{${"absence_id"}}`, encodeURIComponent(String(requestParameters.absenceId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateAbsenceRequestToJSON(requestParameters.createAbsenceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit absence
   */
  editAbsence(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editAbsenceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit absence type
   */
  editAbsenceTypeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceTypeId === null || requestParameters.absenceTypeId === void 0) {
        throw new RequiredError("absenceTypeId", "Required parameter requestParameters.absenceTypeId was null or undefined when calling editAbsenceType.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absence-types/{absence_type_id}`.replace(`{${"absence_type_id"}}`, encodeURIComponent(String(requestParameters.absenceTypeId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateAbsenceTypeRequestToJSON(requestParameters.createAbsenceTypeRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit absence type
   */
  editAbsenceType(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editAbsenceTypeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit card
   */
  editCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling editCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cards/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CardUpdateDTOToJSON(requestParameters.cardUpdateDTO)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit card
   */
  editCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit contact
   */
  editContactRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling editContact.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/contacts/{contact_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ContactToJSON(requestParameters.contact)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit contact
   */
  editContact(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editContactRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit contact person
   */
  editContactPersonRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling editContactPerson.");
      }
      if (requestParameters.contactPersonId === null || requestParameters.contactPersonId === void 0) {
        throw new RequiredError("contactPersonId", "Required parameter requestParameters.contactPersonId was null or undefined when calling editContactPerson.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/{contact_id}/contact_persons/{contact_person_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))).replace(`{${"contact_person_id"}}`, encodeURIComponent(String(requestParameters.contactPersonId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditContactPersonRequestToJSON(requestParameters.editContactPersonRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit contact person
   */
  editContactPerson(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editContactPersonRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit custom email template
   */
  editCustomEmailTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling editCustomEmailTemplate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/custom-email-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCustomEmailTemplateRequestToJSON(requestParameters.createCustomEmailTemplateRequest)
      }, initOverrides);
      return new VoidApiResponse(response);
    });
  }
  /**
   * Edit custom email template
   */
  editCustomEmailTemplate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      yield this.editCustomEmailTemplateRaw(requestParameters, initOverrides);
    });
  }
  /**
   * Edit expense
   */
  editExpenseRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.expenseId === null || requestParameters.expenseId === void 0) {
        throw new RequiredError("expenseId", "Required parameter requestParameters.expenseId was null or undefined when calling editExpense.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/{expense_id}`.replace(`{${"expense_id"}}`, encodeURIComponent(String(requestParameters.expenseId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditExpenseRequestToJSON(requestParameters.editExpenseRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit expense
   */
  editExpense(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editExpenseRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit invoice
   */
  editInvoiceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling editInvoice.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditInvoiceRequestToJSON(requestParameters.editInvoiceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit invoice
   */
  editInvoice(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editInvoiceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit label
   */
  editLabelRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.labelId === null || requestParameters.labelId === void 0) {
        throw new RequiredError("labelId", "Required parameter requestParameters.labelId was null or undefined when calling editLabel.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/labels/{label_id}`.replace(`{${"label_id"}}`, encodeURIComponent(String(requestParameters.labelId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateLabelRequestToJSON(requestParameters.createLabelRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit label
   */
  editLabel(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editLabelRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit offer
   */
  editOfferRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling editOffer.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditOfferRequestToJSON(requestParameters.editOfferRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit offer
   */
  editOffer(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editOfferRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit offer line
   */
  editOfferLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling editOfferLine.");
      }
      if (requestParameters.offerLineId === null || requestParameters.offerLineId === void 0) {
        throw new RequiredError("offerLineId", "Required parameter requestParameters.offerLineId was null or undefined when calling editOfferLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/{offer_line_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))).replace(`{${"offer_line_id"}}`, encodeURIComponent(String(requestParameters.offerLineId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: OfferLineToJSON(requestParameters.offerLine)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit offer line
   */
  editOfferLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editOfferLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit product
   */
  editProductRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productId === null || requestParameters.productId === void 0) {
        throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling editProduct.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/{product_id}`.replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.productId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateProductRequestToJSON(requestParameters.createProductRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit product
   */
  editProduct(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editProductRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit project custom field attribute
   */
  editProjectCustomFieldAttributeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectCustomFieldAttributeId === null || requestParameters.projectCustomFieldAttributeId === void 0) {
        throw new RequiredError("projectCustomFieldAttributeId", "Required parameter requestParameters.projectCustomFieldAttributeId was null or undefined when calling editProjectCustomFieldAttribute.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-custom-field-attributes/{project_custom_field_attribute_id}`.replace(`{${"project_custom_field_attribute_id"}}`, encodeURIComponent(String(requestParameters.projectCustomFieldAttributeId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateProjectCustomFieldAttributeRequestToJSON(requestParameters.createProjectCustomFieldAttributeRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit project custom field attribute
   */
  editProjectCustomFieldAttribute(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editProjectCustomFieldAttributeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit subscription
   */
  editSubscriptionRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === void 0) {
        throw new RequiredError("subscriptionId", "Required parameter requestParameters.subscriptionId was null or undefined when calling editSubscription.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/subscriptions/{subscription_id}`.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditSubscriptionRequestToJSON(requestParameters.editSubscriptionRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit subscription
   */
  editSubscription(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editSubscriptionRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit task
   */
  editTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling editTask.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: TaskCreateOrUpdateDTOToJSON(requestParameters.taskCreateOrUpdateDTO)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit task
   */
  editTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit text template
   */
  editTextTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.textTemplateId === null || requestParameters.textTemplateId === void 0) {
        throw new RequiredError("textTemplateId", "Required parameter requestParameters.textTemplateId was null or undefined when calling editTextTemplate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/text-templates/{text_template_id}`.replace(`{${"text_template_id"}}`, encodeURIComponent(String(requestParameters.textTemplateId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditTextTemplateRequestToJSON(requestParameters.editTextTemplateRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit text template
   */
  editTextTemplate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editTextTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit user
   */
  editUserRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling editUser.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: EditUserRequestToJSON(requestParameters.editUserRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit user
   */
  editUser(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.editUserRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List expense lines
   */
  expenseLinesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.vendorId !== void 0) {
        queryParameters["vendor_id"] = requestParameters.vendorId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expense-lines`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ExpenseLinesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List expense lines
   */
  expenseLinesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.expenseLinesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View expense lines
   */
  expenseLinesViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.expenseId === null || requestParameters.expenseId === void 0) {
        throw new RequiredError("expenseId", "Required parameter requestParameters.expenseId was null or undefined when calling expenseLinesView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expense-lines/{expense_id}`.replace(`{${"expense_id"}}`, encodeURIComponent(String(requestParameters.expenseId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ExpenseLinesView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View expense lines
   */
  expenseLinesView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.expenseLinesViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List expenses
   */
  expensesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.vendorId !== void 0) {
        queryParameters["vendor_id"] = requestParameters.vendorId;
      }
      if (requestParameters.projectId !== void 0) {
        queryParameters["project_id"] = requestParameters.projectId;
      }
      if (requestParameters.sentToEmail !== void 0) {
        queryParameters["sent_to_email"] = requestParameters.sentToEmail;
      }
      if (requestParameters.distributed !== void 0) {
        queryParameters["distributed"] = requestParameters.distributed;
      }
      if (requestParameters.deliveryOrCreatedBefore !== void 0) {
        queryParameters["delivery_or_created_before"] = toLocalDateString(requestParameters.deliveryOrCreatedBefore);
      }
      if (requestParameters.deliveryOrCreatedAfter !== void 0) {
        queryParameters["delivery_or_created_after"] = toLocalDateString(requestParameters.deliveryOrCreatedAfter);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      if (requestParameters.isBooked !== void 0) {
        queryParameters["is_booked"] = requestParameters.isBooked;
      }
      if (requestParameters.status !== void 0) {
        queryParameters["status"] = requestParameters.status;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ExpensesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List expenses
   */
  expensesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.expensesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View expense
   */
  expensesViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.expenseId === null || requestParameters.expenseId === void 0) {
        throw new RequiredError("expenseId", "Required parameter requestParameters.expenseId was null or undefined when calling expensesView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/{expense_id}`.replace(`{${"expense_id"}}`, encodeURIComponent(String(requestParameters.expenseId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ExpensesView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View expense
   */
  expensesView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.expensesViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View form template
   */
  formTemplateViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.formTemplateId === null || requestParameters.formTemplateId === void 0) {
        throw new RequiredError("formTemplateId", "Required parameter requestParameters.formTemplateId was null or undefined when calling formTemplateView.");
      }
      const queryParameters = {};
      if (requestParameters.projectId !== void 0) {
        queryParameters["project_id"] = requestParameters.projectId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/form-templates/{form_template_id}`.replace(`{${"form_template_id"}}`, encodeURIComponent(String(requestParameters.formTemplateId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => FormTemplateView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View form template
   */
  formTemplateView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.formTemplateViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List form templates
   */
  formTemplatesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/form-templates`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => FormTemplatesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List form templates
   */
  formTemplatesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.formTemplatesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View form
   */
  formViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.formId === null || requestParameters.formId === void 0) {
        throw new RequiredError("formId", "Required parameter requestParameters.formId was null or undefined when calling formView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/forms/{form_id}`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => FormView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View form
   */
  formView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.formViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List forms
   */
  formsListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.projectId) {
        queryParameters["project_id[]"] = requestParameters.projectId;
      }
      if (requestParameters.createdById !== void 0) {
        queryParameters["created_by_id"] = requestParameters.createdById;
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      if (requestParameters.formTemplateId) {
        queryParameters["form_template_id[]"] = requestParameters.formTemplateId;
      }
      if (requestParameters.isApproved !== void 0) {
        queryParameters["is_approved"] = requestParameters.isApproved;
      }
      if (requestParameters.isInvoicedFrom !== void 0) {
        queryParameters["is_invoiced_from"] = toLocalDateString(requestParameters.isInvoicedFrom);
      }
      if (requestParameters.isInvoicedTo !== void 0) {
        queryParameters["is_invoiced_to"] = toLocalDateString(requestParameters.isInvoicedTo);
      }
      if (requestParameters.isNotInvoiced !== void 0) {
        queryParameters["is_not_invoiced"] = requestParameters.isNotInvoiced;
      }
      if (requestParameters.activities) {
        queryParameters["activities"] = requestParameters.activities;
      }
      if (requestParameters.approved !== void 0) {
        queryParameters["approved"] = requestParameters.approved;
      }
      if (requestParameters.documentType !== void 0) {
        queryParameters["document_type"] = requestParameters.documentType;
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.userIds) {
        queryParameters["user_ids[]"] = requestParameters.userIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/forms`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => FormsList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List forms
   */
  formsList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.formsListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Gather offer line
   */
  gatherOfferLinesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling gatherOfferLines.");
      }
      if (requestParameters.offerLine === null || requestParameters.offerLine === void 0) {
        throw new RequiredError("offerLine", "Required parameter requestParameters.offerLine was null or undefined when calling gatherOfferLines.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/gather-offer-lines`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.offerLine.map(OfferLineToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GatherOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Gather offer line
   */
  gatherOfferLines(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.gatherOfferLinesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Generate salary file
   */
  generateSalaryFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/generate-salary-file`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new BlobApiResponse(response);
    });
  }
  /**
   * Generate salary file
   */
  generateSalaryFile() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.generateSalaryFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View absence
   */
  getAbsenceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceId === null || requestParameters.absenceId === void 0) {
        throw new RequiredError("absenceId", "Required parameter requestParameters.absenceId was null or undefined when calling getAbsence.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absences/{absence_id}`.replace(`{${"absence_id"}}`, encodeURIComponent(String(requestParameters.absenceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetAbsence200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View absence
   */
  getAbsence(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getAbsenceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View absence type
   */
  getAbsenceTypeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.absenceTypeId === null || requestParameters.absenceTypeId === void 0) {
        throw new RequiredError("absenceTypeId", "Required parameter requestParameters.absenceTypeId was null or undefined when calling getAbsenceType.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absence-types/{absence_type_id}`.replace(`{${"absence_type_id"}}`, encodeURIComponent(String(requestParameters.absenceTypeId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View absence type
   */
  getAbsenceType(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getAbsenceTypeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List absence types
   */
  getAbsenceTypesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absence-types`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetAbsenceTypes200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List absence types
   */
  getAbsenceTypes() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getAbsenceTypesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List absence
   */
  getAbsencesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.dateIntervalFrom !== void 0) {
        queryParameters["dateInterval[from]"] = toLocalDateString(requestParameters.dateIntervalFrom);
      }
      if (requestParameters.dateIntervalTo !== void 0) {
        queryParameters["dateInterval[to]"] = toLocalDateString(requestParameters.dateIntervalTo);
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/absences`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetAbsences200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List absence
   */
  getAbsences() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getAbsencesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get registrations for project
   */
  getAllRegistrationsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling getAllRegistrations.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.allUsers !== void 0) {
        queryParameters["all_users"] = requestParameters.allUsers;
      }
      if (requestParameters.approved !== void 0) {
        queryParameters["approved"] = requestParameters.approved;
      }
      if (requestParameters.documentType !== void 0) {
        queryParameters["document_type"] = requestParameters.documentType;
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/registrations`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetAllRegistrations200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get registrations for project
   */
  getAllRegistrations(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getAllRegistrationsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View card
   */
  getCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling getCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cards/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View card
   */
  getCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List cards
   */
  getCardsWithTaskAndUsersRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.dateBefore === null || requestParameters.dateBefore === void 0) {
        throw new RequiredError("dateBefore", "Required parameter requestParameters.dateBefore was null or undefined when calling getCardsWithTaskAndUsers.");
      }
      if (requestParameters.dateAfter === null || requestParameters.dateAfter === void 0) {
        throw new RequiredError("dateAfter", "Required parameter requestParameters.dateAfter was null or undefined when calling getCardsWithTaskAndUsers.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = requestParameters.dateBefore.toISOString();
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = requestParameters.dateAfter.toISOString();
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      if (requestParameters.projectId !== void 0) {
        queryParameters["project_id"] = requestParameters.projectId;
      }
      if (requestParameters.taskId !== void 0) {
        queryParameters["task_id"] = requestParameters.taskId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/cards/all-cards`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCardsWithTaskAndUsers200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List cards
   */
  getCardsWithTaskAndUsers(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCardsWithTaskAndUsersRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List cities
   */
  getCitiesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.zipCode !== void 0) {
        queryParameters["zip_code"] = requestParameters.zipCode;
      }
      if (requestParameters.name !== void 0) {
        queryParameters["name"] = requestParameters.name;
      }
      if (requestParameters.includeAll !== void 0) {
        queryParameters["include_all"] = requestParameters.includeAll;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cities`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCities200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List cities
   */
  getCities() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getCitiesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View city
   */
  getCityRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cityId === null || requestParameters.cityId === void 0) {
        throw new RequiredError("cityId", "Required parameter requestParameters.cityId was null or undefined when calling getCity.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/cities/{city_id}`.replace(`{${"city_id"}}`, encodeURIComponent(String(requestParameters.cityId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCity200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View city
   */
  getCity(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCityRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List companies
   */
  getCompaniesRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/companies`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCompanies200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List companies
   */
  getCompanies(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCompaniesRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * View company
   */
  getCompanyRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.companyId === null || requestParameters.companyId === void 0) {
        throw new RequiredError("companyId", "Required parameter requestParameters.companyId was null or undefined when calling getCompany.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/companies/{company_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCompany200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View company
   */
  getCompany(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCompanyRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View contact
   */
  getContactRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling getContact.");
      }
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/contacts/{contact_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetContact200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View contact
   */
  getContact(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getContactRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View contact person
   */
  getContactPersonRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling getContactPerson.");
      }
      if (requestParameters.contactPersonId === null || requestParameters.contactPersonId === void 0) {
        throw new RequiredError("contactPersonId", "Required parameter requestParameters.contactPersonId was null or undefined when calling getContactPerson.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/{contact_id}/contact_persons/{contact_person_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))).replace(`{${"contact_person_id"}}`, encodeURIComponent(String(requestParameters.contactPersonId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetContactPerson200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View contact person
   */
  getContactPerson(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getContactPersonRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of contact people associated with a contact
   * List contact people for contact
   */
  getContactPersonsListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.contactId === null || requestParameters.contactId === void 0) {
        throw new RequiredError("contactId", "Required parameter requestParameters.contactId was null or undefined when calling getContactPersonsList.");
      }
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.createdGte !== void 0) {
        queryParameters["created_gte"] = toLocalDateString(requestParameters.createdGte);
      }
      if (requestParameters.createdLte !== void 0) {
        queryParameters["created_lte"] = toLocalDateString(requestParameters.createdLte);
      }
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/{contact_id}/contact_persons`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetContactPersonsList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of contact people associated with a contact
   * List contact people for contact
   */
  getContactPersonsList(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getContactPersonsListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List contacts
   */
  getContactsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.labelId !== void 0) {
        queryParameters["label_id"] = requestParameters.labelId;
      }
      if (requestParameters.labelIds) {
        queryParameters["label_ids[]"] = requestParameters.labelIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/contacts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List contacts
   */
  getContacts() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getContactsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List countries
   */
  getCountriesRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/countries`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCountries200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List countries
   */
  getCountries(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getCountriesRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of email actions for specific email
   * List actions for email
   */
  getEmailActionRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.emailId === null || requestParameters.emailId === void 0) {
        throw new RequiredError("emailId", "Required parameter requestParameters.emailId was null or undefined when calling getEmailAction.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/emails/{email_id}/actions`.replace(`{${"email_id"}}`, encodeURIComponent(String(requestParameters.emailId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetEmailAction200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of email actions for specific email
   * List actions for email
   */
  getEmailAction(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getEmailActionRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Lists available features for the current user
   * List available features
   */
  getFeaturesRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/features`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetFeatures200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Lists available features for the current user
   * List available features
   */
  getFeatures(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getFeaturesRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of integration types associated with a user
   * Return user integration types
   */
  getIntegrationTypesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling getIntegrationTypes.");
      }
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/integration-types/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetIntegrationTypes200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of integration types associated with a user
   * Return user integration types
   */
  getIntegrationTypes(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getIntegrationTypesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get invoice activity log
   */
  getInvoiceActivityLogRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceActivityLog.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/actions`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoiceActivityLog200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get invoice activity log
   */
  getInvoiceActivityLog(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getInvoiceActivityLogRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of invoice emails for specific invoice
   * List invoice emails
   */
  getInvoiceEmailsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceEmails.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/emails`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoiceEmails200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of invoice emails for specific invoice
   * List invoice emails
   */
  getInvoiceEmails(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getInvoiceEmailsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of invoice files for specific invoice
   * List invoice files for invoice
   */
  getInvoiceFilesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceFiles.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/files`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoiceFiles200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of invoice files for specific invoice
   * List invoice files for invoice
   */
  getInvoiceFiles(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getInvoiceFilesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List invoices
   */
  getInvoicesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      if (requestParameters.contactId !== void 0) {
        queryParameters["contact_id"] = requestParameters.contactId;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/invoices`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoices200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List invoices
   */
  getInvoices() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getInvoicesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View label
   */
  getLabelRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.labelId === null || requestParameters.labelId === void 0) {
        throw new RequiredError("labelId", "Required parameter requestParameters.labelId was null or undefined when calling getLabel.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/labels/{label_id}`.replace(`{${"label_id"}}`, encodeURIComponent(String(requestParameters.labelId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetLabel200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View label
   */
  getLabel(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getLabelRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List labels
   */
  getLabelsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.entity !== void 0) {
        queryParameters["entity"] = requestParameters.entity;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/labels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetLabels200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List labels
   */
  getLabels() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getLabelsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List languages
   */
  getLanguagesRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/languages`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetLanguages200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List languages
   */
  getLanguages(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getLanguagesRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * View currently authenticated user
   */
  getMeRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/users/me`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetMe200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View currently authenticated user
   */
  getMe(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getMeRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of action logs for a specific offer
   * List action logs for offer
   */
  getOfferActionLogsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferActionLogs.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/action-logs/offers/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetOfferActionLogs200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of action logs for a specific offer
   * List action logs for offer
   */
  getOfferActionLogs(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferActionLogsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of offer actions for specific offer
   * List offer actions for offer
   */
  getOfferActionsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferActions.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/actions`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetOfferActions200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of offer actions for specific offer
   * List offer actions for offer
   */
  getOfferActions(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferActionsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of offer emails for specific offer
   * List offer emails
   */
  getOfferEmailsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferEmails.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/emails`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoiceEmails200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of offer emails for specific offer
   * List offer emails
   */
  getOfferEmails(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferEmailsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of offer files for specific offer
   * List offer files for offer
   */
  getOfferFilesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferFiles.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/files`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetInvoiceFiles200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of offer files for specific offer
   * List offer files for offer
   */
  getOfferFiles(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferFilesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View offer line
   */
  getOfferLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferLine.");
      }
      if (requestParameters.offerLineId === null || requestParameters.offerLineId === void 0) {
        throw new RequiredError("offerLineId", "Required parameter requestParameters.offerLineId was null or undefined when calling getOfferLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/{offer_line_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))).replace(`{${"offer_line_id"}}`, encodeURIComponent(String(requestParameters.offerLineId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetOfferLine200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View offer line
   */
  getOfferLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a list of offer lines for specific offer
   * List offer lines for offer
   */
  getOfferLinesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferLines.");
      }
      const queryParameters = {};
      if (requestParameters.applyRules !== void 0) {
        queryParameters["apply_rules"] = requestParameters.applyRules;
      }
      if (requestParameters.token !== void 0) {
        queryParameters["token"] = requestParameters.token;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a list of offer lines for specific offer
   * List offer lines for offer
   */
  getOfferLines(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferLinesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get offer PDF for specific offer
   * Get offer PDF for offer
   */
  getOfferPdfRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling getOfferPdf.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/files/pdf`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetOfferPdf200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get offer PDF for specific offer
   * Get offer PDF for offer
   */
  getOfferPdf(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getOfferPdfRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List payment terms
   */
  getPaymentTermsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/payment-terms`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetPaymentTerms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List payment terms
   */
  getPaymentTerms(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getPaymentTermsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * View project custom field attribute
   */
  getProductCustomFieldAttributeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectCustomFieldAttributeId === null || requestParameters.projectCustomFieldAttributeId === void 0) {
        throw new RequiredError("projectCustomFieldAttributeId", "Required parameter requestParameters.projectCustomFieldAttributeId was null or undefined when calling getProductCustomFieldAttribute.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-custom-field-attributes/{project_custom_field_attribute_id}`.replace(`{${"project_custom_field_attribute_id"}}`, encodeURIComponent(String(requestParameters.projectCustomFieldAttributeId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetProductCustomFieldAttribute200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View project custom field attribute
   */
  getProductCustomFieldAttribute(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getProductCustomFieldAttributeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View project
   */
  getProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling getProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/projects/{project_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetProject200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View project
   */
  getProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List project custom field attributes
   */
  getProjectCustomFieldAttributesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-custom-field-attributes`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetProjectCustomFieldAttributes200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List project custom field attributes
   */
  getProjectCustomFieldAttributes() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getProjectCustomFieldAttributesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List projects
   */
  getProjectsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      if (requestParameters.contactId !== void 0) {
        queryParameters["contact_id"] = requestParameters.contactId;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.showAll !== void 0) {
        queryParameters["show_all"] = requestParameters.showAll;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/projects`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetProjects200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List projects
   */
  getProjects() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getProjectsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get release notes
   */
  getReleaseNotesRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/release-notes-proxy`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      if (this.isJsonMime(response.headers.get("content-type"))) {
        return new JSONApiResponse(response);
      } else {
        return new TextApiResponse(response);
      }
    });
  }
  /**
   * Get release notes
   */
  getReleaseNotes(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getReleaseNotesRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * View task
   */
  getTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling getTask.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTask200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View task
   */
  getTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a task product
   */
  getTaskProductRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling getTaskProduct.");
      }
      if (requestParameters.taskProductId === null || requestParameters.taskProductId === void 0) {
        throw new RequiredError("taskProductId", "Required parameter requestParameters.taskProductId was null or undefined when calling getTaskProduct.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/tasks/{taskId}/products/{taskProductId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))).replace(`{${"taskProductId"}}`, encodeURIComponent(String(requestParameters.taskProductId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTaskProduct200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a task product
   */
  getTaskProduct(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getTaskProductRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List products for a task
   */
  getTaskProductsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling getTaskProducts.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/tasks/{taskId}/products`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTaskProducts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List products for a task
   */
  getTaskProducts(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getTaskProductsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List tasks
   */
  getTasksRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/tasks`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListTasks200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List tasks
   */
  getTasks() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getTasksRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View text template
   */
  getTextTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.textTemplateId === null || requestParameters.textTemplateId === void 0) {
        throw new RequiredError("textTemplateId", "Required parameter requestParameters.textTemplateId was null or undefined when calling getTextTemplate.");
      }
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/text-templates/{text_template_id}`.replace(`{${"text_template_id"}}`, encodeURIComponent(String(requestParameters.textTemplateId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTextTemplate200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View text template
   */
  getTextTemplate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getTextTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List text templates
   */
  getTextTemplatesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.visible !== void 0) {
        queryParameters["visible"] = requestParameters.visible;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/text-templates`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTextTemplates200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List text templates
   */
  getTextTemplates() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getTextTemplatesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List time entry rule groups
   */
  getTimeEntryRuleGroupsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/time-entry-rule-groups`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetTimeEntryRuleGroups200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List time entry rule groups
   */
  getTimeEntryRuleGroups(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getTimeEntryRuleGroupsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * List users
   */
  getUsersRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.isActive !== void 0) {
        queryParameters["is_active"] = requestParameters.isActive;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/users`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetUsers200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List users
   */
  getUsers() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getUsersRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View vendor
   */
  getVendorRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.vendorId === null || requestParameters.vendorId === void 0) {
        throw new RequiredError("vendorId", "Required parameter requestParameters.vendorId was null or undefined when calling getVendor.");
      }
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/vendors/{vendor_id}`.replace(`{${"vendor_id"}}`, encodeURIComponent(String(requestParameters.vendorId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetVendor200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View vendor
   */
  getVendor(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getVendorRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List vendors
   */
  getVendorsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.withPriceFile !== void 0) {
        queryParameters["with_price_file"] = requestParameters.withPriceFile;
      }
      if (requestParameters.withExpense !== void 0) {
        queryParameters["with_expense"] = requestParameters.withExpense;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/vendors`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetVendors200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List vendors
   */
  getVendors() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getVendorsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View wall post
   */
  getWallPostRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling getWallPost.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View wall post
   */
  getWallPost(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.getWallPostRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List wall posts
   */
  getWallPostsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.projectId !== void 0) {
        queryParameters["project_id"] = requestParameters.projectId;
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetWallPosts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List wall posts
   */
  getWallPosts() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getWallPostsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Group offer lines by product and hours
   */
  groupByProductAndHoursRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling groupByProductAndHours.");
      }
      if (requestParameters.offerLine === null || requestParameters.offerLine === void 0) {
        throw new RequiredError("offerLine", "Required parameter requestParameters.offerLine was null or undefined when calling groupByProductAndHours.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/group-by-product-and-hours`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.offerLine.map(OfferLineToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GatherOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Group offer lines by product and hours
   */
  groupByProductAndHours(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.groupByProductAndHoursRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Company has certain integration type based on the identifier
   * Check if company has integration by identifier
   */
  hasIntegrationOfTypeRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.identifier === null || requestParameters.identifier === void 0) {
        throw new RequiredError("identifier", "Required parameter requestParameters.identifier was null or undefined when calling hasIntegrationOfType.");
      }
      const queryParameters = {};
      if (requestParameters.identifier !== void 0) {
        queryParameters["identifier"] = requestParameters.identifier;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/has-integration-type`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => HasIntegrationOfType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Company has certain integration type based on the identifier
   * Check if company has integration by identifier
   */
  hasIntegrationOfType(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.hasIntegrationOfTypeRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create product bundle
   */
  iCreateProductBundleRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProductBundleRequestToJSON(requestParameters.iCreateProductBundleRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create product bundle
   */
  iCreateProductBundle() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iCreateProductBundleRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create product bundle line
   */
  iCreateProductBundleLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iCreateProductBundleLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}/product-bundle-lines`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProductBundleLineRequestToJSON(requestParameters.iCreateProductBundleLineRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create product bundle line
   */
  iCreateProductBundleLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iCreateProductBundleLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create project
   */
  iCreateProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProjectRequestToJSON(requestParameters.iCreateProjectRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create project
   */
  iCreateProject() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iCreateProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create users price group
   */
  iCreateUsersPriceGroupRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users-price-groups`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UsersPriceGroupToJSON(requestParameters.usersPriceGroup)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create users price group
   */
  iCreateUsersPriceGroup() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iCreateUsersPriceGroupRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create wall post comment
   */
  iCreateWallCommentRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iCreateWallComment.");
      }
      if (requestParameters.wallComment === null || requestParameters.wallComment === void 0) {
        throw new RequiredError("wallComment", "Required parameter requestParameters.wallComment was null or undefined when calling iCreateWallComment.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/comments`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: WallCommentToJSON(requestParameters.wallComment)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create wall post comment
   */
  iCreateWallComment(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iCreateWallCommentRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete card
   */
  iDeleteCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling iDeleteCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/cards/delete/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: IDeleteCardRequestToJSON(requestParameters.iDeleteCardRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IDeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete card
   */
  iDeleteCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete offer
   */
  iDeleteOfferRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling iDeleteOffer.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete offer
   */
  iDeleteOffer(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteOfferRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete product bundle
   */
  iDeleteProductBundleRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iDeleteProductBundle.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete product bundle
   */
  iDeleteProductBundle(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteProductBundleRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete project
   */
  iDeleteProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iDeleteProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete project
   */
  iDeleteProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete wall post comment
   */
  iDeleteWallCommentRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iDeleteWallComment.");
      }
      if (requestParameters.commentId === null || requestParameters.commentId === void 0) {
        throw new RequiredError("commentId", "Required parameter requestParameters.commentId was null or undefined when calling iDeleteWallComment.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/comments/{commentId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete wall post comment
   */
  iDeleteWallComment(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteWallCommentRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete wall post
   */
  iDeleteWallPostRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iDeleteWallPost.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete wall post
   */
  iDeleteWallPost(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iDeleteWallPostRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit product bundle
   */
  iEditProductBundleRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iEditProductBundle.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProductBundleRequestToJSON(requestParameters.iCreateProductBundleRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit product bundle
   */
  iEditProductBundle(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditProductBundleRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit product bundle line
   */
  iEditProductBundleLineRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iEditProductBundleLine.");
      }
      if (requestParameters.productBundleLineId === null || requestParameters.productBundleLineId === void 0) {
        throw new RequiredError("productBundleLineId", "Required parameter requestParameters.productBundleLineId was null or undefined when calling iEditProductBundleLine.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}/product-bundle-lines/{productBundleLineId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))).replace(`{${"productBundleLineId"}}`, encodeURIComponent(String(requestParameters.productBundleLineId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProductBundleLineRequestToJSON(requestParameters.iCreateProductBundleLineRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit product bundle line
   */
  iEditProductBundleLine(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditProductBundleLineRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit project
   */
  iEditProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iEditProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: ICreateProjectRequestToJSON(requestParameters.iCreateProjectRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit project
   */
  iEditProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit users price group
   */
  iEditUsersPriceGroupRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.usersPriceGroupId === null || requestParameters.usersPriceGroupId === void 0) {
        throw new RequiredError("usersPriceGroupId", "Required parameter requestParameters.usersPriceGroupId was null or undefined when calling iEditUsersPriceGroup.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users-price-groups/{usersPriceGroupId}`.replace(`{${"usersPriceGroupId"}}`, encodeURIComponent(String(requestParameters.usersPriceGroupId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: UsersPriceGroupToJSON(requestParameters.usersPriceGroup)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit users price group
   */
  iEditUsersPriceGroup(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditUsersPriceGroupRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Update wall post comment
   */
  iEditWallCommentRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iEditWallComment.");
      }
      if (requestParameters.commentId === null || requestParameters.commentId === void 0) {
        throw new RequiredError("commentId", "Required parameter requestParameters.commentId was null or undefined when calling iEditWallComment.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/comments/{commentId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: IEditWallCommentRequestToJSON(requestParameters.iEditWallCommentRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Update wall post comment
   */
  iEditWallComment(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditWallCommentRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Update wall post
   */
  iEditWallPostRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iEditWallPost.");
      }
      if (requestParameters.wallPost === null || requestParameters.wallPost === void 0) {
        throw new RequiredError("wallPost", "Required parameter requestParameters.wallPost was null or undefined when calling iEditWallPost.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: WallPostToJSON(requestParameters.wallPost)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Update wall post
   */
  iEditWallPost(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iEditWallPostRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload files for form
   */
  iFormUploadFilesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.files) {
        requestParameters.files.forEach((element) => {
          formParams.append("files[]", element);
        });
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/form-files/upload`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IFormUploadFiles200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload files for form
   */
  iFormUploadFiles() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iFormUploadFilesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List activities
   */
  iGetActivitiesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/activities`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetActivities200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List activities
   */
  iGetActivities() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iGetActivitiesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get total and weekly product, working hours cost consumption
   */
  iGetConsumptionRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/frontpage/consumption`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetConsumption200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get total and weekly product, working hours cost consumption
   */
  iGetConsumption(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetConsumptionRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get a company custom email templates
   */
  iGetCustomEmailTemplatesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.type !== void 0) {
        queryParameters["type"] = requestParameters.type;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/custom-email-templates`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetCustomEmailTemplates200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get a company custom email templates
   */
  iGetCustomEmailTemplates() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iGetCustomEmailTemplatesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Returns feed items (forms, expenses, invoices, wall posts) within the specified date range. Pagination is handled by date windowing - the frontend adjusts date_from/date_to for each page. 
   * Get recent feed
   */
  iGetFeedRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/frontpage/feed`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetFeed200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Returns feed items (forms, expenses, invoices, wall posts) within the specified date range. Pagination is handled by date windowing - the frontend adjusts date_from/date_to for each page. 
   * Get recent feed
   */
  iGetFeed() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iGetFeedRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get feed for project
   */
  iGetFeedForProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iGetFeedForProject.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = requestParameters.dateBefore.toISOString();
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = requestParameters.dateAfter.toISOString();
      }
      if (requestParameters.type) {
        queryParameters["type[]"] = requestParameters.type;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/feed`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ControlPanelApiProjectFeedResponseDTOFromJSON(jsonValue));
    });
  }
  /**
   * Get feed for project
   */
  iGetFeedForProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetFeedForProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Returns metadata about the feed for the current company. Used by frontend to determine when to stop paginating (oldest_date) and where to start scrolling (newest_date). 
   * Get feed metadata
   */
  iGetFeedMetadataRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/frontpage/feed-metadata`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetFeedMetadata200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Returns metadata about the feed for the current company. Used by frontend to determine when to stop paginating (oldest_date) and where to start scrolling (newest_date). 
   * Get feed metadata
   */
  iGetFeedMetadata(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetFeedMetadataRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get total and weekly invoiced and not invoiced amounts
   */
  iGetFrontpageInvoicedRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/frontpage/invoiced`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetFrontpageInvoiced200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get total and weekly invoiced and not invoiced amounts
   */
  iGetFrontpageInvoiced(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetFrontpageInvoicedRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get invoice
   */
  iGetInvoiceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling iGetInvoice.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetInvoice200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get invoice
   */
  iGetInvoice(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetInvoiceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get project
   */
  iGetProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iGetProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetProject200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get project
   */
  iGetProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View task
   */
  iGetTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling iGetTask.");
      }
      const queryParameters = {};
      if (requestParameters.include !== void 0) {
        queryParameters["include"] = requestParameters.include;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/tasks/{task_id}`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetTask200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View task
   */
  iGetTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get tasks for project
   */
  iGetTasksForProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iGetTasksForProject.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/tasks`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetTasksForProject200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get tasks for project
   */
  iGetTasksForProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetTasksForProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View wall post comment
   */
  iGetWallCommentRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iGetWallComment.");
      }
      if (requestParameters.commentId === null || requestParameters.commentId === void 0) {
        throw new RequiredError("commentId", "Required parameter requestParameters.commentId was null or undefined when calling iGetWallComment.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/comments/{commentId}`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListWallComments200ResponseInnerFromJSON(jsonValue));
    });
  }
  /**
   * View wall post comment
   */
  iGetWallComment(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetWallCommentRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * work related data
   */
  iGetWorkRelatedRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/frontpage/work-related`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IGetWorkRelated200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * work related data
   */
  iGetWorkRelated(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iGetWorkRelatedRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Send invoice email
   */
  iInvoiceSendEmailRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling iInvoiceSendEmail.");
      }
      if (requestParameters.recipientEmail === null || requestParameters.recipientEmail === void 0) {
        throw new RequiredError("recipientEmail", "Required parameter requestParameters.recipientEmail was null or undefined when calling iInvoiceSendEmail.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.recipientEmail !== void 0) {
        formParams.append("recipient_email", requestParameters.recipientEmail);
      }
      if (requestParameters.subject !== void 0) {
        formParams.append("subject", requestParameters.subject);
      }
      if (requestParameters.body !== void 0) {
        formParams.append("body", requestParameters.body);
      }
      if (requestParameters.projectOverviewAttached !== void 0) {
        formParams.append("project_overview_attached", requestParameters.projectOverviewAttached);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/emails`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Send invoice email
   */
  iInvoiceSendEmail(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iInvoiceSendEmailRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload invoice file
   */
  iInvoiceUploadFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling iInvoiceUploadFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.files) {
        requestParameters.files.forEach((element) => {
          formParams.append("files[]", element);
        });
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/{invoice_id}/files`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload invoice file
   */
  iInvoiceUploadFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iInvoiceUploadFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List invoices
   */
  iListInvoicesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.contactId !== void 0) {
        queryParameters["contact_id"] = requestParameters.contactId;
      }
      if (requestParameters.projectId !== void 0) {
        queryParameters["project_id"] = requestParameters.projectId;
      }
      if (requestParameters.invoiceNumber !== void 0) {
        queryParameters["invoice_number"] = requestParameters.invoiceNumber;
      }
      if (requestParameters.filter !== void 0) {
        queryParameters["filter"] = requestParameters.filter;
      }
      if (requestParameters.projectName !== void 0) {
        queryParameters["project_name"] = requestParameters.projectName;
      }
      if (requestParameters.gteIssuedDate !== void 0) {
        queryParameters["gte_issued_date"] = toLocalDateString(requestParameters.gteIssuedDate);
      }
      if (requestParameters.lteIssuedDate !== void 0) {
        queryParameters["lte_issued_date"] = toLocalDateString(requestParameters.lteIssuedDate);
      }
      if (requestParameters.isCreditNote !== void 0) {
        queryParameters["is_credit_note"] = requestParameters.isCreditNote;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListInvoices200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List invoices
   */
  iListInvoices() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iListInvoicesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List Offer Statuses
   */
  iListOfferStatusesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.identifier !== void 0) {
        queryParameters["identifier"] = requestParameters.identifier;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offer-statuses`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListOfferStatuses200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List Offer Statuses
   */
  iListOfferStatuses() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iListOfferStatusesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List Project Statuses
   */
  iListProjectStatusesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.name !== void 0) {
        queryParameters["name"] = requestParameters.name;
      }
      if (requestParameters.identifier !== void 0) {
        queryParameters["identifier"] = requestParameters.identifier;
      }
      if (requestParameters.isCustom !== void 0) {
        queryParameters["is_custom"] = requestParameters.isCustom;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/project-statuses`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListProjectStatuses200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List Project Statuses
   */
  iListProjectStatuses() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iListProjectStatusesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List projects
   */
  iListProjectsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.isOffer !== void 0) {
        queryParameters["is_offer"] = requestParameters.isOffer;
      }
      if (requestParameters.includeSubprojects !== void 0) {
        queryParameters["include_subprojects"] = requestParameters.includeSubprojects;
      }
      if (requestParameters.projectStatusId !== void 0) {
        queryParameters["project_status_id"] = requestParameters.projectStatusId;
      }
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids"] = requestParameters.activityIds;
      }
      if (requestParameters.projectStatus) {
        queryParameters["project_status"] = requestParameters.projectStatus.join(COLLECTION_FORMATS["csv"]);
      }
      if (requestParameters.contactId !== void 0) {
        queryParameters["contact_id"] = requestParameters.contactId;
      }
      if (requestParameters.labelIds) {
        queryParameters["label_ids[]"] = requestParameters.labelIds;
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListProjects200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List projects
   */
  iListProjects() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iListProjectsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List tasks
   */
  iListTasksRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/tasks`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IListTasks200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List tasks
   */
  iListTasks() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iListTasksRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List wall post comments
   */
  iListWallCommentsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iListWallComments.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/comments`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => jsonValue.map(IListWallComments200ResponseInnerFromJSON));
    });
  }
  /**
   * List wall post comments
   */
  iListWallComments(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iListWallCommentsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Send offer email
   */
  iOfferSendEmailRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling iOfferSendEmail.");
      }
      if (requestParameters.recipientEmail === null || requestParameters.recipientEmail === void 0) {
        throw new RequiredError("recipientEmail", "Required parameter requestParameters.recipientEmail was null or undefined when calling iOfferSendEmail.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.recipientEmail !== void 0) {
        formParams.append("recipient_email", requestParameters.recipientEmail);
      }
      if (requestParameters.subject !== void 0) {
        formParams.append("subject", requestParameters.subject);
      }
      if (requestParameters.body !== void 0) {
        formParams.append("body", requestParameters.body);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/emails`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Send offer email
   */
  iOfferSendEmail(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iOfferSendEmailRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload offer file
   */
  iOfferUploadFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling iOfferUploadFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.files) {
        requestParameters.files.forEach((element) => {
          formParams.append("files[]", element);
        });
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/files`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload offer file
   */
  iOfferUploadFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iOfferUploadFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Duplicate product bundle
   */
  iProductBundleDuplicateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iProductBundleDuplicate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/duplicate/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Duplicate product bundle
   */
  iProductBundleDuplicate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProductBundleDuplicateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Set sales price based on contribution margin
   */
  iProductBundleSetSalesPriceRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iProductBundleSetSalesPrice.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/set-sales-price/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: IProductBundleSetSalesPriceRequestToJSON(requestParameters.iProductBundleSetSalesPriceRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleSetSalesPrice200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Set sales price based on contribution margin
   */
  iProductBundleSetSalesPrice(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProductBundleSetSalesPriceRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload a file to product bundle
   */
  iProductBundleUploadFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling iProductBundleUploadFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/add-file/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload a file to product bundle
   */
  iProductBundleUploadFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProductBundleUploadFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete project files
   */
  iProjectDeleteFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iProjectDeleteFile.");
      }
      if (requestParameters.iProjectDeleteFileRequestInner === null || requestParameters.iProjectDeleteFileRequestInner === void 0) {
        throw new RequiredError("iProjectDeleteFileRequestInner", "Required parameter requestParameters.iProjectDeleteFileRequestInner was null or undefined when calling iProjectDeleteFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/files`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.iProjectDeleteFileRequestInner.map(IProjectDeleteFileRequestInnerToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete project files
   */
  iProjectDeleteFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProjectDeleteFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List project files
   */
  iProjectListFilesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iProjectListFiles.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/files`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProjectListFiles200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List project files
   */
  iProjectListFiles(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProjectListFilesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Send one or more project files by email
   * Send project files by email
   */
  iProjectSendFilesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iProjectSendFiles.");
      }
      if (requestParameters.iProjectSendFilesRequest === null || requestParameters.iProjectSendFilesRequest === void 0) {
        throw new RequiredError("iProjectSendFilesRequest", "Required parameter requestParameters.iProjectSendFilesRequest was null or undefined when calling iProjectSendFiles.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/files/send`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: IProjectSendFilesRequestToJSON(requestParameters.iProjectSendFilesRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Send one or more project files by email
   * Send project files by email
   */
  iProjectSendFiles(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProjectSendFilesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload a project file
   */
  iProjectUploadFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iProjectUploadFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/files`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload a project file
   */
  iProjectUploadFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iProjectUploadFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Send one or more project forms by email
   * Send project forms by email
   */
  iSendProjectFormsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iSendProjectForms.");
      }
      if (requestParameters.iSendProjectFormsRequest === null || requestParameters.iSendProjectFormsRequest === void 0) {
        throw new RequiredError("iSendProjectFormsRequest", "Required parameter requestParameters.iSendProjectFormsRequest was null or undefined when calling iSendProjectForms.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/send/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ISendProjectFormsRequestToJSON(requestParameters.iSendProjectFormsRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Send one or more project forms by email
   * Send project forms by email
   */
  iSendProjectForms(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iSendProjectFormsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete a standard file
   */
  iStandardFileDeleteRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.standardFileId === null || requestParameters.standardFileId === void 0) {
        throw new RequiredError("standardFileId", "Required parameter requestParameters.standardFileId was null or undefined when calling iStandardFileDelete.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/standard-files/{standard_file_id}`.replace(`{${"standard_file_id"}}`, encodeURIComponent(String(requestParameters.standardFileId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete a standard file
   */
  iStandardFileDelete(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iStandardFileDeleteRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload standard file
   */
  iStandardFileUploadRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      if (requestParameters.type !== void 0) {
        formParams.append("type", requestParameters.type);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/standard-files`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IProductBundleUploadFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload standard file
   */
  iStandardFileUpload() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iStandardFileUploadRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List standard files
   */
  iStandardFilesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/standard-files`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IStandardFilesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List standard files
   */
  iStandardFilesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.iStandardFilesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Attach file to wall post
   */
  iWallpostAttachFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iWallpostAttachFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/files`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Attach file to wall post
   */
  iWallpostAttachFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iWallpostAttachFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Create wall post
   */
  iWallpostCreateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling iWallpostCreate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.projectId !== void 0) {
        formParams.append("project_id", requestParameters.projectId);
      }
      if (requestParameters.message !== void 0) {
        formParams.append("message", requestParameters.message);
      }
      if (requestParameters.postFiles) {
        requestParameters.postFiles.forEach((element) => {
          formParams.append("post_files[]", element);
        });
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create wall post
   */
  iWallpostCreate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iWallpostCreateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete file from wall post
   */
  iWallpostDeleteFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.postId === null || requestParameters.postId === void 0) {
        throw new RequiredError("postId", "Required parameter requestParameters.postId was null or undefined when calling iWallpostDeleteFile.");
      }
      if (requestParameters.requestBody === null || requestParameters.requestBody === void 0) {
        throw new RequiredError("requestBody", "Required parameter requestParameters.requestBody was null or undefined when calling iWallpostDeleteFile.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/wall-posts/{postId}/files`.replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.requestBody
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete file from wall post
   */
  iWallpostDeleteFile(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.iWallpostDeleteFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Add product bundle to invoice
   */
  invoiceAddProductBundleRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling invoiceAddProductBundle.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/invoices/add-product-bundle/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferAddProductBundleRequestToJSON(requestParameters.offerAddProductBundleRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Add product bundle to invoice
   */
  invoiceAddProductBundle(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.invoiceAddProductBundleRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View single invoice
   */
  invoicesViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
        throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling invoicesView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/invoices/{invoice_id}`.replace(`{${"invoice_id"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => InvoicesView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View single invoice
   */
  invoicesView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.invoicesViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Is current user checked in
   */
  isCheckedInRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/clocking-records/is_checked_in`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IsCheckedIn200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Is current user checked in
   */
  isCheckedIn(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.isCheckedInRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * List users
   */
  listUsersRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.ids) {
        queryParameters["ids[]"] = requestParameters.ids;
      }
      if (requestParameters.isActive !== void 0) {
        queryParameters["is_active"] = requestParameters.isActive;
      }
      if (requestParameters.labels) {
        queryParameters["labels[]"] = requestParameters.labels;
      }
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetUsers200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List users
   */
  listUsers() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.listUsersRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Log in with email/password
   */
  loginWithEmailRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.loginWithEmailRequest === null || requestParameters.loginWithEmailRequest === void 0) {
        throw new RequiredError("loginWithEmailRequest", "Required parameter requestParameters.loginWithEmailRequest was null or undefined when calling loginWithEmail.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      const response = yield this.request({
        path: `/api/v1/apiKey`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LoginWithEmailRequestToJSON(requestParameters.loginWithEmailRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => LoginWithEmail200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Log in with email/password
   */
  loginWithEmail(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.loginWithEmailRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Look up CVR by number
   */
  lookupCVRRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.cvr !== void 0) {
        queryParameters["cvr"] = requestParameters.cvr;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/cvr_look_up`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => LookupCVR200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Look up CVR by number
   */
  lookupCVR() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.lookupCVRRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mark all registrations as invoiced
   */
  markAsInvoicedRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling markAsInvoiced.");
      }
      const queryParameters = {};
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/registrations/mark-as-invoiced`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mark all registrations as invoiced
   */
  markAsInvoiced(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.markAsInvoicedRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Trigger background job to merge projects - can take a while depending on amount of content to move
   * Merge projects
   */
  mergeProjectsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/merge`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MergeProjectsRequestToJSON(requestParameters.mergeProjectsRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Trigger background job to merge projects - can take a while depending on amount of content to move
   * Merge projects
   */
  mergeProjects() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.mergeProjectsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Accept offer
   */
  offerAcceptRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.token !== void 0) {
        queryParameters["token"] = requestParameters.token;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/accept`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferAcceptRequestToJSON(requestParameters.offerAcceptRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Accept offer
   */
  offerAccept() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.offerAcceptRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Add product bundle to offer
   */
  offerAddProductBundleRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling offerAddProductBundle.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/add-product-bundle/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferAddProductBundleRequestToJSON(requestParameters.offerAddProductBundleRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Add product bundle to offer
   */
  offerAddProductBundle(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.offerAddProductBundleRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Reverts a previously accepted offer back to an editable draft. The auto-created project is left untouched and a cancellation email is sent to the customer. Scoped to the authenticated user\'s company.
   * Cancel an accepted offer
   */
  offerCancelRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/cancel`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferCancelRequestToJSON(requestParameters.offerCancelRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Reverts a previously accepted offer back to an editable draft. The auto-created project is left untouched and a cancellation email is sent to the customer. Scoped to the authenticated user\'s company.
   * Cancel an accepted offer
   */
  offerCancel() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.offerCancelRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Reject offer
   */
  offerRejectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.token !== void 0) {
        queryParameters["token"] = requestParameters.token;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/reject`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: OfferAcceptRequestToJSON(requestParameters.offerAcceptRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EditAbsenceType200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Reject offer
   */
  offerReject() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.offerRejectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List offers
   */
  offersListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.offerStatusId !== void 0) {
        queryParameters["offer_status_id"] = requestParameters.offerStatusId;
      }
      if (requestParameters.contactId !== void 0) {
        queryParameters["contact_id"] = requestParameters.contactId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => OffersList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List offers
   */
  offersList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.offersListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View single offer
   */
  offersViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling offersView.");
      }
      const queryParameters = {};
      if (requestParameters.token !== void 0) {
        queryParameters["token"] = requestParameters.token;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => OffersView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View single offer
   */
  offersView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.offersViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View productBundleLine
   */
  productBundleLineViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling productBundleLineView.");
      }
      if (requestParameters.productBundleLineId === null || requestParameters.productBundleLineId === void 0) {
        throw new RequiredError("productBundleLineId", "Required parameter requestParameters.productBundleLineId was null or undefined when calling productBundleLineView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}/product-bundle-lines/{productBundleLineId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))).replace(`{${"productBundleLineId"}}`, encodeURIComponent(String(requestParameters.productBundleLineId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductBundleLineView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View productBundleLine
   */
  productBundleLineView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productBundleLineViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List product bundle lines
   */
  productBundleLinesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling productBundleLinesList.");
      }
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}/product-bundle-lines`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductBundleLinesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List product bundle lines
   */
  productBundleLinesList(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productBundleLinesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get numbers for the product bundle KPI cards
   */
  productBundlesGetKpiCardsDataRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling productBundlesGetKpiCardsData.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}/kpi`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductBundlesGetKpiCardsData200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get numbers for the product bundle KPI cards
   */
  productBundlesGetKpiCardsData(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productBundlesGetKpiCardsDataRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List product bundles
   */
  productBundlesListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.activityIds !== void 0) {
        queryParameters["activity_ids"] = requestParameters.activityIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductBundlesList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List product bundles
   */
  productBundlesList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.productBundlesListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View productBundle
   */
  productBundlesViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productBundleId === null || requestParameters.productBundleId === void 0) {
        throw new RequiredError("productBundleId", "Required parameter requestParameters.productBundleId was null or undefined when calling productBundlesView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/product-bundles/{productBundleId}`.replace(`{${"productBundleId"}}`, encodeURIComponent(String(requestParameters.productBundleId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductBundlesView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View productBundle
   */
  productBundlesView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productBundlesViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get products(expense lines, vendor products) pricing history
   */
  productPriceHistoryRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.expenseLineId !== void 0) {
        queryParameters["expense_line_id"] = requestParameters.expenseLineId;
      }
      if (requestParameters.vendorProductId !== void 0) {
        queryParameters["vendor_product_id"] = requestParameters.vendorProductId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/get-price-history`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductPriceHistory200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get products(expense lines, vendor products) pricing history
   */
  productPriceHistory() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.productPriceHistoryRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get product variants
   */
  productVariantsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productId === null || requestParameters.productId === void 0) {
        throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling productVariants.");
      }
      const queryParameters = {};
      if (requestParameters.productId !== void 0) {
        queryParameters["product_id"] = requestParameters.productId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/get-variants`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductVariants200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get product variants
   */
  productVariants(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productVariantsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List products
   */
  productsListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.labelId) {
        queryParameters["label_id[]"] = requestParameters.labelId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductsList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List products
   */
  productsList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.productsListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View product
   */
  productsViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productId === null || requestParameters.productId === void 0) {
        throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling productsView.");
      }
      const queryParameters = {};
      if (requestParameters.includeVariants !== void 0) {
        queryParameters["includeVariants"] = requestParameters.includeVariants;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/{product_id}`.replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.productId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProductsView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View product
   */
  productsView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.productsViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for page behind \"Economy\" KPI card
   */
  projectGetKpiCardEconomySubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardEconomySubPage.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-economy`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardEconomySubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for page behind \"Economy\" KPI card
   */
  projectGetKpiCardEconomySubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardEconomySubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for hours KPI card page - all forms tab
   */
  projectGetKpiCardHoursAllFormsSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardHoursAllFormsSubPage.");
      }
      const queryParameters = {};
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-hours/all-forms`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for hours KPI card page - all forms tab
   */
  projectGetKpiCardHoursAllFormsSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardHoursAllFormsSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for hours KPI card page - pre calculation tab
   */
  projectGetKpiCardHoursPreCalculationSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardHoursPreCalculationSubPage.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-hours/pre-calculation`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for hours KPI card page - pre calculation tab
   */
  projectGetKpiCardHoursPreCalculationSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardHoursPreCalculationSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for hours KPI card page - `Summed by User price group` tab
   */
  projectGetKpiCardHoursSummedByUserPriceGroupSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardHoursSummedByUserPriceGroupSubPage.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-hours/summed-by-user-price-group`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for hours KPI card page - `Summed by User price group` tab
   */
  projectGetKpiCardHoursSummedByUserPriceGroupSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardHoursSummedByUserPriceGroupSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for hours KPI card page - summed tab
   */
  projectGetKpiCardHoursSummedSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardHoursSummedSubPage.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = requestParameters.dateBefore.toISOString();
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = requestParameters.dateAfter.toISOString();
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-hours/summed`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for hours KPI card page - summed tab
   */
  projectGetKpiCardHoursSummedSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardHoursSummedSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for page behind \"Invoices\" KPI card
   */
  projectGetKpiCardInvoicesSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardInvoicesSubPage.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-invoices`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardInvoicesSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for page behind \"Invoices\" KPI card
   */
  projectGetKpiCardInvoicesSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardInvoicesSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for products KPI card page - pre calculation tab
   */
  projectGetKpiCardProductsPreCalculationSubPageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardProductsPreCalculationSubPage.");
      }
      const queryParameters = {};
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-products/pre-calculation`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for products KPI card page - pre calculation tab
   */
  projectGetKpiCardProductsPreCalculationSubPage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardProductsPreCalculationSubPageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for products KPI card page - products tab
   */
  projectGetKpiCardProductsSubpageProductsTabRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardProductsSubpageProductsTab.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards-products/products`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for products KPI card page - products tab
   */
  projectGetKpiCardProductsSubpageProductsTab(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardProductsSubpageProductsTabRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get numbers for the projet KPI cards
   */
  projectGetKpiCardsDataRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling projectGetKpiCardsData.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = toLocalDateString(requestParameters.dateBefore);
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = toLocalDateString(requestParameters.dateAfter);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.isInvoiced !== void 0) {
        queryParameters["is_invoiced"] = requestParameters.isInvoiced;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/kpi-cards`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardsData200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get numbers for the projet KPI cards
   */
  projectGetKpiCardsData(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.projectGetKpiCardsDataRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Request a password reset with email/mobile
   */
  requestResetPasswordRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.requestResetPasswordRequest === null || requestParameters.requestResetPasswordRequest === void 0) {
        throw new RequiredError("requestResetPasswordRequest", "Required parameter requestParameters.requestResetPasswordRequest was null or undefined when calling requestResetPassword.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      const response = yield this.request({
        path: `/control-panel-api/v1/login/reset-password`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RequestResetPasswordRequestToJSON(requestParameters.requestResetPasswordRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => RequestResetPassword200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Request a password reset with email/mobile
   */
  requestResetPassword(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.requestResetPasswordRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Resend welcome sms to user if he have mobile country code and mobile
   */
  resendWelcomeSmsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling resendWelcomeSms.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/resend-welcome-sms-to-user/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Resend welcome sms to user if he have mobile country code and mobile
   */
  resendWelcomeSms(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.resendWelcomeSmsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete custom template and return default email template
   */
  resetCustomEmailTemplateRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling resetCustomEmailTemplate.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/custom-email-templates/reset/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CustomEmailTemplateView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete custom template and return default email template
   */
  resetCustomEmailTemplate(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.resetCustomEmailTemplateRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Sends a password reset email
   */
  resetPasswordRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      const response = yield this.request({
        path: `/api/v1/reset_password`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Sends a password reset email
   */
  resetPassword() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.resetPasswordRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Reverse address lookup
   */
  reverseLookupRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.latitude === null || requestParameters.latitude === void 0) {
        throw new RequiredError("latitude", "Required parameter requestParameters.latitude was null or undefined when calling reverseLookup.");
      }
      if (requestParameters.longitude === null || requestParameters.longitude === void 0) {
        throw new RequiredError("longitude", "Required parameter requestParameters.longitude was null or undefined when calling reverseLookup.");
      }
      const queryParameters = {};
      if (requestParameters.latitude !== void 0) {
        queryParameters["latitude"] = requestParameters.latitude;
      }
      if (requestParameters.longitude !== void 0) {
        queryParameters["longitude"] = requestParameters.longitude;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/geolocation/reverse`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ReverseLookup200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Reverse address lookup
   */
  reverseLookup(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.reverseLookupRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Send a summary report based on the type
   */
  sendReportRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.type === null || requestParameters.type === void 0) {
        throw new RequiredError("type", "Required parameter requestParameters.type was null or undefined when calling sendReport.");
      }
      const queryParameters = {};
      if (requestParameters.type !== void 0) {
        queryParameters["type"] = requestParameters.type;
      }
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/reports/send`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SendReportRequestToJSON(requestParameters.sendReportRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Send a summary report based on the type
   */
  sendReport(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.sendReportRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Set variant as primary
   */
  setPrimaryVariantRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/set-primary-variant`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetPrimaryVariantRequestToJSON(requestParameters.setPrimaryVariantRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Set variant as primary
   */
  setPrimaryVariant() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.setPrimaryVariantRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Show Only Product Bundles
   */
  showOnlyProductBundlesRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.offerId === null || requestParameters.offerId === void 0) {
        throw new RequiredError("offerId", "Required parameter requestParameters.offerId was null or undefined when calling showOnlyProductBundles.");
      }
      if (requestParameters.offerLine === null || requestParameters.offerLine === void 0) {
        throw new RequiredError("offerLine", "Required parameter requestParameters.offerLine was null or undefined when calling showOnlyProductBundles.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/offers/{offer_id}/offer-lines/show-only-product-bundles`.replace(`{${"offer_id"}}`, encodeURIComponent(String(requestParameters.offerId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.offerLine.map(OfferLineToJSON)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GatherOfferLines200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Show Only Product Bundles
   */
  showOnlyProductBundles(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.showOnlyProductBundlesRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Edit task
   */
  taskEditRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.taskId === null || requestParameters.taskId === void 0) {
        throw new RequiredError("taskId", "Required parameter requestParameters.taskId was null or undefined when calling taskEdit.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/tasks/{task_id}`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: TaskCreateOrUpdateDTOToJSON(requestParameters.taskCreateOrUpdateDTO)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Edit task
   */
  taskEdit(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.taskEditRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Undelete deleted form
   */
  undeleteFormRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling undeleteForm.");
      }
      if (requestParameters.formId === null || requestParameters.formId === void 0) {
        throw new RequiredError("formId", "Required parameter requestParameters.formId was null or undefined when calling undeleteForm.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/{projectId}/forms/{formId}/undelete`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"formId"}}`, encodeURIComponent(String(requestParameters.formId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Undelete deleted form
   */
  undeleteForm(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.undeleteFormRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Update a cards list_placement and reindex other cards for same date if necessary
   * Bulk-update cards
   */
  updateCardListingRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling updateCardListing.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/cards/update-card-listing/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateCardListingRequestToJSON(requestParameters.updateCardListingRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UpdateCardListing200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Update a cards list_placement and reindex other cards for same date if necessary
   * Bulk-update cards
   */
  updateCardListing(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.updateCardListingRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Update a form with form fields
   * update form
   */
  updateFormRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.formId === null || requestParameters.formId === void 0) {
        throw new RequiredError("formId", "Required parameter requestParameters.formId was null or undefined when calling updateForm.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/forms/{form_id}`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: CreateFormRequestToJSON(requestParameters.createFormRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => CreateAbsenceType201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Update a form with form fields
   * update form
   */
  updateForm(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.updateFormRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Update a user - integration setting value
   * Update user integration setting value
   */
  updateUserIntegrationSettingRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUserIntegrationSetting.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/integration-settings/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateUserIntegrationSettingRequestToJSON(requestParameters.updateUserIntegrationSettingRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => DeleteCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Update a user - integration setting value
   * Update user integration setting value
   */
  updateUserIntegrationSetting(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.updateUserIntegrationSettingRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload image to a specific expense
   */
  uploadExpenseFileRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.file !== void 0) {
        formParams.append("file", requestParameters.file);
      }
      if (requestParameters.expenseId !== void 0) {
        formParams.append("expense_id", requestParameters.expenseId);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/expenses/add-file`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UploadExpenseFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload image to a specific expense
   */
  uploadExpenseFile() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.uploadExpenseFileRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload image to a specific product
   */
  uploadProductImageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.productId === null || requestParameters.productId === void 0) {
        throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling uploadProductImage.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.image !== void 0) {
        formParams.append("image", requestParameters.image);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/products/upload-image/{product_id}`.replace(`{${"product_id"}}`, encodeURIComponent(String(requestParameters.productId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload image to a specific product
   */
  uploadProductImage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.uploadProductImageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Upload image to a specific user
   */
  uploadUserImageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling uploadUserImage.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const consumes = [
        { contentType: "multipart/form-data" }
      ];
      const canConsumeForm2 = canConsumeForm(consumes);
      let formParams;
      let useForm = false;
      useForm = canConsumeForm2;
      if (useForm) {
        formParams = new FormData();
      } else {
        formParams = new URLSearchParams();
      }
      if (requestParameters.image !== void 0) {
        formParams.append("image", requestParameters.image);
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/upload-image/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: formParams
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Upload image to a specific user
   */
  uploadUserImage(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.uploadUserImageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Allow/disallow employees to access project
   */
  usersAccessToProjectRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling usersAccessToProject.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/users-access/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.requestBody
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IWallpostDeleteFile200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Allow/disallow employees to access project
   */
  usersAccessToProject(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.usersAccessToProjectRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for employees page
   */
  usersGetKpiCardsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      if (requestParameters.active !== void 0) {
        queryParameters["active"] = requestParameters.active;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/kpi-cards`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersGetKpiCards200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for employees page
   */
  usersGetKpiCards() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersGetKpiCardsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for specified tab in employees page
   */
  usersGetSpecifiedRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      if (requestParameters.approved !== void 0) {
        queryParameters["approved"] = requestParameters.approved;
      }
      if (requestParameters.invoiced !== void 0) {
        queryParameters["invoiced"] = requestParameters.invoiced;
      }
      if (requestParameters.onlyAbsences !== void 0) {
        queryParameters["only_absences"] = requestParameters.onlyAbsences;
      }
      if (requestParameters.onlyForms !== void 0) {
        queryParameters["only_forms"] = requestParameters.onlyForms;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/specified`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersGetSpecified200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for specified tab in employees page
   */
  usersGetSpecified() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersGetSpecifiedRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for employees - summed tab
   */
  usersGetSummedRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      if (requestParameters.onlyAbsences !== void 0) {
        queryParameters["only_absences"] = requestParameters.onlyAbsences;
      }
      if (requestParameters.onlyForms !== void 0) {
        queryParameters["only_forms"] = requestParameters.onlyForms;
      }
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/summed`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for employees - summed tab
   */
  usersGetSummed() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersGetSummedRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get data for employees - weekly tab
   */
  usersGetWeeklyRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      if (requestParameters.onlyAbsences !== void 0) {
        queryParameters["only_absences"] = requestParameters.onlyAbsences;
      }
      if (requestParameters.onlyForms !== void 0) {
        queryParameters["only_forms"] = requestParameters.onlyForms;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/weekly`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersGetWeekly200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get data for employees - weekly tab
   */
  usersGetWeekly() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersGetWeeklyRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List users price groups
   */
  usersPriceGroupsListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.direction !== void 0) {
        queryParameters["direction"] = requestParameters.direction;
      }
      if (requestParameters.sort !== void 0) {
        queryParameters["sort"] = requestParameters.sort;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users-price-groups`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersPriceGroupsList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List users price groups
   */
  usersPriceGroupsList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersPriceGroupsListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View users price group
   */
  usersPriceGroupsViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.usersPriceGroupId === null || requestParameters.usersPriceGroupId === void 0) {
        throw new RequiredError("usersPriceGroupId", "Required parameter requestParameters.usersPriceGroupId was null or undefined when calling usersPriceGroupsView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users-price-groups/{usersPriceGroupId}`.replace(`{${"usersPriceGroupId"}}`, encodeURIComponent(String(requestParameters.usersPriceGroupId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersPriceGroupsView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View users price group
   */
  usersPriceGroupsView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.usersPriceGroupsViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Get products usage grouped by users
   */
  usersProductsUsageRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.startDate !== void 0) {
        queryParameters["start_date"] = toLocalDateString(requestParameters.startDate);
      }
      if (requestParameters.endDate !== void 0) {
        queryParameters["end_date"] = toLocalDateString(requestParameters.endDate);
      }
      if (requestParameters.employeeIds) {
        queryParameters["employee_ids[]"] = requestParameters.employeeIds;
      }
      if (requestParameters.productKey !== void 0) {
        queryParameters["product_key"] = requestParameters.productKey;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/products-usage`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersProductsUsage200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Get products usage grouped by users
   */
  usersProductsUsage() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.usersProductsUsageRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View user
   */
  usersViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling usersView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View user
   */
  usersView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.usersViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View vendor product
   */
  vendorProductViewRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.vendorProductId === null || requestParameters.vendorProductId === void 0) {
        throw new RequiredError("vendorProductId", "Required parameter requestParameters.vendorProductId was null or undefined when calling vendorProductView.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/vendor-products/{vendor_product_id}`.replace(`{${"vendor_product_id"}}`, encodeURIComponent(String(requestParameters.vendorProductId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => VendorProductView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View vendor product
   */
  vendorProductView(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.vendorProductViewRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List vendor products
   */
  vendorProductsListRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.limit !== void 0) {
        queryParameters["limit"] = requestParameters.limit;
      }
      if (requestParameters.q !== void 0) {
        queryParameters["q"] = requestParameters.q;
      }
      if (requestParameters.vendorId !== void 0) {
        queryParameters["vendor_id"] = requestParameters.vendorId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/vendor-products`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => VendorProductsList200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List vendor products
   */
  vendorProductsList() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.vendorProductsListRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Verify the validity of a user token
   */
  verifyResetTokenRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.verifyResetTokenRequest === null || requestParameters.verifyResetTokenRequest === void 0) {
        throw new RequiredError("verifyResetTokenRequest", "Required parameter requestParameters.verifyResetTokenRequest was null or undefined when calling verifyResetToken.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      const response = yield this.request({
        path: `/control-panel-api/v1/login/verify-reset-token`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: VerifyResetTokenRequestToJSON(requestParameters.verifyResetTokenRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => RequestResetPassword200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Verify the validity of a user token
   */
  verifyResetToken(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.verifyResetTokenRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View project as PDF
   */
  viewAsPDFRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.projectId === null || requestParameters.projectId === void 0) {
        throw new RequiredError("projectId", "Required parameter requestParameters.projectId was null or undefined when calling viewAsPDF.");
      }
      const queryParameters = {};
      if (requestParameters.dateFrom !== void 0) {
        queryParameters["date_from"] = toLocalDateString(requestParameters.dateFrom);
      }
      if (requestParameters.dateTo !== void 0) {
        queryParameters["date_to"] = toLocalDateString(requestParameters.dateTo);
      }
      if (requestParameters.activityIds) {
        queryParameters["activity_ids[]"] = requestParameters.activityIds;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/projects/view-as-pdf/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new BlobApiResponse(response);
    });
  }
  /**
   * View project as PDF
   */
  viewAsPDF(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.viewAsPDFRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * View user
   */
  viewUserRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.userId === null || requestParameters.userId === void 0) {
        throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling viewUser.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => UsersView200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * View user
   */
  viewUser(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.viewUserRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Lookup City object for zip code
   */
  zipCodeLookupRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.zipCode === null || requestParameters.zipCode === void 0) {
        throw new RequiredError("zipCode", "Required parameter requestParameters.zipCode was null or undefined when calling zipCodeLookup.");
      }
      const queryParameters = {};
      if (requestParameters.zipCode !== void 0) {
        queryParameters["zipCode"] = requestParameters.zipCode;
      }
      if (requestParameters.countryIdentifier !== void 0) {
        queryParameters["countryIdentifier"] = requestParameters.countryIdentifier;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/address-lookup/zipCodeLookup`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCity200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Lookup City object for zip code
   */
  zipCodeLookup(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.zipCodeLookupRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Lookup City object for zip code
   */
  zipCodeSearchRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.zipCode === null || requestParameters.zipCode === void 0) {
        throw new RequiredError("zipCode", "Required parameter requestParameters.zipCode was null or undefined when calling zipCodeSearch.");
      }
      const queryParameters = {};
      if (requestParameters.countryIdentifier !== void 0) {
        queryParameters["countryIdentifier"] = requestParameters.countryIdentifier;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/control-panel-api/v1/address-lookup/zip-code-search/{zipCode}`.replace(`{${"zipCode"}}`, encodeURIComponent(String(requestParameters.zipCode))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetCities200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Lookup City object for zip code
   */
  zipCodeSearch(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.zipCodeSearchRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
};
var ApvFormTemplatesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ExpenseLinesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ExpensesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ExpensesListStatusEnum = {
  NotHandled: "not_handled",
  ExpiredSubscription: "expired_subscription",
  Approved: "approved"
};
var FormTemplatesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var FormsListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetAbsenceTypesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetAbsencesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetAllRegistrationsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetContactPersonsListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetContactsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetInvoiceEmailsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetInvoiceFilesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetInvoicesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetLabelsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetOfferActionLogsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetOfferEmailsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetOfferFilesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetOfferLinesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetOfferPdfDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetProjectCustomFieldAttributesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetProjectsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetTasksDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetTextTemplatesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetUsersDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetVendorsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var GetWallPostsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var HasIntegrationOfTypeIdentifierEnum = {
  PayrollSystem: "payroll_system",
  Roger: "roger",
  Erp: "erp"
};
var IGetActivitiesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IGetCustomEmailTemplatesTypeEnum = {
  Offer: "send_offer",
  Invoice: "send_invoice",
  ProjectFiles: "send_project_files"
};
var IGetFeedForProjectTypeEnum = {
  Form: "form",
  Invoice: "invoice",
  Expense: "expense",
  WallPost: "wall_post",
  ProjectFile: "project_file"
};
var IGetTasksForProjectDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IListInvoicesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IListInvoicesFilterEnum = {
  Booked: "booked",
  Drafted: "drafted",
  BookedAndSentAsDraft: "booked_and_sent_as_draft",
  SentAsDraft: "sent_as_draft"
};
var IListProjectsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IListProjectsProjectStatusEnum = {
  Open: "open",
  ReadyForBilling: "ready_for_billing",
  Closed: "closed"
};
var IListTasksDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IListWallCommentsDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IProjectListFilesDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var IStandardFileUploadTypeEnum = {
  Estimate: "estimate",
  Quote: "quote",
  Invoice: "invoice"
};
var IStandardFilesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ListUsersDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var OffersListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProductBundleLinesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProductBundlesListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProductsListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProjectGetKpiCardHoursAllFormsSubPageDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProjectGetKpiCardInvoicesSubPageDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProjectGetKpiCardProductsPreCalculationSubPageDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var ProjectGetKpiCardProductsSubpageProductsTabDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var UsersGetSpecifiedDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var UsersGetSummedDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};
var UsersPriceGroupsListDirectionEnum = {
  Asc: "asc",
  Desc: "desc"
};

// src/generated/apis/IntegrationsApi.ts
var IntegrationsApi = class extends BaseAPI {
  /**
   * Queues a background job to sync all contacts from the connected Billy integration into Apacta.
   * Import contacts from Billy
   */
  billysImportContactsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/downloadAllBillysContacts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EconomicImportContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Queues a background job to sync all contacts from the connected Billy integration into Apacta.
   * Import contacts from Billy
   */
  billysImportContacts(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.billysImportContactsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Queues a background job to sync all products from the connected Billy integration into Apacta.
   * Import products from Billy
   */
  billysImportProductsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/products/downloadAllBillysProducts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EconomicImportContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Queues a background job to sync all products from the connected Billy integration into Apacta.
   * Import products from Billy
   */
  billysImportProducts(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.billysImportProductsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Queues a background job to sync all contacts from the connected Dinero integration into Apacta.
   * Import contacts from Dinero
   */
  dineroImportContactsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/downloadAllDineroContacts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EconomicImportContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Queues a background job to sync all contacts from the connected Dinero integration into Apacta.
   * Import contacts from Dinero
   */
  dineroImportContacts(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.dineroImportContactsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Queues a background job to sync all contacts from the connected e-conomic integration into Apacta.
   * Import contacts from e-conomic
   */
  economicImportContactsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/contacts/downloadAllEconomicContacts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EconomicImportContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Queues a background job to sync all contacts from the connected e-conomic integration into Apacta.
   * Import contacts from e-conomic
   */
  economicImportContacts(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.economicImportContactsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Queues a background job to sync all products from the connected e-conomic integration into Apacta.
   * Import products from e-conomic
   */
  economicImportProductsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/api/v1/products/downloadAllEconomicProducts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => EconomicImportContacts200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Queues a background job to sync all products from the connected e-conomic integration into Apacta.
   * Import products from e-conomic
   */
  economicImportProducts(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.economicImportProductsRaw(initOverrides);
      return yield response.value();
    });
  }
};

// src/generated/apis/MobileAppApi.ts
var MobileAppApi = class extends BaseAPI {
  /**
   * Create firebase registration token
   */
  createFirebaseTokenRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/firebase-cloud-messaging-registration-tokens`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateFirebaseTokenRequestToJSON(requestParameters.createFirebaseTokenRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Create firebase registration token
   */
  createFirebaseToken() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.createFirebaseTokenRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete all user notifications for user
   */
  deleteAllUserNotificationsRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/user-notifications/delete-all`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete all user notifications for user
   */
  deleteAllUserNotifications(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteAllUserNotificationsRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete firebase token by device id
   */
  deleteTokenByDeviceIdRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/firebase-cloud-messaging-registration-tokens/delete-by-device-id`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteTokenByDeviceIdRequestToJSON(requestParameters.deleteTokenByDeviceIdRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete firebase token by device id
   */
  deleteTokenByDeviceId() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.deleteTokenByDeviceIdRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Delete given user notification
   */
  deleteUserNotificationRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.id === null || requestParameters.id === void 0) {
        throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling deleteUserNotification.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/user-notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Delete given user notification
   */
  deleteUserNotification(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.deleteUserNotificationRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * List all user notifications
   */
  getUserNotificationsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      if (requestParameters.page !== void 0) {
        queryParameters["page"] = requestParameters.page;
      }
      if (requestParameters.onlyUnread !== void 0) {
        queryParameters["only_unread"] = requestParameters.onlyUnread;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/user-notifications`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => GetUserNotifications200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List all user notifications
   */
  getUserNotifications() {
    return __async(this, arguments, function* (requestParameters = {}, initOverrides) {
      const response = yield this.getUserNotificationsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mark all user\'s notifications as read
   */
  markAllAsReadRaw(initOverrides) {
    return __async(this, null, function* () {
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/user-notifications/mark-all-as-read`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => ISendProjectForms200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mark all user\'s notifications as read
   */
  markAllAsRead(initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.markAllAsReadRaw(initOverrides);
      return yield response.value();
    });
  }
  /**
   * List cards
   */
  mobileGetCardsRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.dateBefore === null || requestParameters.dateBefore === void 0) {
        throw new RequiredError("dateBefore", "Required parameter requestParameters.dateBefore was null or undefined when calling mobileGetCards.");
      }
      if (requestParameters.dateAfter === null || requestParameters.dateAfter === void 0) {
        throw new RequiredError("dateAfter", "Required parameter requestParameters.dateAfter was null or undefined when calling mobileGetCards.");
      }
      const queryParameters = {};
      if (requestParameters.dateBefore !== void 0) {
        queryParameters["date_before"] = requestParameters.dateBefore.toISOString();
      }
      if (requestParameters.dateAfter !== void 0) {
        queryParameters["date_after"] = requestParameters.dateAfter.toISOString();
      }
      if (requestParameters.unassignedCardsOnly !== void 0) {
        queryParameters["unassigned_cards_only"] = requestParameters.unassignedCardsOnly;
      }
      if (requestParameters.unplannedCardsOnly !== void 0) {
        queryParameters["unplanned_cards_only"] = requestParameters.unplannedCardsOnly;
      }
      if (requestParameters.userId !== void 0) {
        queryParameters["user_id"] = requestParameters.userId;
      }
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/planning`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => MobileGetCards200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * List cards
   */
  mobileGetCards(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.mobileGetCardsRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mobile - Create task and card
   */
  mobilePlanningCreateCardAndTaskRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.mobilePlanningCreateCardAndTaskRequest === null || requestParameters.mobilePlanningCreateCardAndTaskRequest === void 0) {
        throw new RequiredError("mobilePlanningCreateCardAndTaskRequest", "Required parameter requestParameters.mobilePlanningCreateCardAndTaskRequest was null or undefined when calling mobilePlanningCreateCardAndTask.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/planning/add`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MobilePlanningCreateCardAndTaskRequestToJSON(requestParameters.mobilePlanningCreateCardAndTaskRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => MobilePlanningCreateCardAndTask201ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mobile - Create task and card
   */
  mobilePlanningCreateCardAndTask(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.mobilePlanningCreateCardAndTaskRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mobile - edit card
   */
  mobilePlanningEditCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling mobilePlanningEditCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      headerParameters["Content-Type"] = "application/json";
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/planning/edit-card/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: MobilePlanningEditCardRequestToJSON(requestParameters.mobilePlanningEditCardRequest)
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mobile - edit card
   */
  mobilePlanningEditCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.mobilePlanningEditCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mobile - get card
   */
  mobilePlanningGetCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling mobilePlanningGetCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/planning/view-card/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => MobilePlanningGetCard200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mobile - get card
   */
  mobilePlanningGetCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.mobilePlanningGetCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
  /**
   * Mobile - self-assign card
   */
  mobilePlanningSelfAssignCardRaw(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      if (requestParameters.cardId === null || requestParameters.cardId === void 0) {
        throw new RequiredError("cardId", "Required parameter requestParameters.cardId was null or undefined when calling mobilePlanningSelfAssignCard.");
      }
      const queryParameters = {};
      const headerParameters = {};
      if (this.configuration && this.configuration.apiKey) {
        headerParameters["Authorization"] = this.configuration.apiKey("Authorization");
      }
      const response = yield this.request({
        path: `/mobile-app-api/v1/planning/self-assign/{cardId}`.replace(`{${"cardId"}}`, encodeURIComponent(String(requestParameters.cardId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters
      }, initOverrides);
      return new JSONApiResponse(response, (jsonValue) => IEditWallPost200ResponseFromJSON(jsonValue));
    });
  }
  /**
   * Mobile - self-assign card
   */
  mobilePlanningSelfAssignCard(requestParameters, initOverrides) {
    return __async(this, null, function* () {
      const response = yield this.mobilePlanningSelfAssignCardRaw(requestParameters, initOverrides);
      return yield response.value();
    });
  }
};
export {
  AbsenceCreateOrUpdateDTOFromJSON,
  AbsenceCreateOrUpdateDTOFromJSONTyped,
  AbsenceCreateOrUpdateDTOToJSON,
  AbsenceFromJSON,
  AbsenceFromJSONTyped,
  AbsenceToJSON,
  AbsenceTypeFromJSON,
  AbsenceTypeFromJSONTyped,
  AbsenceTypeToJSON,
  ActionLogActionEnum,
  ActionLogFromJSON,
  ActionLogFromJSONTyped,
  ActionLogMetadataFromJSON,
  ActionLogMetadataFromJSONTyped,
  ActionLogMetadataToJSON,
  ActionLogToJSON,
  ActivityFromJSON,
  ActivityFromJSONTyped,
  ActivityToJSON,
  AddContactPersonRequestFromJSON,
  AddContactPersonRequestFromJSONTyped,
  AddContactPersonRequestToJSON,
  AddVariantRequestFromJSON,
  AddVariantRequestFromJSONTyped,
  AddVariantRequestToJSON,
  AddressLookupFromJSON,
  AddressLookupFromJSONTyped,
  AddressLookupToJSON,
  ApiKeyFromJSON,
  ApiKeyFromJSONTyped,
  ApiKeyToJSON,
  ApvDefaultProject200ResponseFromJSON,
  ApvDefaultProject200ResponseFromJSONTyped,
  ApvDefaultProject200ResponseToJSON,
  ApvFormTemplatesListDirectionEnum,
  AutoCompleteAddress200ResponseFromJSON,
  AutoCompleteAddress200ResponseFromJSONTyped,
  AutoCompleteAddress200ResponseToJSON,
  BASE_PATH,
  BadRequestResponseDataFromJSON,
  BadRequestResponseDataFromJSONTyped,
  BadRequestResponseDataToJSON,
  BadRequestResponseFromJSON,
  BadRequestResponseFromJSONTyped,
  BadRequestResponseToJSON,
  BaseAPI,
  BaseEntityFromJSON,
  BaseEntityFromJSONTyped,
  BaseEntityToJSON,
  BaseFileAllOfFromJSON,
  BaseFileAllOfFromJSONTyped,
  BaseFileAllOfToJSON,
  BaseFileFromJSON,
  BaseFileFromJSONTyped,
  BaseFileToJSON,
  BlobApiResponse,
  BulkMarkAsInvoiced200ResponseFromJSON,
  BulkMarkAsInvoiced200ResponseFromJSONTyped,
  BulkMarkAsInvoiced200ResponseToJSON,
  BulkMarkAsInvoicedRequestFromJSON,
  BulkMarkAsInvoicedRequestFromJSONTyped,
  BulkMarkAsInvoicedRequestToJSON,
  COLLECTION_FORMATS,
  CVRLookupFromJSON,
  CVRLookupFromJSONTyped,
  CVRLookupToJSON,
  CalculateInvoiceDueDate200ResponseDataFromJSON,
  CalculateInvoiceDueDate200ResponseDataFromJSONTyped,
  CalculateInvoiceDueDate200ResponseDataToJSON,
  CalculateInvoiceDueDate200ResponseFromJSON,
  CalculateInvoiceDueDate200ResponseFromJSONTyped,
  CalculateInvoiceDueDate200ResponseToJSON,
  CalculateInvoiceDueDateRequestFromJSON,
  CalculateInvoiceDueDateRequestFromJSONTyped,
  CalculateInvoiceDueDateRequestToJSON,
  CardFromJSON,
  CardFromJSONTyped,
  CardStatusEnum,
  CardToJSON,
  CardTypeEnum,
  CardUpdateDTOFromJSON,
  CardUpdateDTOFromJSONTyped,
  CardUpdateDTOStatusEnum,
  CardUpdateDTOToJSON,
  CardUpdateDTOTypeEnum,
  CardsDeleteManyRequestFromJSON,
  CardsDeleteManyRequestFromJSONTyped,
  CardsDeleteManyRequestToJSON,
  ChangePasswordRequestFromJSON,
  ChangePasswordRequestFromJSONTyped,
  ChangePasswordRequestToJSON,
  ChangePasswordWithTokenRequestFromJSON,
  ChangePasswordWithTokenRequestFromJSONTyped,
  ChangePasswordWithTokenRequestToJSON,
  ChangeStatusRequestFromJSON,
  ChangeStatusRequestFromJSONTyped,
  ChangeStatusRequestToJSON,
  CheckInRequestFromJSON,
  CheckInRequestFromJSONTyped,
  CheckInRequestToJSON,
  CheckOutRequestFromJSON,
  CheckOutRequestFromJSONTyped,
  CheckOutRequestToJSON,
  CityFromJSON,
  CityFromJSONTyped,
  CityToJSON,
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  Configuration,
  ContactFromJSON,
  ContactFromJSONTyped,
  ContactPersonFromJSON,
  ContactPersonFromJSONTyped,
  ContactPersonToJSON,
  ContactToJSON,
  ControlPanelApiOfferStatusResponseFromJSON,
  ControlPanelApiOfferStatusResponseFromJSONTyped,
  ControlPanelApiOfferStatusResponseToJSON,
  ControlPanelApiPaymentTermFromJSON,
  ControlPanelApiPaymentTermFromJSONTyped,
  ControlPanelApiPaymentTermToJSON,
  ControlPanelApiProjectFeedResponseDTODataInnerFromJSON,
  ControlPanelApiProjectFeedResponseDTODataInnerFromJSONTyped,
  ControlPanelApiProjectFeedResponseDTODataInnerToJSON,
  ControlPanelApiProjectFeedResponseDTOFromJSON,
  ControlPanelApiProjectFeedResponseDTOFromJSONTyped,
  ControlPanelApiProjectFeedResponseDTOPaginationFromJSON,
  ControlPanelApiProjectFeedResponseDTOPaginationFromJSONTyped,
  ControlPanelApiProjectFeedResponseDTOPaginationToJSON,
  ControlPanelApiProjectFeedResponseDTOToJSON,
  ControlPanelApiProjectStatusResponseFromJSON,
  ControlPanelApiProjectStatusResponseFromJSONTyped,
  ControlPanelApiProjectStatusResponseToJSON,
  ControlPanelApiProjectViewOrIndexResponseFromJSON,
  ControlPanelApiProjectViewOrIndexResponseFromJSONTyped,
  ControlPanelApiProjectViewOrIndexResponseProjectTypeEnum,
  ControlPanelApiProjectViewOrIndexResponseToJSON,
  ControlPanelProductsToTaskFromJSON,
  ControlPanelProductsToTaskFromJSONTyped,
  ControlPanelProductsToTaskProductFromJSON,
  ControlPanelProductsToTaskProductFromJSONTyped,
  ControlPanelProductsToTaskProductToJSON,
  ControlPanelProductsToTaskToJSON,
  CountryFromJSON,
  CountryFromJSONTyped,
  CountryToJSON,
  CreateAbsence201ResponseDataFromJSON,
  CreateAbsence201ResponseDataFromJSONTyped,
  CreateAbsence201ResponseDataToJSON,
  CreateAbsence201ResponseFromJSON,
  CreateAbsence201ResponseFromJSONTyped,
  CreateAbsence201ResponseToJSON,
  CreateAbsenceRequestFromJSON,
  CreateAbsenceRequestFromJSONTyped,
  CreateAbsenceRequestToJSON,
  CreateAbsenceType201ResponseDataFromJSON,
  CreateAbsenceType201ResponseDataFromJSONTyped,
  CreateAbsenceType201ResponseDataToJSON,
  CreateAbsenceType201ResponseFromJSON,
  CreateAbsenceType201ResponseFromJSONTyped,
  CreateAbsenceType201ResponseToJSON,
  CreateAbsenceTypeRequestFromJSON,
  CreateAbsenceTypeRequestFromJSONTyped,
  CreateAbsenceTypeRequestToJSON,
  CreateCardAndAbsences201ResponseDataFromJSON,
  CreateCardAndAbsences201ResponseDataFromJSONTyped,
  CreateCardAndAbsences201ResponseDataToJSON,
  CreateCardAndAbsences201ResponseFromJSON,
  CreateCardAndAbsences201ResponseFromJSONTyped,
  CreateCardAndAbsences201ResponseToJSON,
  CreateCardAndAbsencesRequestFromJSON,
  CreateCardAndAbsencesRequestFromJSONTyped,
  CreateCardAndAbsencesRequestToJSON,
  CreateCardAndTask201ResponseDataFromJSON,
  CreateCardAndTask201ResponseDataFromJSONTyped,
  CreateCardAndTask201ResponseDataToJSON,
  CreateCardAndTask201ResponseFromJSON,
  CreateCardAndTask201ResponseFromJSONTyped,
  CreateCardAndTask201ResponseToJSON,
  CreateCardAndTaskRequestCardsInnerFromJSON,
  CreateCardAndTaskRequestCardsInnerFromJSONTyped,
  CreateCardAndTaskRequestCardsInnerToJSON,
  CreateCardAndTaskRequestFromJSON,
  CreateCardAndTaskRequestFromJSONTyped,
  CreateCardAndTaskRequestToJSON,
  CreateContactRequestContactTypesFromJSON,
  CreateContactRequestContactTypesFromJSONTyped,
  CreateContactRequestContactTypesToJSON,
  CreateContactRequestFromJSON,
  CreateContactRequestFromJSONTyped,
  CreateContactRequestToJSON,
  CreateCustomEmailTemplateRequestFromJSON,
  CreateCustomEmailTemplateRequestFromJSONTyped,
  CreateCustomEmailTemplateRequestToJSON,
  CreateExpenseFromFile200ResponseDataFromJSON,
  CreateExpenseFromFile200ResponseDataFromJSONTyped,
  CreateExpenseFromFile200ResponseDataToJSON,
  CreateExpenseFromFile200ResponseFromJSON,
  CreateExpenseFromFile200ResponseFromJSONTyped,
  CreateExpenseFromFile200ResponseToJSON,
  CreateExpenseRequestFromJSON,
  CreateExpenseRequestFromJSONTyped,
  CreateExpenseRequestStatusEnum,
  CreateExpenseRequestToJSON,
  CreateFirebaseTokenRequestFromJSON,
  CreateFirebaseTokenRequestFromJSONTyped,
  CreateFirebaseTokenRequestToJSON,
  CreateFormRequestFromJSON,
  CreateFormRequestFromJSONTyped,
  CreateFormRequestToJSON,
  CreateInvoiceRequestFromJSON,
  CreateInvoiceRequestFromJSONTyped,
  CreateInvoiceRequestToJSON,
  CreateLabelRequestEntityEnum,
  CreateLabelRequestFromJSON,
  CreateLabelRequestFromJSONTyped,
  CreateLabelRequestToJSON,
  CreateProductRequestFromJSON,
  CreateProductRequestFromJSONTyped,
  CreateProductRequestPriceTypeEnum,
  CreateProductRequestProductRuleEnum,
  CreateProductRequestToJSON,
  CreateProjectCustomFieldAttributeRequestAccessTypeEnum,
  CreateProjectCustomFieldAttributeRequestFromJSON,
  CreateProjectCustomFieldAttributeRequestFromJSONTyped,
  CreateProjectCustomFieldAttributeRequestToJSON,
  CreateTextTemplateRequestFromJSON,
  CreateTextTemplateRequestFromJSONTyped,
  CreateTextTemplateRequestToJSON,
  CreateUserRequestFromJSON,
  CreateUserRequestFromJSONTyped,
  CreateUserRequestToJSON,
  CustomEmailTemplateFromJSON,
  CustomEmailTemplateFromJSONTyped,
  CustomEmailTemplateToJSON,
  CustomEmailTemplateView200ResponseFromJSON,
  CustomEmailTemplateView200ResponseFromJSONTyped,
  CustomEmailTemplateView200ResponseToJSON,
  CvrSearchByName200ResponseFromJSON,
  CvrSearchByName200ResponseFromJSONTyped,
  CvrSearchByName200ResponseToJSON,
  DefaultApi,
  DefaultConfig,
  DeleteAbsenceType200ResponseFromJSON,
  DeleteAbsenceType200ResponseFromJSONTyped,
  DeleteAbsenceType200ResponseToJSON,
  DeleteCard200ResponseFromJSON,
  DeleteCard200ResponseFromJSONTyped,
  DeleteCard200ResponseToJSON,
  DeleteProductVariantsRequestFromJSON,
  DeleteProductVariantsRequestFromJSONTyped,
  DeleteProductVariantsRequestToJSON,
  DeleteTokenByDeviceIdRequestFromJSON,
  DeleteTokenByDeviceIdRequestFromJSONTyped,
  DeleteTokenByDeviceIdRequestToJSON,
  DuplicateInvoiceRequestFromJSON,
  DuplicateInvoiceRequestFromJSONTyped,
  DuplicateInvoiceRequestToJSON,
  EconomicImportContacts200ResponseFromJSON,
  EconomicImportContacts200ResponseFromJSONTyped,
  EconomicImportContacts200ResponseToJSON,
  EditAbsenceType200ResponseFromJSON,
  EditAbsenceType200ResponseFromJSONTyped,
  EditAbsenceType200ResponseToJSON,
  EditContactPersonRequestFromJSON,
  EditContactPersonRequestFromJSONTyped,
  EditContactPersonRequestToJSON,
  EditExpenseRequestFromJSON,
  EditExpenseRequestFromJSONTyped,
  EditExpenseRequestStatusEnum,
  EditExpenseRequestToJSON,
  EditInvoiceRequestFromJSON,
  EditInvoiceRequestFromJSONTyped,
  EditInvoiceRequestToJSON,
  EditOfferRequestFromJSON,
  EditOfferRequestFromJSONTyped,
  EditOfferRequestOfferLinesRuleEnum,
  EditOfferRequestToJSON,
  EditSubscriptionRequestFromJSON,
  EditSubscriptionRequestFromJSONTyped,
  EditSubscriptionRequestToJSON,
  EditTextTemplateRequestFromJSON,
  EditTextTemplateRequestFromJSONTyped,
  EditTextTemplateRequestToJSON,
  EditUserRequestAdminAccessEnum,
  EditUserRequestCustomIntegrationSettingsInnerFromJSON,
  EditUserRequestCustomIntegrationSettingsInnerFromJSONTyped,
  EditUserRequestCustomIntegrationSettingsInnerToJSON,
  EditUserRequestFromJSON,
  EditUserRequestFromJSONTyped,
  EditUserRequestToJSON,
  EmailActionEventEnum,
  EmailActionFromJSON,
  EmailActionFromJSONTyped,
  EmailActionToJSON,
  EmailFromJSON,
  EmailFromJSONTyped,
  EmailTemplateFromJSON,
  EmailTemplateFromJSONTyped,
  EmailTemplateToJSON,
  EmailToJSON,
  EntityIdFromJSON,
  EntityIdFromJSONTyped,
  EntityIdToJSON,
  ErrorNotFoundDataFromJSON,
  ErrorNotFoundDataFromJSONTyped,
  ErrorNotFoundDataToJSON,
  ErrorNotFoundFromJSON,
  ErrorNotFoundFromJSONTyped,
  ErrorNotFoundToJSON,
  ErrorValidationDataFromJSON,
  ErrorValidationDataFromJSONTyped,
  ErrorValidationDataToJSON,
  ErrorValidationFromJSON,
  ErrorValidationFromJSONTyped,
  ErrorValidationToJSON,
  ExpenseFromJSON,
  ExpenseFromJSONTyped,
  ExpenseLineFromJSON,
  ExpenseLineFromJSONTyped2 as ExpenseLineFromJSONTyped,
  ExpenseLineToJSON,
  ExpenseLinesList200ResponseAllOfDataInnerAllOfFromJSON,
  ExpenseLinesList200ResponseAllOfDataInnerAllOfFromJSONTyped,
  ExpenseLinesList200ResponseAllOfDataInnerAllOfToJSON,
  ExpenseLinesList200ResponseAllOfDataInnerFromJSON,
  ExpenseLinesList200ResponseAllOfDataInnerFromJSONTyped,
  ExpenseLinesList200ResponseAllOfDataInnerToJSON,
  ExpenseLinesList200ResponseAllOfFromJSON,
  ExpenseLinesList200ResponseAllOfFromJSONTyped,
  ExpenseLinesList200ResponseAllOfToJSON,
  ExpenseLinesList200ResponseFromJSON,
  ExpenseLinesList200ResponseFromJSONTyped,
  ExpenseLinesList200ResponseToJSON,
  ExpenseLinesListDirectionEnum,
  ExpenseLinesView200ResponseFromJSON,
  ExpenseLinesView200ResponseFromJSONTyped,
  ExpenseLinesView200ResponseToJSON,
  ExpenseReadDTOFromJSON,
  ExpenseReadDTOFromJSONTyped,
  ExpenseReadDTOStatusEnum,
  ExpenseReadDTOToJSON,
  ExpenseStatusEnum,
  ExpenseToJSON,
  ExpensesList200ResponseAllOfFromJSON,
  ExpensesList200ResponseAllOfFromJSONTyped,
  ExpensesList200ResponseAllOfToJSON,
  ExpensesList200ResponseFromJSON,
  ExpensesList200ResponseFromJSONTyped,
  ExpensesList200ResponseToJSON,
  ExpensesListDirectionEnum,
  ExpensesListStatusEnum,
  ExpensesView200ResponseFromJSON,
  ExpensesView200ResponseFromJSONTyped,
  ExpensesView200ResponseToJSON,
  FeatureFromJSON,
  FeatureFromJSONTyped,
  FeatureToJSON,
  FeedItemExpenseAllOfFromJSON,
  FeedItemExpenseAllOfFromJSONTyped,
  FeedItemExpenseAllOfToJSON,
  FeedItemExpenseFromJSON,
  FeedItemExpenseFromJSONTyped,
  FeedItemExpenseToJSON,
  FeedItemExpenseTypeEnum,
  FeedItemFormAllOfFromJSON,
  FeedItemFormAllOfFromJSONTyped,
  FeedItemFormAllOfToJSON,
  FeedItemFormFromJSON,
  FeedItemFormFromJSONTyped,
  FeedItemFormToJSON,
  FeedItemFormTypeEnum,
  FeedItemFromJSON,
  FeedItemFromJSONTyped,
  FeedItemInvoiceAllOfFromJSON,
  FeedItemInvoiceAllOfFromJSONTyped,
  FeedItemInvoiceAllOfToJSON,
  FeedItemInvoiceFromJSON,
  FeedItemInvoiceFromJSONTyped,
  FeedItemInvoiceToJSON,
  FeedItemInvoiceTypeEnum,
  FeedItemProjectFileAllOfFromJSON,
  FeedItemProjectFileAllOfFromJSONTyped,
  FeedItemProjectFileAllOfToJSON,
  FeedItemProjectFileFromJSON,
  FeedItemProjectFileFromJSONTyped,
  FeedItemProjectFileToJSON,
  FeedItemProjectFileTypeEnum,
  FeedItemToJSON,
  FeedItemTypeEnum,
  FeedItemWallPostAllOfFromJSON,
  FeedItemWallPostAllOfFromJSONTyped,
  FeedItemWallPostAllOfToJSON,
  FeedItemWallPostFromJSON,
  FeedItemWallPostFromJSONTyped,
  FeedItemWallPostToJSON,
  FeedItemWallPostTypeEnum,
  FeedMetadataDTOFromJSON,
  FeedMetadataDTOFromJSONTyped,
  FeedMetadataDTOToJSON,
  FeedPaginationDTOFromJSON,
  FeedPaginationDTOFromJSONTyped,
  FeedPaginationDTOToJSON,
  FetchError,
  FormDtoWithJsonFormsDataAllOfFromJSON,
  FormDtoWithJsonFormsDataAllOfFromJSONTyped,
  FormDtoWithJsonFormsDataAllOfToJSON,
  FormDtoWithJsonFormsDataFromJSON,
  FormDtoWithJsonFormsDataFromJSONTyped,
  FormDtoWithJsonFormsDataToJSON,
  FormFieldFromJSON,
  FormFieldFromJSONTyped,
  FormFieldToJSON,
  FormFromJSON,
  FormFromJSONTyped,
  FormReadDTOFromJSON,
  FormReadDTOFromJSONTyped,
  FormReadDTOToJSON,
  FormTemplateModelWithJsonFormsDataFieldsFromJSON,
  FormTemplateModelWithJsonFormsDataFieldsFromJSONTyped,
  FormTemplateModelWithJsonFormsDataFieldsToJSON,
  FormTemplateModelWithJsonFormsDataFromJSON,
  FormTemplateModelWithJsonFormsDataFromJSONTyped,
  FormTemplateModelWithJsonFormsDataToJSON,
  FormTemplateSimpleEntityFromJSON,
  FormTemplateSimpleEntityFromJSONTyped,
  FormTemplateSimpleEntityToJSON,
  FormTemplateView200ResponseFromJSON,
  FormTemplateView200ResponseFromJSONTyped,
  FormTemplateView200ResponseToJSON,
  FormTemplatesList200ResponseAllOfFromJSON,
  FormTemplatesList200ResponseAllOfFromJSONTyped,
  FormTemplatesList200ResponseAllOfToJSON,
  FormTemplatesList200ResponseFromJSON,
  FormTemplatesList200ResponseFromJSONTyped,
  FormTemplatesList200ResponseToJSON,
  FormTemplatesListDirectionEnum,
  FormTemplatesTasksModelFromJSON,
  FormTemplatesTasksModelFromJSONTyped,
  FormTemplatesTasksModelToJSON,
  FormToJSON,
  FormView200ResponseDataAllOfFromJSON,
  FormView200ResponseDataAllOfFromJSONTyped,
  FormView200ResponseDataAllOfToJSON,
  FormView200ResponseDataFromJSON,
  FormView200ResponseDataFromJSONTyped,
  FormView200ResponseDataToJSON,
  FormView200ResponseFromJSON,
  FormView200ResponseFromJSONTyped,
  FormView200ResponseToJSON,
  FormsList200ResponseAllOfFromJSON,
  FormsList200ResponseAllOfFromJSONTyped,
  FormsList200ResponseAllOfToJSON,
  FormsList200ResponseFromJSON,
  FormsList200ResponseFromJSONTyped,
  FormsList200ResponseToJSON,
  FormsListDirectionEnum,
  FrontpageFeedDTOFormFieldsFromJSON,
  FrontpageFeedDTOFormFieldsFromJSONTyped,
  FrontpageFeedDTOFormFieldsToJSON,
  FrontpageFeedDTOFromJSON,
  FrontpageFeedDTOFromJSONTyped,
  FrontpageFeedDTOToJSON,
  FrontpageFeedDTOTypeEnum,
  FrontpageTotalConsumptionDTOFromJSON,
  FrontpageTotalConsumptionDTOFromJSONTyped,
  FrontpageTotalConsumptionDTOToJSON,
  FrontpageWeeklyConsumptionDTOFromJSON,
  FrontpageWeeklyConsumptionDTOFromJSONTyped,
  FrontpageWeeklyConsumptionDTOToJSON,
  GatherOfferLines200ResponseFromJSON,
  GatherOfferLines200ResponseFromJSONTyped,
  GatherOfferLines200ResponseToJSON,
  GenericIndexResponseWithEntitiesAndPaginationOkFromJSON,
  GenericIndexResponseWithEntitiesAndPaginationOkFromJSONTyped,
  GenericIndexResponseWithEntitiesAndPaginationOkToJSON,
  GetAbsence200ResponseFromJSON,
  GetAbsence200ResponseFromJSONTyped,
  GetAbsence200ResponseToJSON,
  GetAbsenceType200ResponseFromJSON,
  GetAbsenceType200ResponseFromJSONTyped,
  GetAbsenceType200ResponseToJSON,
  GetAbsenceTypes200ResponseAllOfFromJSON,
  GetAbsenceTypes200ResponseAllOfFromJSONTyped,
  GetAbsenceTypes200ResponseAllOfToJSON,
  GetAbsenceTypes200ResponseFromJSON,
  GetAbsenceTypes200ResponseFromJSONTyped,
  GetAbsenceTypes200ResponseToJSON,
  GetAbsenceTypesDirectionEnum,
  GetAbsences200ResponseAllOfFromJSON,
  GetAbsences200ResponseAllOfFromJSONTyped,
  GetAbsences200ResponseAllOfToJSON,
  GetAbsences200ResponseFromJSON,
  GetAbsences200ResponseFromJSONTyped,
  GetAbsences200ResponseToJSON,
  GetAbsencesDirectionEnum,
  GetAllRegistrations200ResponseDataInnerFromJSON,
  GetAllRegistrations200ResponseDataInnerFromJSONTyped,
  GetAllRegistrations200ResponseDataInnerToJSON,
  GetAllRegistrations200ResponseDocumentTypesInnerFromJSON,
  GetAllRegistrations200ResponseDocumentTypesInnerFromJSONTyped,
  GetAllRegistrations200ResponseDocumentTypesInnerToJSON,
  GetAllRegistrations200ResponseFromJSON,
  GetAllRegistrations200ResponseFromJSONTyped,
  GetAllRegistrations200ResponseToJSON,
  GetAllRegistrationsDirectionEnum,
  GetCard200ResponseFromJSON,
  GetCard200ResponseFromJSONTyped,
  GetCard200ResponseToJSON,
  GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSON,
  GetCardsWithTaskAndUsers200ResponseDataAbsencesValueFromJSONTyped,
  GetCardsWithTaskAndUsers200ResponseDataAbsencesValueToJSON,
  GetCardsWithTaskAndUsers200ResponseDataFromJSON,
  GetCardsWithTaskAndUsers200ResponseDataFromJSONTyped,
  GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSON,
  GetCardsWithTaskAndUsers200ResponseDataTasksValueFromJSONTyped,
  GetCardsWithTaskAndUsers200ResponseDataTasksValueRepeatEnum,
  GetCardsWithTaskAndUsers200ResponseDataTasksValueToJSON,
  GetCardsWithTaskAndUsers200ResponseDataToJSON,
  GetCardsWithTaskAndUsers200ResponseFromJSON,
  GetCardsWithTaskAndUsers200ResponseFromJSONTyped,
  GetCardsWithTaskAndUsers200ResponseToJSON,
  GetCities200ResponseAllOfFromJSON,
  GetCities200ResponseAllOfFromJSONTyped,
  GetCities200ResponseAllOfToJSON,
  GetCities200ResponseFromJSON,
  GetCities200ResponseFromJSONTyped,
  GetCities200ResponseToJSON,
  GetCity200ResponseFromJSON,
  GetCity200ResponseFromJSONTyped,
  GetCity200ResponseToJSON,
  GetCompanies200ResponseAllOfFromJSON,
  GetCompanies200ResponseAllOfFromJSONTyped,
  GetCompanies200ResponseAllOfToJSON,
  GetCompanies200ResponseFromJSON,
  GetCompanies200ResponseFromJSONTyped,
  GetCompanies200ResponseToJSON,
  GetCompany200ResponseFromJSON,
  GetCompany200ResponseFromJSONTyped,
  GetCompany200ResponseToJSON,
  GetContact200ResponseFromJSON,
  GetContact200ResponseFromJSONTyped,
  GetContact200ResponseToJSON,
  GetContactPerson200ResponseFromJSON,
  GetContactPerson200ResponseFromJSONTyped,
  GetContactPerson200ResponseToJSON,
  GetContactPersonsList200ResponseAllOfFromJSON,
  GetContactPersonsList200ResponseAllOfFromJSONTyped,
  GetContactPersonsList200ResponseAllOfToJSON,
  GetContactPersonsList200ResponseFromJSON,
  GetContactPersonsList200ResponseFromJSONTyped,
  GetContactPersonsList200ResponseToJSON,
  GetContactPersonsListDirectionEnum,
  GetContacts200ResponseAllOfFromJSON,
  GetContacts200ResponseAllOfFromJSONTyped,
  GetContacts200ResponseAllOfToJSON,
  GetContacts200ResponseFromJSON,
  GetContacts200ResponseFromJSONTyped,
  GetContacts200ResponseToJSON,
  GetContactsDirectionEnum,
  GetCountries200ResponseFromJSON,
  GetCountries200ResponseFromJSONTyped,
  GetCountries200ResponseToJSON,
  GetEmailAction200ResponseAllOfFromJSON,
  GetEmailAction200ResponseAllOfFromJSONTyped,
  GetEmailAction200ResponseAllOfToJSON,
  GetEmailAction200ResponseFromJSON,
  GetEmailAction200ResponseFromJSONTyped,
  GetEmailAction200ResponseToJSON,
  GetFeatures200ResponseAllOfFromJSON,
  GetFeatures200ResponseAllOfFromJSONTyped,
  GetFeatures200ResponseAllOfToJSON,
  GetFeatures200ResponseFromJSON,
  GetFeatures200ResponseFromJSONTyped,
  GetFeatures200ResponseToJSON,
  GetIntegrationTypes200ResponseAllOfFromJSON,
  GetIntegrationTypes200ResponseAllOfFromJSONTyped,
  GetIntegrationTypes200ResponseAllOfToJSON,
  GetIntegrationTypes200ResponseFromJSON,
  GetIntegrationTypes200ResponseFromJSONTyped,
  GetIntegrationTypes200ResponseToJSON,
  GetInvoiceActivityLog200ResponseFromJSON,
  GetInvoiceActivityLog200ResponseFromJSONTyped,
  GetInvoiceActivityLog200ResponseToJSON,
  GetInvoiceEmails200ResponseAllOfFromJSON,
  GetInvoiceEmails200ResponseAllOfFromJSONTyped,
  GetInvoiceEmails200ResponseAllOfToJSON,
  GetInvoiceEmails200ResponseFromJSON,
  GetInvoiceEmails200ResponseFromJSONTyped,
  GetInvoiceEmails200ResponseToJSON,
  GetInvoiceEmailsDirectionEnum,
  GetInvoiceFiles200ResponseAllOfFromJSON,
  GetInvoiceFiles200ResponseAllOfFromJSONTyped,
  GetInvoiceFiles200ResponseAllOfToJSON,
  GetInvoiceFiles200ResponseFromJSON,
  GetInvoiceFiles200ResponseFromJSONTyped,
  GetInvoiceFiles200ResponseToJSON,
  GetInvoiceFilesDirectionEnum,
  GetInvoices200ResponseAllOfFromJSON,
  GetInvoices200ResponseAllOfFromJSONTyped,
  GetInvoices200ResponseAllOfToJSON,
  GetInvoices200ResponseFromJSON,
  GetInvoices200ResponseFromJSONTyped,
  GetInvoices200ResponseToJSON,
  GetInvoicesDirectionEnum,
  GetLabel200ResponseFromJSON,
  GetLabel200ResponseFromJSONTyped,
  GetLabel200ResponseToJSON,
  GetLabels200ResponseAllOfFromJSON,
  GetLabels200ResponseAllOfFromJSONTyped,
  GetLabels200ResponseAllOfToJSON,
  GetLabels200ResponseFromJSON,
  GetLabels200ResponseFromJSONTyped,
  GetLabels200ResponseToJSON,
  GetLabelsDirectionEnum,
  GetLanguages200ResponseFromJSON,
  GetLanguages200ResponseFromJSONTyped,
  GetLanguages200ResponseToJSON,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSON,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerFromJSONTyped,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSON,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeFromJSONTyped,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTimeToJSON,
  GetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerToJSON,
  GetMe200ResponseCompanySettingsFromJSON,
  GetMe200ResponseCompanySettingsFromJSONTyped,
  GetMe200ResponseCompanySettingsProductPricesSettingEnum,
  GetMe200ResponseCompanySettingsSalesPriceByCostPriceEnum,
  GetMe200ResponseCompanySettingsToJSON,
  GetMe200ResponseErpIntegrationCapabilitiesFromJSON,
  GetMe200ResponseErpIntegrationCapabilitiesFromJSONTyped,
  GetMe200ResponseErpIntegrationCapabilitiesToJSON,
  GetMe200ResponseFeaturesEnum,
  GetMe200ResponseFromJSON,
  GetMe200ResponseFromJSONTyped,
  GetMe200ResponseIntegrationsEnabledFromJSON,
  GetMe200ResponseIntegrationsEnabledFromJSONTyped,
  GetMe200ResponseIntegrationsEnabledToJSON,
  GetMe200ResponseIntegrationsErpEnum,
  GetMe200ResponseIntegrationsFromJSON,
  GetMe200ResponseIntegrationsFromJSONTyped,
  GetMe200ResponseIntegrationsSalaryEnum,
  GetMe200ResponseIntegrationsToJSON,
  GetMe200ResponseLogosFromJSON,
  GetMe200ResponseLogosFromJSONTyped,
  GetMe200ResponseLogosToJSON,
  GetMe200ResponseSubscriptionFromJSON,
  GetMe200ResponseSubscriptionFromJSONTyped,
  GetMe200ResponseSubscriptionToJSON,
  GetMe200ResponseToJSON,
  GetMe200ResponseUserAdminAccessEnum,
  GetMe200ResponseUserAllOfFromJSON,
  GetMe200ResponseUserAllOfFromJSONTyped,
  GetMe200ResponseUserAllOfToJSON,
  GetMe200ResponseUserFromJSON,
  GetMe200ResponseUserFromJSONTyped,
  GetMe200ResponseUserToJSON,
  GetOfferActionLogs200ResponseAllOfFromJSON,
  GetOfferActionLogs200ResponseAllOfFromJSONTyped,
  GetOfferActionLogs200ResponseAllOfToJSON,
  GetOfferActionLogs200ResponseFromJSON,
  GetOfferActionLogs200ResponseFromJSONTyped,
  GetOfferActionLogs200ResponseToJSON,
  GetOfferActionLogsDirectionEnum,
  GetOfferActions200ResponseAllOfFromJSON,
  GetOfferActions200ResponseAllOfFromJSONTyped,
  GetOfferActions200ResponseAllOfToJSON,
  GetOfferActions200ResponseFromJSON,
  GetOfferActions200ResponseFromJSONTyped,
  GetOfferActions200ResponseToJSON,
  GetOfferEmailsDirectionEnum,
  GetOfferFilesDirectionEnum,
  GetOfferLine200ResponseFromJSON,
  GetOfferLine200ResponseFromJSONTyped,
  GetOfferLine200ResponseToJSON,
  GetOfferLines200ResponseAllOfFromJSON,
  GetOfferLines200ResponseAllOfFromJSONTyped,
  GetOfferLines200ResponseAllOfToJSON,
  GetOfferLines200ResponseFromJSON,
  GetOfferLines200ResponseFromJSONTyped,
  GetOfferLines200ResponseToJSON,
  GetOfferLinesDirectionEnum,
  GetOfferPdf200ResponseAllOfFromJSON,
  GetOfferPdf200ResponseAllOfFromJSONTyped,
  GetOfferPdf200ResponseAllOfToJSON,
  GetOfferPdf200ResponseFromJSON,
  GetOfferPdf200ResponseFromJSONTyped,
  GetOfferPdf200ResponseToJSON,
  GetOfferPdfDirectionEnum,
  GetPaymentTerms200ResponseFromJSON,
  GetPaymentTerms200ResponseFromJSONTyped,
  GetPaymentTerms200ResponseToJSON,
  GetProductCustomFieldAttribute200ResponseFromJSON,
  GetProductCustomFieldAttribute200ResponseFromJSONTyped,
  GetProductCustomFieldAttribute200ResponseToJSON,
  GetProject200ResponseFromJSON,
  GetProject200ResponseFromJSONTyped,
  GetProject200ResponseToJSON,
  GetProjectCustomFieldAttributes200ResponseAllOfFromJSON,
  GetProjectCustomFieldAttributes200ResponseAllOfFromJSONTyped,
  GetProjectCustomFieldAttributes200ResponseAllOfToJSON,
  GetProjectCustomFieldAttributes200ResponseFromJSON,
  GetProjectCustomFieldAttributes200ResponseFromJSONTyped,
  GetProjectCustomFieldAttributes200ResponseToJSON,
  GetProjectCustomFieldAttributesDirectionEnum,
  GetProjects200ResponseAllOfFromJSON,
  GetProjects200ResponseAllOfFromJSONTyped,
  GetProjects200ResponseAllOfToJSON,
  GetProjects200ResponseFromJSON,
  GetProjects200ResponseFromJSONTyped,
  GetProjects200ResponseToJSON,
  GetProjectsDirectionEnum,
  GetTask200ResponseFromJSON,
  GetTask200ResponseFromJSONTyped,
  GetTask200ResponseToJSON,
  GetTaskProduct200ResponseFromJSON,
  GetTaskProduct200ResponseFromJSONTyped,
  GetTaskProduct200ResponseToJSON,
  GetTaskProducts200ResponseFromJSON,
  GetTaskProducts200ResponseFromJSONTyped,
  GetTaskProducts200ResponseToJSON,
  GetTasksDirectionEnum,
  GetTextTemplate200ResponseFromJSON,
  GetTextTemplate200ResponseFromJSONTyped,
  GetTextTemplate200ResponseToJSON,
  GetTextTemplates200ResponseAllOfFromJSON,
  GetTextTemplates200ResponseAllOfFromJSONTyped,
  GetTextTemplates200ResponseAllOfToJSON,
  GetTextTemplates200ResponseFromJSON,
  GetTextTemplates200ResponseFromJSONTyped,
  GetTextTemplates200ResponseToJSON,
  GetTextTemplatesDirectionEnum,
  GetTimeEntryRuleGroups200ResponseFromJSON,
  GetTimeEntryRuleGroups200ResponseFromJSONTyped,
  GetTimeEntryRuleGroups200ResponseToJSON,
  GetUserNotifications200ResponseAllOfFromJSON,
  GetUserNotifications200ResponseAllOfFromJSONTyped,
  GetUserNotifications200ResponseAllOfToJSON,
  GetUserNotifications200ResponseFromJSON,
  GetUserNotifications200ResponseFromJSONTyped,
  GetUserNotifications200ResponseToJSON,
  GetUsers200ResponseAllOfFromJSON,
  GetUsers200ResponseAllOfFromJSONTyped,
  GetUsers200ResponseAllOfToJSON,
  GetUsers200ResponseFromJSON,
  GetUsers200ResponseFromJSONTyped,
  GetUsers200ResponseToJSON,
  GetUsersDirectionEnum,
  GetVendor200ResponseFromJSON,
  GetVendor200ResponseFromJSONTyped,
  GetVendor200ResponseToJSON,
  GetVendors200ResponseAllOfFromJSON,
  GetVendors200ResponseAllOfFromJSONTyped,
  GetVendors200ResponseAllOfToJSON,
  GetVendors200ResponseFromJSON,
  GetVendors200ResponseFromJSONTyped,
  GetVendors200ResponseToJSON,
  GetVendorsDirectionEnum,
  GetWallPost200ResponseFromJSON,
  GetWallPost200ResponseFromJSONTyped,
  GetWallPost200ResponseToJSON,
  GetWallPosts200ResponseAllOfFromJSON,
  GetWallPosts200ResponseAllOfFromJSONTyped,
  GetWallPosts200ResponseAllOfToJSON,
  GetWallPosts200ResponseFromJSON,
  GetWallPosts200ResponseFromJSONTyped,
  GetWallPosts200ResponseToJSON,
  GetWallPostsDirectionEnum,
  HasIntegrationOfType200ResponseFromJSON,
  HasIntegrationOfType200ResponseFromJSONTyped,
  HasIntegrationOfType200ResponseToJSON,
  HasIntegrationOfTypeIdentifierEnum,
  ICreateProductBundleLineRequestFromJSON,
  ICreateProductBundleLineRequestFromJSONTyped,
  ICreateProductBundleLineRequestToJSON,
  ICreateProductBundleRequestFromJSON,
  ICreateProductBundleRequestFromJSONTyped,
  ICreateProductBundleRequestProductBundleLinesInnerFromJSON,
  ICreateProductBundleRequestProductBundleLinesInnerFromJSONTyped,
  ICreateProductBundleRequestProductBundleLinesInnerToJSON,
  ICreateProductBundleRequestToJSON,
  ICreateProjectRequestFromJSON,
  ICreateProjectRequestFromJSONTyped,
  ICreateProjectRequestToJSON,
  IDeleteCard200ResponseFromJSON,
  IDeleteCard200ResponseFromJSONTyped,
  IDeleteCard200ResponseToJSON,
  IDeleteCardRequestFromJSON,
  IDeleteCardRequestFromJSONTyped,
  IDeleteCardRequestToJSON,
  IEditWallCommentRequestFromJSON,
  IEditWallCommentRequestFromJSONTyped,
  IEditWallCommentRequestToJSON,
  IEditWallPost200ResponseFromJSON,
  IEditWallPost200ResponseFromJSONTyped,
  IEditWallPost200ResponseToJSON,
  IFormUploadFiles200ResponseDataInnerFromJSON,
  IFormUploadFiles200ResponseDataInnerFromJSONTyped,
  IFormUploadFiles200ResponseDataInnerToJSON,
  IFormUploadFiles200ResponseFromJSON,
  IFormUploadFiles200ResponseFromJSONTyped,
  IFormUploadFiles200ResponseToJSON,
  IGetActivities200ResponseAllOfFromJSON,
  IGetActivities200ResponseAllOfFromJSONTyped,
  IGetActivities200ResponseAllOfToJSON,
  IGetActivities200ResponseFromJSON,
  IGetActivities200ResponseFromJSONTyped,
  IGetActivities200ResponseToJSON,
  IGetActivitiesDirectionEnum,
  IGetConsumption200ResponseDataFromJSON,
  IGetConsumption200ResponseDataFromJSONTyped,
  IGetConsumption200ResponseDataToJSON,
  IGetConsumption200ResponseDataWeeklyConsumptionFromJSON,
  IGetConsumption200ResponseDataWeeklyConsumptionFromJSONTyped,
  IGetConsumption200ResponseDataWeeklyConsumptionToJSON,
  IGetConsumption200ResponseFromJSON,
  IGetConsumption200ResponseFromJSONTyped,
  IGetConsumption200ResponseToJSON,
  IGetCustomEmailTemplates200ResponseFromJSON,
  IGetCustomEmailTemplates200ResponseFromJSONTyped,
  IGetCustomEmailTemplates200ResponseToJSON,
  IGetCustomEmailTemplatesTypeEnum,
  IGetFeed200ResponseFromJSON,
  IGetFeed200ResponseFromJSONTyped,
  IGetFeed200ResponseToJSON,
  IGetFeedForProjectTypeEnum,
  IGetFeedMetadata200ResponseFromJSON,
  IGetFeedMetadata200ResponseFromJSONTyped,
  IGetFeedMetadata200ResponseToJSON,
  IGetFrontpageInvoiced200ResponseDataFromJSON,
  IGetFrontpageInvoiced200ResponseDataFromJSONTyped,
  IGetFrontpageInvoiced200ResponseDataToJSON,
  IGetFrontpageInvoiced200ResponseDataTotalFromJSON,
  IGetFrontpageInvoiced200ResponseDataTotalFromJSONTyped,
  IGetFrontpageInvoiced200ResponseDataTotalToJSON,
  IGetFrontpageInvoiced200ResponseDataWeeklyFromJSON,
  IGetFrontpageInvoiced200ResponseDataWeeklyFromJSONTyped,
  IGetFrontpageInvoiced200ResponseDataWeeklyToJSON,
  IGetFrontpageInvoiced200ResponseFromJSON,
  IGetFrontpageInvoiced200ResponseFromJSONTyped,
  IGetFrontpageInvoiced200ResponseToJSON,
  IGetInvoice200ResponseFromJSON,
  IGetInvoice200ResponseFromJSONTyped,
  IGetInvoice200ResponseToJSON,
  IGetProject200ResponseDataAllOfFromJSON,
  IGetProject200ResponseDataAllOfFromJSONTyped,
  IGetProject200ResponseDataAllOfToJSON,
  IGetProject200ResponseDataFromJSON,
  IGetProject200ResponseDataFromJSONTyped,
  IGetProject200ResponseDataProjectTypeEnum,
  IGetProject200ResponseDataToJSON,
  IGetProject200ResponseFromJSON,
  IGetProject200ResponseFromJSONTyped,
  IGetProject200ResponseToJSON,
  IGetTask200ResponseDataFromJSON,
  IGetTask200ResponseDataFromJSONTyped,
  IGetTask200ResponseDataRepeatEnum,
  IGetTask200ResponseDataToJSON,
  IGetTask200ResponseFromJSON,
  IGetTask200ResponseFromJSONTyped,
  IGetTask200ResponseToJSON,
  IGetTasksForProject200ResponseAllOfFromJSON,
  IGetTasksForProject200ResponseAllOfFromJSONTyped,
  IGetTasksForProject200ResponseAllOfToJSON,
  IGetTasksForProject200ResponseFromJSON,
  IGetTasksForProject200ResponseFromJSONTyped,
  IGetTasksForProject200ResponseToJSON,
  IGetTasksForProjectDirectionEnum,
  IGetWorkRelated200ResponseAllOfDataFromJSON,
  IGetWorkRelated200ResponseAllOfDataFromJSONTyped,
  IGetWorkRelated200ResponseAllOfDataToJSON,
  IGetWorkRelated200ResponseAllOfFromJSON,
  IGetWorkRelated200ResponseAllOfFromJSONTyped,
  IGetWorkRelated200ResponseAllOfToJSON,
  IGetWorkRelated200ResponseFromJSON,
  IGetWorkRelated200ResponseFromJSONTyped,
  IGetWorkRelated200ResponseToJSON,
  IListInvoices200ResponseAllOfFromJSON,
  IListInvoices200ResponseAllOfFromJSONTyped,
  IListInvoices200ResponseAllOfToJSON,
  IListInvoices200ResponseFromJSON,
  IListInvoices200ResponseFromJSONTyped,
  IListInvoices200ResponseToJSON,
  IListInvoicesDirectionEnum,
  IListInvoicesFilterEnum,
  IListOfferStatuses200ResponseAllOfFromJSON,
  IListOfferStatuses200ResponseAllOfFromJSONTyped,
  IListOfferStatuses200ResponseAllOfToJSON,
  IListOfferStatuses200ResponseFromJSON,
  IListOfferStatuses200ResponseFromJSONTyped,
  IListOfferStatuses200ResponseToJSON,
  IListProjectStatuses200ResponseAllOfFromJSON,
  IListProjectStatuses200ResponseAllOfFromJSONTyped,
  IListProjectStatuses200ResponseAllOfToJSON,
  IListProjectStatuses200ResponseFromJSON,
  IListProjectStatuses200ResponseFromJSONTyped,
  IListProjectStatuses200ResponseToJSON,
  IListProjects200ResponseAllOfFromJSON,
  IListProjects200ResponseAllOfFromJSONTyped,
  IListProjects200ResponseAllOfToJSON,
  IListProjects200ResponseFromJSON,
  IListProjects200ResponseFromJSONTyped,
  IListProjects200ResponseToJSON,
  IListProjectsDirectionEnum,
  IListProjectsProjectStatusEnum,
  IListTasks200ResponseAllOfFromJSON,
  IListTasks200ResponseAllOfFromJSONTyped,
  IListTasks200ResponseAllOfToJSON,
  IListTasks200ResponseFromJSON,
  IListTasks200ResponseFromJSONTyped,
  IListTasks200ResponseToJSON,
  IListTasksDirectionEnum,
  IListWallComments200ResponseInnerFromJSON,
  IListWallComments200ResponseInnerFromJSONTyped,
  IListWallComments200ResponseInnerToJSON,
  IListWallCommentsDirectionEnum,
  IProductBundleSetSalesPrice200ResponseFromJSON,
  IProductBundleSetSalesPrice200ResponseFromJSONTyped,
  IProductBundleSetSalesPrice200ResponseToJSON,
  IProductBundleSetSalesPriceRequestFromJSON,
  IProductBundleSetSalesPriceRequestFromJSONTyped,
  IProductBundleSetSalesPriceRequestToJSON,
  IProductBundleUploadFile200ResponseFromJSON,
  IProductBundleUploadFile200ResponseFromJSONTyped,
  IProductBundleUploadFile200ResponseToJSON,
  IProjectDeleteFileRequestInnerFromJSON,
  IProjectDeleteFileRequestInnerFromJSONTyped,
  IProjectDeleteFileRequestInnerToJSON,
  IProjectDeleteFileRequestInnerTypeEnum,
  IProjectListFiles200ResponseAllOfDataInnerFromJSON,
  IProjectListFiles200ResponseAllOfDataInnerFromJSONTyped,
  IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSON,
  IProjectListFiles200ResponseAllOfDataInnerImageUrlsFromJSONTyped,
  IProjectListFiles200ResponseAllOfDataInnerImageUrlsToJSON,
  IProjectListFiles200ResponseAllOfDataInnerToJSON,
  IProjectListFiles200ResponseAllOfDataInnerTypeEnum,
  IProjectListFiles200ResponseAllOfFromJSON,
  IProjectListFiles200ResponseAllOfFromJSONTyped,
  IProjectListFiles200ResponseAllOfToJSON,
  IProjectListFiles200ResponseFromJSON,
  IProjectListFiles200ResponseFromJSONTyped,
  IProjectListFiles200ResponseToJSON,
  IProjectListFilesDirectionEnum,
  IProjectSendFilesRequestFromJSON,
  IProjectSendFilesRequestFromJSONTyped,
  IProjectSendFilesRequestToJSON,
  IProjectSendFilesRequestTypeEnum,
  ISendProjectForms200ResponseFromJSON,
  ISendProjectForms200ResponseFromJSONTyped,
  ISendProjectForms200ResponseToJSON,
  ISendProjectFormsRequestFromJSON,
  ISendProjectFormsRequestFromJSONTyped,
  ISendProjectFormsRequestToJSON,
  IStandardFileUploadTypeEnum,
  IStandardFilesList200ResponseAllOfFromJSON,
  IStandardFilesList200ResponseAllOfFromJSONTyped,
  IStandardFilesList200ResponseAllOfToJSON,
  IStandardFilesList200ResponseFromJSON,
  IStandardFilesList200ResponseFromJSONTyped,
  IStandardFilesList200ResponseToJSON,
  IStandardFilesListDirectionEnum,
  IWallpostDeleteFile200ResponseFromJSON,
  IWallpostDeleteFile200ResponseFromJSONTyped,
  IWallpostDeleteFile200ResponseToJSON,
  ImageUrlsFromJSON,
  ImageUrlsFromJSONTyped,
  ImageUrlsToJSON,
  IntegrationFromJSON,
  IntegrationFromJSONTyped,
  IntegrationSettingFromJSON,
  IntegrationSettingFromJSONTyped,
  IntegrationSettingToJSON,
  IntegrationSettingUsersInnerFromJSON,
  IntegrationSettingUsersInnerFromJSONTyped,
  IntegrationSettingUsersInnerJoinDataFromJSON,
  IntegrationSettingUsersInnerJoinDataFromJSONTyped,
  IntegrationSettingUsersInnerJoinDataToJSON,
  IntegrationSettingUsersInnerToJSON,
  IntegrationToJSON,
  IntegrationTypeFromJSON,
  IntegrationTypeFromJSONTyped,
  IntegrationTypeToJSON,
  IntegrationsApi,
  InvoiceActivityLogActionEnum,
  InvoiceActivityLogFromJSON,
  InvoiceActivityLogFromJSONTyped,
  InvoiceActivityLogToJSON,
  InvoiceFromJSON,
  InvoiceFromJSONTyped,
  InvoiceIntegrationFromJSON,
  InvoiceIntegrationFromJSONTyped,
  InvoiceIntegrationToJSON,
  InvoiceLineFromJSON,
  InvoiceLineFromJSONTyped,
  InvoiceLineInvoiceTypeEnum,
  InvoiceLineToJSON,
  InvoiceLineTypeEnum,
  InvoiceReadDTOFromJSON,
  InvoiceReadDTOFromJSONTyped,
  InvoiceReadDTOToJSON,
  InvoiceToJSON,
  InvoicesView200ResponseFromJSON,
  InvoicesView200ResponseFromJSONTyped,
  InvoicesView200ResponseToJSON,
  IsCheckedIn200ResponseDataFromJSON,
  IsCheckedIn200ResponseDataFromJSONTyped,
  IsCheckedIn200ResponseDataToJSON,
  IsCheckedIn200ResponseFromJSON,
  IsCheckedIn200ResponseFromJSONTyped,
  IsCheckedIn200ResponseToJSON,
  JSONApiResponse,
  KpiCardEconomyPriceFromJSON,
  KpiCardEconomyPriceFromJSONTyped,
  KpiCardEconomyPriceToJSON,
  KpiCardHoursSummedIndividualEntryFromJSON,
  KpiCardHoursSummedIndividualEntryFromJSONTyped,
  KpiCardHoursSummedIndividualEntryToJSON,
  KpiCardHoursSummedIndividualEntryTypeEnum,
  KpiCardPreCalculationIndividualEntryFromJSON,
  KpiCardPreCalculationIndividualEntryFromJSONTyped,
  KpiCardPreCalculationIndividualEntryToJSON,
  KpiCardProductsIndividualEntryFromJSON,
  KpiCardProductsIndividualEntryFromJSONTyped,
  KpiCardProductsIndividualEntryOriginTypeEnum,
  KpiCardProductsIndividualEntryToJSON,
  KpiCardProductsIndividualEntryTypeEnum,
  KpiCardsIndexResponseContributionMarginsFromJSON,
  KpiCardsIndexResponseContributionMarginsFromJSONTyped,
  KpiCardsIndexResponseContributionMarginsToJSON,
  KpiCardsIndexResponseFromJSON,
  KpiCardsIndexResponseFromJSONTyped,
  KpiCardsIndexResponsePreCalculationFromJSON,
  KpiCardsIndexResponsePreCalculationFromJSONTyped,
  KpiCardsIndexResponsePreCalculationToJSON,
  KpiCardsIndexResponseToJSON,
  KpiChardHoursIndividualEntryFromJSON,
  KpiChardHoursIndividualEntryFromJSONTyped,
  KpiChardHoursIndividualEntryToJSON,
  KpiChardHoursIndividualEntryTypeEnum,
  LabelEntityEntityEnum,
  LabelEntityFromJSON,
  LabelEntityFromJSONTyped,
  LabelEntityToJSON,
  LanguageFromJSON,
  LanguageFromJSONTyped,
  LanguageToJSON,
  ListUsersDirectionEnum,
  LoginWithEmail200ResponseFromJSON,
  LoginWithEmail200ResponseFromJSONTyped,
  LoginWithEmail200ResponseToJSON,
  LoginWithEmailRequestFromJSON,
  LoginWithEmailRequestFromJSONTyped,
  LoginWithEmailRequestToJSON,
  LookupCVR200ResponseFromJSON,
  LookupCVR200ResponseFromJSONTyped,
  LookupCVR200ResponseToJSON,
  MergeProjectsRequestFromJSON,
  MergeProjectsRequestFromJSONTyped,
  MergeProjectsRequestToJSON,
  MobileAppApi,
  MobileGetCards200ResponseDataInnerAllOfFromJSON,
  MobileGetCards200ResponseDataInnerAllOfFromJSONTyped,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfFromJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfFromJSONTyped,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfFromJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfFromJSONTyped,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOfToJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectFromJSONTyped,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectToJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskAllOfToJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskFromJSON,
  MobileGetCards200ResponseDataInnerAllOfTaskFromJSONTyped,
  MobileGetCards200ResponseDataInnerAllOfTaskRepeatEnum,
  MobileGetCards200ResponseDataInnerAllOfTaskToJSON,
  MobileGetCards200ResponseDataInnerAllOfToJSON,
  MobileGetCards200ResponseDataInnerFromJSON,
  MobileGetCards200ResponseDataInnerFromJSONTyped,
  MobileGetCards200ResponseDataInnerStatusEnum,
  MobileGetCards200ResponseDataInnerToJSON,
  MobileGetCards200ResponseDataInnerTypeEnum,
  MobileGetCards200ResponseFromJSON,
  MobileGetCards200ResponseFromJSONTyped,
  MobileGetCards200ResponseToJSON,
  MobilePlanningCreateCardAndTask201ResponseDataFromJSON,
  MobilePlanningCreateCardAndTask201ResponseDataFromJSONTyped,
  MobilePlanningCreateCardAndTask201ResponseDataToJSON,
  MobilePlanningCreateCardAndTask201ResponseFromJSON,
  MobilePlanningCreateCardAndTask201ResponseFromJSONTyped,
  MobilePlanningCreateCardAndTask201ResponseToJSON,
  MobilePlanningCreateCardAndTaskRequestFromJSON,
  MobilePlanningCreateCardAndTaskRequestFromJSONTyped,
  MobilePlanningCreateCardAndTaskRequestToJSON,
  MobilePlanningEditCardRequestFromJSON,
  MobilePlanningEditCardRequestFromJSONTyped,
  MobilePlanningEditCardRequestToJSON,
  MobilePlanningGetCard200ResponseDataAllOfFromJSON,
  MobilePlanningGetCard200ResponseDataAllOfFromJSONTyped,
  MobilePlanningGetCard200ResponseDataAllOfTaskAllOfFromJSON,
  MobilePlanningGetCard200ResponseDataAllOfTaskAllOfFromJSONTyped,
  MobilePlanningGetCard200ResponseDataAllOfTaskAllOfToJSON,
  MobilePlanningGetCard200ResponseDataAllOfTaskFromJSON,
  MobilePlanningGetCard200ResponseDataAllOfTaskFromJSONTyped,
  MobilePlanningGetCard200ResponseDataAllOfTaskRepeatEnum,
  MobilePlanningGetCard200ResponseDataAllOfTaskToJSON,
  MobilePlanningGetCard200ResponseDataAllOfToJSON,
  MobilePlanningGetCard200ResponseDataFromJSON,
  MobilePlanningGetCard200ResponseDataFromJSONTyped,
  MobilePlanningGetCard200ResponseDataStatusEnum,
  MobilePlanningGetCard200ResponseDataToJSON,
  MobilePlanningGetCard200ResponseDataTypeEnum,
  MobilePlanningGetCard200ResponseFromJSON,
  MobilePlanningGetCard200ResponseFromJSONTyped,
  MobilePlanningGetCard200ResponseToJSON,
  OfferAcceptRequestFromJSON,
  OfferAcceptRequestFromJSONTyped,
  OfferAcceptRequestToJSON,
  OfferAcceptedByEnum,
  OfferActionActionEnum,
  OfferActionFromJSON,
  OfferActionFromJSONTyped,
  OfferActionToJSON,
  OfferAddProductBundleRequestFromJSON,
  OfferAddProductBundleRequestFromJSONTyped,
  OfferAddProductBundleRequestToJSON,
  OfferCancelRequestFromJSON,
  OfferCancelRequestFromJSONTyped,
  OfferCancelRequestToJSON,
  OfferCompanyFromJSON,
  OfferCompanyFromJSONTyped,
  OfferCompanyToJSON,
  OfferContactFromJSON,
  OfferContactFromJSONTyped,
  OfferContactPersonFromJSON,
  OfferContactPersonFromJSONTyped,
  OfferContactPersonToJSON,
  OfferContactToJSON,
  OfferFromJSON,
  OfferFromJSONTyped,
  OfferLineDiscountTypeEnum,
  OfferLineFromJSON,
  OfferLineFromJSONTyped,
  OfferLineToJSON,
  OfferLineTypeEnum,
  OfferOfferLinesRuleEnum,
  OfferOfferStatusFromJSON,
  OfferOfferStatusFromJSONTyped,
  OfferOfferStatusToJSON,
  OfferProjectFromJSON,
  OfferProjectFromJSONTyped,
  OfferProjectToJSON,
  OfferStatusEnum,
  OfferToJSON,
  OffersList200ResponseAllOfFromJSON,
  OffersList200ResponseAllOfFromJSONTyped,
  OffersList200ResponseAllOfToJSON,
  OffersList200ResponseFromJSON,
  OffersList200ResponseFromJSONTyped,
  OffersList200ResponseToJSON,
  OffersListDirectionEnum,
  OffersView200ResponseFromJSON,
  OffersView200ResponseFromJSONTyped,
  OffersView200ResponseToJSON,
  PaginationDetailsFromJSON,
  PaginationDetailsFromJSONTyped,
  PaginationDetailsToJSON,
  PaymentTermFromJSON,
  PaymentTermFromJSONTyped,
  PaymentTermToJSON,
  PaymentTermTypeFromJSON,
  PaymentTermTypeFromJSONTyped,
  PaymentTermTypeToJSON,
  PriceHistoryFromJSON,
  PriceHistoryFromJSONTyped,
  PriceHistoryToJSON,
  PriceHistoryTypeEnum,
  PriceMarginFromJSON,
  PriceMarginFromJSONTyped,
  PriceMarginToJSON,
  ProductBundleFileFromJSON,
  ProductBundleFileFromJSONTyped,
  ProductBundleFileToJSON,
  ProductBundleFromJSON,
  ProductBundleFromJSONTyped,
  ProductBundleLineFromJSON,
  ProductBundleLineFromJSONTyped,
  ProductBundleLineToJSON,
  ProductBundleLineView200ResponseFromJSON,
  ProductBundleLineView200ResponseFromJSONTyped,
  ProductBundleLineView200ResponseToJSON,
  ProductBundleLinesList200ResponseAllOfFromJSON,
  ProductBundleLinesList200ResponseAllOfFromJSONTyped,
  ProductBundleLinesList200ResponseAllOfToJSON,
  ProductBundleLinesList200ResponseFromJSON,
  ProductBundleLinesList200ResponseFromJSONTyped,
  ProductBundleLinesList200ResponseToJSON,
  ProductBundleLinesListDirectionEnum,
  ProductBundleToJSON,
  ProductBundlesGetKpiCardsData200ResponseDataFromJSON,
  ProductBundlesGetKpiCardsData200ResponseDataFromJSONTyped,
  ProductBundlesGetKpiCardsData200ResponseDataToJSON,
  ProductBundlesGetKpiCardsData200ResponseFromJSON,
  ProductBundlesGetKpiCardsData200ResponseFromJSONTyped,
  ProductBundlesGetKpiCardsData200ResponseToJSON,
  ProductBundlesList200ResponseAllOfFromJSON,
  ProductBundlesList200ResponseAllOfFromJSONTyped,
  ProductBundlesList200ResponseAllOfToJSON,
  ProductBundlesList200ResponseFromJSON,
  ProductBundlesList200ResponseFromJSONTyped,
  ProductBundlesList200ResponseToJSON,
  ProductBundlesListDirectionEnum,
  ProductBundlesView200ResponseFromJSON,
  ProductBundlesView200ResponseFromJSONTyped,
  ProductBundlesView200ResponseToJSON,
  ProductFromJSON,
  ProductFromJSONTyped,
  ProductPriceHistory200ResponseAllOfFromJSON,
  ProductPriceHistory200ResponseAllOfFromJSONTyped,
  ProductPriceHistory200ResponseAllOfToJSON,
  ProductPriceHistory200ResponseFromJSON,
  ProductPriceHistory200ResponseFromJSONTyped,
  ProductPriceHistory200ResponseToJSON,
  ProductPriceTypeEnum,
  ProductToJSON,
  ProductVariantFromJSON,
  ProductVariantFromJSONTyped,
  ProductVariantToJSON,
  ProductVariantTypeEnum,
  ProductVariants200ResponseAllOfFromJSON,
  ProductVariants200ResponseAllOfFromJSONTyped,
  ProductVariants200ResponseAllOfToJSON,
  ProductVariants200ResponseFromJSON,
  ProductVariants200ResponseFromJSONTyped,
  ProductVariants200ResponseToJSON,
  ProductsList200ResponseAllOfDataInnerAllOfFromJSON,
  ProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped,
  ProductsList200ResponseAllOfDataInnerAllOfToJSON,
  ProductsList200ResponseAllOfDataInnerFromJSON,
  ProductsList200ResponseAllOfDataInnerFromJSONTyped,
  ProductsList200ResponseAllOfDataInnerPriceTypeEnum,
  ProductsList200ResponseAllOfDataInnerToJSON,
  ProductsList200ResponseAllOfFromJSON,
  ProductsList200ResponseAllOfFromJSONTyped,
  ProductsList200ResponseAllOfToJSON,
  ProductsList200ResponseFromJSON,
  ProductsList200ResponseFromJSONTyped,
  ProductsList200ResponseToJSON,
  ProductsListDirectionEnum,
  ProductsTaskFromJSON,
  ProductsTaskFromJSONTyped,
  ProductsTaskToJSON,
  ProductsView200ResponseFromJSON,
  ProductsView200ResponseFromJSONTyped,
  ProductsView200ResponseToJSON,
  ProjectCustomFieldAttributeAccessTypeEnum,
  ProjectCustomFieldAttributeFromJSON,
  ProjectCustomFieldAttributeFromJSONTyped,
  ProjectCustomFieldAttributeToJSON,
  ProjectFileReadDTOFromJSON,
  ProjectFileReadDTOFromJSONTyped,
  ProjectFileReadDTOToJSON,
  ProjectFileReadDTOTypeEnum,
  ProjectFromJSON,
  ProjectFromJSONTyped,
  ProjectGetKpiCardEconomySubPage200ResponseDataFromJSON,
  ProjectGetKpiCardEconomySubPage200ResponseDataFromJSONTyped,
  ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSON,
  ProjectGetKpiCardEconomySubPage200ResponseDataIntervalFromJSONTyped,
  ProjectGetKpiCardEconomySubPage200ResponseDataIntervalToJSON,
  ProjectGetKpiCardEconomySubPage200ResponseDataToJSON,
  ProjectGetKpiCardEconomySubPage200ResponseFromJSON,
  ProjectGetKpiCardEconomySubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardEconomySubPage200ResponseToJSON,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSON,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerFromJSONTyped,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInnerToJSON,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSON,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardHoursAllFormsSubPage200ResponseToJSON,
  ProjectGetKpiCardHoursAllFormsSubPageDirectionEnum,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSON,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataFromJSONTyped,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseDataToJSON,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSON,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardHoursPreCalculationSubPage200ResponseToJSON,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSON,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerFromJSONTyped,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInnerToJSON,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSON,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseToJSON,
  ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSON,
  ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerFromJSONTyped,
  ProjectGetKpiCardHoursSummedSubPage200ResponseDataInnerToJSON,
  ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSON,
  ProjectGetKpiCardHoursSummedSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardHoursSummedSubPage200ResponseToJSON,
  ProjectGetKpiCardInvoicesSubPage200ResponseFromJSON,
  ProjectGetKpiCardInvoicesSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardInvoicesSubPage200ResponseToJSON,
  ProjectGetKpiCardInvoicesSubPageDirectionEnum,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSON,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataFromJSONTyped,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseDataToJSON,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSON,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseFromJSONTyped,
  ProjectGetKpiCardProductsPreCalculationSubPage200ResponseToJSON,
  ProjectGetKpiCardProductsPreCalculationSubPageDirectionEnum,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSON,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerFromJSONTyped,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerToJSON,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInnerTypeEnum,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSON,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseFromJSONTyped,
  ProjectGetKpiCardProductsSubpageProductsTab200ResponseToJSON,
  ProjectGetKpiCardProductsSubpageProductsTabDirectionEnum,
  ProjectGetKpiCardsData200ResponseFromJSON,
  ProjectGetKpiCardsData200ResponseFromJSONTyped,
  ProjectGetKpiCardsData200ResponseToJSON,
  ProjectStatusFromJSON,
  ProjectStatusFromJSONTyped,
  ProjectStatusIdentifierEnum,
  ProjectStatusToJSON,
  ProjectStatusTypeFromJSON,
  ProjectStatusTypeFromJSONTyped,
  ProjectStatusTypeToJSON,
  ProjectToJSON,
  RegistrationsDTOFromJSON,
  RegistrationsDTOFromJSONTyped,
  RegistrationsDTOToJSON,
  RegistrationsDTOTypeEnum,
  RegistrationsInvoiceDTOAllOfCustomMetadataFromJSON,
  RegistrationsInvoiceDTOAllOfCustomMetadataFromJSONTyped,
  RegistrationsInvoiceDTOAllOfCustomMetadataToJSON,
  RegistrationsInvoiceDTOAllOfFromJSON,
  RegistrationsInvoiceDTOAllOfFromJSONTyped,
  RegistrationsInvoiceDTOAllOfToJSON,
  RegistrationsInvoiceDTOFromJSON,
  RegistrationsInvoiceDTOFromJSONTyped,
  RegistrationsInvoiceDTOToJSON,
  RegistrationsInvoiceDTOTypeEnum,
  ReportTypes,
  ReportTypesFromJSON,
  ReportTypesFromJSONTyped,
  ReportTypesToJSON,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSON,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdFromJSONTyped,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdRepeatEnum,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdStatusEnum,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskIdToJSON,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSON,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameFromJSONTyped,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameRepeatEnum,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameStatusEnum,
  RequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskNameToJSON,
  RequestResetPassword200ResponseFromJSON,
  RequestResetPassword200ResponseFromJSONTyped,
  RequestResetPassword200ResponseToJSON,
  RequestResetPasswordRequestFromJSON,
  RequestResetPasswordRequestFromJSONTyped,
  RequestResetPasswordRequestToJSON,
  RequiredError,
  ResetPasswordRequestFromJSON,
  ResetPasswordRequestFromJSONTyped,
  ResetPasswordRequestToJSON,
  ResponseError,
  ReverseLookup200ResponseDataFromJSON,
  ReverseLookup200ResponseDataFromJSONTyped,
  ReverseLookup200ResponseDataToJSON,
  ReverseLookup200ResponseFromJSON,
  ReverseLookup200ResponseFromJSONTyped,
  ReverseLookup200ResponseToJSON,
  RoleFromJSON,
  RoleFromJSONTyped,
  RoleIdentifierEnum,
  RoleToJSON,
  SendReportRequestFromJSON,
  SendReportRequestFromJSONTyped,
  SendReportRequestToJSON,
  SetPrimaryVariantRequestFromJSON,
  SetPrimaryVariantRequestFromJSONTyped,
  SetPrimaryVariantRequestToJSON,
  StandardFileFromJSON,
  StandardFileFromJSONTyped,
  StandardFileToJSON,
  StandardFileTypeEnum,
  TaskCreateOrUpdateDTOFromJSON,
  TaskCreateOrUpdateDTOFromJSONTyped,
  TaskCreateOrUpdateDTOToJSON,
  TaskReadDTOFromJSON,
  TaskReadDTOFromJSONTyped,
  TaskReadDTORepeatEnum,
  TaskReadDTOToJSON,
  TemplateType,
  TemplateTypeFromJSON,
  TemplateTypeFromJSONTyped,
  TemplateTypeToJSON,
  TextApiResponse,
  TextTemplateFromJSON,
  TextTemplateFromJSONTyped,
  TextTemplateToJSON,
  TimeEntryRuleGroupFromJSON,
  TimeEntryRuleGroupFromJSONTyped,
  TimeEntryRuleGroupToJSON,
  UpdateCardListing200ResponseDataFromJSON,
  UpdateCardListing200ResponseDataFromJSONTyped,
  UpdateCardListing200ResponseDataToJSON,
  UpdateCardListing200ResponseFromJSON,
  UpdateCardListing200ResponseFromJSONTyped,
  UpdateCardListing200ResponseToJSON,
  UpdateCardListingRequestFromJSON,
  UpdateCardListingRequestFromJSONTyped,
  UpdateCardListingRequestToJSON,
  UpdateUserIntegrationSettingRequestFromJSON,
  UpdateUserIntegrationSettingRequestFromJSONTyped,
  UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSON,
  UpdateUserIntegrationSettingRequestIntegrationSettingsInnerFromJSONTyped,
  UpdateUserIntegrationSettingRequestIntegrationSettingsInnerToJSON,
  UpdateUserIntegrationSettingRequestToJSON,
  UploadExpenseFile200ResponseFromJSON,
  UploadExpenseFile200ResponseFromJSONTyped,
  UploadExpenseFile200ResponseToJSON,
  UserAdminAccessEnum,
  UserFromJSON,
  UserFromJSONTyped,
  UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSON,
  UserMobileAppPreferencesFormsDailyReminderPreferencesFromJSONTyped,
  UserMobileAppPreferencesFormsDailyReminderPreferencesToJSON,
  UserMobileAppPreferencesFromJSON,
  UserMobileAppPreferencesFromJSONTyped,
  UserMobileAppPreferencesToJSON,
  UserNotificationFromJSON,
  UserNotificationFromJSONTyped,
  UserNotificationToJSON,
  UserToJSON,
  UsersGetKpiCards200ResponseDataInnerFromJSON,
  UsersGetKpiCards200ResponseDataInnerFromJSONTyped,
  UsersGetKpiCards200ResponseDataInnerToJSON,
  UsersGetKpiCards200ResponseDataInnerTypeEnum,
  UsersGetKpiCards200ResponseFromJSON,
  UsersGetKpiCards200ResponseFromJSONTyped,
  UsersGetKpiCards200ResponseToJSON,
  UsersGetSpecified200ResponseDataInnerFromJSON,
  UsersGetSpecified200ResponseDataInnerFromJSONTyped,
  UsersGetSpecified200ResponseDataInnerToJSON,
  UsersGetSpecified200ResponseDataInnerTypeEnum,
  UsersGetSpecified200ResponseFromJSON,
  UsersGetSpecified200ResponseFromJSONTyped,
  UsersGetSpecified200ResponseToJSON,
  UsersGetSpecifiedDirectionEnum,
  UsersGetSummedDirectionEnum,
  UsersGetWeekly200ResponseDateRangeInnerFromJSON,
  UsersGetWeekly200ResponseDateRangeInnerFromJSONTyped,
  UsersGetWeekly200ResponseDateRangeInnerToJSON,
  UsersGetWeekly200ResponseFromJSON,
  UsersGetWeekly200ResponseFromJSONTyped,
  UsersGetWeekly200ResponseToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerFromJSONTyped,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInnerToJSON,
  UsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerToJSON,
  UsersPriceGroupFromJSON,
  UsersPriceGroupFromJSONTyped,
  UsersPriceGroupToJSON,
  UsersPriceGroupsList200ResponseAllOfFromJSON,
  UsersPriceGroupsList200ResponseAllOfFromJSONTyped,
  UsersPriceGroupsList200ResponseAllOfToJSON,
  UsersPriceGroupsList200ResponseFromJSON,
  UsersPriceGroupsList200ResponseFromJSONTyped,
  UsersPriceGroupsList200ResponseToJSON,
  UsersPriceGroupsListDirectionEnum,
  UsersPriceGroupsView200ResponseFromJSON,
  UsersPriceGroupsView200ResponseFromJSONTyped,
  UsersPriceGroupsView200ResponseToJSON,
  UsersProductsUsage200ResponseDataInnerFromJSON,
  UsersProductsUsage200ResponseDataInnerFromJSONTyped,
  UsersProductsUsage200ResponseDataInnerToJSON,
  UsersProductsUsage200ResponseFromJSON,
  UsersProductsUsage200ResponseFromJSONTyped,
  UsersProductsUsage200ResponseToJSON,
  UsersProductsUsageEntityFromJSON,
  UsersProductsUsageEntityFromJSONTyped,
  UsersProductsUsageEntityToJSON,
  UsersProductsUsageEntryFromJSON,
  UsersProductsUsageEntryFromJSONTyped,
  UsersProductsUsageEntryOriginEnum,
  UsersProductsUsageEntryToJSON,
  UsersView200ResponseFromJSON,
  UsersView200ResponseFromJSONTyped,
  UsersView200ResponseToJSON,
  VendorAllOfFromJSON,
  VendorAllOfFromJSONTyped,
  VendorAllOfToJSON,
  VendorFromJSON,
  VendorFromJSONTyped,
  VendorProductBuyingPriceSourceEnum,
  VendorProductFromJSON,
  VendorProductFromJSONTyped2 as VendorProductFromJSONTyped,
  VendorProductPriceFromJSON,
  VendorProductPriceFromJSONTyped,
  VendorProductPriceToJSON,
  VendorProductToJSON,
  VendorProductView200ResponseFromJSON,
  VendorProductView200ResponseFromJSONTyped,
  VendorProductView200ResponseToJSON,
  VendorProductsList200ResponseAllOfDataInnerAllOfBuyingPriceSourceEnum,
  VendorProductsList200ResponseAllOfDataInnerAllOfFromJSON,
  VendorProductsList200ResponseAllOfDataInnerAllOfFromJSONTyped,
  VendorProductsList200ResponseAllOfDataInnerAllOfToJSON,
  VendorProductsList200ResponseAllOfDataInnerBuyingPriceSourceEnum,
  VendorProductsList200ResponseAllOfDataInnerFromJSON,
  VendorProductsList200ResponseAllOfDataInnerFromJSONTyped,
  VendorProductsList200ResponseAllOfDataInnerToJSON,
  VendorProductsList200ResponseAllOfFromJSON,
  VendorProductsList200ResponseAllOfFromJSONTyped,
  VendorProductsList200ResponseAllOfToJSON,
  VendorProductsList200ResponseFromJSON,
  VendorProductsList200ResponseFromJSONTyped,
  VendorProductsList200ResponseToJSON,
  VendorToJSON,
  VerifyResetTokenRequestFromJSON,
  VerifyResetTokenRequestFromJSONTyped,
  VerifyResetTokenRequestToJSON,
  VoidApiResponse,
  WallCommentFromJSON,
  WallCommentFromJSONTyped,
  WallCommentToJSON,
  WallPostFromJSON,
  WallPostFromJSONTyped,
  WallPostToJSON,
  WallPostWallCommentsInnerFromJSON,
  WallPostWallCommentsInnerFromJSONTyped,
  WallPostWallCommentsInnerToJSON,
  canConsumeForm,
  exists,
  fromLocalDateString,
  instanceOfAbsence,
  instanceOfAbsenceCreateOrUpdateDTO,
  instanceOfAbsenceType,
  instanceOfActionLog,
  instanceOfActionLogMetadata,
  instanceOfActivity,
  instanceOfAddContactPersonRequest,
  instanceOfAddVariantRequest,
  instanceOfAddressLookup,
  instanceOfApiKey,
  instanceOfApvDefaultProject200Response,
  instanceOfAutoCompleteAddress200Response,
  instanceOfBadRequestResponse,
  instanceOfBadRequestResponseData,
  instanceOfBaseEntity,
  instanceOfBaseFile,
  instanceOfBaseFileAllOf,
  instanceOfBulkMarkAsInvoiced200Response,
  instanceOfBulkMarkAsInvoicedRequest,
  instanceOfCVRLookup,
  instanceOfCalculateInvoiceDueDate200Response,
  instanceOfCalculateInvoiceDueDate200ResponseData,
  instanceOfCalculateInvoiceDueDateRequest,
  instanceOfCard,
  instanceOfCardUpdateDTO,
  instanceOfCardsDeleteManyRequest,
  instanceOfChangePasswordRequest,
  instanceOfChangePasswordWithTokenRequest,
  instanceOfChangeStatusRequest,
  instanceOfCheckInRequest,
  instanceOfCheckOutRequest,
  instanceOfCity,
  instanceOfCompany,
  instanceOfContact,
  instanceOfContactPerson,
  instanceOfControlPanelApiOfferStatusResponse,
  instanceOfControlPanelApiPaymentTerm,
  instanceOfControlPanelApiProjectFeedResponseDTO,
  instanceOfControlPanelApiProjectFeedResponseDTOPagination,
  instanceOfControlPanelApiProjectStatusResponse,
  instanceOfControlPanelApiProjectViewOrIndexResponse,
  instanceOfControlPanelProductsToTask,
  instanceOfControlPanelProductsToTaskProduct,
  instanceOfCountry,
  instanceOfCreateAbsence201Response,
  instanceOfCreateAbsence201ResponseData,
  instanceOfCreateAbsenceRequest,
  instanceOfCreateAbsenceType201Response,
  instanceOfCreateAbsenceType201ResponseData,
  instanceOfCreateAbsenceTypeRequest,
  instanceOfCreateCardAndAbsences201Response,
  instanceOfCreateCardAndAbsences201ResponseData,
  instanceOfCreateCardAndAbsencesRequest,
  instanceOfCreateCardAndTask201Response,
  instanceOfCreateCardAndTask201ResponseData,
  instanceOfCreateCardAndTaskRequest,
  instanceOfCreateContactRequest,
  instanceOfCreateContactRequestContactTypes,
  instanceOfCreateCustomEmailTemplateRequest,
  instanceOfCreateExpenseFromFile200Response,
  instanceOfCreateExpenseFromFile200ResponseData,
  instanceOfCreateExpenseRequest,
  instanceOfCreateFirebaseTokenRequest,
  instanceOfCreateFormRequest,
  instanceOfCreateInvoiceRequest,
  instanceOfCreateLabelRequest,
  instanceOfCreateProductRequest,
  instanceOfCreateProjectCustomFieldAttributeRequest,
  instanceOfCreateTextTemplateRequest,
  instanceOfCreateUserRequest,
  instanceOfCustomEmailTemplate,
  instanceOfCustomEmailTemplateView200Response,
  instanceOfCvrSearchByName200Response,
  instanceOfDeleteAbsenceType200Response,
  instanceOfDeleteCard200Response,
  instanceOfDeleteProductVariantsRequest,
  instanceOfDeleteTokenByDeviceIdRequest,
  instanceOfDuplicateInvoiceRequest,
  instanceOfEconomicImportContacts200Response,
  instanceOfEditAbsenceType200Response,
  instanceOfEditContactPersonRequest,
  instanceOfEditExpenseRequest,
  instanceOfEditInvoiceRequest,
  instanceOfEditOfferRequest,
  instanceOfEditSubscriptionRequest,
  instanceOfEditTextTemplateRequest,
  instanceOfEditUserRequest,
  instanceOfEditUserRequestCustomIntegrationSettingsInner,
  instanceOfEmail,
  instanceOfEmailAction,
  instanceOfEmailTemplate,
  instanceOfEntityId,
  instanceOfErrorNotFound,
  instanceOfErrorNotFoundData,
  instanceOfErrorValidation,
  instanceOfErrorValidationData,
  instanceOfExpense,
  instanceOfExpenseLine,
  instanceOfExpenseLinesList200Response,
  instanceOfExpenseLinesList200ResponseAllOf,
  instanceOfExpenseLinesList200ResponseAllOfDataInner,
  instanceOfExpenseLinesList200ResponseAllOfDataInnerAllOf,
  instanceOfExpenseLinesView200Response,
  instanceOfExpenseReadDTO,
  instanceOfExpensesList200Response,
  instanceOfExpensesList200ResponseAllOf,
  instanceOfExpensesView200Response,
  instanceOfFeature,
  instanceOfFeedItem,
  instanceOfFeedItemExpense,
  instanceOfFeedItemExpenseAllOf,
  instanceOfFeedItemForm,
  instanceOfFeedItemFormAllOf,
  instanceOfFeedItemInvoice,
  instanceOfFeedItemInvoiceAllOf,
  instanceOfFeedItemProjectFile,
  instanceOfFeedItemProjectFileAllOf,
  instanceOfFeedItemWallPost,
  instanceOfFeedItemWallPostAllOf,
  instanceOfFeedMetadataDTO,
  instanceOfFeedPaginationDTO,
  instanceOfForm,
  instanceOfFormDtoWithJsonFormsData,
  instanceOfFormDtoWithJsonFormsDataAllOf,
  instanceOfFormField,
  instanceOfFormReadDTO,
  instanceOfFormTemplateModelWithJsonFormsData,
  instanceOfFormTemplateModelWithJsonFormsDataFields,
  instanceOfFormTemplateSimpleEntity,
  instanceOfFormTemplateView200Response,
  instanceOfFormTemplatesList200Response,
  instanceOfFormTemplatesList200ResponseAllOf,
  instanceOfFormTemplatesTasksModel,
  instanceOfFormView200Response,
  instanceOfFormView200ResponseData,
  instanceOfFormView200ResponseDataAllOf,
  instanceOfFormsList200Response,
  instanceOfFormsList200ResponseAllOf,
  instanceOfFrontpageFeedDTO,
  instanceOfFrontpageFeedDTOFormFields,
  instanceOfFrontpageTotalConsumptionDTO,
  instanceOfFrontpageWeeklyConsumptionDTO,
  instanceOfGatherOfferLines200Response,
  instanceOfGenericIndexResponseWithEntitiesAndPaginationOk,
  instanceOfGetAbsence200Response,
  instanceOfGetAbsenceType200Response,
  instanceOfGetAbsenceTypes200Response,
  instanceOfGetAbsenceTypes200ResponseAllOf,
  instanceOfGetAbsences200Response,
  instanceOfGetAbsences200ResponseAllOf,
  instanceOfGetAllRegistrations200Response,
  instanceOfGetAllRegistrations200ResponseDocumentTypesInner,
  instanceOfGetCard200Response,
  instanceOfGetCardsWithTaskAndUsers200Response,
  instanceOfGetCardsWithTaskAndUsers200ResponseData,
  instanceOfGetCardsWithTaskAndUsers200ResponseDataAbsencesValue,
  instanceOfGetCardsWithTaskAndUsers200ResponseDataTasksValue,
  instanceOfGetCities200Response,
  instanceOfGetCities200ResponseAllOf,
  instanceOfGetCity200Response,
  instanceOfGetCompanies200Response,
  instanceOfGetCompanies200ResponseAllOf,
  instanceOfGetCompany200Response,
  instanceOfGetContact200Response,
  instanceOfGetContactPerson200Response,
  instanceOfGetContactPersonsList200Response,
  instanceOfGetContactPersonsList200ResponseAllOf,
  instanceOfGetContacts200Response,
  instanceOfGetContacts200ResponseAllOf,
  instanceOfGetCountries200Response,
  instanceOfGetEmailAction200Response,
  instanceOfGetEmailAction200ResponseAllOf,
  instanceOfGetFeatures200Response,
  instanceOfGetFeatures200ResponseAllOf,
  instanceOfGetIntegrationTypes200Response,
  instanceOfGetIntegrationTypes200ResponseAllOf,
  instanceOfGetInvoiceActivityLog200Response,
  instanceOfGetInvoiceEmails200Response,
  instanceOfGetInvoiceEmails200ResponseAllOf,
  instanceOfGetInvoiceFiles200Response,
  instanceOfGetInvoiceFiles200ResponseAllOf,
  instanceOfGetInvoices200Response,
  instanceOfGetInvoices200ResponseAllOf,
  instanceOfGetLabel200Response,
  instanceOfGetLabels200Response,
  instanceOfGetLabels200ResponseAllOf,
  instanceOfGetLanguages200Response,
  instanceOfGetMe200Response,
  instanceOfGetMe200ResponseCompanySettings,
  instanceOfGetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInner,
  instanceOfGetMe200ResponseCompanySettingsDagseddelDefaultWorkingTimeInnerStartTime,
  instanceOfGetMe200ResponseErpIntegrationCapabilities,
  instanceOfGetMe200ResponseIntegrations,
  instanceOfGetMe200ResponseIntegrationsEnabled,
  instanceOfGetMe200ResponseLogos,
  instanceOfGetMe200ResponseSubscription,
  instanceOfGetMe200ResponseUser,
  instanceOfGetMe200ResponseUserAllOf,
  instanceOfGetOfferActionLogs200Response,
  instanceOfGetOfferActionLogs200ResponseAllOf,
  instanceOfGetOfferActions200Response,
  instanceOfGetOfferActions200ResponseAllOf,
  instanceOfGetOfferLine200Response,
  instanceOfGetOfferLines200Response,
  instanceOfGetOfferLines200ResponseAllOf,
  instanceOfGetOfferPdf200Response,
  instanceOfGetOfferPdf200ResponseAllOf,
  instanceOfGetPaymentTerms200Response,
  instanceOfGetProductCustomFieldAttribute200Response,
  instanceOfGetProject200Response,
  instanceOfGetProjectCustomFieldAttributes200Response,
  instanceOfGetProjectCustomFieldAttributes200ResponseAllOf,
  instanceOfGetProjects200Response,
  instanceOfGetProjects200ResponseAllOf,
  instanceOfGetTask200Response,
  instanceOfGetTaskProduct200Response,
  instanceOfGetTaskProducts200Response,
  instanceOfGetTextTemplate200Response,
  instanceOfGetTextTemplates200Response,
  instanceOfGetTextTemplates200ResponseAllOf,
  instanceOfGetTimeEntryRuleGroups200Response,
  instanceOfGetUserNotifications200Response,
  instanceOfGetUserNotifications200ResponseAllOf,
  instanceOfGetUsers200Response,
  instanceOfGetUsers200ResponseAllOf,
  instanceOfGetVendor200Response,
  instanceOfGetVendors200Response,
  instanceOfGetVendors200ResponseAllOf,
  instanceOfGetWallPost200Response,
  instanceOfGetWallPosts200Response,
  instanceOfGetWallPosts200ResponseAllOf,
  instanceOfHasIntegrationOfType200Response,
  instanceOfICreateProductBundleLineRequest,
  instanceOfICreateProductBundleRequest,
  instanceOfICreateProductBundleRequestProductBundleLinesInner,
  instanceOfICreateProjectRequest,
  instanceOfIDeleteCard200Response,
  instanceOfIDeleteCardRequest,
  instanceOfIEditWallCommentRequest,
  instanceOfIEditWallPost200Response,
  instanceOfIFormUploadFiles200Response,
  instanceOfIFormUploadFiles200ResponseDataInner,
  instanceOfIGetActivities200Response,
  instanceOfIGetActivities200ResponseAllOf,
  instanceOfIGetConsumption200Response,
  instanceOfIGetConsumption200ResponseData,
  instanceOfIGetConsumption200ResponseDataWeeklyConsumption,
  instanceOfIGetCustomEmailTemplates200Response,
  instanceOfIGetFeed200Response,
  instanceOfIGetFeedMetadata200Response,
  instanceOfIGetFrontpageInvoiced200Response,
  instanceOfIGetFrontpageInvoiced200ResponseData,
  instanceOfIGetFrontpageInvoiced200ResponseDataTotal,
  instanceOfIGetFrontpageInvoiced200ResponseDataWeekly,
  instanceOfIGetInvoice200Response,
  instanceOfIGetProject200Response,
  instanceOfIGetProject200ResponseData,
  instanceOfIGetProject200ResponseDataAllOf,
  instanceOfIGetTask200Response,
  instanceOfIGetTask200ResponseData,
  instanceOfIGetTasksForProject200Response,
  instanceOfIGetTasksForProject200ResponseAllOf,
  instanceOfIGetWorkRelated200Response,
  instanceOfIGetWorkRelated200ResponseAllOf,
  instanceOfIGetWorkRelated200ResponseAllOfData,
  instanceOfIListInvoices200Response,
  instanceOfIListInvoices200ResponseAllOf,
  instanceOfIListOfferStatuses200Response,
  instanceOfIListOfferStatuses200ResponseAllOf,
  instanceOfIListProjectStatuses200Response,
  instanceOfIListProjectStatuses200ResponseAllOf,
  instanceOfIListProjects200Response,
  instanceOfIListProjects200ResponseAllOf,
  instanceOfIListTasks200Response,
  instanceOfIListTasks200ResponseAllOf,
  instanceOfIListWallComments200ResponseInner,
  instanceOfIProductBundleSetSalesPrice200Response,
  instanceOfIProductBundleSetSalesPriceRequest,
  instanceOfIProductBundleUploadFile200Response,
  instanceOfIProjectDeleteFileRequestInner,
  instanceOfIProjectListFiles200Response,
  instanceOfIProjectListFiles200ResponseAllOf,
  instanceOfIProjectListFiles200ResponseAllOfDataInner,
  instanceOfIProjectListFiles200ResponseAllOfDataInnerImageUrls,
  instanceOfIProjectSendFilesRequest,
  instanceOfISendProjectForms200Response,
  instanceOfISendProjectFormsRequest,
  instanceOfIStandardFilesList200Response,
  instanceOfIStandardFilesList200ResponseAllOf,
  instanceOfIWallpostDeleteFile200Response,
  instanceOfImageUrls,
  instanceOfIntegration,
  instanceOfIntegrationSetting,
  instanceOfIntegrationSettingUsersInner,
  instanceOfIntegrationSettingUsersInnerJoinData,
  instanceOfIntegrationType,
  instanceOfInvoice,
  instanceOfInvoiceActivityLog,
  instanceOfInvoiceIntegration,
  instanceOfInvoiceLine,
  instanceOfInvoiceReadDTO,
  instanceOfInvoicesView200Response,
  instanceOfIsCheckedIn200Response,
  instanceOfIsCheckedIn200ResponseData,
  instanceOfKpiCardEconomyPrice,
  instanceOfKpiCardHoursSummedIndividualEntry,
  instanceOfKpiCardPreCalculationIndividualEntry,
  instanceOfKpiCardProductsIndividualEntry,
  instanceOfKpiCardsIndexResponse,
  instanceOfKpiCardsIndexResponseContributionMargins,
  instanceOfKpiCardsIndexResponsePreCalculation,
  instanceOfKpiChardHoursIndividualEntry,
  instanceOfLabelEntity,
  instanceOfLanguage,
  instanceOfLoginWithEmail200Response,
  instanceOfLoginWithEmailRequest,
  instanceOfLookupCVR200Response,
  instanceOfMergeProjectsRequest,
  instanceOfMobileGetCards200Response,
  instanceOfMobileGetCards200ResponseDataInner,
  instanceOfMobileGetCards200ResponseDataInnerAllOf,
  instanceOfMobileGetCards200ResponseDataInnerAllOfTask,
  instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOf,
  instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOfProject,
  instanceOfMobileGetCards200ResponseDataInnerAllOfTaskAllOfProjectAllOf,
  instanceOfMobilePlanningCreateCardAndTask201Response,
  instanceOfMobilePlanningCreateCardAndTask201ResponseData,
  instanceOfMobilePlanningCreateCardAndTaskRequest,
  instanceOfMobilePlanningEditCardRequest,
  instanceOfMobilePlanningGetCard200Response,
  instanceOfMobilePlanningGetCard200ResponseData,
  instanceOfMobilePlanningGetCard200ResponseDataAllOf,
  instanceOfMobilePlanningGetCard200ResponseDataAllOfTask,
  instanceOfMobilePlanningGetCard200ResponseDataAllOfTaskAllOf,
  instanceOfOffer,
  instanceOfOfferAcceptRequest,
  instanceOfOfferAction,
  instanceOfOfferAddProductBundleRequest,
  instanceOfOfferCancelRequest,
  instanceOfOfferCompany,
  instanceOfOfferContact,
  instanceOfOfferContactPerson,
  instanceOfOfferLine,
  instanceOfOfferOfferStatus,
  instanceOfOfferProject,
  instanceOfOffersList200Response,
  instanceOfOffersList200ResponseAllOf,
  instanceOfOffersView200Response,
  instanceOfPaginationDetails,
  instanceOfPaymentTerm,
  instanceOfPaymentTermType,
  instanceOfPriceHistory,
  instanceOfPriceMargin,
  instanceOfProduct,
  instanceOfProductBundle,
  instanceOfProductBundleFile,
  instanceOfProductBundleLine,
  instanceOfProductBundleLineView200Response,
  instanceOfProductBundleLinesList200Response,
  instanceOfProductBundleLinesList200ResponseAllOf,
  instanceOfProductBundlesGetKpiCardsData200Response,
  instanceOfProductBundlesGetKpiCardsData200ResponseData,
  instanceOfProductBundlesList200Response,
  instanceOfProductBundlesList200ResponseAllOf,
  instanceOfProductBundlesView200Response,
  instanceOfProductPriceHistory200Response,
  instanceOfProductPriceHistory200ResponseAllOf,
  instanceOfProductVariant,
  instanceOfProductVariants200Response,
  instanceOfProductVariants200ResponseAllOf,
  instanceOfProductsList200Response,
  instanceOfProductsList200ResponseAllOf,
  instanceOfProductsList200ResponseAllOfDataInner,
  instanceOfProductsList200ResponseAllOfDataInnerAllOf,
  instanceOfProductsTask,
  instanceOfProductsView200Response,
  instanceOfProject,
  instanceOfProjectCustomFieldAttribute,
  instanceOfProjectFileReadDTO,
  instanceOfProjectGetKpiCardEconomySubPage200Response,
  instanceOfProjectGetKpiCardEconomySubPage200ResponseData,
  instanceOfProjectGetKpiCardEconomySubPage200ResponseDataInterval,
  instanceOfProjectGetKpiCardHoursAllFormsSubPage200Response,
  instanceOfProjectGetKpiCardHoursAllFormsSubPage200ResponseDataInner,
  instanceOfProjectGetKpiCardHoursPreCalculationSubPage200Response,
  instanceOfProjectGetKpiCardHoursPreCalculationSubPage200ResponseData,
  instanceOfProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200Response,
  instanceOfProjectGetKpiCardHoursSummedByUserPriceGroupSubPage200ResponseDataInner,
  instanceOfProjectGetKpiCardHoursSummedSubPage200Response,
  instanceOfProjectGetKpiCardHoursSummedSubPage200ResponseDataInner,
  instanceOfProjectGetKpiCardInvoicesSubPage200Response,
  instanceOfProjectGetKpiCardProductsPreCalculationSubPage200Response,
  instanceOfProjectGetKpiCardProductsPreCalculationSubPage200ResponseData,
  instanceOfProjectGetKpiCardProductsSubpageProductsTab200Response,
  instanceOfProjectGetKpiCardProductsSubpageProductsTab200ResponseDataInner,
  instanceOfProjectGetKpiCardsData200Response,
  instanceOfProjectStatus,
  instanceOfProjectStatusType,
  instanceOfRegistrationsDTO,
  instanceOfRegistrationsInvoiceDTO,
  instanceOfRegistrationsInvoiceDTOAllOf,
  instanceOfRegistrationsInvoiceDTOAllOfCustomMetadata,
  instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskId,
  instanceOfRequestDTOControlPanelApiPlanningCreateTaskAndCardWithTaskName,
  instanceOfRequestResetPassword200Response,
  instanceOfRequestResetPasswordRequest,
  instanceOfResetPasswordRequest,
  instanceOfReverseLookup200Response,
  instanceOfReverseLookup200ResponseData,
  instanceOfRole,
  instanceOfSendReportRequest,
  instanceOfSetPrimaryVariantRequest,
  instanceOfStandardFile,
  instanceOfTaskCreateOrUpdateDTO,
  instanceOfTaskReadDTO,
  instanceOfTextTemplate,
  instanceOfTimeEntryRuleGroup,
  instanceOfUpdateCardListing200Response,
  instanceOfUpdateCardListing200ResponseData,
  instanceOfUpdateCardListingRequest,
  instanceOfUpdateUserIntegrationSettingRequest,
  instanceOfUpdateUserIntegrationSettingRequestIntegrationSettingsInner,
  instanceOfUploadExpenseFile200Response,
  instanceOfUser,
  instanceOfUserMobileAppPreferences,
  instanceOfUserMobileAppPreferencesFormsDailyReminderPreferences,
  instanceOfUserNotification,
  instanceOfUsersGetKpiCards200Response,
  instanceOfUsersGetKpiCards200ResponseDataInner,
  instanceOfUsersGetSpecified200Response,
  instanceOfUsersGetSpecified200ResponseDataInner,
  instanceOfUsersGetWeekly200Response,
  instanceOfUsersGetWeekly200ResponseDateRangeInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerAbsencesInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerProjectsInnerFormsInnerEntriesInner,
  instanceOfUsersGetWeekly200ResponseWeeklyViewInnerWeeksInnerSumHoursInner,
  instanceOfUsersPriceGroup,
  instanceOfUsersPriceGroupsList200Response,
  instanceOfUsersPriceGroupsList200ResponseAllOf,
  instanceOfUsersPriceGroupsView200Response,
  instanceOfUsersProductsUsage200Response,
  instanceOfUsersProductsUsage200ResponseDataInner,
  instanceOfUsersProductsUsageEntity,
  instanceOfUsersProductsUsageEntry,
  instanceOfUsersView200Response,
  instanceOfVendor,
  instanceOfVendorAllOf,
  instanceOfVendorProduct,
  instanceOfVendorProductPrice,
  instanceOfVendorProductView200Response,
  instanceOfVendorProductsList200Response,
  instanceOfVendorProductsList200ResponseAllOf,
  instanceOfVendorProductsList200ResponseAllOfDataInner,
  instanceOfVendorProductsList200ResponseAllOfDataInnerAllOf,
  instanceOfVerifyResetTokenRequest,
  instanceOfWallComment,
  instanceOfWallPost,
  instanceOfWallPostWallCommentsInner,
  mapValues,
  querystring,
  toLocalDateString
};
//# sourceMappingURL=index.js.map